/*
 * naming_convention_lookup.js — unified browser bundle
 *
 * Concatenates the previously separate browser files into a single script:
 *   1. ui/local_data_bundle.js              -> window.NCL_LOCAL_DATA_BUNDLE (rules + code definitions for all conventions)
 *   2. ui/multi_convention_decoder_runtime.js -> window.initMultiConventionDecoderRuntime (decoder engine + UI wiring)
 * Generated from the canonical files; do not edit by hand.
 */

window.NCL_LOCAL_DATA_BUNDLE = {
  "generatedAt": "2026-07-20T18:07:27.822Z",
  "conventions": {
    "./data/conventions/disney-wonderland-modern/rules.draft.json": {
      "conventionId": "DWC-Modern",
      "maskSpec": {
        "mask": "TITLE_CLASS-WIP_VID_TYPE_CONF_SPEC_RES-RANGE_FPS_TEXL-IAR_AUDL-TF_TTL-TYPE_REC",
        "mainDelimiter": "_",
        "subDelimiter": "-",
        "optionalSegments": [
          "TEXL-IAR",
          "TTL-TYPE"
        ],
        "optionalSubTokenSegments": [
          "CLASS-WIP",
          "RES-RANGE",
          "TTL-TYPE"
        ],
        "informationalTokens": [
          "TITLE",
          "VID",
          "REC"
        ]
      },
      "version": 1,
      "status": "draft",
      "generatedAt": "2026-07-17T21:32:43.487Z",
      "ruleCount": 252,
      "rules": [
        {
          "rule_id": "DWC-Modern:AUDL:ZXX",
          "convention_id": "DWC-Modern",
          "token_name": "AUDL",
          "token_pattern": "ZXX",
          "semantic_meaning": "No Linguistic Content (e.g. textless bed or fully textless). In Audio-only deliveries, this code designates material which contains no discernible language.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "ZXX",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audl"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-audl-tf.json",
            "source_key": "ZXX",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audl"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:AUDL:STX",
          "convention_id": "DWC-Modern",
          "token_name": "AUDL",
          "token_pattern": "STX",
          "semantic_meaning": "Semi-Textless. Program contains some textless inserts for simplified distribution.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "STX",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audl"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-audl-tf.json",
            "source_key": "STX",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audl"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:AUDL:QAL",
          "convention_id": "DWC-Modern",
          "token_name": "AUDL",
          "token_pattern": "QAL",
          "semantic_meaning": "Qualified for All Languages (e.g. Music & Effects).",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "QAL",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audl"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-audl-tf.json",
            "source_key": "QAL",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audl"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:AUDL:MOS",
          "convention_id": "DWC-Modern",
          "token_name": "AUDL",
          "token_pattern": "MOS",
          "semantic_meaning": "Mute of sound. May indicate included silent tracks, or no audio at all. Superseded by ZXX but still in common use.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "MOS",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audl"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-audl-tf.json",
            "source_key": "MOS",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audl"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:AUDL:UND",
          "convention_id": "DWC-Modern",
          "token_name": "AUDL",
          "token_pattern": "UND",
          "semantic_meaning": "Undetermined Language or to be curated.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "UND",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audl"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-audl-tf.json",
            "source_key": "UND",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audl"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TF:ALL",
          "convention_id": "DWC-Modern",
          "token_name": "TF",
          "token_pattern": "ALL",
          "semantic_meaning": "Any Track Format",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "ALL",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "tf"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-audl-tf.json",
            "source_key": "ALL",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "tf"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TF:MO",
          "convention_id": "DWC-Modern",
          "token_name": "TF",
          "token_pattern": "MO",
          "semantic_meaning": "Mono (1 channel)",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "MO",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "tf"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-audl-tf.json",
            "source_key": "MO",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "tf"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TF:DMO",
          "convention_id": "DWC-Modern",
          "token_name": "TF",
          "token_pattern": "DMO",
          "semantic_meaning": "Dual Mono (2 channels)",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "DMO",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "tf"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-audl-tf.json",
            "source_key": "DMO",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "tf"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TF:20",
          "convention_id": "DWC-Modern",
          "token_name": "TF",
          "token_pattern": "20",
          "semantic_meaning": "Stereo or Lo/Ro (2 channels)",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "20",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "tf"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-audl-tf.json",
            "source_key": "20",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "tf"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TF:50",
          "convention_id": "DWC-Modern",
          "token_name": "TF",
          "token_pattern": "50",
          "semantic_meaning": "5.0 Surround (5 channels)",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "50",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "tf"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-audl-tf.json",
            "source_key": "50",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "tf"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TF:51",
          "convention_id": "DWC-Modern",
          "token_name": "TF",
          "token_pattern": "51",
          "semantic_meaning": "5.1 Surround (6 channels)",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "51",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "tf"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-audl-tf.json",
            "source_key": "51",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "tf"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TF:5120",
          "convention_id": "DWC-Modern",
          "token_name": "TF",
          "token_pattern": "5120",
          "semantic_meaning": "5.1 Surround + Stereo (8 channels)",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "5120",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "tf"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-audl-tf.json",
            "source_key": "5120",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "tf"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TF:70",
          "convention_id": "DWC-Modern",
          "token_name": "TF",
          "token_pattern": "70",
          "semantic_meaning": "7.0 Surround (7 channels)",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "70",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "tf"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-audl-tf.json",
            "source_key": "70",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "tf"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TF:71",
          "convention_id": "DWC-Modern",
          "token_name": "TF",
          "token_pattern": "71",
          "semantic_meaning": "7.1 Surround (8 channels)",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "71",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "tf"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-audl-tf.json",
            "source_key": "71",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "tf"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TF:91",
          "convention_id": "DWC-Modern",
          "token_name": "TF",
          "token_pattern": "91",
          "semantic_meaning": "9.1 or 7.1.2 Surround (10 channels)",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "91",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "tf"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-audl-tf.json",
            "source_key": "91",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "tf"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TF:120",
          "convention_id": "DWC-Modern",
          "token_name": "TF",
          "token_pattern": "120",
          "semantic_meaning": "12.0 Surround (12 channels) IMAX theatrical",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "120",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "tf"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-audl-tf.json",
            "source_key": "120",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "tf"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TF:12CH",
          "convention_id": "DWC-Modern",
          "token_name": "TF",
          "token_pattern": "12CH",
          "semantic_meaning": "12 Channels (12 channels)",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "12CH",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "tf"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-audl-tf.json",
            "source_key": "12CH",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "tf"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TF:24CH",
          "convention_id": "DWC-Modern",
          "token_name": "TF",
          "token_pattern": "24CH",
          "semantic_meaning": "24 Channels (24 channels)",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "24CH",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "tf"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-audl-tf.json",
            "source_key": "24CH",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "tf"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TF:ATMOS",
          "convention_id": "DWC-Modern",
          "token_name": "TF",
          "token_pattern": "Atmos",
          "semantic_meaning": "Dolby Atmos Immersive Audio",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "ATMOS",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "tf"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-audl-tf.json",
            "source_key": "Atmos",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "tf"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TF:IE",
          "convention_id": "DWC-Modern",
          "token_name": "TF",
          "token_pattern": "IE",
          "semantic_meaning": "IMAX Enhanced Audio",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "IE",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "tf"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-audl-tf.json",
            "source_key": "IE",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "tf"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TF:BED",
          "convention_id": "DWC-Modern",
          "token_name": "TF",
          "token_pattern": "BED",
          "semantic_meaning": "Dolby Atmos Bed",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "BED",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "tf"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-audl-tf.json",
            "source_key": "BED",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "tf"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TF:OBJ-XX",
          "convention_id": "DWC-Modern",
          "token_name": "TF",
          "token_pattern": "OBJ-XX",
          "semantic_meaning": "Dolby Atmos Object",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "OBJ-XX",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "tf",
              "notes": "XX represents the RMU input number for that object. Stereo Pair Atmos Objects will include both RMU input numbers, and also indicate L or R in the Audio Channel Descriptor token."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-audl-tf.json",
            "source_key": "OBJ-XX",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "tf",
              "notes": "XX represents the RMU input number for that object. Stereo Pair Atmos Objects will include both RMU input numbers, and also indicate L or R in the Audio Channel Descriptor token."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:3D",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "3D",
          "semantic_meaning": "3D",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "3D",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "3D",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:AE",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "AE",
          "semantic_meaning": "Alternate Ending",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "AE",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "AE",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:AN",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "AN",
          "semantic_meaning": "Anniversary",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "AN",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "AN",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:CN",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "CN",
          "semantic_meaning": "Censored",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "CN",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "CN",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:CL",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "CL",
          "semantic_meaning": "Colorized",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "CL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "CL",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:CB",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "CB",
          "semantic_meaning": "Content Break",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "CB",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "CB",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:CR",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "CR",
          "semantic_meaning": "Creative",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "CR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "CR",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:CD",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "CD",
          "semantic_meaning": "Credits",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "CD",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "CD",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:DL",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "DL",
          "semantic_meaning": "Dialog",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "DL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "DL",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:DC",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "DC",
          "semantic_meaning": "Director's Cut",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "DC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "DC",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:DNU",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "DNU",
          "semantic_meaning": "DO NOT USE",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "DNU",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "DNU",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:DB",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "DB",
          "semantic_meaning": "Dubbing Credits",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "DB",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "DB",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:ET",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "ET",
          "semantic_meaning": "Exit",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "ET",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "ET",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:EX",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "EX",
          "semantic_meaning": "Extended",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "EX",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "EX",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:IN",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "IN",
          "semantic_meaning": "Intermission",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "IN",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "IN",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:LO",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "LO",
          "semantic_meaning": "Logos",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "LO",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "LO",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:MS",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "MS",
          "semantic_meaning": "Music",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "MS",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "MS",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:OV",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "OV",
          "semantic_meaning": "Original",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "OV",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "OV",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:OT",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "OT",
          "semantic_meaning": "Other",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "OT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "OT",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:OE",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "OE",
          "semantic_meaning": "Overture",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "OE",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "OE",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:PP",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "PP",
          "semantic_meaning": "Product Placement",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "PP",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "PP",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:PROMO",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "PROMO",
          "semantic_meaning": "Promotional",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "PROMO",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "PROMO",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:RC",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "RC",
          "semantic_meaning": "Recap",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "RC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "RC",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:RGN",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "RGN",
          "semantic_meaning": "Regionalized",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "RGN",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "RGN",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:RR",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "RR",
          "semantic_meaning": "Rereleased",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "RR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "RR",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:RE",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "RE",
          "semantic_meaning": "Restored",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "RE",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "RE",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:RA",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "RA",
          "semantic_meaning": "Restored Audio",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "RA",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "RA",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:RP",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "RP",
          "semantic_meaning": "Restored Picture",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "RP",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "RP",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:SN",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "SN",
          "semantic_meaning": "Sanitized",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "SN",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "SN",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:SA",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "SA",
          "semantic_meaning": "Sanitized Audio",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "SA",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "SA",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:SP",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "SP",
          "semantic_meaning": "Sanitized Picture",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "SP",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "SP",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:ST",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "ST",
          "semantic_meaning": "Shortened",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "ST",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "ST",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:SE",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "SE",
          "semantic_meaning": "Sound Effects",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "SE",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "SE",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:SPLIT",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "SPLIT",
          "semantic_meaning": "Split",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "SPLIT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "SPLIT",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:SUB",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "SUB",
          "semantic_meaning": "Substitutions",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "SUB",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "SUB",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:SYND",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "SYND",
          "semantic_meaning": "Syndication",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "SYND",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "SYND",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:UR",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "UR",
          "semantic_meaning": "Unrated",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "UR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "UR",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:3DL",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "3DL",
          "semantic_meaning": "3DL",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "3DL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "3DL",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:3DR",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "3DR",
          "semantic_meaning": "3DR",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "3DR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "3DR",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:3DSBS",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "3DSBS",
          "semantic_meaning": "3DSBS",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "3DSBS",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "3DSBS",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:3DTAB",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "3DTAB",
          "semantic_meaning": "3DTAB",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "3DTAB",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "3DTAB",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:IMAX",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "IMAX",
          "semantic_meaning": "IMAX",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "IMAX",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "IMAX",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:INT",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "INT",
          "semantic_meaning": "INT",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "INT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "INT",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:VAM",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "VAM",
          "semantic_meaning": "VAM",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "VAM",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "VAM",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:VS",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "VS",
          "semantic_meaning": "VS",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "VS",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "VS",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:WIP",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "WIP",
          "semantic_meaning": "WIP",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "WIP",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "WIP",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CLASS:P#",
          "convention_id": "DWC-Modern",
          "token_name": "CLASS",
          "token_pattern": "P#",
          "semantic_meaning": "P#",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "P#",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-class-wip.json",
            "source_key": "P#",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CONF:CPO",
          "convention_id": "DWC-Modern",
          "token_name": "CONF",
          "token_pattern": "CPO",
          "semantic_meaning": "C Conformance (10s handles) Program Only.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "CPO",
            "rule_kind": "code-definition",
            "source_metadata": {
              "notes": "[10s][Program][10s]"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-conf.json",
            "source_key": "CPO",
            "source_token_name": "definitions",
            "source_metadata": {
              "notes": "[10s][Program][10s]"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CONF:DPO",
          "convention_id": "DWC-Modern",
          "token_name": "CONF",
          "token_pattern": "DPO",
          "semantic_meaning": "D Conformance (1s handles) Program Only.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "DPO",
            "rule_kind": "code-definition",
            "source_metadata": {
              "notes": "[1s][Program][1s]"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-conf.json",
            "source_key": "DPO",
            "source_token_name": "definitions",
            "source_metadata": {
              "notes": "[1s][Program][1s]"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CONF:DTO",
          "convention_id": "DWC-Modern",
          "token_name": "CONF",
          "token_pattern": "DTO",
          "semantic_meaning": "D Conformance (1s handles) Textless Bed Only.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "DTO",
            "rule_kind": "code-definition",
            "source_metadata": {
              "notes": "[1s][TXB][1s]"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-conf.json",
            "source_key": "DTO",
            "source_token_name": "definitions",
            "source_metadata": {
              "notes": "[1s][TXB][1s]"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CONF:DPT",
          "convention_id": "DWC-Modern",
          "token_name": "CONF",
          "token_pattern": "DPT",
          "semantic_meaning": "DPT D Conformance (1s handles) Program and Textless Bed at tail.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "DPT",
            "rule_kind": "code-definition",
            "source_metadata": {
              "notes": "[1s][Program][30s][TXB][1s]"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-conf.json",
            "source_key": "DPT",
            "source_token_name": "definitions",
            "source_metadata": {
              "notes": "[1s][Program][30s][TXB][1s]"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CONF:DSPF",
          "convention_id": "DWC-Modern",
          "token_name": "CONF",
          "token_pattern": "DSPF",
          "semantic_meaning": "Disney Streaming Platform Format, 1 frame handles in black head and tail.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "DSPF",
            "rule_kind": "code-definition",
            "source_metadata": {
              "notes": "[1f][Program][1f]"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-conf.json",
            "source_key": "DSPF",
            "source_token_name": "definitions",
            "source_metadata": {
              "notes": "[1f][Program][1f]"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CONF:PPO",
          "convention_id": "DWC-Modern",
          "token_name": "CONF",
          "token_pattern": "PPO",
          "semantic_meaning": "Picture to Picture Conformance (no handles), Program only.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "PPO",
            "rule_kind": "code-definition",
            "source_metadata": {
              "notes": "[Program]"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-conf.json",
            "source_key": "PPO",
            "source_token_name": "definitions",
            "source_metadata": {
              "notes": "[Program]"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CONF:DDO",
          "convention_id": "DWC-Modern",
          "token_name": "CONF",
          "token_pattern": "DDO",
          "semantic_meaning": "D Conformance (1s handles) Dub Cards Only.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "DDO",
            "rule_kind": "code-definition",
            "source_metadata": {
              "notes": "[1s][Dub Cards][1s]"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-conf.json",
            "source_key": "DDO",
            "source_token_name": "definitions",
            "source_metadata": {
              "notes": "[1s][Dub Cards][1s]"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CONF:DCO",
          "convention_id": "DWC-Modern",
          "token_name": "CONF",
          "token_pattern": "DCO",
          "semantic_meaning": "Dub Cards Only (no conformance handles in black).",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "DCO",
            "rule_kind": "code-definition",
            "source_metadata": {
              "notes": "[Dub Cards]"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-conf.json",
            "source_key": "DCO",
            "source_token_name": "definitions",
            "source_metadata": {
              "notes": "[Dub Cards]"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CONF:DCB-#",
          "convention_id": "DWC-Modern",
          "token_name": "CONF",
          "token_pattern": "DCB-#",
          "semantic_meaning": "D Conformance (1s handles) Credit Bed Only, modified by two-digit duration suffix. Common values are 30, 60, and 90.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "DCB-#",
            "rule_kind": "code-definition",
            "source_metadata": {
              "notes": "[1s][Credit bed][1s]"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-conf.json",
            "source_key": "DCB-#",
            "source_token_name": "definitions",
            "source_metadata": {
              "notes": "[1s][Credit bed][1s]"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CONF:DAO",
          "convention_id": "DWC-Modern",
          "token_name": "CONF",
          "token_pattern": "DAO",
          "semantic_meaning": "D Conformance (1s handles) Alternate shots Bed Only.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "DAO",
            "rule_kind": "code-definition",
            "source_metadata": {
              "notes": "[1s][ALT][1s]"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-conf.json",
            "source_key": "DAO",
            "source_token_name": "definitions",
            "source_metadata": {
              "notes": "[1s][ALT][1s]"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CONF:LP",
          "convention_id": "DWC-Modern",
          "token_name": "CONF",
          "token_pattern": "LP",
          "semantic_meaning": "Longplay material with unspecified handles.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "LP",
            "rule_kind": "code-definition",
            "source_metadata": {
              "notes": "[Ns][Program][Ns]"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-conf.json",
            "source_key": "LP",
            "source_token_name": "definitions",
            "source_metadata": {
              "notes": "[Ns][Program][Ns]"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CONF:R#",
          "convention_id": "DWC-Modern",
          "token_name": "CONF",
          "token_pattern": "R#",
          "semantic_meaning": "Reels*",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "R#",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-conf.json",
            "source_key": "R#",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CONF:NCA",
          "convention_id": "DWC-Modern",
          "token_name": "CONF",
          "token_pattern": "NCA",
          "semantic_meaning": "Non-Conformed Asset",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "NCA",
            "rule_kind": "code-definition",
            "source_metadata": {
              "notes": "(no set conformance or formatting)"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-conf.json",
            "source_key": "NCA",
            "source_token_name": "definitions",
            "source_metadata": {
              "notes": "(no set conformance or formatting)"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:FPS:23",
          "convention_id": "DWC-Modern",
          "token_name": "FPS",
          "token_pattern": "23",
          "semantic_meaning": "23.98 fps",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "23",
            "rule_kind": "code-definition",
            "source_metadata": {
              "notes": "from 23.976 fps"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-fps.json",
            "source_key": "23",
            "source_token_name": "definitions",
            "source_metadata": {
              "notes": "from 23.976 fps"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:FPS:24",
          "convention_id": "DWC-Modern",
          "token_name": "FPS",
          "token_pattern": "24",
          "semantic_meaning": "24 fps",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "24",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-fps.json",
            "source_key": "24",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:FPS:25",
          "convention_id": "DWC-Modern",
          "token_name": "FPS",
          "token_pattern": "25",
          "semantic_meaning": "25 fps",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "25",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-fps.json",
            "source_key": "25",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:FPS:29",
          "convention_id": "DWC-Modern",
          "token_name": "FPS",
          "token_pattern": "29",
          "semantic_meaning": "29.97 fps",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "29",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-fps.json",
            "source_key": "29",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:FPS:30",
          "convention_id": "DWC-Modern",
          "token_name": "FPS",
          "token_pattern": "30",
          "semantic_meaning": "30 fps",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "30",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-fps.json",
            "source_key": "30",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:FPS:47",
          "convention_id": "DWC-Modern",
          "token_name": "FPS",
          "token_pattern": "47",
          "semantic_meaning": "47.95 fps",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "47",
            "rule_kind": "code-definition",
            "source_metadata": {
              "notes": "from 47.952 fps"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-fps.json",
            "source_key": "47",
            "source_token_name": "definitions",
            "source_metadata": {
              "notes": "from 47.952 fps"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:FPS:48",
          "convention_id": "DWC-Modern",
          "token_name": "FPS",
          "token_pattern": "48",
          "semantic_meaning": "48 fps",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "48",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-fps.json",
            "source_key": "48",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:FPS:50",
          "convention_id": "DWC-Modern",
          "token_name": "FPS",
          "token_pattern": "50",
          "semantic_meaning": "50 fps",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "50",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-fps.json",
            "source_key": "50",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:FPS:59",
          "convention_id": "DWC-Modern",
          "token_name": "FPS",
          "token_pattern": "59",
          "semantic_meaning": "59.94 fps",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "59",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-fps.json",
            "source_key": "59",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:FPS:60",
          "convention_id": "DWC-Modern",
          "token_name": "FPS",
          "token_pattern": "60",
          "semantic_meaning": "60 fps",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "60",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-fps.json",
            "source_key": "60",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:FPS:96",
          "convention_id": "DWC-Modern",
          "token_name": "FPS",
          "token_pattern": "96",
          "semantic_meaning": "96 fps",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "96",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-fps.json",
            "source_key": "96",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:FPS:120",
          "convention_id": "DWC-Modern",
          "token_name": "FPS",
          "token_pattern": "120",
          "semantic_meaning": "120 fps",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "120",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-fps.json",
            "source_key": "120",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CODE-DEFINITIONS-INDEX:VERSION",
          "convention_id": "DWC-Modern",
          "token_name": "CODE-DEFINITIONS-INDEX",
          "token_pattern": "version",
          "semantic_meaning": "1.0.0",
          "constraints": {
            "source_token_name": "code-definitions-index",
            "code_normalized": "VERSION",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-index.json",
            "source_key": "version",
            "source_token_name": "code-definitions-index",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:CODE-DEFINITIONS-INDEX:SOURCE",
          "convention_id": "DWC-Modern",
          "token_name": "CODE-DEFINITIONS-INDEX",
          "token_pattern": "source",
          "semantic_meaning": "Naming Spec Decoder Ring scaffold (split index)",
          "constraints": {
            "source_token_name": "code-definitions-index",
            "code_normalized": "SOURCE",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-index.json",
            "source_key": "source",
            "source_token_name": "code-definitions-index",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:REC:TBD",
          "convention_id": "DWC-Modern",
          "token_name": "REC",
          "token_pattern": "TBD",
          "semantic_meaning": "Record",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "TBD",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-record.json",
            "source_key": "TBD",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:RES:SD",
          "convention_id": "DWC-Modern",
          "token_name": "RES",
          "token_pattern": "SD",
          "semantic_meaning": "Standard Definition video, typically 720x480.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "SD",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "resolution",
              "notes": "NTSC: 720x486, PAL 720x576"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-res-aud-range.json",
            "source_key": "SD",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "resolution",
              "notes": "NTSC: 720x486, PAL 720x576"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:RES:HD",
          "convention_id": "DWC-Modern",
          "token_name": "RES",
          "token_pattern": "HD",
          "semantic_meaning": "High Definition video, typically 1920x1080.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "HD",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "resolution",
              "notes": "This code also covers 1280x720, etc."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-res-aud-range.json",
            "source_key": "HD",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "resolution",
              "notes": "This code also covers 1280x720, etc."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:RES:UHD",
          "convention_id": "DWC-Modern",
          "token_name": "RES",
          "token_pattern": "UHD",
          "semantic_meaning": "Ultra High Definition video, typically 3840x2160.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "UHD",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "resolution"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-res-aud-range.json",
            "source_key": "UHD",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "resolution"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:RES:UHD2",
          "convention_id": "DWC-Modern",
          "token_name": "RES",
          "token_pattern": "UHD2",
          "semantic_meaning": "Ultra High Definition video, typically 7680x4320.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "UHD2",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "resolution"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-res-aud-range.json",
            "source_key": "UHD2",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "resolution"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:RES:2K",
          "convention_id": "DWC-Modern",
          "token_name": "RES",
          "token_pattern": "2K",
          "semantic_meaning": "Generic 2K",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "2K",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "resolution"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-res-aud-range.json",
            "source_key": "2K",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "resolution"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:RES:4K",
          "convention_id": "DWC-Modern",
          "token_name": "RES",
          "token_pattern": "4K",
          "semantic_meaning": "Generic 4K, such as for full aperture scans.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "4K",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "resolution"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-res-aud-range.json",
            "source_key": "4K",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "resolution"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:RANGE:SDR",
          "convention_id": "DWC-Modern",
          "token_name": "RANGE",
          "token_pattern": "SDR",
          "semantic_meaning": "Standard Dynamic Range",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "SDR",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "range"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-res-aud-range.json",
            "source_key": "SDR",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "range"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:RANGE:HDR",
          "convention_id": "DWC-Modern",
          "token_name": "RANGE",
          "token_pattern": "HDR",
          "semantic_meaning": "High Dynamic Range",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "HDR",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "range"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-res-aud-range.json",
            "source_key": "HDR",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "range"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:RANGE:HDRC",
          "convention_id": "DWC-Modern",
          "token_name": "RANGE",
          "token_pattern": "HDRC",
          "semantic_meaning": "High Dynamic Range - Constrained using a target output as a post process.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "HDRC",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "range",
              "notes": "Only used with specific instruction from mastering technology."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-res-aud-range.json",
            "source_key": "HDRC",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "range",
              "notes": "Only used with specific instruction from mastering technology."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:RANGE:EDR",
          "convention_id": "DWC-Modern",
          "token_name": "RANGE",
          "token_pattern": "EDR",
          "semantic_meaning": "Theatrical Extended Dynamic Range up to 108nits.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "EDR",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "range"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-res-aud-range.json",
            "source_key": "EDR",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "range"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:RANGE:LOG",
          "convention_id": "DWC-Modern",
          "token_name": "RANGE",
          "token_pattern": "Log",
          "semantic_meaning": "Logarithmic transform",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "LOG",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "range"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-res-aud-range.json",
            "source_key": "Log",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "range"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:RANGE:LIN",
          "convention_id": "DWC-Modern",
          "token_name": "RANGE",
          "token_pattern": "Lin",
          "semantic_meaning": "Linear transform",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "LIN",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "range"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-res-aud-range.json",
            "source_key": "Lin",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "range"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:RANGE:HDR1",
          "convention_id": "DWC-Modern",
          "token_name": "RANGE",
          "token_pattern": "HDR1",
          "semantic_meaning": "Theatrical Extended Dynamic Range up to 300nits.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "HDR1",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "range"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-res-aud-range.json",
            "source_key": "HDR1",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "range"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:RANGE:TH",
          "convention_id": "DWC-Modern",
          "token_name": "RANGE",
          "token_pattern": "TH",
          "semantic_meaning": "Disney Theatrical",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "TH",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "range",
              "notes": "For Pro Tools Sessions and Supersessions, this is used to designate the widest dynamic range within that session."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-res-aud-range.json",
            "source_key": "TH",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "range",
              "notes": "For Pro Tools Sessions and Supersessions, this is used to designate the widest dynamic range within that session."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:RANGE:NF",
          "convention_id": "DWC-Modern",
          "token_name": "RANGE",
          "token_pattern": "NF",
          "semantic_meaning": "Disney Near-Field",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "NF",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "range",
              "notes": "For Pro Tools Sessions and Supersessions, this is used to designate the widest dynamic range within that session."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-res-aud-range.json",
            "source_key": "NF",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "range",
              "notes": "For Pro Tools Sessions and Supersessions, this is used to designate the widest dynamic range within that session."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:RANGE:A85",
          "convention_id": "DWC-Modern",
          "token_name": "RANGE",
          "token_pattern": "A85",
          "semantic_meaning": "ATSC A/85 loudness limited standard",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "A85",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "range",
              "notes": "For Pro Tools Sessions and Supersessions, this is used to designate the widest dynamic range within that session."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-res-aud-range.json",
            "source_key": "A85",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "range",
              "notes": "For Pro Tools Sessions and Supersessions, this is used to designate the widest dynamic range within that session."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:RANGE:R128",
          "convention_id": "DWC-Modern",
          "token_name": "RANGE",
          "token_pattern": "R128",
          "semantic_meaning": "Disney R128",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "R128",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "range",
              "notes": "For Pro Tools Sessions and Supersessions, this is used to designate the widest dynamic range within that session."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-res-aud-range.json",
            "source_key": "R128",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "range",
              "notes": "For Pro Tools Sessions and Supersessions, this is used to designate the widest dynamic range within that session."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:RANGE:UN",
          "convention_id": "DWC-Modern",
          "token_name": "RANGE",
          "token_pattern": "UN",
          "semantic_meaning": "Undefined",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "UN",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "range",
              "notes": "For Pro Tools Sessions and Supersessions, this is used to designate the widest dynamic range within that session."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-res-aud-range.json",
            "source_key": "UN",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "range",
              "notes": "For Pro Tools Sessions and Supersessions, this is used to designate the widest dynamic range within that session."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:IMFA",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "IMFA",
          "semantic_meaning": "Lossless Archival IMF",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "IMFA",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "image"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "IMFA",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "image"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:IMFA-HT",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "IMFA-HT",
          "semantic_meaning": "Lossless Archival IMF using High Throughput J2K (HT) compression",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "IMFA-HT",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "image"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "IMFA-HT",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "image"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:IMFD",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "IMFD",
          "semantic_meaning": "Lossy Distribution IMF",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "IMFD",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "image"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "IMFD",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "image"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:IMFH",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "IMFH",
          "semantic_meaning": "Lossy Distribution IMF with HULU variant specifications",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "IMFH",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "image"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "IMFH",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "image"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:PROHQ",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "ProHQ",
          "semantic_meaning": "Apple ProRes 422 HQ",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "PROHQ",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "image"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "ProHQ",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "image"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:PROXQ",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "ProXQ",
          "semantic_meaning": "Apple ProRes 4444 XQ",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "PROXQ",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "image"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "ProXQ",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "image"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:PRO4444",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "Pro4444",
          "semantic_meaning": "ProRes 4444",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "PRO4444",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "image"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "Pro4444",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "image"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:PROLT",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "ProLT",
          "semantic_meaning": "Apple ProRes LT",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "PROLT",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "image"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "ProLT",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "image"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:PROPROXY",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "ProProxy",
          "semantic_meaning": "Apple ProRes Proxy",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "PROPROXY",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "image"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "ProProxy",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "image"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:PXYC",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "PXYC",
          "semantic_meaning": "Proxy C (Audio Conform)",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "PXYC",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "image"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "PXYC",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "image"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:PXYD",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "PXYD",
          "semantic_meaning": "Proxy D (Distribution)",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "PXYD",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "image"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "PXYD",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "image"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:PXYR",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "PXYR",
          "semantic_meaning": "Proxy-R; Reel-based proxy, usually with Academy formatting",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "PXYR",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "image"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "PXYR",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "image"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:PRELIM",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "Prelim",
          "semantic_meaning": "Prelim Reference Proxy",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "PRELIM",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "image"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "Prelim",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "image"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:SCRN",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "SCRN",
          "semantic_meaning": "Screener (generic)",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "SCRN",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "image"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "SCRN",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "image"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:SCRN-GSS",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "SCRN-GSS",
          "semantic_meaning": "GSS PIX specialized screener",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "SCRN-GSS",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "image"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "SCRN-GSS",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "image"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:SCAN",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "Scan",
          "semantic_meaning": "Film Scans, usually \"raw\" or original",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "SCAN",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "image"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "Scan",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "image"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:SCAN-NCC",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "Scan-NCC",
          "semantic_meaning": "Film Scans, cleaned but not color corrected",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "SCAN-NCC",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "image"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "Scan-NCC",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "image"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:SCAN-DRS",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "Scan-DRS",
          "semantic_meaning": "Film Scans, DRS only",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "SCAN-DRS",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "image"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "Scan-DRS",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "image"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:SCAN-ACES",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "Scan-ACES",
          "semantic_meaning": "Film Scans, ACES encoded",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "SCAN-ACES",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "image"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "Scan-ACES",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "image"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:ISM",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "ISM",
          "semantic_meaning": "Image Sequence Master (TIFF, EXR or DPX)",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "ISM",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "image"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "ISM",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "image"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:EPS",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "EPS",
          "semantic_meaning": "EPS vector image format",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "EPS",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "image"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "EPS",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "image"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:PNG",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "PNG",
          "semantic_meaning": "PNG image format",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "PNG",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "image"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "PNG",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "image"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:WAV",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "WAV",
          "semantic_meaning": "WAV audio format",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "WAV",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "WAV",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:ADMBWF",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "ADMBWF",
          "semantic_meaning": "ADM BWAV audio format",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "ADMBWF",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "ADMBWF",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:DAMF",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "DAMF",
          "semantic_meaning": "Home Atmos Printmaster (Dolby Atmos Master Format)",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "DAMF",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "DAMF",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:RMU",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "RMU",
          "semantic_meaning": "Theatrical Atmos Printmaster; in Dolby terminology this stands for Rendering and Mastering Unit",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "RMU",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "RMU",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:EAC3",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "EAC3",
          "semantic_meaning": "Dolby EAC-3 encoded bitstream",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "EAC3",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "EAC3",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:PT",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "PT",
          "semantic_meaning": "Standalone Pro Tools Session",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "PT",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "PT",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:SS",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "SS",
          "semantic_meaning": "Multi-Element Pro Tools Supersession",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "SS",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "SS",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:MIX",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "MIX",
          "semantic_meaning": "Pro Tools Mix Session",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "MIX",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "MIX",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:TMPL-LAN",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "TMPL-LAN",
          "semantic_meaning": "Language Mix Template",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "TMPL-LAN",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "TMPL-LAN",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:TMPL-PMR",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "TMPL-PMR",
          "semantic_meaning": "Printmaster Record Mix Template",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "TMPL-PMR",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "TMPL-PMR",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:SCC",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "SCC",
          "semantic_meaning": "SCC formatted Closed Captions",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "SCC",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "text"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "SCC",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "text"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:CAP",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "CAP",
          "semantic_meaning": "CAP formatted Closed Captions",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "CAP",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "text"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "CAP",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "text"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:IMSC",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "IMSC",
          "semantic_meaning": "IMSC formattedSubtitles",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "IMSC",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "text"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "IMSC",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "text"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:SRT",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "SRT",
          "semantic_meaning": "SRT formatted Subtitles",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "SRT",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "text"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "SRT",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "text"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:STL",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "STL",
          "semantic_meaning": "EBU-STL formattedSubtitles",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "STL",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "text"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "STL",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "text"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:DOVI10",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "DoVi10",
          "semantic_meaning": "Dolby Vision v2.9 10-bit 422 XML",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "DOVI10",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "metadata"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "DoVi10",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "metadata"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:DOVI12",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "DoVi12",
          "semantic_meaning": "Dolby Vision v2.9 12-bit 444 XML",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "DOVI12",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "metadata"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "DoVi12",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "metadata"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:DOVI16",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "DoVi16",
          "semantic_meaning": "Dolby Vision v2.9 16-bit 444 XML",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "DOVI16",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "metadata"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "DoVi16",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "metadata"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:DOVI40",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "DoVi40",
          "semantic_meaning": "Dolby Vision v4.0 XML (the v4.0 DoVi spec excludes the track bit depth)",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "DOVI40",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "metadata"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "DoVi40",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "metadata"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:ADR",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "ADR",
          "semantic_meaning": "Automated Dialog Replacement",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "ADR",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "ADR",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:BG",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "BG",
          "semantic_meaning": "Background Stem",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "BG",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "BG",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:COMP",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "COMP",
          "semantic_meaning": "Composite Atmos Bed",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "COMP",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio",
              "notes": "While multiple Atmos beds are allowed, there can only be a single composite bed"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "COMP",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio",
              "notes": "While multiple Atmos beds are allowed, there can only be a single composite bed"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:DIA",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "DIA",
          "semantic_meaning": "Dialogue Stem",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "DIA",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "DIA",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:FSS",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "FSS",
          "semantic_meaning": "Foreign Pro Tools Supersession",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "FSS",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "FSS",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:FOL",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "FOL",
          "semantic_meaning": "Foley Stem",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "FOL",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "FOL",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:FX",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "FX",
          "semantic_meaning": "Effects Stem",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "FX",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "FX",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:GRP",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "GRP",
          "semantic_meaning": "Group Stem",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "GRP",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "GRP",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:MFX",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "MFX",
          "semantic_meaning": "Music and Effects",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "MFX",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "MFX",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:MMN",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "MMN",
          "semantic_meaning": "Mix Minus Narration",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "MMN",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "MMN",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:MUS",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "MUS",
          "semantic_meaning": "Music Stem",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "MUS",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "MUS",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:OPT",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "OPT",
          "semantic_meaning": "Optional",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "OPT",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio",
              "notes": "If there is only a single Optional group, only OPT is needed. If there are multiple Optional groups, include a letter after OPT (OPTA, OPTB, etc.) to indicate the Optional group"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "OPT",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio",
              "notes": "If there is only a single Optional group, only OPT is needed. If there are multiple Optional groups, include a letter after OPT (OPTA, OPTB, etc.) to indicate the Optional group"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:PD",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "PD",
          "semantic_meaning": "Grouping of PreDubs",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "PD",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "PD",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:PDDIA",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "PDDIA",
          "semantic_meaning": "PreDub Dialogue",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "PDDIA",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "PDDIA",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:PDFX",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "PDFX",
          "semantic_meaning": "PreDub Effects",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "PDFX",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "PDFX",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:PDMUS",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "PDMUS",
          "semantic_meaning": "PreDub Music",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "PDMUS",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "PDMUS",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:PM",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "PM",
          "semantic_meaning": "Printmaster (full mix)",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "PM",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "PM",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:STEM",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "STEM",
          "semantic_meaning": "Grouping of Stems Session",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "STEM",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "STEM",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:VOC",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "VOC",
          "semantic_meaning": "Vocal Stem",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "VOC",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "VOC",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:AD",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "AD",
          "semantic_meaning": "Audio Description",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "AD",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "AD",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:HI",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "HI",
          "semantic_meaning": "Hearing Impaired",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "HI",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "HI",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:PC",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "PC",
          "semantic_meaning": "Pitch Corrected",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "PC",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "PC",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:RAW",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "RAW",
          "semantic_meaning": "Restoration - Raw Unrestored Transfer",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "RAW",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "image"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "RAW",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "image"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:RES",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "RES",
          "semantic_meaning": "Restoration - Restored (cleaned) audio",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "RES",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "RES",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:DME",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "DME",
          "semantic_meaning": "Crashdown of wider stems for DME component, only in an SS-STEM when wide stem plus DME are delivered.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "DME",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often used in GE SS-STEM delivery which contains wider stems as well as DME."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "DME",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often used in GE SS-STEM delivery which contains wider stems as well as DME."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:DIA-DME",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "DIA-DME",
          "semantic_meaning": "Dialogue Component of DME contains all material found in wide DIA stem delivery.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "DIA-DME",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often used in GE SS-STEM delivery which contains wider stems as well as DME."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "DIA-DME",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often used in GE SS-STEM delivery which contains wider stems as well as DME."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:FX-DME",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "FX-DME",
          "semantic_meaning": "Effects Component of DME contains all material found in wide FX stem delivery.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "FX-DME",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often used in GE SS-STEM delivery which contains wider stems as well as DME."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "FX-DME",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often used in GE SS-STEM delivery which contains wider stems as well as DME."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:MUS-DME",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "MUS-DME",
          "semantic_meaning": "Music Component of DME contains all material found in wide Music stem delivery.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "MUS-DME",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often used in GE SS-STEM delivery which contains wider stems as well as DME."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "MUS-DME",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often used in GE SS-STEM delivery which contains wider stems as well as DME."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:ARC",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "ARC",
          "semantic_meaning": "Archival; old radio and TV footage",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "ARC",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often found in WAV files within a deliverable, not in folder names."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "ARC",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often found in WAV files within a deliverable, not in folder names."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:AUD",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "AUD",
          "semantic_meaning": "Audience",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "AUD",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often found in WAV files within a deliverable, not in folder names."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "AUD",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often found in WAV files within a deliverable, not in folder names."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:CRD",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "CRD",
          "semantic_meaning": "Crowd",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "CRD",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often found in WAV files within a deliverable, not in folder names."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "CRD",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often found in WAV files within a deliverable, not in folder names."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:FFX",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "FFX",
          "semantic_meaning": "Filled Effects Stem (Full or Partially Filled).",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "FFX",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often found in WAV files within a deliverable, not in folder names."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "FFX",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often found in WAV files within a deliverable, not in folder names."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:FGN",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "FGN",
          "semantic_meaning": "Foreign - used outside the primary language designation.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "FGN",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often found in WAV files within a deliverable, not in folder names."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "FGN",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often found in WAV files within a deliverable, not in folder names."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:GRP (LANG)",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "GRP (lang)",
          "semantic_meaning": "Group of stems specific to a given language. Examples: GRPENG, GRPJPN, or GRPFOR.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "GRP (LANG)",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often found in WAV files within a deliverable, not in folder names."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "GRP (lang)",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often found in WAV files within a deliverable, not in folder names."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:LAF",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "LAF",
          "semantic_meaning": "Laugh Tracks (also written as \"LAFF\" or LAFFS\" in some deliveries).",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "LAF",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often found in WAV files within a deliverable, not in folder names."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "LAF",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often found in WAV files within a deliverable, not in folder names."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:MDE",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "MDE",
          "semantic_meaning": "Mix minus narration",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "MDE",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often found in WAV files within a deliverable, not in folder names."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "MDE",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often found in WAV files within a deliverable, not in folder names."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:NAR",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "NAR",
          "semantic_meaning": "Narration",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "NAR",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often found in WAV files within a deliverable, not in folder names."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "NAR",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often found in WAV files within a deliverable, not in folder names."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:PFX",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "PFX",
          "semantic_meaning": "Production Effects - sound effects recorded on set and part of dailies. A Dialog editor will split them into a PFX track in their DIA units as they cut a reel. Examples are footsteps on set, knife to plate, etc.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "PFX",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often found in WAV files within a deliverable, not in folder names."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "PFX",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often found in WAV files within a deliverable, not in folder names."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:SFX",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "SFX",
          "semantic_meaning": "Sound Effects; added in Editorial and/or Mixing.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "SFX",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often found in WAV files within a deliverable, not in folder names."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "SFX",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often found in WAV files within a deliverable, not in folder names."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:SOT",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "SOT",
          "semantic_meaning": "Sound on Tape",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "SOT",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often found in WAV files within a deliverable, not in folder names."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "SOT",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often found in WAV files within a deliverable, not in folder names."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:VO",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "VO",
          "semantic_meaning": "Voiceover",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "VO",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often found in WAV files within a deliverable, not in folder names."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "VO",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often found in WAV files within a deliverable, not in folder names."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:SPEC:WAL",
          "convention_id": "DWC-Modern",
          "token_name": "SPEC",
          "token_pattern": "WAL",
          "semantic_meaning": "Walla",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "WAL",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often found in WAV files within a deliverable, not in folder names."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-spec.json",
            "source_key": "WAL",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "audio",
              "notes": "Most often found in WAV files within a deliverable, not in folder names."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TEXL:ZXX",
          "convention_id": "DWC-Modern",
          "token_name": "TEXL",
          "token_pattern": "ZXX",
          "semantic_meaning": "No Linguistic Content (e.g. textless bed or fully textless). In Audio-only deliveries, this code designates material which contains no discernible language.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "ZXX",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "texl"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-texl-iar.json",
            "source_key": "ZXX",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "texl"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TEXL:STX",
          "convention_id": "DWC-Modern",
          "token_name": "TEXL",
          "token_pattern": "STX",
          "semantic_meaning": "Semi-Textless. Program contains some textless inserts for simplified distribution.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "STX",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "texl"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-texl-iar.json",
            "source_key": "STX",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "texl"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TEXL:QAL",
          "convention_id": "DWC-Modern",
          "token_name": "TEXL",
          "token_pattern": "QAL",
          "semantic_meaning": "Qualified for All Languages (e.g. Music & Effects).",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "QAL",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "texl"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-texl-iar.json",
            "source_key": "QAL",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "texl"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TEXL:MOS",
          "convention_id": "DWC-Modern",
          "token_name": "TEXL",
          "token_pattern": "MOS",
          "semantic_meaning": "Mute of sound. May indicate included silent tracks, or no audio at all. Superseded by ZXX but still in common use.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "MOS",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "texl"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-texl-iar.json",
            "source_key": "MOS",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "texl"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:IAR:ALL",
          "convention_id": "DWC-Modern",
          "token_name": "IAR",
          "token_pattern": "ALL",
          "semantic_meaning": "Any IAR",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "ALL",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "iar"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-texl-iar.json",
            "source_key": "ALL",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "iar"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:IAR:119",
          "convention_id": "DWC-Modern",
          "token_name": "IAR",
          "token_pattern": "119",
          "semantic_meaning": "1.19 Aspect Ratio",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "119",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "iar"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-texl-iar.json",
            "source_key": "119",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "iar"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:IAR:120",
          "convention_id": "DWC-Modern",
          "token_name": "IAR",
          "token_pattern": "120",
          "semantic_meaning": "1.2 Aspect Ratio",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "120",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "iar"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-texl-iar.json",
            "source_key": "120",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "iar"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:IAR:132",
          "convention_id": "DWC-Modern",
          "token_name": "IAR",
          "token_pattern": "132",
          "semantic_meaning": "1.32 (full ap) Aspect Ratio",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "132",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "iar",
              "notes": "Film Scans or some digital camera files may append this field with \"-FA\" to represent \"full aperture\"."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-texl-iar.json",
            "source_key": "132",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "iar",
              "notes": "Film Scans or some digital camera files may append this field with \"-FA\" to represent \"full aperture\"."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:IAR:133",
          "convention_id": "DWC-Modern",
          "token_name": "IAR",
          "token_pattern": "133",
          "semantic_meaning": "1.33 Aspect Ratio",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "133",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "iar"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-texl-iar.json",
            "source_key": "133",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "iar"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:IAR:137",
          "convention_id": "DWC-Modern",
          "token_name": "IAR",
          "token_pattern": "137",
          "semantic_meaning": "1.37 Aspect Ratio",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "137",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "iar"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-texl-iar.json",
            "source_key": "137",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "iar"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:IAR:166",
          "convention_id": "DWC-Modern",
          "token_name": "IAR",
          "token_pattern": "166",
          "semantic_meaning": "1.66 Aspect Ratio",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "166",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "iar"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-texl-iar.json",
            "source_key": "166",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "iar"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:IAR:175",
          "convention_id": "DWC-Modern",
          "token_name": "IAR",
          "token_pattern": "175",
          "semantic_meaning": "1.75 Aspect Ratio",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "175",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "iar"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-texl-iar.json",
            "source_key": "175",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "iar"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:IAR:178",
          "convention_id": "DWC-Modern",
          "token_name": "IAR",
          "token_pattern": "178",
          "semantic_meaning": "1.78 Aspect Ratio",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "178",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "iar"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-texl-iar.json",
            "source_key": "178",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "iar"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:IAR:185",
          "convention_id": "DWC-Modern",
          "token_name": "IAR",
          "token_pattern": "185",
          "semantic_meaning": "1.85 Aspect Ratio",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "185",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "iar"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-texl-iar.json",
            "source_key": "185",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "iar"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:IAR:190",
          "convention_id": "DWC-Modern",
          "token_name": "IAR",
          "token_pattern": "190",
          "semantic_meaning": "1.9 Aspect Ratio",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "190",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "iar"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-texl-iar.json",
            "source_key": "190",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "iar"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:IAR:200",
          "convention_id": "DWC-Modern",
          "token_name": "IAR",
          "token_pattern": "200",
          "semantic_meaning": "2 Aspect Ratio",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "200",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "iar"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-texl-iar.json",
            "source_key": "200",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "iar"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:IAR:210",
          "convention_id": "DWC-Modern",
          "token_name": "IAR",
          "token_pattern": "210",
          "semantic_meaning": "2.1 Aspect Ratio",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "210",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "iar"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-texl-iar.json",
            "source_key": "210",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "iar"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:IAR:220",
          "convention_id": "DWC-Modern",
          "token_name": "IAR",
          "token_pattern": "220",
          "semantic_meaning": "2.2 Aspect Ratio",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "220",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "iar"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-texl-iar.json",
            "source_key": "220",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "iar"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:IAR:221",
          "convention_id": "DWC-Modern",
          "token_name": "IAR",
          "token_pattern": "221",
          "semantic_meaning": "2.21 Aspect Ratio",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "221",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "iar"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-texl-iar.json",
            "source_key": "221",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "iar"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:IAR:224",
          "convention_id": "DWC-Modern",
          "token_name": "IAR",
          "token_pattern": "224",
          "semantic_meaning": "2.24 Aspect Ratio",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "224",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "iar"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-texl-iar.json",
            "source_key": "224",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "iar"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:IAR:229",
          "convention_id": "DWC-Modern",
          "token_name": "IAR",
          "token_pattern": "229",
          "semantic_meaning": "2.29 Aspect Ratio",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "229",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "iar"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-texl-iar.json",
            "source_key": "229",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "iar"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:IAR:235",
          "convention_id": "DWC-Modern",
          "token_name": "IAR",
          "token_pattern": "235",
          "semantic_meaning": "2.35 Aspect Ratio",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "235",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "iar"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-texl-iar.json",
            "source_key": "235",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "iar"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:IAR:239",
          "convention_id": "DWC-Modern",
          "token_name": "IAR",
          "token_pattern": "239",
          "semantic_meaning": "2.39 Aspect Ratio",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "239",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "iar"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-texl-iar.json",
            "source_key": "239",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "iar"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:IAR:240",
          "convention_id": "DWC-Modern",
          "token_name": "IAR",
          "token_pattern": "240",
          "semantic_meaning": "2.4 Aspect Ratio",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "240",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "iar"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-texl-iar.json",
            "source_key": "240",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "iar"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:IAR:255",
          "convention_id": "DWC-Modern",
          "token_name": "IAR",
          "token_pattern": "255",
          "semantic_meaning": "2.55 Aspect Ratio",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "255",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "iar"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-texl-iar.json",
            "source_key": "255",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "iar"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:IAR:276",
          "convention_id": "DWC-Modern",
          "token_name": "IAR",
          "token_pattern": "276",
          "semantic_meaning": "2.76 Aspect Ratio",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "276",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "iar"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-texl-iar.json",
            "source_key": "276",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "iar"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:IAR:296",
          "convention_id": "DWC-Modern",
          "token_name": "IAR",
          "token_pattern": "296",
          "semantic_meaning": "2.96 Aspect Ratio",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "296",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "iar"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-texl-iar.json",
            "source_key": "296",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "iar"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:IAR:FA",
          "convention_id": "DWC-Modern",
          "token_name": "IAR",
          "token_pattern": "FA",
          "semantic_meaning": "Full Aperture",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "FA",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "iar",
              "notes": "IAR subdescriptor suffix. May be appended to an IAR code (for example 132-FA) to indicate full aperture."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-texl-iar.json",
            "source_key": "FA",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "iar",
              "notes": "IAR subdescriptor suffix. May be appended to an IAR code (for example 132-FA) to indicate full aperture."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TITLE:TBD",
          "convention_id": "DWC-Modern",
          "token_name": "TITLE",
          "token_pattern": "TBD",
          "semantic_meaning": "Title",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "TBD",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-title.json",
            "source_key": "TBD",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TTL:STX",
          "convention_id": "DWC-Modern",
          "token_name": "TTL",
          "token_pattern": "STX",
          "semantic_meaning": "Semi-Textless. Program contains some textless inserts for simplified distribution.",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "STX",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "ttl"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-ttl-type.json",
            "source_key": "STX",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "ttl"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TYPE:CC",
          "convention_id": "DWC-Modern",
          "token_name": "TYPE",
          "token_pattern": "CC",
          "semantic_meaning": "Closed Captioning Timed Text",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "CC",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "type"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-ttl-type.json",
            "source_key": "CC",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "type"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TYPE:SDH",
          "convention_id": "DWC-Modern",
          "token_name": "TYPE",
          "token_pattern": "SDH",
          "semantic_meaning": "Subtitles for the Deaf and Hard of Hearing Timed Text",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "SDH",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "type"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-ttl-type.json",
            "source_key": "SDH",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "type"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TYPE:FULL",
          "convention_id": "DWC-Modern",
          "token_name": "TYPE",
          "token_pattern": "FULL",
          "semantic_meaning": "Full Subtitles Timed Text",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "FULL",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "type"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-ttl-type.json",
            "source_key": "FULL",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "type"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TYPE:FRCD",
          "convention_id": "DWC-Modern",
          "token_name": "TYPE",
          "token_pattern": "FRCD",
          "semantic_meaning": "Forced Subtitles Timed Text",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "FRCD",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "type"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-ttl-type.json",
            "source_key": "FRCD",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "type"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TYPE:BURN",
          "convention_id": "DWC-Modern",
          "token_name": "TYPE",
          "token_pattern": "BURN",
          "semantic_meaning": "Full Subtitles burned into picture",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "BURN",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "type"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-ttl-type.json",
            "source_key": "BURN",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "type"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TYPE:TMPLFL",
          "convention_id": "DWC-Modern",
          "token_name": "TYPE",
          "token_pattern": "TMPLFL",
          "semantic_meaning": "Language Template Full Subtitle",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "TMPLFL",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "type"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-ttl-type.json",
            "source_key": "TMPLFL",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "type"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TYPE:TMPLFR",
          "convention_id": "DWC-Modern",
          "token_name": "TYPE",
          "token_pattern": "TMPLFR",
          "semantic_meaning": "Language Template Forced Narrative",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "TMPLFR",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "type"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-ttl-type.json",
            "source_key": "TMPLFR",
            "source_token_name": "definitions",
            "source_metadata": {
              "format": "type"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TYPE:FP",
          "convention_id": "DWC-Modern",
          "token_name": "TYPE",
          "token_pattern": "FP",
          "semantic_meaning": "Full Program",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "FP",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-type.json",
            "source_key": "FP",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TYPE:TB",
          "convention_id": "DWC-Modern",
          "token_name": "TYPE",
          "token_pattern": "TB",
          "semantic_meaning": "Textless Bed",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "TB",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-type.json",
            "source_key": "TB",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TYPE:DC",
          "convention_id": "DWC-Modern",
          "token_name": "TYPE",
          "token_pattern": "DC",
          "semantic_meaning": "Dub Card Sequence",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "DC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-type.json",
            "source_key": "DC",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TYPE:TR",
          "convention_id": "DWC-Modern",
          "token_name": "TYPE",
          "token_pattern": "TR",
          "semantic_meaning": "Trailer",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "TR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-type.json",
            "source_key": "TR",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TYPE:RC",
          "convention_id": "DWC-Modern",
          "token_name": "TYPE",
          "token_pattern": "RC",
          "semantic_meaning": "Recap",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "RC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-type.json",
            "source_key": "RC",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TYPE:NO",
          "convention_id": "DWC-Modern",
          "token_name": "TYPE",
          "token_pattern": "NO",
          "semantic_meaning": "Next On",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "NO",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-type.json",
            "source_key": "NO",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TYPE:CB",
          "convention_id": "DWC-Modern",
          "token_name": "TYPE",
          "token_pattern": "CB",
          "semantic_meaning": "Credit Bed",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "CB",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-type.json",
            "source_key": "CB",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TYPE:AB",
          "convention_id": "DWC-Modern",
          "token_name": "TYPE",
          "token_pattern": "AB",
          "semantic_meaning": "Alternate Shots Bed",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "AB",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-type.json",
            "source_key": "AB",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TYPE:PR",
          "convention_id": "DWC-Modern",
          "token_name": "TYPE",
          "token_pattern": "PR",
          "semantic_meaning": "Promo",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "PR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-type.json",
            "source_key": "PR",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TYPE:VM",
          "convention_id": "DWC-Modern",
          "token_name": "TYPE",
          "token_pattern": "VM",
          "semantic_meaning": "VAM or Bonus material",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "VM",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-type.json",
            "source_key": "VM",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TYPE:CP",
          "convention_id": "DWC-Modern",
          "token_name": "TYPE",
          "token_pattern": "CP",
          "semantic_meaning": "Clip",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "CP",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-type.json",
            "source_key": "CP",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:TYPE:SP",
          "convention_id": "DWC-Modern",
          "token_name": "TYPE",
          "token_pattern": "SP",
          "semantic_meaning": "TV Spot",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "SP",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-type.json",
            "source_key": "SP",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:VID:TBD",
          "convention_id": "DWC-Modern",
          "token_name": "VID",
          "token_pattern": "TBD",
          "semantic_meaning": "Version ID",
          "constraints": {
            "source_token_name": "definitions",
            "code_normalized": "TBD",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/code-definitions-vid.json",
            "source_key": "TBD",
            "source_token_name": "definitions",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:MANIFEST:REPOURL",
          "convention_id": "DWC-Modern",
          "token_name": "MANIFEST",
          "token_pattern": "repoUrl",
          "semantic_meaning": "https://gitlab.disney.com/Mike.Krause/naming-spec-decoder-ring",
          "constraints": {
            "source_token_name": "manifest",
            "code_normalized": "REPOURL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/manifest.json",
            "source_key": "repoUrl",
            "source_token_name": "manifest",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:MANIFEST:REF",
          "convention_id": "DWC-Modern",
          "token_name": "MANIFEST",
          "token_pattern": "ref",
          "semantic_meaning": "main",
          "constraints": {
            "source_token_name": "manifest",
            "code_normalized": "REF",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/manifest.json",
            "source_key": "ref",
            "source_token_name": "manifest",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:MANIFEST:SOURCEDIR",
          "convention_id": "DWC-Modern",
          "token_name": "MANIFEST",
          "token_pattern": "sourceDir",
          "semantic_meaning": "data/code-definitions",
          "constraints": {
            "source_token_name": "manifest",
            "code_normalized": "SOURCEDIR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/manifest.json",
            "source_key": "sourceDir",
            "source_token_name": "manifest",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        },
        {
          "rule_id": "DWC-Modern:MANIFEST:IMPORTEDAT",
          "convention_id": "DWC-Modern",
          "token_name": "MANIFEST",
          "token_pattern": "importedAt",
          "semantic_meaning": "2026-06-27T00:00:03Z",
          "constraints": {
            "source_token_name": "manifest",
            "code_normalized": "IMPORTEDAT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/dwc-modern/manifest.json",
            "source_key": "importedAt",
            "source_token_name": "manifest",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T21:32:43.487Z",
          "updated_at": "2026-07-17T21:32:43.487Z"
        }
      ]
    },
    "./data/conventions/wmls/rules.draft.json": {
      "conventionId": "WMLS",
      "maskSpec": {
        "id": "WMLS-folder",
        "name": "WMLS Folder Mask",
        "role": "folder",
        "mask": "TITLE_Version_ProductType_FileType_FileInfo_AspectRatio_AUD-TXT_WMLS##",
        "mainDelimiter": "_",
        "subDelimiter": "-",
        "informationalTokens": [
          "TITLE"
        ]
      },
      "maskSpecs": [
        {
          "id": "WMLS-folder",
          "name": "WMLS Folder Mask",
          "role": "folder",
          "mask": "TITLE_Version_ProductType_FileType_FileInfo_AspectRatio_AUD-TXT_WMLS##",
          "mainDelimiter": "_",
          "subDelimiter": "-",
          "informationalTokens": [
            "TITLE"
          ]
        },
        {
          "id": "WMLS-files",
          "name": "WMLS File Mask",
          "role": "file",
          "mask": "TITLE_Version_FileType_FileInfo_AspectRatio_AUD-TXT_WMLS##.EXT",
          "mainDelimiter": "_",
          "subDelimiter": "-",
          "informationalTokens": [
            "TITLE"
          ]
        },
        {
          "id": "WMLS-folder-audsub",
          "name": "WMLS Folder Mask (Audio Only)",
          "role": "folder",
          "mask": "TITLE_Version_ProductType_FileType_FileInfo_AUD_WMLS##",
          "mainDelimiter": "_",
          "subDelimiter": "-",
          "informationalTokens": [
            "TITLE"
          ],
          "tokenPolicies": {
            "FILETYPE": {
              "tokenName": "FILETYPE",
              "segmentMask": "FILETYPE",
              "allowedValues": [
                "DPX-A",
                "EXR-A",
                "IMF-A",
                "QT-A",
                "TIF-A"
              ],
              "allowLanguageCodes": false
            },
            "FILEINFO": {
              "tokenName": "FILEINFO",
              "segmentMask": "FILEINFO",
              "required": true,
              "format": {
                "regex": "^\\d{2,4}(?:NDF|DF)?$",
                "message": "Audio-only mask expects FILEINFO to contain frame-rate code only."
              }
            }
          }
        },
        {
          "id": "WMLS-files-audsub",
          "name": "WMLS File Mask (Audio Only)",
          "role": "file",
          "mask": "TITLE_Version_FileType_FileInfo_AUD_WMLS##",
          "mainDelimiter": "_",
          "subDelimiter": "-",
          "informationalTokens": [
            "TITLE"
          ],
          "tokenPolicies": {
            "FILETYPE": {
              "tokenName": "FILETYPE",
              "segmentMask": "FILETYPE",
              "allowedValues": [
                "DPX-A",
                "EXR-A",
                "IMF-A",
                "QT-A",
                "TIF-A"
              ],
              "allowLanguageCodes": false
            },
            "FILEINFO": {
              "tokenName": "FILEINFO",
              "segmentMask": "FILEINFO",
              "required": true,
              "format": {
                "regex": "^\\d{2,4}(?:NDF|DF)?$",
                "message": "Audio-only mask expects FILEINFO to contain frame-rate code only."
              }
            }
          }
        },
        {
          "id": "WMLS-folder-subcap",
          "name": "WMLS Folder Mask (Subtitle/Caption)",
          "role": "folder",
          "mask": "TITLE_Version_ProductType_FileType_FileInfo_TXT_WMLS##",
          "mainDelimiter": "_",
          "subDelimiter": "-",
          "informationalTokens": [
            "TITLE"
          ],
          "tokenPolicies": {
            "FILETYPE": {
              "tokenName": "FILETYPE",
              "segmentMask": "FILETYPE",
              "allowedValues": [
                "CC",
                "SDH"
              ],
              "allowLanguageCodes": false
            },
            "FILEINFO": {
              "tokenName": "FILEINFO",
              "segmentMask": "FILEINFO",
              "required": true,
              "format": {
                "regex": "^\\d{2,4}(?:NDF|DF)?$",
                "message": "Subtitle/caption mask expects FILEINFO to contain frame-rate code only."
              }
            }
          }
        },
        {
          "id": "WMLS-files-subcap",
          "name": "WMLS File Mask (Subtitle/Caption)",
          "role": "file",
          "mask": "TITLE_Version_FileType_FileInfo_TXT_WMLS##.EXT",
          "mainDelimiter": "_",
          "subDelimiter": "-",
          "informationalTokens": [
            "TITLE"
          ],
          "tokenPolicies": {
            "FILETYPE": {
              "tokenName": "FILETYPE",
              "segmentMask": "FILETYPE",
              "allowedValues": [
                "CC",
                "SDH"
              ],
              "allowLanguageCodes": false
            },
            "FILEINFO": {
              "tokenName": "FILEINFO",
              "segmentMask": "FILEINFO",
              "required": true,
              "format": {
                "regex": "^\\d{2,4}(?:NDF|DF)?$",
                "message": "Subtitle/caption mask expects FILEINFO to contain frame-rate code only."
              }
            }
          }
        },
        {
          "id": "WMLS-files-audio-master",
          "name": "WMLS File Mask (Audio Master)",
          "role": "file",
          "mask": "TITLE_Version_Language_FrameRate_ElementType_Reel#_WMLS#.EXT",
          "mainDelimiter": "_",
          "subDelimiter": "-",
          "informationalTokens": [
            "TITLE"
          ],
          "tokenPolicies": {
            "FRAMERATE": {
              "tokenName": "FRAMERATE",
              "segmentMask": "FRAMERATE",
              "required": true,
              "format": {
                "regex": "^\\d{2,4}(?:NDF|DF)?$",
                "message": "Audio-master mask expects FrameRate to be a FILEINFO frame-rate code."
              }
            }
          }
        }
      ],
      "matchThreshold": 0.35,
      "version": 1,
      "status": "draft",
      "generatedAt": "2026-07-20T17:32:24.601Z",
      "ruleCount": 198,
      "rules": [
        {
          "rule_id": "WMLS:ELEMENTTYPE:DPA",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "DPA",
          "semantic_meaning": "Dialogue PreDubs",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "DPA",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "predub"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "DPA",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "predub"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:FXPA",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "FXPA",
          "semantic_meaning": "Effect PreDubs",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "FXPA",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "predub"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "FXPA",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "predub"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:CRDPA",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "CRDPA",
          "semantic_meaning": "Crowd PreDubs",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "CRDPA",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "predub"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "CRDPA",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "predub"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:FOLPA",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "FOLPA",
          "semantic_meaning": "Foley PreDubs",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "FOLPA",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "predub"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "FOLPA",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "predub"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:BGPA",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "BGPA",
          "semantic_meaning": "Background PreDubs",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "BGPA",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "predub"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "BGPA",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "predub"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:GRPA",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "GRPA",
          "semantic_meaning": "Group PreDubs",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "GRPA",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "predub"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "GRPA",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "predub"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:DIA",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "DIA",
          "semantic_meaning": "Dialogue Stems",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "DIA",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "stems"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "DIA",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "stems"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:MUS",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "MUS",
          "semantic_meaning": "Music Stems",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "MUS",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "stems"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "MUS",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "stems"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:FX",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "FX",
          "semantic_meaning": "Effects Stems",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "FX",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "stems"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "FX",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "stems"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:VOC",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "VOC",
          "semantic_meaning": "Vocal Stems",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "VOC",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "stems"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "VOC",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "stems"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:CHR",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "CHR",
          "semantic_meaning": "Chorus Stems",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "CHR",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "stems"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "CHR",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "stems"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:AUD",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "AUD",
          "semantic_meaning": "Audience Stems (TV)",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "AUD",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "stems"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "AUD",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "stems"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:LAF",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "LAF",
          "semantic_meaning": "Laugh Stems (TV)",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "LAF",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "stems"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "LAF",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "stems"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:CRD",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "CRD",
          "semantic_meaning": "Crowd Stems (Theatrical)",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "CRD",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "stems"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "CRD",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "stems"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:FOL",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "FOL",
          "semantic_meaning": "Foley Stems",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "FOL",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "stems"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "FOL",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "stems"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:BG",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "BG",
          "semantic_meaning": "Background Stems",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "BG",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "stems"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "BG",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "stems"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:GR",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "GR",
          "semantic_meaning": "Group Stems",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "GR",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "stems"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "GR",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "stems"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:AA",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "AA",
          "semantic_meaning": "Extra / Additional Stems",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "AA",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "stems",
              "notes": "AA baseline; AB-AZ are additional stem variants",
              "matchPattern": "A[A-Z]",
              "pattern": "A[A-Z]"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "AA",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "stems",
              "notes": "AA baseline; AB-AZ are additional stem variants",
              "matchPattern": "A[A-Z]",
              "pattern": "A[A-Z]"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:OPT",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "OPT",
          "semantic_meaning": "Optional Stems",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "OPT",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "stems",
              "notes": "OPT baseline; OPT1-OPT9 and higher indicate numbered optional stem variants",
              "matchPattern": "OPT[0-9]*",
              "pattern": "OPT[0-9]*"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "OPT",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "stems",
              "notes": "OPT baseline; OPT1-OPT9 and higher indicate numbered optional stem variants",
              "matchPattern": "OPT[0-9]*",
              "pattern": "OPT[0-9]*"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:MFX",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "MFX",
          "semantic_meaning": "Music & Effects",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "MFX",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "musefx"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "MFX",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "musefx"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:PM",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "PM",
          "semantic_meaning": "Printmaster",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "PM",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "printmasters"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "PM",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "printmasters"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:DC",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "DC",
          "semantic_meaning": "Digital Cinema",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "DC",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "printmasters"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "DC",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "printmasters"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:PM_STACK_CC",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "PM_STACK_CC",
          "semantic_meaning": "Stacked printmaster element: Printmaster with optional Digital Cinema and channel configuration",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "PM_STACK_CC",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "printmasters",
              "notes": "No-dash ElementSubElementType stacked code (examples: PMDC51, PM20)",
              "matchPattern": "PM(?:DC)?(?:10|20|40|50|51EX|51|60|61|70|71)",
              "pattern": "PM(?:DC)?(?:10|20|40|50|51EX|51|60|61|70|71)"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "PM_STACK_CC",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "printmasters",
              "notes": "No-dash ElementSubElementType stacked code (examples: PMDC51, PM20)",
              "matchPattern": "PM(?:DC)?(?:10|20|40|50|51EX|51|60|61|70|71)",
              "pattern": "PM(?:DC)?(?:10|20|40|50|51EX|51|60|61|70|71)"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:PM_STACK_CC_MIX",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "PM_STACK_CC_MIX",
          "semantic_meaning": "Stacked printmaster element: Printmaster with optional Digital Cinema, channel configuration, and mix type",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "PM_STACK_CC_MIX",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "printmasters",
              "notes": "No-dash ElementSubElementType stacked code with one or more mix-type suffixes (examples: PM20PAL9, PM51EXNFR128)",
              "matchPattern": "PM(?:DC)?(?:10|20|40|50|51EX|51|60|61|70|71)(?:(?:PAL9|A85|R128|NF|IMAX|DEHT))+",
              "pattern": "PM(?:DC)?(?:10|20|40|50|51EX|51|60|61|70|71)(?:(?:PAL9|A85|R128|NF|IMAX|DEHT))+"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "PM_STACK_CC_MIX",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "printmasters",
              "notes": "No-dash ElementSubElementType stacked code with one or more mix-type suffixes (examples: PM20PAL9, PM51EXNFR128)",
              "matchPattern": "PM(?:DC)?(?:10|20|40|50|51EX|51|60|61|70|71)(?:(?:PAL9|A85|R128|NF|IMAX|DEHT))+",
              "pattern": "PM(?:DC)?(?:10|20|40|50|51EX|51|60|61|70|71)(?:(?:PAL9|A85|R128|NF|IMAX|DEHT))+"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:MOD",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "MOD",
          "semantic_meaning": "Dolby Media",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "MOD",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "dolbymedia"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "MOD",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "dolbymedia"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:AMRSS",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "AMRSS",
          "semantic_meaning": "Audio Migration Reels Super Session",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "AMRSS",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "supersessions"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "AMRSS",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "supersessions"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:FSS",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "FSS",
          "semantic_meaning": "Foreign Super Session",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "FSS",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "supersessions"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "FSS",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "supersessions"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:STMSS",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "STMSS",
          "semantic_meaning": "Stem Super Session",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "STMSS",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "supersessions"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "STMSS",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "supersessions"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:PTSS",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "PTSS",
          "semantic_meaning": "Protools Super Session",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "PTSS",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "supersessions"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "PTSS",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "supersessions"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:10",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "10",
          "semantic_meaning": "Mono",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "10",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "channelconfig"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "10",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "channelconfig"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:20",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "20",
          "semantic_meaning": "2.0 True Stereo",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "20",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "channelconfig"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "20",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "channelconfig"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:40",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "40",
          "semantic_meaning": "4.0",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "40",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "channelconfig"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "40",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "channelconfig"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:50",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "50",
          "semantic_meaning": "5.0",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "50",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "channelconfig"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "50",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "channelconfig"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:51",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "51",
          "semantic_meaning": "5.1",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "51",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "channelconfig"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "51",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "channelconfig"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:51EX",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "51EX",
          "semantic_meaning": "5.1 EX",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "51EX",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "channelconfig"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "51EX",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "channelconfig"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:60",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "60",
          "semantic_meaning": "6.0",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "60",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "channelconfig"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "60",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "channelconfig"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:61",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "61",
          "semantic_meaning": "6.1",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "61",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "channelconfig"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "61",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "channelconfig"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:70",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "70",
          "semantic_meaning": "7.0",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "70",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "channelconfig"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "70",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "channelconfig"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:71",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "71",
          "semantic_meaning": "7.1",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "71",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "channelconfig"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "71",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "channelconfig"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:DEHT",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "DEHT",
          "semantic_meaning": "Disney Enhanced Home Theater",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "DEHT",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "mixtype"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "DEHT",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "mixtype"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:R128",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "R128",
          "semantic_meaning": "FICAM EBU R-128",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "R128",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "mixtype"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "R128",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "mixtype"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:IMAX",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "IMAX",
          "semantic_meaning": "IMAX",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "IMAX",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "mixtype"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "IMAX",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "mixtype"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:NF",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "NF",
          "semantic_meaning": "Near Field",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "NF",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "mixtype"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "NF",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "mixtype"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:PAL9",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "PAL9",
          "semantic_meaning": "PAL Legal with -9dBFS peak",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "PAL9",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "mixtype"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "PAL9",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "mixtype"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ELEMENTTYPE:A85",
          "convention_id": "WMLS",
          "token_name": "ELEMENTTYPE",
          "token_pattern": "A85",
          "semantic_meaning": "U.S. A/85-2011A",
          "constraints": {
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "code_normalized": "A85",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "mixtype"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-elementsubelementtype.json",
            "source_key": "A85",
            "source_token_name": "code-definitions-wmls-elementsubelementtype",
            "source_metadata": {
              "format": "mixtype"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILEINFO:P",
          "convention_id": "WMLS",
          "token_name": "FILEINFO",
          "token_pattern": "P",
          "semantic_meaning": "Progressive",
          "constraints": {
            "source_token_name": "code-definitions-wmls-fileinfo",
            "code_normalized": "P",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "scanning/raster"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-fileinfo.json",
            "source_key": "P",
            "source_token_name": "code-definitions-wmls-fileinfo",
            "source_metadata": {
              "format": "scanning/raster"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILEINFO:I",
          "convention_id": "WMLS",
          "token_name": "FILEINFO",
          "token_pattern": "I",
          "semantic_meaning": "Interlaced",
          "constraints": {
            "source_token_name": "code-definitions-wmls-fileinfo",
            "code_normalized": "I",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "scanning/raster"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-fileinfo.json",
            "source_key": "I",
            "source_token_name": "code-definitions-wmls-fileinfo",
            "source_metadata": {
              "format": "scanning/raster"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILEINFO:480",
          "convention_id": "WMLS",
          "token_name": "FILEINFO",
          "token_pattern": "480",
          "semantic_meaning": "480 vertical lines (720x480 SD)",
          "constraints": {
            "source_token_name": "code-definitions-wmls-fileinfo",
            "code_normalized": "480",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "resolution"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-fileinfo.json",
            "source_key": "480",
            "source_token_name": "code-definitions-wmls-fileinfo",
            "source_metadata": {
              "format": "resolution"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILEINFO:486",
          "convention_id": "WMLS",
          "token_name": "FILEINFO",
          "token_pattern": "486",
          "semantic_meaning": "486 vertical lines (720x486 SD)",
          "constraints": {
            "source_token_name": "code-definitions-wmls-fileinfo",
            "code_normalized": "486",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "resolution"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-fileinfo.json",
            "source_key": "486",
            "source_token_name": "code-definitions-wmls-fileinfo",
            "source_metadata": {
              "format": "resolution"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILEINFO:576",
          "convention_id": "WMLS",
          "token_name": "FILEINFO",
          "token_pattern": "576",
          "semantic_meaning": "576 vertical lines (720x576 SD) PAL",
          "constraints": {
            "source_token_name": "code-definitions-wmls-fileinfo",
            "code_normalized": "576",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "resolution"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-fileinfo.json",
            "source_key": "576",
            "source_token_name": "code-definitions-wmls-fileinfo",
            "source_metadata": {
              "format": "resolution"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILEINFO:720",
          "convention_id": "WMLS",
          "token_name": "FILEINFO",
          "token_pattern": "720",
          "semantic_meaning": "720 vertical lines (1280x720 HD)",
          "constraints": {
            "source_token_name": "code-definitions-wmls-fileinfo",
            "code_normalized": "720",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "resolution"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-fileinfo.json",
            "source_key": "720",
            "source_token_name": "code-definitions-wmls-fileinfo",
            "source_metadata": {
              "format": "resolution"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILEINFO:960",
          "convention_id": "WMLS",
          "token_name": "FILEINFO",
          "token_pattern": "960",
          "semantic_meaning": "960 vertical lines (1280x960 HD)",
          "constraints": {
            "source_token_name": "code-definitions-wmls-fileinfo",
            "code_normalized": "960",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "resolution"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-fileinfo.json",
            "source_key": "960",
            "source_token_name": "code-definitions-wmls-fileinfo",
            "source_metadata": {
              "format": "resolution"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILEINFO:1080",
          "convention_id": "WMLS",
          "token_name": "FILEINFO",
          "token_pattern": "1080",
          "semantic_meaning": "1080 vertical lines (1920x1080 HD)",
          "constraints": {
            "source_token_name": "code-definitions-wmls-fileinfo",
            "code_normalized": "1080",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "resolution"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-fileinfo.json",
            "source_key": "1080",
            "source_token_name": "code-definitions-wmls-fileinfo",
            "source_metadata": {
              "format": "resolution"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILEINFO:2160",
          "convention_id": "WMLS",
          "token_name": "FILEINFO",
          "token_pattern": "2160",
          "semantic_meaning": "2160 vertical lines (3840x2160 UHD)",
          "constraints": {
            "source_token_name": "code-definitions-wmls-fileinfo",
            "code_normalized": "2160",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "resolution"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-fileinfo.json",
            "source_key": "2160",
            "source_token_name": "code-definitions-wmls-fileinfo",
            "source_metadata": {
              "format": "resolution"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILEINFO:4320",
          "convention_id": "WMLS",
          "token_name": "FILEINFO",
          "token_pattern": "4320",
          "semantic_meaning": "4320 vertical lines (7680x4320 UHD2)",
          "constraints": {
            "source_token_name": "code-definitions-wmls-fileinfo",
            "code_normalized": "4320",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "resolution"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-fileinfo.json",
            "source_key": "4320",
            "source_token_name": "code-definitions-wmls-fileinfo",
            "source_metadata": {
              "format": "resolution"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FRAMERATE:23",
          "convention_id": "WMLS",
          "token_name": "FRAMERATE",
          "token_pattern": "23",
          "semantic_meaning": "23 fps",
          "constraints": {
            "source_token_name": "code-definitions-wmls-fileinfo",
            "code_normalized": "23",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "framerate"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-fileinfo.json",
            "source_key": "23",
            "source_token_name": "code-definitions-wmls-fileinfo",
            "source_metadata": {
              "format": "framerate"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FRAMERATE:24",
          "convention_id": "WMLS",
          "token_name": "FRAMERATE",
          "token_pattern": "24",
          "semantic_meaning": "24 fps",
          "constraints": {
            "source_token_name": "code-definitions-wmls-fileinfo",
            "code_normalized": "24",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "framerate"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-fileinfo.json",
            "source_key": "24",
            "source_token_name": "code-definitions-wmls-fileinfo",
            "source_metadata": {
              "format": "framerate"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FRAMERATE:25",
          "convention_id": "WMLS",
          "token_name": "FRAMERATE",
          "token_pattern": "25",
          "semantic_meaning": "25 fps",
          "constraints": {
            "source_token_name": "code-definitions-wmls-fileinfo",
            "code_normalized": "25",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "framerate"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-fileinfo.json",
            "source_key": "25",
            "source_token_name": "code-definitions-wmls-fileinfo",
            "source_metadata": {
              "format": "framerate"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FRAMERATE:29DF",
          "convention_id": "WMLS",
          "token_name": "FRAMERATE",
          "token_pattern": "29DF",
          "semantic_meaning": "29.97 fps Drop Frame",
          "constraints": {
            "source_token_name": "code-definitions-wmls-fileinfo",
            "code_normalized": "29DF",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "framerate"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-fileinfo.json",
            "source_key": "29DF",
            "source_token_name": "code-definitions-wmls-fileinfo",
            "source_metadata": {
              "format": "framerate"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FRAMERATE:29NDF",
          "convention_id": "WMLS",
          "token_name": "FRAMERATE",
          "token_pattern": "29NDF",
          "semantic_meaning": "29.97 fps Non-Drop Frame",
          "constraints": {
            "source_token_name": "code-definitions-wmls-fileinfo",
            "code_normalized": "29NDF",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "framerate"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-fileinfo.json",
            "source_key": "29NDF",
            "source_token_name": "code-definitions-wmls-fileinfo",
            "source_metadata": {
              "format": "framerate"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FRAMERATE:30",
          "convention_id": "WMLS",
          "token_name": "FRAMERATE",
          "token_pattern": "30",
          "semantic_meaning": "30 fps",
          "constraints": {
            "source_token_name": "code-definitions-wmls-fileinfo",
            "code_normalized": "30",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "framerate"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-fileinfo.json",
            "source_key": "30",
            "source_token_name": "code-definitions-wmls-fileinfo",
            "source_metadata": {
              "format": "framerate"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FRAMERATE:50",
          "convention_id": "WMLS",
          "token_name": "FRAMERATE",
          "token_pattern": "50",
          "semantic_meaning": "50 fps",
          "constraints": {
            "source_token_name": "code-definitions-wmls-fileinfo",
            "code_normalized": "50",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "framerate"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-fileinfo.json",
            "source_key": "50",
            "source_token_name": "code-definitions-wmls-fileinfo",
            "source_metadata": {
              "format": "framerate"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FRAMERATE:59DF",
          "convention_id": "WMLS",
          "token_name": "FRAMERATE",
          "token_pattern": "59DF",
          "semantic_meaning": "59.94 fps Drop Frame",
          "constraints": {
            "source_token_name": "code-definitions-wmls-fileinfo",
            "code_normalized": "59DF",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "framerate"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-fileinfo.json",
            "source_key": "59DF",
            "source_token_name": "code-definitions-wmls-fileinfo",
            "source_metadata": {
              "format": "framerate"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FRAMERATE:59NDF",
          "convention_id": "WMLS",
          "token_name": "FRAMERATE",
          "token_pattern": "59NDF",
          "semantic_meaning": "59.94 fps Non-Drop Frame",
          "constraints": {
            "source_token_name": "code-definitions-wmls-fileinfo",
            "code_normalized": "59NDF",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "framerate"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-fileinfo.json",
            "source_key": "59NDF",
            "source_token_name": "code-definitions-wmls-fileinfo",
            "source_metadata": {
              "format": "framerate"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FRAMERATE:60",
          "convention_id": "WMLS",
          "token_name": "FRAMERATE",
          "token_pattern": "60",
          "semantic_meaning": "60 fps",
          "constraints": {
            "source_token_name": "code-definitions-wmls-fileinfo",
            "code_normalized": "60",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "framerate"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-fileinfo.json",
            "source_key": "60",
            "source_token_name": "code-definitions-wmls-fileinfo",
            "source_metadata": {
              "format": "framerate"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ASPECTRATIO:255",
          "convention_id": "WMLS",
          "token_name": "ASPECTRATIO",
          "token_pattern": "255",
          "semantic_meaning": "2.55 Aspect Ratio",
          "constraints": {
            "source_token_name": "code-definitions-wmls-fileinfo",
            "code_normalized": "255",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "aspectratio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-fileinfo.json",
            "source_key": "255",
            "source_token_name": "code-definitions-wmls-fileinfo",
            "source_metadata": {
              "format": "aspectratio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ASPECTRATIO:240",
          "convention_id": "WMLS",
          "token_name": "ASPECTRATIO",
          "token_pattern": "240",
          "semantic_meaning": "2.40 Aspect Ratio",
          "constraints": {
            "source_token_name": "code-definitions-wmls-fileinfo",
            "code_normalized": "240",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "aspectratio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-fileinfo.json",
            "source_key": "240",
            "source_token_name": "code-definitions-wmls-fileinfo",
            "source_metadata": {
              "format": "aspectratio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ASPECTRATIO:239",
          "convention_id": "WMLS",
          "token_name": "ASPECTRATIO",
          "token_pattern": "239",
          "semantic_meaning": "2.39 Aspect Ratio",
          "constraints": {
            "source_token_name": "code-definitions-wmls-fileinfo",
            "code_normalized": "239",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "aspectratio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-fileinfo.json",
            "source_key": "239",
            "source_token_name": "code-definitions-wmls-fileinfo",
            "source_metadata": {
              "format": "aspectratio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ASPECTRATIO:235",
          "convention_id": "WMLS",
          "token_name": "ASPECTRATIO",
          "token_pattern": "235",
          "semantic_meaning": "2.35 Aspect Ratio",
          "constraints": {
            "source_token_name": "code-definitions-wmls-fileinfo",
            "code_normalized": "235",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "aspectratio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-fileinfo.json",
            "source_key": "235",
            "source_token_name": "code-definitions-wmls-fileinfo",
            "source_metadata": {
              "format": "aspectratio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ASPECTRATIO:220",
          "convention_id": "WMLS",
          "token_name": "ASPECTRATIO",
          "token_pattern": "220",
          "semantic_meaning": "2.20 Aspect Ratio",
          "constraints": {
            "source_token_name": "code-definitions-wmls-fileinfo",
            "code_normalized": "220",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "aspectratio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-fileinfo.json",
            "source_key": "220",
            "source_token_name": "code-definitions-wmls-fileinfo",
            "source_metadata": {
              "format": "aspectratio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ASPECTRATIO:185",
          "convention_id": "WMLS",
          "token_name": "ASPECTRATIO",
          "token_pattern": "185",
          "semantic_meaning": "1.85 Aspect Ratio",
          "constraints": {
            "source_token_name": "code-definitions-wmls-fileinfo",
            "code_normalized": "185",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "aspectratio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-fileinfo.json",
            "source_key": "185",
            "source_token_name": "code-definitions-wmls-fileinfo",
            "source_metadata": {
              "format": "aspectratio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ASPECTRATIO:178",
          "convention_id": "WMLS",
          "token_name": "ASPECTRATIO",
          "token_pattern": "178",
          "semantic_meaning": "1.78 Aspect Ratio",
          "constraints": {
            "source_token_name": "code-definitions-wmls-fileinfo",
            "code_normalized": "178",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "aspectratio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-fileinfo.json",
            "source_key": "178",
            "source_token_name": "code-definitions-wmls-fileinfo",
            "source_metadata": {
              "format": "aspectratio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ASPECTRATIO:166",
          "convention_id": "WMLS",
          "token_name": "ASPECTRATIO",
          "token_pattern": "166",
          "semantic_meaning": "1.66 Aspect Ratio",
          "constraints": {
            "source_token_name": "code-definitions-wmls-fileinfo",
            "code_normalized": "166",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "aspectratio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-fileinfo.json",
            "source_key": "166",
            "source_token_name": "code-definitions-wmls-fileinfo",
            "source_metadata": {
              "format": "aspectratio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ASPECTRATIO:133",
          "convention_id": "WMLS",
          "token_name": "ASPECTRATIO",
          "token_pattern": "133",
          "semantic_meaning": "1.33 Aspect Ratio",
          "constraints": {
            "source_token_name": "code-definitions-wmls-fileinfo",
            "code_normalized": "133",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "aspectratio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-fileinfo.json",
            "source_key": "133",
            "source_token_name": "code-definitions-wmls-fileinfo",
            "source_metadata": {
              "format": "aspectratio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:ASPECTRATIO:132",
          "convention_id": "WMLS",
          "token_name": "ASPECTRATIO",
          "token_pattern": "132",
          "semantic_meaning": "1.32 Aspect Ratio",
          "constraints": {
            "source_token_name": "code-definitions-wmls-fileinfo",
            "code_normalized": "132",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "aspectratio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-fileinfo.json",
            "source_key": "132",
            "source_token_name": "code-definitions-wmls-fileinfo",
            "source_metadata": {
              "format": "aspectratio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:ACES",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "ACES",
          "semantic_meaning": "ACES encoded element.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "ACES",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "ACES",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:DSM",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "DSM",
          "semantic_meaning": "ACES Digital Source Master (DSM), OpenEXR Files.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "DSM",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video",
              "subdescriptor": "TRUE"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "DSM",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video",
              "subdescriptor": "TRUE"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:R",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "R",
          "semantic_meaning": "Aces raw scans or conversions from Original Digital Camera Files with no applied color correction, dirt/scratch removal, etc.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "R",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video",
              "subdescriptor": "TRUE"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "R",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video",
              "subdescriptor": "TRUE"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:ANC",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "ANC",
          "semantic_meaning": "Parent Ancillary Folder.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "ANC",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "ancillary"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "ANC",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "ancillary"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:PSL",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "PSL",
          "semantic_meaning": "Ancillary File - Pan-scan list.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "PSL",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "ancillary",
              "subdescriptor": "TRUE"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "PSL",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "ancillary",
              "subdescriptor": "TRUE"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:709LUT",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "709LUT",
          "semantic_meaning": "Ancillary File - 709 Emulation LUT.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "709LUT",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "ancillary",
              "subdescriptor": "TRUE"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "709LUT",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "ancillary",
              "subdescriptor": "TRUE"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:FILMLUT",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "FILMLUT",
          "semantic_meaning": "Ancillary File - Film Emulation LUT.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "FILMLUT",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "ancillary",
              "subdescriptor": "TRUE"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "FILMLUT",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "ancillary",
              "subdescriptor": "TRUE"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:P3LUT",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "P3LUT",
          "semantic_meaning": "Ancillary File - P3 LUT.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "P3LUT",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "ancillary",
              "subdescriptor": "TRUE"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "P3LUT",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "ancillary",
              "subdescriptor": "TRUE"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:709CDL",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "709CDL",
          "semantic_meaning": "Ancillary File - 709 color decision lists.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "709CDL",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "ancillary",
              "subdescriptor": "TRUE"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "709CDL",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "ancillary",
              "subdescriptor": "TRUE"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:FILMCDL",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "FILMCDL",
          "semantic_meaning": "Ancillary File - Film color decision lists.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "FILMCDL",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "ancillary",
              "subdescriptor": "TRUE"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "FILMCDL",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "ancillary",
              "subdescriptor": "TRUE"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:P3CDL",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "P3CDL",
          "semantic_meaning": "Ancillary File - P3 color decision lists.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "P3CDL",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "ancillary",
              "subdescriptor": "TRUE"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "P3CDL",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "ancillary",
              "subdescriptor": "TRUE"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:CC",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "CC",
          "semantic_meaning": "Closed Captioning Files.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "CC",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "subtitle"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "CC",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "subtitle"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:DCDM",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "DCDM",
          "semantic_meaning": "Digital Cinema Distribution Master (Image Only).",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "DCDM",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "DCDM",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:DPX-V",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "DPX-V",
          "semantic_meaning": "DPX Video/Image (Clipster project).",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "DPX-V",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "DPX-V",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:DPX-A",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "DPX-A",
          "semantic_meaning": "Audio that accompanies the DPX frames (especially in a Clipster Project).",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "DPX-A",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "DPX-A",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:DPX-D",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "DPX-D",
          "semantic_meaning": "Dub Cards Only DPX files, no associated Clipster project.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "DPX-D",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "DPX-D",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:DPX-DSM",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "DPX-DSM",
          "semantic_meaning": "Digital Source Master (DSM), using DPX files.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "DPX-DSM",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "DPX-DSM",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:DPX-R",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "DPX-R",
          "semantic_meaning": "DPX raw scans with no applied color correction, dirt/scratch removal, etc.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "DPX-R",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "DPX-R",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:EXR-DSM",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "EXR-DSM",
          "semantic_meaning": "Digital Source Master (DSM), using EXR files.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "EXR-DSM",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "EXR-DSM",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:EXR-R",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "EXR-R",
          "semantic_meaning": "Open EXR raw scans with no applied color-correction, dirt/scratch removal, etc.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "EXR-R",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "EXR-R",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:EXR-V",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "EXR-V",
          "semantic_meaning": "Open EXR Video/Image (Clipster project).",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "EXR-V",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "EXR-V",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:EXR-A",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "EXR-A",
          "semantic_meaning": "Audio that accompanies the EXR frames (especially in a Clipster Project).",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "EXR-A",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "EXR-A",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:EXR-D",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "EXR-D",
          "semantic_meaning": "Dub Cards Only EXR files, no associated Clipster project.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "EXR-D",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "EXR-D",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:IMF-DSM",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "IMF-DSM",
          "semantic_meaning": "Digital Source Master (DSM), using IMF files.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "IMF-DSM",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "IMF-DSM",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:IMF-R",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "IMF-R",
          "semantic_meaning": "IMF raw scans with no applied color-correction, dirt/scratch removal, etc.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "IMF-R",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "IMF-R",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:IMF-V",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "IMF-V",
          "semantic_meaning": "IMF Video/Image (Clipster project).",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "IMF-V",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "IMF-V",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:IMF-A",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "IMF-A",
          "semantic_meaning": "Audio that accompanies the IMF frames (especially in a Clipster Project).",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "IMF-A",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "IMF-A",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:IMF-D",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "IMF-D",
          "semantic_meaning": "Dub Cards Only IMF files, no associated Clipster project.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "IMF-D",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "IMF-D",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:IMF",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "IMF",
          "semantic_meaning": "Interoperable Master Format (IMF) Generic.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "IMF",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "IMF",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:IMF-OV",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "IMF-OV",
          "semantic_meaning": "IMF Original Version.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "IMF-OV",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "IMF-OV",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:IMF-S",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "IMF-S",
          "semantic_meaning": "IMF Supplemental.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "IMF-S",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "IMF-S",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:IMP",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "IMP",
          "semantic_meaning": "Interoperable Master Package (Generic).",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "IMP",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "IMP",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:IMP-S",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "IMP-S",
          "semantic_meaning": "IMP Supplemental.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "IMP-S",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "IMP-S",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:META",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "META",
          "semantic_meaning": "Metadata document.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "META",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "metadata"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "META",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "metadata"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:META-2086",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "META-2086",
          "semantic_meaning": "ST 2086 Metadata documents.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "META-2086",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "metadata"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "META-2086",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "metadata"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:META-DOVI",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "META-DOVI",
          "semantic_meaning": "Dolby Vision Metadata documents.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "META-DOVI",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "metadata"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "META-DOVI",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "metadata"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:PRO-HQ",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "PRO-HQ",
          "semantic_meaning": "ProRes HQ QT (finished master file for Distribution).",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "PRO-HQ",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "PRO-HQ",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:PRO-LIR",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "PRO-LIR",
          "semantic_meaning": "ProRes HQ Library Insert Reel (intended for MAP projects).",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "PRO-LIR",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "PRO-LIR",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:PRO-XQ",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "PRO-XQ",
          "semantic_meaning": "ProRes 4444 XQ QT (finished master file for Distribution).",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "PRO-XQ",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "PRO-XQ",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:PXY-AP",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "PXY-AP",
          "semantic_meaning": "MPEG-2 Program Stream for Anti-Piracy Reference.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "PXY-AP",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "PXY-AP",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:PXY-BBFC",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "PXY-BBFC",
          "semantic_meaning": "Simplified FileType for PAL ProRes LT QT or PAL DV QT, used only for BBFC International Reference Master.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "PXY-BBFC",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "PXY-BBFC",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:PXY-BID-C",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "PXY-BID-C",
          "semantic_meaning": "ProRes HQ QT continuous proxy of Raw film scans for Remastering bidding (used for both folder and file name).",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "PXY-BID-C",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "PXY-BID-C",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:PXY-BID-R",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "PXY-BID-R",
          "semantic_meaning": "ProRes HQ QT proxies in reels of Raw film scans for Remastering bidding (used for folder name).",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "PXY-BID-R",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "PXY-BID-R",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:PXY-BID-R#",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "PXY-BID-R#",
          "semantic_meaning": "ProRes HQ QT proxies in reels of Raw film scans for Remastering bidding (used for file name).",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "PXY-BID-R#",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "PXY-BID-R#",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:PXY-C",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "PXY-C",
          "semantic_meaning": "QT Continuous Proxy for Audio Conforming.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "PXY-C",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "PXY-C",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:PXY-F",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "PXY-F",
          "semantic_meaning": "Digital Fingerprint.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "PXY-F",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "PXY-F",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:PXY-FF",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "PXY-FF",
          "semantic_meaning": "Digital Fingerprint, Flipped horizontally.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "PXY-FF",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "PXY-FF",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:PXY-R",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "PXY-R",
          "semantic_meaning": "QT Proxy in Reels for Audio Conforming (used for folder name).",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "PXY-R",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "PXY-R",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:PXY-R#",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "PXY-R#",
          "semantic_meaning": "QT Proxy in Reels w/ Reel Number for Audio Conforming (used for filename).",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "PXY-R#",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "PXY-R#",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:QCR",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "QCR",
          "semantic_meaning": "QC Report.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "QCR",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "document"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "QCR",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "document"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:QT-A",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "QT-A",
          "semantic_meaning": "Audio-Only QT.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "QT-A",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "QT-A",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:SDH",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "SDH",
          "semantic_meaning": "Subtitles for the Deaf and Hearing Impaired.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "SDH",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "subtitle"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "SDH",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "subtitle"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:TIF-V",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "TIF-V",
          "semantic_meaning": "TIFF Video/Image.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "TIF-V",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "TIF-V",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:TIF-A",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "TIF-A",
          "semantic_meaning": "Audio that accompanies TIF frames (especially in a Clipster Project).",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "TIF-A",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "audio"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "TIF-A",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "audio"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:TIF-D",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "TIF-D",
          "semantic_meaning": "Dub Cards only TIFF files, no associated Clipster project.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "TIF-D",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "TIF-D",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:TIF-DSM",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "TIF-DSM",
          "semantic_meaning": "Digital Source Master (DSM), using TIFF files.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "TIF-DSM",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "TIF-DSM",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:TIF-R",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "TIF-R",
          "semantic_meaning": "TIFF raw scans with no applied color correction, dirt/scratch removal, etc.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "TIF-R",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "TIF-R",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:CNF-HI",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "CNF-HI",
          "semantic_meaning": "Legacy Cineform codec, wrapped in AVI or MOV.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "CNF-HI",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "CNF-HI",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:MP2-80",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "MP2-80",
          "semantic_meaning": "Legacy Mpeg2 file at 80mbps.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "MP2-80",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "MP2-80",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:MP2-50",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "MP2-50",
          "semantic_meaning": "Legacy Mpeg2 file at 50mbps.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "MP2-50",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "MP2-50",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:MP2-15",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "MP2-15",
          "semantic_meaning": "Legacy Mpeg2 file at 15mbps.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "MP2-15",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "MP2-15",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:FILETYPE:MP2-6",
          "convention_id": "WMLS",
          "token_name": "FILETYPE",
          "token_pattern": "MP2-6",
          "semantic_meaning": "Legacy Mpeg2 file at 6mbps.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-filetype",
            "code_normalized": "MP2-6",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "video"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-filetype.json",
            "source_key": "MP2-6",
            "source_token_name": "code-definitions-wmls-filetype",
            "source_metadata": {
              "format": "video"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:PRODUCTTYPE:BNS",
          "convention_id": "WMLS",
          "token_name": "PRODUCTTYPE",
          "token_pattern": "BNS",
          "semantic_meaning": "Bonus",
          "constraints": {
            "source_token_name": "code-definitions-wmls-producttype",
            "code_normalized": "BNS",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-producttype.json",
            "source_key": "BNS",
            "source_token_name": "code-definitions-wmls-producttype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:PRODUCTTYPE:CPO",
          "convention_id": "WMLS",
          "token_name": "PRODUCTTYPE",
          "token_pattern": "CPO",
          "semantic_meaning": "Clipster Project Only (can include some image content like slates).",
          "constraints": {
            "source_token_name": "code-definitions-wmls-producttype",
            "code_normalized": "CPO",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-producttype.json",
            "source_key": "CPO",
            "source_token_name": "code-definitions-wmls-producttype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:PRODUCTTYPE:CV",
          "convention_id": "WMLS",
          "token_name": "PRODUCTTYPE",
          "token_pattern": "CV",
          "semantic_meaning": "Compilation / Volume",
          "constraints": {
            "source_token_name": "code-definitions-wmls-producttype",
            "code_normalized": "CV",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-producttype.json",
            "source_key": "CV",
            "source_token_name": "code-definitions-wmls-producttype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:PRODUCTTYPE:DUB",
          "convention_id": "WMLS",
          "token_name": "PRODUCTTYPE",
          "token_pattern": "DUB",
          "semantic_meaning": "Dub Cards Only",
          "constraints": {
            "source_token_name": "code-definitions-wmls-producttype",
            "code_normalized": "DUB",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-producttype.json",
            "source_key": "DUB",
            "source_token_name": "code-definitions-wmls-producttype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:PRODUCTTYPE:EDU",
          "convention_id": "WMLS",
          "token_name": "PRODUCTTYPE",
          "token_pattern": "EDU",
          "semantic_meaning": "Educatonal",
          "constraints": {
            "source_token_name": "code-definitions-wmls-producttype",
            "code_normalized": "EDU",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-producttype.json",
            "source_key": "EDU",
            "source_token_name": "code-definitions-wmls-producttype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:PRODUCTTYPE:EPS",
          "convention_id": "WMLS",
          "token_name": "PRODUCTTYPE",
          "token_pattern": "EPS",
          "semantic_meaning": "Full Episode in its entirety (may include textless at end after episode).",
          "constraints": {
            "source_token_name": "code-definitions-wmls-producttype",
            "code_normalized": "EPS",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-producttype.json",
            "source_key": "EPS",
            "source_token_name": "code-definitions-wmls-producttype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:PRODUCTTYPE:ET",
          "convention_id": "WMLS",
          "token_name": "PRODUCTTYPE",
          "token_pattern": "ET",
          "semantic_meaning": "End Titles Only",
          "constraints": {
            "source_token_name": "code-definitions-wmls-producttype",
            "code_normalized": "ET",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-producttype.json",
            "source_key": "ET",
            "source_token_name": "code-definitions-wmls-producttype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:PRODUCTTYPE:FEA",
          "convention_id": "WMLS",
          "token_name": "PRODUCTTYPE",
          "token_pattern": "FEA",
          "semantic_meaning": "Full Feature in its entirety (may include textless at end after feature).",
          "constraints": {
            "source_token_name": "code-definitions-wmls-producttype",
            "code_normalized": "FEA",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-producttype.json",
            "source_key": "FEA",
            "source_token_name": "code-definitions-wmls-producttype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:PRODUCTTYPE:FTT",
          "convention_id": "WMLS",
          "token_name": "PRODUCTTYPE",
          "token_pattern": "FTT",
          "semantic_meaning": "Featurette",
          "constraints": {
            "source_token_name": "code-definitions-wmls-producttype",
            "code_normalized": "FTT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-producttype.json",
            "source_key": "FTT",
            "source_token_name": "code-definitions-wmls-producttype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:PRODUCTTYPE:INS",
          "convention_id": "WMLS",
          "token_name": "PRODUCTTYPE",
          "token_pattern": "INS",
          "semantic_meaning": "Inserts Only",
          "constraints": {
            "source_token_name": "code-definitions-wmls-producttype",
            "code_normalized": "INS",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-producttype.json",
            "source_key": "INS",
            "source_token_name": "code-definitions-wmls-producttype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:PRODUCTTYPE:MET",
          "convention_id": "WMLS",
          "token_name": "PRODUCTTYPE",
          "token_pattern": "MET",
          "semantic_meaning": "Main & Ends only",
          "constraints": {
            "source_token_name": "code-definitions-wmls-producttype",
            "code_normalized": "MET",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-producttype.json",
            "source_key": "MET",
            "source_token_name": "code-definitions-wmls-producttype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:PRODUCTTYPE:MIE",
          "convention_id": "WMLS",
          "token_name": "PRODUCTTYPE",
          "token_pattern": "MIE",
          "semantic_meaning": "Main, Inserts & Ends",
          "constraints": {
            "source_token_name": "code-definitions-wmls-producttype",
            "code_normalized": "MIE",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-producttype.json",
            "source_key": "MIE",
            "source_token_name": "code-definitions-wmls-producttype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:PRODUCTTYPE:MIN",
          "convention_id": "WMLS",
          "token_name": "PRODUCTTYPE",
          "token_pattern": "MIN",
          "semantic_meaning": "Main & Inserts Only",
          "constraints": {
            "source_token_name": "code-definitions-wmls-producttype",
            "code_normalized": "MIN",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-producttype.json",
            "source_key": "MIN",
            "source_token_name": "code-definitions-wmls-producttype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:PRODUCTTYPE:MM",
          "convention_id": "WMLS",
          "token_name": "PRODUCTTYPE",
          "token_pattern": "MM",
          "semantic_meaning": "Marketing Materials",
          "constraints": {
            "source_token_name": "code-definitions-wmls-producttype",
            "code_normalized": "MM",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-producttype.json",
            "source_key": "MM",
            "source_token_name": "code-definitions-wmls-producttype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:PRODUCTTYPE:MT",
          "convention_id": "WMLS",
          "token_name": "PRODUCTTYPE",
          "token_pattern": "MT",
          "semantic_meaning": "Main Titles only",
          "constraints": {
            "source_token_name": "code-definitions-wmls-producttype",
            "code_normalized": "MT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-producttype.json",
            "source_key": "MT",
            "source_token_name": "code-definitions-wmls-producttype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:PRODUCTTYPE:SH",
          "convention_id": "WMLS",
          "token_name": "PRODUCTTYPE",
          "token_pattern": "SH",
          "semantic_meaning": "Short",
          "constraints": {
            "source_token_name": "code-definitions-wmls-producttype",
            "code_normalized": "SH",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-producttype.json",
            "source_key": "SH",
            "source_token_name": "code-definitions-wmls-producttype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:PRODUCTTYPE:TP",
          "convention_id": "WMLS",
          "token_name": "PRODUCTTYPE",
          "token_pattern": "TP",
          "semantic_meaning": "Theme Park",
          "constraints": {
            "source_token_name": "code-definitions-wmls-producttype",
            "code_normalized": "TP",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-producttype.json",
            "source_key": "TP",
            "source_token_name": "code-definitions-wmls-producttype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:PRODUCTTYPE:TVM",
          "convention_id": "WMLS",
          "token_name": "PRODUCTTYPE",
          "token_pattern": "TVM",
          "semantic_meaning": "TV Movie",
          "constraints": {
            "source_token_name": "code-definitions-wmls-producttype",
            "code_normalized": "TVM",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-producttype.json",
            "source_key": "TVM",
            "source_token_name": "code-definitions-wmls-producttype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:PRODUCTTYPE:TVMS",
          "convention_id": "WMLS",
          "token_name": "PRODUCTTYPE",
          "token_pattern": "TVMS",
          "semantic_meaning": "TV Mini-series",
          "constraints": {
            "source_token_name": "code-definitions-wmls-producttype",
            "code_normalized": "TVMS",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-producttype.json",
            "source_key": "TVMS",
            "source_token_name": "code-definitions-wmls-producttype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:PRODUCTTYPE:TVSP",
          "convention_id": "WMLS",
          "token_name": "PRODUCTTYPE",
          "token_pattern": "TVSP",
          "semantic_meaning": "TV Special",
          "constraints": {
            "source_token_name": "code-definitions-wmls-producttype",
            "code_normalized": "TVSP",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-producttype.json",
            "source_key": "TVSP",
            "source_token_name": "code-definitions-wmls-producttype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:DTHE",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "DTHE",
          "semantic_meaning": "Drect to Home Entertainment",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "DTHE",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "DTHE",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:TH",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "TH",
          "semantic_meaning": "Theatrical Version",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "TH",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "TH",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:DC",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "DC",
          "semantic_meaning": "Director's Cut",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "DC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "DC",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:SE",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "SE",
          "semantic_meaning": "Special Edition",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "SE",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "SE",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:EX",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "EX",
          "semantic_meaning": "Extended Version",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "EX",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "EX",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:EXT",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "EXT",
          "semantic_meaning": "Extended Version",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "EXT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "EXT",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:UNC",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "UNC",
          "semantic_meaning": "Uncut Version",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "UNC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "UNC",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:ALT",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "ALT",
          "semantic_meaning": "Alternate Version",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "ALT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "ALT",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:ALT1",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "ALT1",
          "semantic_meaning": "Alternate Version 1",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "ALT1",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "ALT1",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:ALT2",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "ALT2",
          "semantic_meaning": "Alternate Version 2",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "ALT2",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "ALT2",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:ALT3",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "ALT3",
          "semantic_meaning": "Alternate Version 3",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "ALT3",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "ALT3",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:ALT4",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "ALT4",
          "semantic_meaning": "Alternate Version 4",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "ALT4",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "ALT4",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:INT",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "INT",
          "semantic_meaning": "International Cut",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "INT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "INT",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:UNR",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "UNR",
          "semantic_meaning": "Unrated Cut",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "UNR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "UNR",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:NEU",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "NEU",
          "semantic_meaning": "Neutral Version (typically animated titles)",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "NEU",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "NEU",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:EDIT",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "EDIT",
          "semantic_meaning": "Edited or cut-down version",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "EDIT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "EDIT",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:IMAX",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "IMAX",
          "semantic_meaning": "IMAX Version",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "IMAX",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "IMAX",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:NTH",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "NTH",
          "semantic_meaning": "Non-theatrical version (edited; may be used for Airlines, Military and/or other reasons).",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "NTH",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "NTH",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:AIR",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "AIR",
          "semantic_meaning": "Airline (edited; for airline use only).",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "AIR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "AIR",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:CNSR",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "CNSR",
          "semantic_meaning": "Censored Version (edited for cultural, violence and/or other sensitive reasons; version typically limited to specific territories).",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "CNSR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "CNSR",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:BCAB",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "BCAB",
          "semantic_meaning": "Basic Cable Version",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "BCAB",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "BCAB",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:NTV",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "NTV",
          "semantic_meaning": "Network Television Version",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "NTV",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "NTV",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:2D",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "2D",
          "semantic_meaning": "2D Version, only used when a 3D version exists and the 2D must be specified.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "2D",
            "rule_kind": "code-definition",
            "source_metadata": {
              "subdescriptor": "TRUE"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "2D",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {
              "subdescriptor": "TRUE"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:3D",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "3D",
          "semantic_meaning": "3D undefined, or a master yet to be componentized.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "3D",
            "rule_kind": "code-definition",
            "source_metadata": {
              "subdescriptor": "TRUE"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "3D",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {
              "subdescriptor": "TRUE"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:3DL",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "3DL",
          "semantic_meaning": "3D Left Eye only",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "3DL",
            "rule_kind": "code-definition",
            "source_metadata": {
              "subdescriptor": "TRUE"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "3DL",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {
              "subdescriptor": "TRUE"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:3DR",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "3DR",
          "semantic_meaning": "3D Right Eye only",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "3DR",
            "rule_kind": "code-definition",
            "source_metadata": {
              "subdescriptor": "TRUE"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "3DR",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {
              "subdescriptor": "TRUE"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:3DSBS",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "3DSBS",
          "semantic_meaning": "3D Side-by-side configuration",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "3DSBS",
            "rule_kind": "code-definition",
            "source_metadata": {
              "subdescriptor": "TRUE"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "3DSBS",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {
              "subdescriptor": "TRUE"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:3DTAB",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "3DTAB",
          "semantic_meaning": "3D Top-and-bottom configuration",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "3DTAB",
            "rule_kind": "code-definition",
            "source_metadata": {
              "subdescriptor": "TRUE"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "3DTAB",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {
              "subdescriptor": "TRUE"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:HDR",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "HDR",
          "semantic_meaning": "High Dynamic Range version (Dolby Vision™, SMPTE 2084 or other variant).",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "HDR",
            "rule_kind": "code-definition",
            "source_metadata": {
              "subdescriptor": "TRUE"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "HDR",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {
              "subdescriptor": "TRUE"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:HDRC",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "HDRC",
          "semantic_meaning": "High Dynamic Range version with constrained or limited luminance.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "HDRC",
            "rule_kind": "code-definition",
            "source_metadata": {
              "subdescriptor": "TRUE"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "HDRC",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {
              "subdescriptor": "TRUE"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:1000",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "1000",
          "semantic_meaning": "High Dynamic Range version with constrained or limited luminance.",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "1000",
            "rule_kind": "code-definition",
            "source_metadata": {
              "subdescriptor": "TRUE"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "1000",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {
              "subdescriptor": "TRUE"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:TV",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "TV",
          "semantic_meaning": "TV-originated element (not an Episode and/or does not have an Episode number).",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "TV",
            "rule_kind": "code-definition",
            "source_metadata": {
              "subdescriptor": "TRUE"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "TV",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {
              "subdescriptor": "TRUE"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:RX",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "RX",
          "semantic_meaning": "Cut Down TV Version",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "RX",
            "rule_kind": "code-definition",
            "source_metadata": {
              "subdescriptor": "TRUE"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "RX",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {
              "subdescriptor": "TRUE"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:RY",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "RY",
          "semantic_meaning": "2 Hour TV Version",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "RY",
            "rule_kind": "code-definition",
            "source_metadata": {
              "subdescriptor": "TRUE"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "RY",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {
              "subdescriptor": "TRUE"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:P",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "P",
          "semantic_meaning": "Pilot Standard Version",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "P",
            "rule_kind": "code-definition",
            "source_metadata": {
              "subdescriptor": "TRUE"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "P",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {
              "subdescriptor": "TRUE"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:PS",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "PS",
          "semantic_meaning": "Pilot Short Version",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "PS",
            "rule_kind": "code-definition",
            "source_metadata": {
              "subdescriptor": "TRUE"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "PS",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {
              "subdescriptor": "TRUE"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:VERSION:PL",
          "convention_id": "WMLS",
          "token_name": "VERSION",
          "token_pattern": "PL",
          "semantic_meaning": "Pilot Long Version",
          "constraints": {
            "source_token_name": "code-definitions-wmls-version",
            "code_normalized": "PL",
            "rule_kind": "code-definition",
            "source_metadata": {
              "subdescriptor": "TRUE"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/code-definitions-wmls-version.json",
            "source_key": "PL",
            "source_token_name": "code-definitions-wmls-version",
            "source_metadata": {
              "subdescriptor": "TRUE"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:MANIFEST:REPOURL",
          "convention_id": "WMLS",
          "token_name": "MANIFEST",
          "token_pattern": "repoUrl",
          "semantic_meaning": "TBD",
          "constraints": {
            "source_token_name": "manifest",
            "code_normalized": "REPOURL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/manifest.json",
            "source_key": "repoUrl",
            "source_token_name": "manifest",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:MANIFEST:REF",
          "convention_id": "WMLS",
          "token_name": "MANIFEST",
          "token_pattern": "ref",
          "semantic_meaning": "TBD",
          "constraints": {
            "source_token_name": "manifest",
            "code_normalized": "REF",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/manifest.json",
            "source_key": "ref",
            "source_token_name": "manifest",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:MANIFEST:SOURCEDIR",
          "convention_id": "WMLS",
          "token_name": "MANIFEST",
          "token_pattern": "sourceDir",
          "semantic_meaning": "WMLS documents",
          "constraints": {
            "source_token_name": "manifest",
            "code_normalized": "SOURCEDIR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/manifest.json",
            "source_key": "sourceDir",
            "source_token_name": "manifest",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        },
        {
          "rule_id": "WMLS:MANIFEST:IMPORTEDAT",
          "convention_id": "WMLS",
          "token_name": "MANIFEST",
          "token_pattern": "importedAt",
          "semantic_meaning": "2026-07-01T00:00:00Z",
          "constraints": {
            "source_token_name": "manifest",
            "code_normalized": "IMPORTEDAT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/wmls/manifest.json",
            "source_key": "importedAt",
            "source_token_name": "manifest",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-20T17:32:24.601Z",
          "updated_at": "2026-07-20T17:32:24.601Z"
        }
      ]
    },
    "./data/conventions/fox/rules.draft.json": {
      "conventionId": "FOX",
      "maskSpec": {
        "id": "FOX-v10",
        "name": "Fox Legacy v10",
        "role": "file",
        "mask": "SHOW_EP_CLASS_VID_MAST_TYPE_DIV_REND_FPS_TL_IAR_CL/CU-TF_RT_NOTE",
        "mainDelimiter": "_",
        "subDelimiter": "-",
        "optionalSegments": [
          "NOTE"
        ],
        "informationalTokens": [
          "SHOW",
          "VID",
          "RT",
          "NOTE"
        ]
      },
      "maskSpecs": [
        {
          "id": "FOX-v9",
          "name": "Fox Legacy v9.4",
          "role": "file",
          "mask": "SHOW_WPR_VER_VID_MAST_TYPE_DIV_REND_FPS_TL_IAR_CL/CU-TF_RT_NOTE",
          "mainDelimiter": "_",
          "subDelimiter": "-",
          "optionalSegments": [
            "NOTE"
          ],
          "informationalTokens": [
            "SHOW",
            "WPR",
            "VID",
            "RT",
            "NOTE"
          ],
          "tokenPolicies": {
            "WPR": {
              "tokenName": "WPR",
              "segmentMask": "WPR",
              "required": true,
              "format": {
                "regex": "^[A-Z0-9]{6}$",
                "message": "WPR must be a 6-character alphanumeric string."
              }
            },
            "VER": {
              "tokenName": "VER",
              "segmentMask": "VER",
              "required": true,
              "allowedValues": [
                "3DVD",
                "AIRL",
                "ALTV",
                "BART",
                "BBID",
                "CABL",
                "CASH",
                "CNSH",
                "CRFX",
                "DIRC",
                "EXTD",
                "FNGS",
                "FOXF",
                "HOME",
                "INTL",
                "LOGO",
                "LONG",
                "MUSR",
                "NETW",
                "NSVR",
                "NSYN",
                "NPRE",
                "NPRO",
                "ORIG",
                "RCRD",
                "RCUT",
                "REVD",
                "SHRT",
                "SING",
                "SPCL",
                "STAL",
                "TELE",
                "TVCE",
                "TVSN",
                "UNCN",
                "UNRT",
                "VAKA",
                "WOCB",
                "WORC"
              ]
            },
            "VID": {
              "tokenName": "VID",
              "segmentMask": "VID",
              "required": true,
              "format": {
                "regex": "^V[A-Z0-9]{0,11}$",
                "message": "VID must start with V and not exceed 12 total characters."
              }
            },
            "MAST": {
              "tokenName": "MAST",
              "segmentMask": "MAST",
              "required": true,
              "allowedValues": [
                "INT",
                "QD",
                "OLC",
                "VAM"
              ]
            },
            "TYPE": {
              "tokenName": "TYPE",
              "segmentMask": "TYPE",
              "required": true,
              "allowedValues": [
                "C",
                "D",
                "E",
                "P",
                "R",
                "T"
              ]
            },
            "DIV": {
              "tokenName": "DIV",
              "segmentMask": "DIV",
              "required": true,
              "allowedValues": [
                "ASM",
                "CP",
                "EST",
                "HE",
                "THE",
                "TTV",
                "TVD"
              ]
            },
            "REND": {
              "tokenName": "REND",
              "segmentMask": "REND",
              "divFormatMustMatchToken": "DIV",
              "divFormatMatchSegmentMask": "DIV"
            },
            "FPS": {
              "tokenName": "FPS",
              "segmentMask": "FPS",
              "required": true,
              "allowedValues": [
                "23",
                "24",
                "25",
                "29",
                "30",
                "50",
                "59",
                "60",
                "XX"
              ]
            },
            "TL": {
              "tokenName": "TL",
              "segmentMask": "TL",
              "required": true,
              "allowLanguageCodes": true,
              "allowedValues": [
                "TEX",
                "PTX",
                "ALL"
              ]
            },
            "IAR": {
              "tokenName": "IAR",
              "segmentMask": "IAR",
              "required": true,
              "allowedValues": [
                "ALL",
                "56",
                "120",
                "133",
                "137",
                "148",
                "155",
                "166",
                "175",
                "178",
                "185",
                "200",
                "220",
                "235",
                "239",
                "240",
                "255",
                "259",
                "266",
                "276",
                "285"
              ]
            },
            "RT": {
              "tokenName": "RT",
              "segmentMask": "RT",
              "format": {
                "regex": "^RT\\d{6}$",
                "message": "RT must be prefixed with RT and followed by 6 digits (HHMMSS), e.g. RT004512."
              }
            },
            "TF": {
              "tokenName": "TF",
              "segmentMask": "CL/CU-TF",
              "requiresNoteWhenValues": [
                "OPT"
              ],
              "noteDescriptionHint": "NOTE should explain what OPT means for the deliverable in recognizable terms."
            }
          }
        },
        {
          "id": "FOX-v10",
          "name": "Fox Legacy v10",
          "role": "file",
          "mask": "SHOW_EP_CLASS_VID_MAST_TYPE_DIV_REND_FPS_TL_IAR_CL/CU-TF_RT_NOTE",
          "mainDelimiter": "_",
          "subDelimiter": "-",
          "optionalSegments": [
            "NOTE"
          ],
          "informationalTokens": [
            "SHOW",
            "VID",
            "RT",
            "NOTE"
          ],
          "tokenPolicies": {
            "VID": {
              "tokenName": "VID",
              "segmentMask": "VID",
              "required": true,
              "format": {
                "regex": "^V[A-Z0-9]{0,11}$",
                "message": "VID must start with V and not exceed 12 total characters."
              }
            },
            "MAST": {
              "tokenName": "MAST",
              "segmentMask": "MAST",
              "required": true,
              "allowedValues": [
                "INT",
                "QD",
                "OLC",
                "VAM"
              ]
            },
            "TYPE": {
              "tokenName": "TYPE",
              "segmentMask": "TYPE",
              "required": true,
              "allowedValues": [
                "C",
                "D",
                "E",
                "P",
                "R",
                "T"
              ]
            },
            "DIV": {
              "tokenName": "DIV",
              "segmentMask": "DIV",
              "required": true,
              "allowedValues": [
                "ASM",
                "CP",
                "EST",
                "HE",
                "THE",
                "TTV",
                "TVD"
              ]
            },
            "REND": {
              "tokenName": "REND",
              "segmentMask": "REND",
              "divFormatMustMatchToken": "DIV",
              "divFormatMatchSegmentMask": "DIV"
            },
            "FPS": {
              "tokenName": "FPS",
              "segmentMask": "FPS",
              "required": true,
              "allowedValues": [
                "23",
                "24",
                "25",
                "29",
                "30",
                "50",
                "59",
                "60",
                "XX"
              ]
            },
            "TL": {
              "tokenName": "TL",
              "segmentMask": "TL",
              "required": true,
              "allowLanguageCodes": true,
              "allowedValues": [
                "TEX",
                "PTX",
                "ALL"
              ]
            },
            "IAR": {
              "tokenName": "IAR",
              "segmentMask": "IAR",
              "required": true,
              "allowedValues": [
                "ALL",
                "56",
                "120",
                "133",
                "137",
                "148",
                "155",
                "166",
                "175",
                "178",
                "185",
                "200",
                "220",
                "235",
                "239",
                "240",
                "255",
                "259",
                "266",
                "276",
                "285"
              ]
            },
            "RT": {
              "tokenName": "RT",
              "segmentMask": "RT",
              "format": {
                "regex": "^RT\\d{6}$",
                "message": "RT must be prefixed with RT and followed by 6 digits (HHMMSS), e.g. RT004512."
              }
            },
            "TF": {
              "tokenName": "TF",
              "segmentMask": "CL/CU-TF",
              "requiresNoteWhenValues": [
                "OPT"
              ],
              "noteDescriptionHint": "NOTE should explain what OPT means for the deliverable in recognizable terms."
            }
          }
        }
      ],
      "matchThreshold": 0.35,
      "version": 1,
      "status": "draft",
      "generatedAt": "2026-07-08T01:00:50.284Z",
      "ruleCount": 333,
      "rules": [
        {
          "rule_id": "FOX:CLASS:AE",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "AE",
          "semantic_meaning": "Alternate Ending",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "AE",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "AE",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:AN",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "AN",
          "semantic_meaning": "Anniversary",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "AN",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "AN",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:CN",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "CN",
          "semantic_meaning": "Censored",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "CN",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "CN",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:CL",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "CL",
          "semantic_meaning": "Colorized",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "CL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "CL",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:CB",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "CB",
          "semantic_meaning": "Content Break",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "CB",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "CB",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:CR",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "CR",
          "semantic_meaning": "Creative",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "CR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "CR",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:CD",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "CD",
          "semantic_meaning": "Credits",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "CD",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "CD",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:DL",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "DL",
          "semantic_meaning": "Dialog",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "DL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "DL",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:DC",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "DC",
          "semantic_meaning": "Director's Cut",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "DC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "DC",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:DNU",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "DNU",
          "semantic_meaning": "DO NOT USE",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "DNU",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "DNU",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:DB",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "DB",
          "semantic_meaning": "Dubbing Credits",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "DB",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "DB",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:ET",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "ET",
          "semantic_meaning": "Exit",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "ET",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "ET",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:EX",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "EX",
          "semantic_meaning": "Extended",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "EX",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "EX",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:IN",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "IN",
          "semantic_meaning": "Intermission",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "IN",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "IN",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:LO",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "LO",
          "semantic_meaning": "Logos",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "LO",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "LO",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:MS",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "MS",
          "semantic_meaning": "Music",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "MS",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "MS",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:OV",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "OV",
          "semantic_meaning": "Original",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "OV",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "OV",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:OT",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "OT",
          "semantic_meaning": "Other",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "OT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "OT",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:OE",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "OE",
          "semantic_meaning": "Overture",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "OE",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "OE",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:PP",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "PP",
          "semantic_meaning": "Product Placement",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "PP",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "PP",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:PROMO",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "PROMO",
          "semantic_meaning": "Promotional",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "PROMO",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "PROMO",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:RC",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "RC",
          "semantic_meaning": "Recap",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "RC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "RC",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:RGN",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "RGN",
          "semantic_meaning": "Regionalized",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "RGN",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "RGN",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:RR",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "RR",
          "semantic_meaning": "Rereleased",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "RR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "RR",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:RE",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "RE",
          "semantic_meaning": "Restored",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "RE",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "RE",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:RA",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "RA",
          "semantic_meaning": "Restored Audio",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "RA",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "RA",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:RP",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "RP",
          "semantic_meaning": "Restored Picture",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "RP",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "RP",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:SN",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "SN",
          "semantic_meaning": "Sanitized",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "SN",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "SN",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:SA",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "SA",
          "semantic_meaning": "Sanitized Audio",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "SA",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "SA",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:SP",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "SP",
          "semantic_meaning": "Sanitized Picture",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "SP",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "SP",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:ST",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "ST",
          "semantic_meaning": "Shortened",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "ST",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "ST",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:SE",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "SE",
          "semantic_meaning": "Sound Effects",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "SE",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "SE",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:SPLIT",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "SPLIT",
          "semantic_meaning": "Split",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "SPLIT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "SPLIT",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:SUB",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "SUB",
          "semantic_meaning": "Substitutions",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "SUB",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "SUB",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:SYND",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "SYND",
          "semantic_meaning": "Syndication",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "SYND",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "SYND",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:3D",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "3D",
          "semantic_meaning": "Three-D",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "3D",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "3D",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CLASS:UR",
          "convention_id": "FOX",
          "token_name": "CLASS",
          "token_pattern": "UR",
          "semantic_meaning": "Unrated",
          "constraints": {
            "source_token_name": "code-definitions-fox-class",
            "code_normalized": "UR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-class.json",
            "source_key": "UR",
            "source_token_name": "code-definitions-fox-class",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:COM",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "COM",
          "semantic_meaning": "Commentary",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "COM",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "ChannelUsage"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "COM",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "ChannelUsage"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:DE",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "DE",
          "semantic_meaning": "Dialogue & Effects",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "DE",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "ChannelUsage"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "DE",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "ChannelUsage"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:DIA",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "DIA",
          "semantic_meaning": "Dialogue",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "DIA",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "ChannelUsage"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "DIA",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "ChannelUsage"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:DME",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "DME",
          "semantic_meaning": "Dialogue/Music/Effects",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "DME",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "ChannelUsage"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "DME",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "ChannelUsage"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:DN",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "DN",
          "semantic_meaning": "Dialogue & Narration",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "DN",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "ChannelUsage"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "DN",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "ChannelUsage"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:DVS",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "DVS",
          "semantic_meaning": "Descriptive Video",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "DVS",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "ChannelUsage"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "DVS",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "ChannelUsage"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:EFX",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "EFX",
          "semantic_meaning": "Effects",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "EFX",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "ChannelUsage"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "EFX",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "ChannelUsage"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:LAF",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "LAF",
          "semantic_meaning": "Laugh Track",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "LAF",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "ChannelUsage"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "LAF",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "ChannelUsage"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:MNE",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "MnE",
          "semantic_meaning": "Music & Effects",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "MNE",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "ChannelUsage"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "MnE",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "ChannelUsage"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:MUS",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "MUS",
          "semantic_meaning": "Music",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "MUS",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "ChannelUsage"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "MUS",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "ChannelUsage"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:NAR",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "NAR",
          "semantic_meaning": "Narration",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "NAR",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "ChannelUsage"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "NAR",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "ChannelUsage"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:TC",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "TC",
          "semantic_meaning": "Time Code",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "TC",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "ChannelUsage"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "TC",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "ChannelUsage"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:MO",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "MO",
          "semantic_meaning": "Mono (1 channel)",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "MO",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "MO",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:DMO",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "DMO",
          "semantic_meaning": "Dual Mono (2 channels)",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "DMO",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "DMO",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:ST",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "ST",
          "semantic_meaning": "Stereo or Lt/Rt (2 channels)",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "ST",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "ST",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:50SUR",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "50SUR",
          "semantic_meaning": "5.0 Surround (5 channels)",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "50SUR",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "50SUR",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:50L",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "50L",
          "semantic_meaning": "5.0 Surround Left  (1 channel)",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "50L",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "50L",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:50R",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "50R",
          "semantic_meaning": "5.0 Surround Right  (1 channel)",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "50R",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "50R",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:50C",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "50C",
          "semantic_meaning": "5.0 Surround Center  (1 channel)",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "50C",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "50C",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:50LS",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "50LS",
          "semantic_meaning": "5.0 Surround Left Surround  (1 channel)",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "50LS",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "50LS",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:50RS",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "50RS",
          "semantic_meaning": "5.0 Surround Right Surround (1 channel)",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "50RS",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "50RS",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:51SUR",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "51SUR",
          "semantic_meaning": "5.1 Surround (6 channels)",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "51SUR",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "51SUR",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:51ST",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "51ST",
          "semantic_meaning": "5.1 Surround + Stereo (8 channels)",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "51ST",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "51ST",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:ST51",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "ST51",
          "semantic_meaning": "Stereo + 5.1 Surround (8 channels)",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "ST51",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "ST51",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:51L",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "51L",
          "semantic_meaning": "5.1 Surround Left  (1 channel)",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "51L",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "51L",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:51R",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "51R",
          "semantic_meaning": "5.1 Surround Right  (1 channel)",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "51R",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "51R",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:51C",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "51C",
          "semantic_meaning": "5.1 Surround Center  (1 channel)",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "51C",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "51C",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:51LFE",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "51LFE",
          "semantic_meaning": "5.1 Surround LFE (1 channel)",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "51LFE",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "51LFE",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:51LS",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "51LS",
          "semantic_meaning": "5.1 Surround Left Surround (1 channel)",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "51LS",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "51LS",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:51RS",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "51RS",
          "semantic_meaning": "5.1 Surround Right Surround (1 channel)",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "51RS",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "51RS",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:71SUR",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "71SUR",
          "semantic_meaning": "7.1 Surround (8 channels)",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "71SUR",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "71SUR",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:71ST",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "71ST",
          "semantic_meaning": "7.1 Surround + Stereo (10 channels)",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "71ST",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "71ST",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:ST71",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "ST71",
          "semantic_meaning": "Stereo + 7.1 Surround (10 channels)",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "ST71",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "ST71",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:71L",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "71L",
          "semantic_meaning": "7.1 Surround Left (1 channel)",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "71L",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "71L",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:71R",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "71R",
          "semantic_meaning": "7.1 Surround Right (1 channel)",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "71R",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "71R",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:71C",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "71C",
          "semantic_meaning": "7.1 Surround Center (1 channel)",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "71C",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "71C",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:71LFE",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "71LFE",
          "semantic_meaning": "7.1 Surround LFE (1 channel)",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "71LFE",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "71LFE",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:71LS",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "71LS",
          "semantic_meaning": "7.1 Surround Left Surround (1 channel)",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "71LS",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "71LS",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:71RS",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "71RS",
          "semantic_meaning": "7.1 Surround Right Surround (1 channel)",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "71RS",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "71RS",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:71LSS",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "71LSS",
          "semantic_meaning": "7.1 Surround Left Surround Side (1 channel)",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "71LSS",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "71LSS",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:71RSS",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "71RSS",
          "semantic_meaning": "7.1 Surround Right Surround Side (1 channel)",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "71RSS",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "71RSS",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:71LSR",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "71LSR",
          "semantic_meaning": "7.1 Surround Left Surround Rear (1 channel)",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "71LSR",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "71LSR",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:71RSR",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "71RSR",
          "semantic_meaning": "7.1 Surround Right Surround Rear (1 channel)",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "71RSR",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "71RSR",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:ATMOS",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "Atmos",
          "semantic_meaning": "Dolby Atmos Immersive Audio",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "ATMOS",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "Atmos",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:OPT",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "OPT",
          "semantic_meaning": "Optional",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "OPT",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "OPT",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:CL/CU:XX",
          "convention_id": "FOX",
          "token_name": "CL/CU",
          "token_pattern": "XX",
          "semantic_meaning": "No Audio (e.g., Subtitle or CC file)",
          "constraints": {
            "source_token_name": "code-definitions-fox-clcu",
            "code_normalized": "XX",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-clcu.json",
            "source_key": "XX",
            "source_token_name": "code-definitions-fox-clcu",
            "source_metadata": {
              "format": "TrackFormat"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:DIV:ASM",
          "convention_id": "FOX",
          "token_name": "DIV",
          "token_pattern": "ASM",
          "semantic_meaning": "Files for long-term asset archival",
          "constraints": {
            "source_token_name": "code-definitions-fox-div",
            "code_normalized": "ASM",
            "rule_kind": "code-definition",
            "source_metadata": {
              "description": "Archival Servicing Master"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-div.json",
            "source_key": "ASM",
            "source_token_name": "code-definitions-fox-div",
            "source_metadata": {
              "description": "Archival Servicing Master"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:DIV:CP",
          "convention_id": "FOX",
          "token_name": "DIV",
          "token_pattern": "CP",
          "semantic_meaning": "Files for video/audio fingerprinting",
          "constraints": {
            "source_token_name": "code-definitions-fox-div",
            "code_normalized": "CP",
            "rule_kind": "code-definition",
            "source_metadata": {
              "description": "Content Protection"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-div.json",
            "source_key": "CP",
            "source_token_name": "code-definitions-fox-div",
            "source_metadata": {
              "description": "Content Protection"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:DIV:EST",
          "convention_id": "FOX",
          "token_name": "DIV",
          "token_pattern": "EST",
          "semantic_meaning": "Files for streaming portal delivery",
          "constraints": {
            "source_token_name": "code-definitions-fox-div",
            "code_normalized": "EST",
            "rule_kind": "code-definition",
            "source_metadata": {
              "description": "Electronic Sell Through / Video On Demand"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-div.json",
            "source_key": "EST",
            "source_token_name": "code-definitions-fox-div",
            "source_metadata": {
              "description": "Electronic Sell Through / Video On Demand"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:DIV:HE",
          "convention_id": "FOX",
          "token_name": "DIV",
          "token_pattern": "HE",
          "semantic_meaning": "Files for DVD/Blu-Ray workflows",
          "constraints": {
            "source_token_name": "code-definitions-fox-div",
            "code_normalized": "HE",
            "rule_kind": "code-definition",
            "source_metadata": {
              "description": "Home Entertainment"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-div.json",
            "source_key": "HE",
            "source_token_name": "code-definitions-fox-div",
            "source_metadata": {
              "description": "Home Entertainment"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:DIV:THE",
          "convention_id": "FOX",
          "token_name": "DIV",
          "token_pattern": "THE",
          "semantic_meaning": "Files for feature post production",
          "constraints": {
            "source_token_name": "code-definitions-fox-div",
            "code_normalized": "THE",
            "rule_kind": "code-definition",
            "source_metadata": {
              "description": "Theatrical"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-div.json",
            "source_key": "THE",
            "source_token_name": "code-definitions-fox-div",
            "source_metadata": {
              "description": "Theatrical"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:DIV:TTV",
          "convention_id": "FOX",
          "token_name": "DIV",
          "token_pattern": "TTV",
          "semantic_meaning": "Files for Domestic TV syndication",
          "constraints": {
            "source_token_name": "code-definitions-fox-div",
            "code_normalized": "TTV",
            "rule_kind": "code-definition",
            "source_metadata": {
              "description": "Twentieth Television"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-div.json",
            "source_key": "TTV",
            "source_token_name": "code-definitions-fox-div",
            "source_metadata": {
              "description": "Twentieth Television"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:DIV:TVD",
          "convention_id": "FOX",
          "token_name": "DIV",
          "token_pattern": "TVD",
          "semantic_meaning": "Files for International broadcasters",
          "constraints": {
            "source_token_name": "code-definitions-fox-div",
            "code_normalized": "TVD",
            "rule_kind": "code-definition",
            "source_metadata": {
              "description": "Television Distribution"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-div.json",
            "source_key": "TVD",
            "source_token_name": "code-definitions-fox-div",
            "source_metadata": {
              "description": "Television Distribution"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:FPS:23",
          "convention_id": "FOX",
          "token_name": "FPS",
          "token_pattern": "23",
          "semantic_meaning": "23.976 fps",
          "constraints": {
            "source_token_name": "code-definitions-fox-fps",
            "code_normalized": "23",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-fps.json",
            "source_key": "23",
            "source_token_name": "code-definitions-fox-fps",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:FPS:24",
          "convention_id": "FOX",
          "token_name": "FPS",
          "token_pattern": "24",
          "semantic_meaning": "24 fps",
          "constraints": {
            "source_token_name": "code-definitions-fox-fps",
            "code_normalized": "24",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-fps.json",
            "source_key": "24",
            "source_token_name": "code-definitions-fox-fps",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:FPS:25",
          "convention_id": "FOX",
          "token_name": "FPS",
          "token_pattern": "25",
          "semantic_meaning": "25 fps",
          "constraints": {
            "source_token_name": "code-definitions-fox-fps",
            "code_normalized": "25",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-fps.json",
            "source_key": "25",
            "source_token_name": "code-definitions-fox-fps",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:FPS:29",
          "convention_id": "FOX",
          "token_name": "FPS",
          "token_pattern": "29",
          "semantic_meaning": "29.97 fps",
          "constraints": {
            "source_token_name": "code-definitions-fox-fps",
            "code_normalized": "29",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-fps.json",
            "source_key": "29",
            "source_token_name": "code-definitions-fox-fps",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:FPS:30",
          "convention_id": "FOX",
          "token_name": "FPS",
          "token_pattern": "30",
          "semantic_meaning": "30 fps",
          "constraints": {
            "source_token_name": "code-definitions-fox-fps",
            "code_normalized": "30",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-fps.json",
            "source_key": "30",
            "source_token_name": "code-definitions-fox-fps",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:FPS:50",
          "convention_id": "FOX",
          "token_name": "FPS",
          "token_pattern": "50",
          "semantic_meaning": "50 fps",
          "constraints": {
            "source_token_name": "code-definitions-fox-fps",
            "code_normalized": "50",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-fps.json",
            "source_key": "50",
            "source_token_name": "code-definitions-fox-fps",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:FPS:59",
          "convention_id": "FOX",
          "token_name": "FPS",
          "token_pattern": "59",
          "semantic_meaning": "59.94 fps",
          "constraints": {
            "source_token_name": "code-definitions-fox-fps",
            "code_normalized": "59",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-fps.json",
            "source_key": "59",
            "source_token_name": "code-definitions-fox-fps",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:FPS:60",
          "convention_id": "FOX",
          "token_name": "FPS",
          "token_pattern": "60",
          "semantic_meaning": "60 fps",
          "constraints": {
            "source_token_name": "code-definitions-fox-fps",
            "code_normalized": "60",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-fps.json",
            "source_key": "60",
            "source_token_name": "code-definitions-fox-fps",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:FPS:XX",
          "convention_id": "FOX",
          "token_name": "FPS",
          "token_pattern": "XX",
          "semantic_meaning": "No Frame Rate (e.g., Dub Cards)",
          "constraints": {
            "source_token_name": "code-definitions-fox-fps",
            "code_normalized": "XX",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-fps.json",
            "source_key": "XX",
            "source_token_name": "code-definitions-fox-fps",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:IAR:ALL",
          "convention_id": "FOX",
          "token_name": "IAR",
          "token_pattern": "ALL",
          "semantic_meaning": "All Aspects",
          "constraints": {
            "source_token_name": "code-definitions-fox-iar",
            "code_normalized": "ALL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-iar.json",
            "source_key": "ALL",
            "source_token_name": "code-definitions-fox-iar",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:IAR:56",
          "convention_id": "FOX",
          "token_name": "IAR",
          "token_pattern": "56",
          "semantic_meaning": "0.56:1",
          "constraints": {
            "source_token_name": "code-definitions-fox-iar",
            "code_normalized": "56",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-iar.json",
            "source_key": "56",
            "source_token_name": "code-definitions-fox-iar",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:IAR:120",
          "convention_id": "FOX",
          "token_name": "IAR",
          "token_pattern": "120",
          "semantic_meaning": "1.20:1",
          "constraints": {
            "source_token_name": "code-definitions-fox-iar",
            "code_normalized": "120",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-iar.json",
            "source_key": "120",
            "source_token_name": "code-definitions-fox-iar",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:IAR:133",
          "convention_id": "FOX",
          "token_name": "IAR",
          "token_pattern": "133",
          "semantic_meaning": "1.33:1",
          "constraints": {
            "source_token_name": "code-definitions-fox-iar",
            "code_normalized": "133",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-iar.json",
            "source_key": "133",
            "source_token_name": "code-definitions-fox-iar",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:IAR:137",
          "convention_id": "FOX",
          "token_name": "IAR",
          "token_pattern": "137",
          "semantic_meaning": "1.37:1",
          "constraints": {
            "source_token_name": "code-definitions-fox-iar",
            "code_normalized": "137",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-iar.json",
            "source_key": "137",
            "source_token_name": "code-definitions-fox-iar",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:IAR:148",
          "convention_id": "FOX",
          "token_name": "IAR",
          "token_pattern": "148",
          "semantic_meaning": "1.48:1",
          "constraints": {
            "source_token_name": "code-definitions-fox-iar",
            "code_normalized": "148",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-iar.json",
            "source_key": "148",
            "source_token_name": "code-definitions-fox-iar",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:IAR:155",
          "convention_id": "FOX",
          "token_name": "IAR",
          "token_pattern": "155",
          "semantic_meaning": "1.55:1",
          "constraints": {
            "source_token_name": "code-definitions-fox-iar",
            "code_normalized": "155",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-iar.json",
            "source_key": "155",
            "source_token_name": "code-definitions-fox-iar",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:IAR:166",
          "convention_id": "FOX",
          "token_name": "IAR",
          "token_pattern": "166",
          "semantic_meaning": "1.66:1",
          "constraints": {
            "source_token_name": "code-definitions-fox-iar",
            "code_normalized": "166",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-iar.json",
            "source_key": "166",
            "source_token_name": "code-definitions-fox-iar",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:IAR:175",
          "convention_id": "FOX",
          "token_name": "IAR",
          "token_pattern": "175",
          "semantic_meaning": "1.75:1",
          "constraints": {
            "source_token_name": "code-definitions-fox-iar",
            "code_normalized": "175",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-iar.json",
            "source_key": "175",
            "source_token_name": "code-definitions-fox-iar",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:IAR:178",
          "convention_id": "FOX",
          "token_name": "IAR",
          "token_pattern": "178",
          "semantic_meaning": "1.78:1",
          "constraints": {
            "source_token_name": "code-definitions-fox-iar",
            "code_normalized": "178",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-iar.json",
            "source_key": "178",
            "source_token_name": "code-definitions-fox-iar",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:IAR:185",
          "convention_id": "FOX",
          "token_name": "IAR",
          "token_pattern": "185",
          "semantic_meaning": "1.85:1",
          "constraints": {
            "source_token_name": "code-definitions-fox-iar",
            "code_normalized": "185",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-iar.json",
            "source_key": "185",
            "source_token_name": "code-definitions-fox-iar",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:IAR:200",
          "convention_id": "FOX",
          "token_name": "IAR",
          "token_pattern": "200",
          "semantic_meaning": "2.00:1",
          "constraints": {
            "source_token_name": "code-definitions-fox-iar",
            "code_normalized": "200",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-iar.json",
            "source_key": "200",
            "source_token_name": "code-definitions-fox-iar",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:IAR:220",
          "convention_id": "FOX",
          "token_name": "IAR",
          "token_pattern": "220",
          "semantic_meaning": "2.20:1",
          "constraints": {
            "source_token_name": "code-definitions-fox-iar",
            "code_normalized": "220",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-iar.json",
            "source_key": "220",
            "source_token_name": "code-definitions-fox-iar",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:IAR:235",
          "convention_id": "FOX",
          "token_name": "IAR",
          "token_pattern": "235",
          "semantic_meaning": "2.35:1",
          "constraints": {
            "source_token_name": "code-definitions-fox-iar",
            "code_normalized": "235",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-iar.json",
            "source_key": "235",
            "source_token_name": "code-definitions-fox-iar",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:IAR:239",
          "convention_id": "FOX",
          "token_name": "IAR",
          "token_pattern": "239",
          "semantic_meaning": "2.39:1",
          "constraints": {
            "source_token_name": "code-definitions-fox-iar",
            "code_normalized": "239",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-iar.json",
            "source_key": "239",
            "source_token_name": "code-definitions-fox-iar",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:IAR:240",
          "convention_id": "FOX",
          "token_name": "IAR",
          "token_pattern": "240",
          "semantic_meaning": "2.40:1",
          "constraints": {
            "source_token_name": "code-definitions-fox-iar",
            "code_normalized": "240",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-iar.json",
            "source_key": "240",
            "source_token_name": "code-definitions-fox-iar",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:IAR:255",
          "convention_id": "FOX",
          "token_name": "IAR",
          "token_pattern": "255",
          "semantic_meaning": "2.55:1",
          "constraints": {
            "source_token_name": "code-definitions-fox-iar",
            "code_normalized": "255",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-iar.json",
            "source_key": "255",
            "source_token_name": "code-definitions-fox-iar",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:IAR:259",
          "convention_id": "FOX",
          "token_name": "IAR",
          "token_pattern": "259",
          "semantic_meaning": "2.59:1",
          "constraints": {
            "source_token_name": "code-definitions-fox-iar",
            "code_normalized": "259",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-iar.json",
            "source_key": "259",
            "source_token_name": "code-definitions-fox-iar",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:IAR:266",
          "convention_id": "FOX",
          "token_name": "IAR",
          "token_pattern": "266",
          "semantic_meaning": "2.66:1",
          "constraints": {
            "source_token_name": "code-definitions-fox-iar",
            "code_normalized": "266",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-iar.json",
            "source_key": "266",
            "source_token_name": "code-definitions-fox-iar",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:IAR:276",
          "convention_id": "FOX",
          "token_name": "IAR",
          "token_pattern": "276",
          "semantic_meaning": "2.76:1",
          "constraints": {
            "source_token_name": "code-definitions-fox-iar",
            "code_normalized": "276",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-iar.json",
            "source_key": "276",
            "source_token_name": "code-definitions-fox-iar",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:IAR:285",
          "convention_id": "FOX",
          "token_name": "IAR",
          "token_pattern": "285",
          "semantic_meaning": "2.85:1",
          "constraints": {
            "source_token_name": "code-definitions-fox-iar",
            "code_normalized": "285",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-iar.json",
            "source_key": "285",
            "source_token_name": "code-definitions-fox-iar",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:MAST:INT",
          "convention_id": "FOX",
          "token_name": "MAST",
          "token_pattern": "INT",
          "semantic_meaning": "Final Finished Product made from a source that has passed QC.",
          "constraints": {
            "source_token_name": "code-definitions-fox-mast",
            "code_normalized": "INT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-mast.json",
            "source_key": "INT",
            "source_token_name": "code-definitions-fox-mast",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:MAST:QD",
          "convention_id": "FOX",
          "token_name": "MAST",
          "token_pattern": "QD",
          "semantic_meaning": "Episodic Quuick Delivery Master (primarily for Television).",
          "constraints": {
            "source_token_name": "code-definitions-fox-mast",
            "code_normalized": "QD",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-mast.json",
            "source_key": "QD",
            "source_token_name": "code-definitions-fox-mast",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:MAST:OLC",
          "convention_id": "FOX",
          "token_name": "MAST",
          "token_pattern": "OLC",
          "semantic_meaning": "Online cut",
          "constraints": {
            "source_token_name": "code-definitions-fox-mast",
            "code_normalized": "OLC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-mast.json",
            "source_key": "OLC",
            "source_token_name": "code-definitions-fox-mast",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:MAST:VAM",
          "convention_id": "FOX",
          "token_name": "MAST",
          "token_pattern": "VAM",
          "semantic_meaning": "Miscellaneous Short Form Material (Value Added Material).",
          "constraints": {
            "source_token_name": "code-definitions-fox-mast",
            "code_normalized": "VAM",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-mast.json",
            "source_key": "VAM",
            "source_token_name": "code-definitions-fox-mast",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:IMP2160PML7HDR10",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "IMP2160pML7HDR10",
          "semantic_meaning": "3840x2160 Progressive HDR10 Archival IMF Package",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "IMP2160PML7HDR10",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "IMP2160pML7HDR10",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:IMP2160PML7HDR10FRC",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "IMP2160pML7HDR10frc",
          "semantic_meaning": "3840x2160 Progressive HDR10 Archival IMF Package Forced",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "IMP2160PML7HDR10FRC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "IMP2160pML7HDR10frc",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:IMP2160PML7HDR10FUL",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "IMP2160pML7HDR10ful",
          "semantic_meaning": "3840x2160 Progressive HDR10 Archival IMF Package Full",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "IMP2160PML7HDR10FUL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "IMP2160pML7HDR10ful",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:IMP2160PML7HDR10SDH",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "IMP2160pML7HDR10sdh",
          "semantic_meaning": "3840x2160 Progressive HDR10 Archival IMF Package SDH",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "IMP2160PML7HDR10SDH",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "IMP2160pML7HDR10sdh",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:IMP2160PML7SDR",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "IMP2160pML7SDR",
          "semantic_meaning": "3840x2160 Progressive SDR Archival IMF Package",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "IMP2160PML7SDR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "IMP2160pML7SDR",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:IMP2160PML7SDRFRC",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "IMP2160pML7SDRfrc",
          "semantic_meaning": "3840x2160 Progressive SDR Archival IMF Package Forced",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "IMP2160PML7SDRFRC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "IMP2160pML7SDRfrc",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:IMP2160PML7SDRFUL",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "IMP2160pML7SDRful",
          "semantic_meaning": "3840x2160 Progressive SDR Archival IMF Package Full",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "IMP2160PML7SDRFUL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "IMP2160pML7SDRful",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:IMP2160PML7SDRSDH",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "IMP2160pML7SDRsdh",
          "semantic_meaning": "3840x2160 Progressive SDR Archival IMF Package SDH",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "IMP2160PML7SDRSDH",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "IMP2160pML7SDRsdh",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:IMP1080PML4SDR",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "IMP1080pML4SDR",
          "semantic_meaning": "1920x1080 Progressive SDR Archival IMF Package",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "IMP1080PML4SDR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "IMP1080pML4SDR",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:422L1080IAVI",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "422L1080iAVI",
          "semantic_meaning": "1920x1080 Interlaced 4:2:2 Legal Lossless AVI",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "422L1080IAVI",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "422L1080iAVI",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:422L1080IJ2K",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "422L1080iJ2K",
          "semantic_meaning": "1920x1080 Interlaced 4:2:2 Legal Lossless J2K/MXF",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "422L1080IJ2K",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "422L1080iJ2K",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:422L1080PAVI",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "422L1080pAVI",
          "semantic_meaning": "1920x1080 Progressive 4:2:2 Legal Lossless AVI",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "422L1080PAVI",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "422L1080pAVI",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:422L1080PCOMP",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "422L1080pCOMP",
          "semantic_meaning": "1920x1080 Progressive 4:2:2 Legal Composite",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "422L1080PCOMP",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "422L1080pCOMP",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:422L1080PJ2K",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "422L1080pJ2K",
          "semantic_meaning": "1920x1080 Progressive 4:2:2 Legal Lossless J2K/MXF",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "422L1080PJ2K",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "422L1080pJ2K",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:422L1920PJ2K",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "422L1920pJ2K",
          "semantic_meaning": "1080x1920 Progressive 4:2:2 Legal Lossless J2K/MXF",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "422L1920PJ2K",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "422L1920pJ2K",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:422L720PAVI",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "422L720pAVI",
          "semantic_meaning": "1280x720 Progressive 4:2:2 Legal Lossless AVI",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "422L720PAVI",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "422L720pAVI",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:422L720PJ2K",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "422L720pJ2K",
          "semantic_meaning": "1280x720 Progressive 4:2:2 Legal Lossless J2K/MXF",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "422L720PJ2K",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "422L720pJ2K",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:422L486P4X3",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "422L486p4x3",
          "semantic_meaning": "720x486 4x3 Progressive 4:2:2 J2K/MXF",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "422L486P4X3",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "422L486p4x3",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:422L486P16X9",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "422L486p16x9",
          "semantic_meaning": "720x486 16x9 Progressive 4:2:2 J2K/MXF",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "422L486P16X9",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "422L486p16x9",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:422L486I4X3",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "422L486i4x3",
          "semantic_meaning": "720x486 4x3 Interlaced 4:2:2 J2K/MXF",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "422L486I4X3",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "422L486i4x3",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:422L486I16X9",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "422L486i16x9",
          "semantic_meaning": "720x486 16x9 Interlaced 4:2:2 J2K/MXF",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "422L486I16X9",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "422L486i16x9",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:422L576P4X3",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "422L576p4x3",
          "semantic_meaning": "720x576 4x3 Progressive 4:2:2 J2K/MXF",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "422L576P4X3",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "422L576p4x3",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:422L576P16X9",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "422L576p16x9",
          "semantic_meaning": "720x576 16x9 Progressive 4:2:2 J2K/MXF",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "422L576P16X9",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "422L576p16x9",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:422L576I4X3",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "422L576i4x3",
          "semantic_meaning": "720x576 4x3 Interlaced 4:2:2 J2K/MXF",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "422L576I4X3",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "422L576i4x3",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:422L576I16X9",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "422L576i16x9",
          "semantic_meaning": "720x576 16x9 Interlaced 4:2:2 J2K/MXF",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "422L576I16X9",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "422L576i16x9",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:PROHQ2160PHDR10",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "PROHQ2160pHDR10",
          "semantic_meaning": "3840x2160 Progressive HDR10 ProRes(XQ)",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "PROHQ2160PHDR10",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "PROHQ2160pHDR10",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:PROHQ2160P",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "PROHQ2160p",
          "semantic_meaning": "3840x2160 Progressive ProRes(HQ)",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "PROHQ2160P",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "PROHQ2160p",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:PROHQ1080I",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "PROHQ1080i",
          "semantic_meaning": "1920x1080 Interlaced ProRes(HQ)",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "PROHQ1080I",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "PROHQ1080i",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:PROHQ1080P",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "PROHQ1080p",
          "semantic_meaning": "1920x1080 Progressive ProRes(HQ)",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "PROHQ1080P",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "PROHQ1080p",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:PROHQ480I4X3",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "PROHQ480i4x3",
          "semantic_meaning": "720x480 4x3 (NTSC) Interlaced ProRes(HQ)",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "PROHQ480I4X3",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "PROHQ480i4x3",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:PROHQ480I16X9",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "PROHQ480i16x9",
          "semantic_meaning": "720x480 16x9 (NTSC) Interlaced ProRes(HQ)",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "PROHQ480I16X9",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "PROHQ480i16x9",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:PROHQ480P4X3",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "PROHQ480p4x3",
          "semantic_meaning": "720x480 4x3 (NTSC) Progressive ProRes(HQ)",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "PROHQ480P4X3",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "PROHQ480p4x3",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:PROHQ480P16X9",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "PROHQ480p16x9",
          "semantic_meaning": "720x480 16x9 (NTSC) Progressive ProRes(HQ)",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "PROHQ480P16X9",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "PROHQ480p16x9",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:PROHQ576I4X3",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "PROHQ576i4x3",
          "semantic_meaning": "720x576 4x3 (PAL) Interlaced ProRes(HQ)",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "PROHQ576I4X3",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "PROHQ576i4x3",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:PROHQ576I16X9",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "PROHQ576i16x9",
          "semantic_meaning": "720x576 16x9 (PAL) Interlaced ProRes(HQ)",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "PROHQ576I16X9",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "PROHQ576i16x9",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:PROHQ576P4X3",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "PROHQ576p4x3",
          "semantic_meaning": "720x576 4x3 (PAL) Progressive ProRes(HQ)",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "PROHQ576P4X3",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "PROHQ576p4x3",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:PROHQ576P16X9",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "PROHQ576p16x9",
          "semantic_meaning": "720x576 16x9 (PAL) Progressive ProRes(HQ)",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "PROHQ576P16X9",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "PROHQ576p16x9",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:MOVPRXY720P",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "MOVPRXY720p",
          "semantic_meaning": "1280x720 Progressive MOV Proxy",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "MOVPRXY720P",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "MOVPRXY720p",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:444F2160PIMF",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "444F2160pIMF",
          "semantic_meaning": "3840x2160 Progressive 4:4:4 Full Lossless IMF Package",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "444F2160PIMF",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "444F2160pIMF",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:444L2160PIMF",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "444L2160pIMF",
          "semantic_meaning": "3840x2160 Progressive 4:4:4 Legal Lossless IMF Package",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "444L2160PIMF",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "444L2160pIMF",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:422L2160PIMF",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "422L2160pIMF",
          "semantic_meaning": "3840x2160 Progressive 4:2:2 Legal Lossless IMF Package",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "422L2160PIMF",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "422L2160pIMF",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:444F1080PIMF",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "444F1080pIMF",
          "semantic_meaning": "1920x1080 Progressive 4:4:4 Full Lossless IMF Package",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "444F1080PIMF",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "444F1080pIMF",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:444L1080PIMF",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "444L1080pIMF",
          "semantic_meaning": "1920x1080 Progressive 4:4:4 Legal Lossless IMF Package",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "444L1080PIMF",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "444L1080pIMF",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:422L1080PIMF",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "422L1080pIMF",
          "semantic_meaning": "1920x1080 Progressive 4:2:2 Legal Lossless IMF Package",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "422L1080PIMF",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "422L1080pIMF",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:444F2160PJ2K",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "444F2160pJ2K",
          "semantic_meaning": "3840x2160 Progressive 4:4:4 Full Lossless J2K/MXF",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "444F2160PJ2K",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "444F2160pJ2K",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:444L2160PJ2K",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "444L2160pJ2K",
          "semantic_meaning": "3840x2160 Progressive 4:4:4 Legal Lossless J2K/MXF",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "444L2160PJ2K",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "444L2160pJ2K",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:422L2160PJ2K",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "422L2160pJ2K",
          "semantic_meaning": "3840x2160 Progressive 4:2:2 Legal Lossless J2K/MXF",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "422L2160PJ2K",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "422L2160pJ2K",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:444F1080PJ2K",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "444F1080pJ2K",
          "semantic_meaning": "1920x1080 Progressive 4:4:4 Full Lossless J2K/MXF",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "444F1080PJ2K",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "444F1080pJ2K",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:444L1080PJ2K",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "444L1080pJ2K",
          "semantic_meaning": "1920x1080 Progressive 4:4:4 Legal Lossless J2K/MXF",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "444L1080PJ2K",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "444L1080pJ2K",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:422L720PIMF",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "422L720pIMF",
          "semantic_meaning": "1280x720 Progressive 4:2:2 Legal Lossless IMF Package",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "422L720PIMF",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "422L720pIMF",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:DVP480P4X3",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "DVP480p4x3",
          "semantic_meaning": "720x480 4x3 Progressive DV25 Proxy",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "DVP480P4X3",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "DVP480p4x3",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:DVP480P16X9",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "DVP480p16x9",
          "semantic_meaning": "720x480 16x9 Progressive DV25 Proxy",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "DVP480P16X9",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "DVP480p16x9",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:MP4PRXY720P",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "MP4PRXY720p",
          "semantic_meaning": "1280x720 Progressive MP4 Proxy",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "MP4PRXY720P",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "MP4PRXY720p",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:CP360P",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "CP360p",
          "semantic_meaning": "640x360 1Mbps H.264/MP4 16x9 for Content Protection",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "CP360P",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "CP360p",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:CP480P",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "CP480p",
          "semantic_meaning": "640x480 1Mbps H.264/MP4 4x3 for Content Protection",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "CP480P",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "CP480p",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:IMP2160PML5HDR10",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "IMP2160pML5HDR10",
          "semantic_meaning": "3840x2160 Progressive HDR10 Servicing IMF Package",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "IMP2160PML5HDR10",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "IMP2160pML5HDR10",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:IMP2160PML5HDR10FRC",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "IMP2160pML5HDR10frc",
          "semantic_meaning": "3840x2160 Progressive HDR10 Servicing IMF Package Forced",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "IMP2160PML5HDR10FRC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "IMP2160pML5HDR10frc",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:IMP2160PML5HDR10FUL",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "IMP2160pML5HDR10ful",
          "semantic_meaning": "3840x2160 Progressive HDR10 Servicing IMF Package Full",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "IMP2160PML5HDR10FUL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "IMP2160pML5HDR10ful",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:IMP2160PML5HDR10SDH",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "IMP2160pML5HDR10sdh",
          "semantic_meaning": "3840x2160 Progressive HDR10 Servicing IMF Package SDH",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "IMP2160PML5HDR10SDH",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "IMP2160pML5HDR10sdh",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:IMP2160PML5SDR",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "IMP2160pML5SDR",
          "semantic_meaning": "3840x2160 Progressive SDR Servicing IMF Package",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "IMP2160PML5SDR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "IMP2160pML5SDR",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:IMP2160PML5SDRFRC",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "IMP2160pML5SDRfrc",
          "semantic_meaning": "3840x2160 Progressive SDR Servicing IMF Package Forced",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "IMP2160PML5SDRFRC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "IMP2160pML5SDRfrc",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:IMP2160PML5SDRFUL",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "IMP2160pML5SDRful",
          "semantic_meaning": "3840x2160 Progressive SDR Servicing IMF Package Full",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "IMP2160PML5SDRFUL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "IMP2160pML5SDRful",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:IMP2160PML5SDRSDH",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "IMP2160pML5SDRsdh",
          "semantic_meaning": "3840x2160 Progressive SDR Servicing IMF Package SDH",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "IMP2160PML5SDRSDH",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "IMP2160pML5SDRsdh",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:HD50TS1080P",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "HD50TS1080p",
          "semantic_meaning": "1920x1080 HD 8 Channel 50Mbps Transport Stream",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "HD50TS1080P",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "HD50TS1080p",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:HD50PS1080P",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "HD50PS1080p",
          "semantic_meaning": "1920x1080 HD 2 Channel 50Mbps Program Stream",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "HD50PS1080P",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "HD50PS1080p",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SD15480P4X3",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SD15480p4x3",
          "semantic_meaning": "720x480 4x3 SD (NTSC) 2 Channel 15Mbps Program Stream",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SD15480P4X3",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SD15480p4x3",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SD15480P16X9",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SD15480p16x9",
          "semantic_meaning": "720x480 16x9 SD (NTSC) 2 Channel 15Mbps Program Stream",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SD15480P16X9",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SD15480p16x9",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SD15576P4X3",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SD15576p4x3",
          "semantic_meaning": "720x576 4x3 SD (PAL) 2 Channel 15Mbps Program Stream",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SD15576P4X3",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SD15576p4x3",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SD15576P16X9",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SD15576p16x9",
          "semantic_meaning": "720x576 16x9 SD (PAL) 2 Channel 15Mbps Program Stream",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SD15576P16X9",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SD15576p16x9",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:PROXQ2160PHDR10",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "PROXQ2160pHDR10",
          "semantic_meaning": "3840x2160 Progressive HDR10 ProRes(XQ)",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "PROXQ2160PHDR10",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "PROXQ2160pHDR10",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:CFFHD",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "CFFHD",
          "semantic_meaning": "HD UltraViolet UVU (1920x1080 nominal cropped to OAR)",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "CFFHD",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "CFFHD",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:CFFSD",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "CFFSD",
          "semantic_meaning": "SD UltraViolet UVU (854x480 nominal cropped to OAR)",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "CFFSD",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "CFFSD",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:UKCENSOR",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "UKCENSOR",
          "semantic_meaning": "UKCENSOR",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "UKCENSOR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "UKCENSOR",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:XDCAM1080I",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "XDCAM1080i",
          "semantic_meaning": "1920x1080 XDCAM HD 422",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "XDCAM1080I",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "XDCAM1080i",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:XDCAM1080ICC",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "XDCAM1080iCC",
          "semantic_meaning": "1920x1080 XDCAM HD 422 W/ SMPTE 436M Caption",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "XDCAM1080ICC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "XDCAM1080iCC",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:XDCAM720P",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "XDCAM720p",
          "semantic_meaning": "1280x720 XDCAM HD 422",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "XDCAM720P",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "XDCAM720p",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:XDCAM720PCC",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "XDCAM720pCC",
          "semantic_meaning": "1280x720 XDCAM HD 422 W/ SMPTE 436M Caption",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "XDCAM720PCC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "XDCAM720pCC",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:DPP1080I",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "DPP1080i",
          "semantic_meaning": "1920x1080 Interlaced AVC-Intra 100 in an AS-11 MXF",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "DPP1080I",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "DPP1080i",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:IMX512I4X3",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "IMX512i4x3",
          "semantic_meaning": "720x512 (NTSC) Interlaced D10 IMX50 flagged as 4x3",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "IMX512I4X3",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "IMX512i4x3",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:IMX512I4X3CC",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "IMX512i4x3CC",
          "semantic_meaning": "720x512 (NTSC) Interlaced D10 IMX50 flagged as 4x3 W/ CC",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "IMX512I4X3CC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "IMX512i4x3CC",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:IMX512I16X9",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "IMX512i16x9",
          "semantic_meaning": "720x512 (NTSC) Interlaced D10 IMX50 flagged as 16x9",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "IMX512I16X9",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "IMX512i16x9",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:IMX512I16X9CC",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "IMX512i16x9CC",
          "semantic_meaning": "720x512 (NTSC) Interlaced D10 IMX50 flagged as 16x9 W/ CC",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "IMX512I16X9CC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "IMX512i16x9CC",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SCRNRFFE720P",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SCRNRFFE720p",
          "semantic_meaning": "1280x720p 8Mbps H.264/MP4 FFE Screener",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SCRNRFFE720P",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SCRNRFFE720p",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:FFWMV480P4X3",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "FFWMV480p4x3",
          "semantic_meaning": "640x480p FoxFast WMV Screener (current spec)",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "FFWMV480P4X3",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "FFWMV480p4x3",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:FFWMV480P16X9",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "FFWMV480p16x9",
          "semantic_meaning": "854x480p FoxFast WMV Screener (current spec)",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "FFWMV480P16X9",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "FFWMV480p16x9",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:FFWMV360P",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "FFWMV360p",
          "semantic_meaning": "640x360p FoxFast WMV Screener (deprecated)",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "FFWMV360P",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "FFWMV360p",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:FFWMV480P",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "FFWMV480p",
          "semantic_meaning": "640x480p FoxFast WMV Screener (deprecated)",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "FFWMV480P",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "FFWMV480p",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:IMX608I4X3",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "IMX608i4x3",
          "semantic_meaning": "720x608 (PAL) Interlaced D10 IMX50 flagged as 4x3",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "IMX608I4X3",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "IMX608i4x3",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:IMX608I16X9",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "IMX608i16x9",
          "semantic_meaning": "720x608 (PAL) Interlaced D10 IMX50 flagged as 16x9",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "IMX608I16X9",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "IMX608i16x9",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SCRNRFFE1080P",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SCRNRFFE1080p",
          "semantic_meaning": "1920x1080p 20Mbps H.264/MP4 Screener",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SCRNRFFE1080P",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SCRNRFFE1080p",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:DR",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "DR",
          "semantic_meaning": "720x480 23.976fps Dubbing Reference QuickTime",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "DR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "DR",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:NDR",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "NDR",
          "semantic_meaning": "720x480 NTSC 29.97fps Dubbing Reference QuickTime",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "NDR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "NDR",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:PDR",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "PDR",
          "semantic_meaning": "720x576 PAL 25fps Dubbing Reference QuickTime",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "PDR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "PDR",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:CTFR",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "CTFR",
          "semantic_meaning": "Conformed Track Full Range",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "CTFR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "CTFR",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:CTFRMOV",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "CTFRMOV",
          "semantic_meaning": "Conformed Track Full Range MOV",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "CTFRMOV",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "CTFRMOV",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:ADMBWAV",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "ADMBWAV",
          "semantic_meaning": "ADM Broadcast WAV",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "ADMBWAV",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "ADMBWAV",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:CTA85",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "CTA85",
          "semantic_meaning": "Conformed Track ATSC A/85 Normalized",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "CTA85",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "CTA85",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:CTR128",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "CTR128",
          "semantic_meaning": "Conformed Track EBU R128 Normalized",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "CTR128",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "CTR128",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:CCSMPTETT",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "CCSMPTETT",
          "semantic_meaning": "SMPTE TT Caption File",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "CCSMPTETT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "CCSMPTETT",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:CCTDS",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "CCTDS",
          "semantic_meaning": "TDS Caption File",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "CCTDS",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "CCTDS",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:CCSCC",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "CCSCC",
          "semantic_meaning": "SCC Caption File",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "CCSCC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "CCSCC",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:CCSMI",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "CCSMI",
          "semantic_meaning": "SMI Caption File",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "CCSMI",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "CCSMI",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:CCCAP",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "CCCAP",
          "semantic_meaning": "CAP Caption",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "CCCAP",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "CCCAP",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SUBFULIMSC",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SUBFULIMSC",
          "semantic_meaning": "Full IMSC Subtitle Package",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SUBFULIMSC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SUBFULIMSC",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SUBSDHIMSC",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SUBSDHIMSC",
          "semantic_meaning": "SDH IMSC Subtitle Package",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SUBSDHIMSC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SUBSDHIMSC",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SUBFRCIMSC",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SUBFRCIMSC",
          "semantic_meaning": "Forced IMSC Subtitle Package",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SUBFRCIMSC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SUBFRCIMSC",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SUBFULSTL",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SUBFULSTL",
          "semantic_meaning": "Full EBU STL Subtitle Package",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SUBFULSTL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SUBFULSTL",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SUBSDHSTL",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SUBSDHSTL",
          "semantic_meaning": "SDH EBU STL Subtitle Package",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SUBSDHSTL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SUBSDHSTL",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SUBFRCSTL",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SUBFRCSTL",
          "semantic_meaning": "Forced EBU STL Subtitle Package",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SUBFRCSTL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SUBFRCSTL",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SUBFULBDN",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SUBFULBDN",
          "semantic_meaning": "Full BDN Subtitle Package (zipped)",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SUBFULBDN",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SUBFULBDN",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SUBFRCBDN",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SUBFRCBDN",
          "semantic_meaning": "Forced BDN Subtitle Package (zipped)",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SUBFRCBDN",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SUBFRCBDN",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SUBFULUHDBDN",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SUBFULUHDBDN",
          "semantic_meaning": "Full UHD BDN Subtitle Package (zipped)",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SUBFULUHDBDN",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SUBFULUHDBDN",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SUBFRCUHDBDN",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SUBFRCUHDBDN",
          "semantic_meaning": "Forced UHD BDN Subtitle Package (zipped)",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SUBFRCUHDBDN",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SUBFRCUHDBDN",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SUBFULUHDHDRBDN",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SUBFULUHDHDRBDN",
          "semantic_meaning": "Full UHD HDR BDN Subtitle Package (zipped)",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SUBFULUHDHDRBDN",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SUBFULUHDHDRBDN",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SUBFRCUHDHDRBDN",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SUBFRCUHDHDRBDN",
          "semantic_meaning": "Forced UHD HDR BDN Subtitle Package (zipped)",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SUBFRCUHDHDRBDN",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SUBFRCUHDHDRBDN",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SUBFULUYC",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SUBFULUYC",
          "semantic_meaning": "Full UYC Subtitle Package (zipped)",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SUBFULUYC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SUBFULUYC",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SUBFRCUYC",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SUBFRCUYC",
          "semantic_meaning": "Forced UYC Subtitle Package (zipped)",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SUBFRCUYC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SUBFRCUYC",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SUBFULFCP",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SUBFULFCP",
          "semantic_meaning": "Full FCP Subtitle Package (zipped)",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SUBFULFCP",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SUBFULFCP",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SUBFRCFCP",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SUBFRCFCP",
          "semantic_meaning": "Forced FCP Subtitle Package (zipped)",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SUBFRCFCP",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SUBFRCFCP",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SUBFULIFF",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SUBFULIFF",
          "semantic_meaning": "Full Apple iTT Subtitle",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SUBFULIFF",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SUBFULIFF",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SUBFRCITT",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SUBFRCITT",
          "semantic_meaning": "Forced Apple iTT Subtitle",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SUBFRCITT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SUBFRCITT",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SUBFULSMI",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SUBFULSMI",
          "semantic_meaning": "Full SAMI Subtitle",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SUBFULSMI",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SUBFULSMI",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SUBFRCSMI",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SUBFRCSMI",
          "semantic_meaning": "Forced SAMI Subtitle",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SUBFRCSMI",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SUBFRCSMI",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SUBFULCAP",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SUBFULCAP",
          "semantic_meaning": "Full Lambda CAP (Japanese) Subtitle",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SUBFULCAP",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SUBFULCAP",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SUBFRCCAP",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SUBFRCCAP",
          "semantic_meaning": "Forced Lambda CAP (Japanese) Subtitle",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SUBFRCCAP",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SUBFRCCAP",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SUBFULTXT",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SUBFULTXT",
          "semantic_meaning": "Full TXT Subtitle",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SUBFULTXT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SUBFULTXT",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SUBFRCTXT",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SUBFRCTXT",
          "semantic_meaning": "Forced TXT Subtitle",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SUBFRCTXT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SUBFRCTXT",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SUBFULSRT",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SUBFULSRT",
          "semantic_meaning": "Full SRT Subtitle",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SUBFULSRT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SUBFULSRT",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SUBFRCSRT",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SUBFRCSRT",
          "semantic_meaning": "Forced SRT Subtitle",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SUBFRCSRT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SUBFRCSRT",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SUBFULPAC",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SUBFULPAC",
          "semantic_meaning": "Full PAC Subtitle",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SUBFULPAC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SUBFULPAC",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SUBFRCPAC",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SUBFRCPAC",
          "semantic_meaning": "Forced PAC Subtitle",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SUBFRCPAC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SUBFRCPAC",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SUBSDHSRT",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SUBSDHSRT",
          "semantic_meaning": "SDH SRT Subtitle",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SUBSDHSRT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SUBSDHSRT",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:DUBCARDUHDHDR",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "DUBCARDUHDHDR",
          "semantic_meaning": "3840x2160 HDR Dub Card image or document",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "DUBCARDUHDHDR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "DUBCARDUHDHDR",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:DUBCARDUHDSDR",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "DUBCARDUHDSDR",
          "semantic_meaning": "3840x2160 SDR Dub Card image or document",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "DUBCARDUHDSDR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "DUBCARDUHDSDR",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:DUBCARDHD",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "DUBCARDHD",
          "semantic_meaning": "1920x1080 SDR Dub Card image or document",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "DUBCARDHD",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "DUBCARDHD",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:DUBCARDNTSC",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "DUBCARDNTSC",
          "semantic_meaning": "720x486 SDR Dub Card image or document",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "DUBCARDNTSC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "DUBCARDNTSC",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:DUBCARDPAL",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "DUBCARDPAL",
          "semantic_meaning": "720x576 SDR Dub Card image or document",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "DUBCARDPAL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "DUBCARDPAL",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:DUBCARDMOVHD",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "DUBCARDMOVHD",
          "semantic_meaning": "1920x1080 SDR Dub Card MOV",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "DUBCARDMOVHD",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "DUBCARDMOVHD",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:DUBCARDMOVNTSC4X3",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "DUBCARDMOVNTSC4x3",
          "semantic_meaning": "720x480 4x3 SDR Dub Card MOV",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "DUBCARDMOVNTSC4X3",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "DUBCARDMOVNTSC4x3",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:DUBCARDMOVNTSC16X9",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "DUBCARDMOVNTSC16x9",
          "semantic_meaning": "720x480 16x9 SDR Dub Card MOV",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "DUBCARDMOVNTSC16X9",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "DUBCARDMOVNTSC16x9",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:DUBCARDMOVPAL4X3",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "DUBCARDMOVPAL4x3",
          "semantic_meaning": "720x576 4x3 SDR Dub Card MOV",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "DUBCARDMOVPAL4X3",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "DUBCARDMOVPAL4x3",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:DUBCARDMOVPAL16X9",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "DUBCARDMOVPAL16x9",
          "semantic_meaning": "720x576 16x9 SDR Dub Card MOV",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "DUBCARDMOVPAL16X9",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "DUBCARDMOVPAL16x9",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:DOLBYVISIONMD444",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "DolbyVisionMD444",
          "semantic_meaning": "Dolby Vision 4:4:4 HDR Metadata",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "DOLBYVISIONMD444",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "DolbyVisionMD444",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:DOLBYVISIONMD422",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "DolbyVisionMD422",
          "semantic_meaning": "Dolby Vision 4:2:2 HDR Metadata",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "DOLBYVISIONMD422",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "DolbyVisionMD422",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:LREPORTBASE",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "LREPORTBASE",
          "semantic_meaning": "Localization Base Report",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "LREPORTBASE",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "LREPORTBASE",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:LREPORTSUB",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "LREPORTSUB",
          "semantic_meaning": "Localization Subtitled Report",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "LREPORTSUB",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "LREPORTSUB",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:LREPORTDUB",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "LREPORTDUB",
          "semantic_meaning": "Localization Dubbed Report",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "LREPORTDUB",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "LREPORTDUB",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SCRIPTPROD",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SCRIPTPROD",
          "semantic_meaning": "Production Script",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SCRIPTPROD",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SCRIPTPROD",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SCRIPTASREC",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SCRIPTASREC",
          "semantic_meaning": "As Recorded Script",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SCRIPTASREC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SCRIPTASREC",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SCRIPTDIALST",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SCRIPTDIALST",
          "semantic_meaning": "Dialogue List",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SCRIPTDIALST",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SCRIPTDIALST",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:REND:SCRIPTSPOTLST",
          "convention_id": "FOX",
          "token_name": "REND",
          "token_pattern": "SCRIPTSPOTLST",
          "semantic_meaning": "Spotting List",
          "constraints": {
            "source_token_name": "code-definitions-fox-rend",
            "code_normalized": "SCRIPTSPOTLST",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-rend.json",
            "source_key": "SCRIPTSPOTLST",
            "source_token_name": "code-definitions-fox-rend",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:TL:TEX",
          "convention_id": "FOX",
          "token_name": "TL",
          "token_pattern": "TEX",
          "semantic_meaning": "Textless",
          "constraints": {
            "source_token_name": "code-definitions-fox-tl",
            "code_normalized": "TEX",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-tl.json",
            "source_key": "TEX",
            "source_token_name": "code-definitions-fox-tl",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:TL:PTX",
          "convention_id": "FOX",
          "token_name": "TL",
          "token_pattern": "PTX",
          "semantic_meaning": "Pseudo Textless",
          "constraints": {
            "source_token_name": "code-definitions-fox-tl",
            "code_normalized": "PTX",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-tl.json",
            "source_key": "PTX",
            "source_token_name": "code-definitions-fox-tl",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:TL:ALL",
          "convention_id": "FOX",
          "token_name": "TL",
          "token_pattern": "ALL",
          "semantic_meaning": "MnE conformed to all Texted Languages",
          "constraints": {
            "source_token_name": "code-definitions-fox-tl",
            "code_normalized": "ALL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-tl.json",
            "source_key": "ALL",
            "source_token_name": "code-definitions-fox-tl",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:TYPE:C",
          "convention_id": "FOX",
          "token_name": "TYPE",
          "token_pattern": "C",
          "semantic_meaning": "Feature or Episode Full Length.",
          "constraints": {
            "source_token_name": "code-definitions-fox-type",
            "code_normalized": "C",
            "rule_kind": "code-definition",
            "source_metadata": {
              "description": "Content"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-type.json",
            "source_key": "C",
            "source_token_name": "code-definitions-fox-type",
            "source_metadata": {
              "description": "Content"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:TYPE:D",
          "convention_id": "FOX",
          "token_name": "TYPE",
          "token_pattern": "D",
          "semantic_meaning": "Credit for voice actors of a Localized Language.",
          "constraints": {
            "source_token_name": "code-definitions-fox-type",
            "code_normalized": "D",
            "rule_kind": "code-definition",
            "source_metadata": {
              "description": "Dub Card"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-type.json",
            "source_key": "D",
            "source_token_name": "code-definitions-fox-type",
            "source_metadata": {
              "description": "Dub Card"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:TYPE:E",
          "convention_id": "FOX",
          "token_name": "TYPE",
          "token_pattern": "E",
          "semantic_meaning": "Electronic Press Kit materials.",
          "constraints": {
            "source_token_name": "code-definitions-fox-type",
            "code_normalized": "E",
            "rule_kind": "code-definition",
            "source_metadata": {
              "description": "EPK"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-type.json",
            "source_key": "E",
            "source_token_name": "code-definitions-fox-type",
            "source_metadata": {
              "description": "EPK"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:TYPE:P",
          "convention_id": "FOX",
          "token_name": "TYPE",
          "token_pattern": "P",
          "semantic_meaning": "A short subclip of a Full Program, usually Episodic material.",
          "constraints": {
            "source_token_name": "code-definitions-fox-type",
            "code_normalized": "P",
            "rule_kind": "code-definition",
            "source_metadata": {
              "description": "Preview"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-type.json",
            "source_key": "P",
            "source_token_name": "code-definitions-fox-type",
            "source_metadata": {
              "description": "Preview"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:TYPE:R",
          "convention_id": "FOX",
          "token_name": "TYPE",
          "token_pattern": "R",
          "semantic_meaning": "Typically short commercial-like material.",
          "constraints": {
            "source_token_name": "code-definitions-fox-type",
            "code_normalized": "R",
            "rule_kind": "code-definition",
            "source_metadata": {
              "description": "Promo"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-type.json",
            "source_key": "R",
            "source_token_name": "code-definitions-fox-type",
            "source_metadata": {
              "description": "Promo"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:TYPE:T",
          "convention_id": "FOX",
          "token_name": "TYPE",
          "token_pattern": "T",
          "semantic_meaning": "Standard Theatrical Trailer.",
          "constraints": {
            "source_token_name": "code-definitions-fox-type",
            "code_normalized": "T",
            "rule_kind": "code-definition",
            "source_metadata": {
              "description": "Trailer"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-type.json",
            "source_key": "T",
            "source_token_name": "code-definitions-fox-type",
            "source_metadata": {
              "description": "Trailer"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:3DVD",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "3DVD",
          "semantic_meaning": "3D",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "3DVD",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "3DVD",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:AIRL",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "AIRL",
          "semantic_meaning": "Airline",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "AIRL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "AIRL",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:ALTV",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "ALTV",
          "semantic_meaning": "Alternate",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "ALTV",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "ALTV",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:BART",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "BART",
          "semantic_meaning": "Barter",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "BART",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "BART",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:BBID",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "BBID",
          "semantic_meaning": "Blind Bid",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "BBID",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "BBID",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:CABL",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "CABL",
          "semantic_meaning": "TTV Cable",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "CABL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "CABL",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:CASH",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "CASH",
          "semantic_meaning": "Cash Syndicated",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "CASH",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "CASH",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:CNSH",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "CNSH",
          "semantic_meaning": "Censorship",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "CNSH",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "CNSH",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:CRFX",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "CRFX",
          "semantic_meaning": "Credit Fixes",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "CRFX",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "CRFX",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:DIRC",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "DIRC",
          "semantic_meaning": "Director's Cut",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "DIRC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "DIRC",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:EXTD",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "EXTD",
          "semantic_meaning": "Extended",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "EXTD",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "EXTD",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:FNGS",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "FNGS",
          "semantic_meaning": "FNG Syndication",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "FNGS",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "FNGS",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:FOXF",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "FOXF",
          "semantic_meaning": "Fox",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "FOXF",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "FOXF",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:HOME",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "HOME",
          "semantic_meaning": "Home Entertainment",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "HOME",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "HOME",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:INTL",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "INTL",
          "semantic_meaning": "International",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "INTL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "INTL",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:LOGO",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "LOGO",
          "semantic_meaning": "Logo",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "LOGO",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "LOGO",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:LONG",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "LONG",
          "semantic_meaning": "Long",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "LONG",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "LONG",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:MUSR",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "MUSR",
          "semantic_meaning": "Music Replacement",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "MUSR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "MUSR",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:NETW",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "NETW",
          "semantic_meaning": "TV Network",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "NETW",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "NETW",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:NSVR",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "NSVR",
          "semantic_meaning": "Not Version Specific",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "NSVR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "NSVR",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:NSYN",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "NSYN",
          "semantic_meaning": "TV Network / Syndicated",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "NSYN",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "NSYN",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:NPRE",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "NPRE",
          "semantic_meaning": "Network Presents",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "NPRE",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "NPRE",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:NPRO",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "NPRO",
          "semantic_meaning": "Network Promo",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "NPRO",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "NPRO",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:ORIG",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "ORIG",
          "semantic_meaning": "Original",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "ORIG",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "ORIG",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:RCRD",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "RCRD",
          "semantic_meaning": "Rating Card",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "RCRD",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "RCRD",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:RCUT",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "RCUT",
          "semantic_meaning": "Recut",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "RCUT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "RCUT",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:REVD",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "REVD",
          "semantic_meaning": "Revised",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "REVD",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "REVD",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:SHRT",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "SHRT",
          "semantic_meaning": "Shortened",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "SHRT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "SHRT",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:SING",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "SING",
          "semantic_meaning": "Sing Along",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "SING",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "SING",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:SPCL",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "SPCL",
          "semantic_meaning": "Special Edition",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "SPCL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "SPCL",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:STAL",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "STAL",
          "semantic_meaning": "Stand Alone",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "STAL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "STAL",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:TELE",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "TELE",
          "semantic_meaning": "TV",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "TELE",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "TELE",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:TVCE",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "TVCE",
          "semantic_meaning": "TTV Content Edit",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "TVCE",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "TVCE",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:TVSN",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "TVSN",
          "semantic_meaning": "TTV Syndicated",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "TVSN",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "TVSN",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:UNCN",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "UNCN",
          "semantic_meaning": "Uncensored",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "UNCN",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "UNCN",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:UNRT",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "UNRT",
          "semantic_meaning": "Unrated",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "UNRT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "UNRT",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:VAKA",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "VAKA",
          "semantic_meaning": "Version AKA",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "VAKA",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "VAKA",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:WOCB",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "WOCB",
          "semantic_meaning": "Without Commercial Breaks",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "WOCB",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "WOCB",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:VER:WORC",
          "convention_id": "FOX",
          "token_name": "VER",
          "token_pattern": "WORC",
          "semantic_meaning": "Without Recap",
          "constraints": {
            "source_token_name": "code-definitions-fox-ver",
            "code_normalized": "WORC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/code-definitions-fox-ver.json",
            "source_key": "WORC",
            "source_token_name": "code-definitions-fox-ver",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:FOX-TOKEN-DEFINITIONS_V10:VERSION",
          "convention_id": "FOX",
          "token_name": "FOX-TOKEN-DEFINITIONS_V10",
          "token_pattern": "version",
          "semantic_meaning": "1.0.0",
          "constraints": {
            "source_token_name": "fox-token-definitions_v10",
            "code_normalized": "VERSION",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/fox-token-definitions_v10.json",
            "source_key": "version",
            "source_token_name": "fox-token-definitions_v10",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:FOX-TOKEN-DEFINITIONS_V10:MASKSTRING",
          "convention_id": "FOX",
          "token_name": "FOX-TOKEN-DEFINITIONS_V10",
          "token_pattern": "maskString",
          "semantic_meaning": "SHOW_EP_CLASS_VID_MAST_TYPE_DIV_REND_FPS_TL_IAR_CL/CU-TF_RT_NOTE",
          "constraints": {
            "source_token_name": "fox-token-definitions_v10",
            "code_normalized": "MASKSTRING",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/fox-token-definitions_v10.json",
            "source_key": "maskString",
            "source_token_name": "fox-token-definitions_v10",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:FOX-TOKEN-DEFINITIONS_V10:SOURCE",
          "convention_id": "FOX",
          "token_name": "FOX-TOKEN-DEFINITIONS_V10",
          "token_pattern": "source",
          "semantic_meaning": "Version 10",
          "constraints": {
            "source_token_name": "fox-token-definitions_v10",
            "code_normalized": "SOURCE",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/fox-token-definitions_v10.json",
            "source_key": "source",
            "source_token_name": "fox-token-definitions_v10",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:FOX-TOKEN-DEFINITIONS_V9:VERSION",
          "convention_id": "FOX",
          "token_name": "FOX-TOKEN-DEFINITIONS_V9",
          "token_pattern": "version",
          "semantic_meaning": "1.0.0",
          "constraints": {
            "source_token_name": "fox-token-definitions_v9",
            "code_normalized": "VERSION",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/fox-token-definitions_v9.json",
            "source_key": "version",
            "source_token_name": "fox-token-definitions_v9",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:FOX-TOKEN-DEFINITIONS_V9:MASKSTRING",
          "convention_id": "FOX",
          "token_name": "FOX-TOKEN-DEFINITIONS_V9",
          "token_pattern": "maskString",
          "semantic_meaning": "SHOW_WPR_VER_VID_MAST_TYPE_DIV_REND_FPS_TL_IAR_CL/CU-TF_RT_NOTE",
          "constraints": {
            "source_token_name": "fox-token-definitions_v9",
            "code_normalized": "MASKSTRING",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/fox-token-definitions_v9.json",
            "source_key": "maskString",
            "source_token_name": "fox-token-definitions_v9",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:FOX-TOKEN-DEFINITIONS_V9:SOURCE",
          "convention_id": "FOX",
          "token_name": "FOX-TOKEN-DEFINITIONS_V9",
          "token_pattern": "source",
          "semantic_meaning": "Version 9.4",
          "constraints": {
            "source_token_name": "fox-token-definitions_v9",
            "code_normalized": "SOURCE",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/fox-token-definitions_v9.json",
            "source_key": "source",
            "source_token_name": "fox-token-definitions_v9",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:MANIFEST:REPOURL",
          "convention_id": "FOX",
          "token_name": "MANIFEST",
          "token_pattern": "repoUrl",
          "semantic_meaning": "TBD",
          "constraints": {
            "source_token_name": "manifest",
            "code_normalized": "REPOURL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/manifest.json",
            "source_key": "repoUrl",
            "source_token_name": "manifest",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:MANIFEST:REF",
          "convention_id": "FOX",
          "token_name": "MANIFEST",
          "token_pattern": "ref",
          "semantic_meaning": "fox-legacy-branch",
          "constraints": {
            "source_token_name": "manifest",
            "code_normalized": "REF",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/manifest.json",
            "source_key": "ref",
            "source_token_name": "manifest",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:MANIFEST:SOURCEDIR",
          "convention_id": "FOX",
          "token_name": "MANIFEST",
          "token_pattern": "sourceDir",
          "semantic_meaning": "fox/sources",
          "constraints": {
            "source_token_name": "manifest",
            "code_normalized": "SOURCEDIR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/manifest.json",
            "source_key": "sourceDir",
            "source_token_name": "manifest",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        },
        {
          "rule_id": "FOX:MANIFEST:IMPORTEDAT",
          "convention_id": "FOX",
          "token_name": "MANIFEST",
          "token_pattern": "importedAt",
          "semantic_meaning": "2026-07-06T00:00:00Z",
          "constraints": {
            "source_token_name": "manifest",
            "code_normalized": "IMPORTEDAT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/manifest.json",
            "source_key": "importedAt",
            "source_token_name": "manifest",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-08T01:00:50.284Z",
          "updated_at": "2026-07-08T01:00:50.284Z"
        }
      ]
    },
    "./data/conventions/fox-audio-services/rules.draft.json": {
      "conventionId": "FOX-AUDIO-SERVICES",
      "maskSpec": {
        "id": "FOX-AUDIO-SERVICES-v1",
        "name": "Fox Audio Services (Legacy)",
        "role": "file",
        "mask": "TITLE_WPR_JOBTYPE_PICCUT_ADTLINFO_LANGSND_TRACKCONFIG_STANDARD_R_TECHINFO_VERSION_SUFFIX",
        "mainDelimiter": "_",
        "subDelimiter": "-",
        "optionalSegments": [
          "ADTLINFO",
          "R",
          "TECHINFO",
          "VERSION",
          "SUFFIX"
        ],
        "informationalTokens": [
          "TITLE",
          "WPR"
        ]
      },
      "matchThreshold": 0.35,
      "version": 1,
      "status": "draft",
      "generatedAt": "2026-07-17T23:13:40Z",
      "ruleCount": 217,
      "rules": [
        {
          "rule_id": "FOX-AUDIO-SERVICES:ADTLINFO:2IM",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "ADTLINFO",
          "token_pattern": "2im",
          "semantic_meaning": "Secondary Audio Bitstream - in mux",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "code_normalized": "2IM",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-adtlinfo.json",
            "source_key": "2im",
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:ADTLINFO:2OM",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "ADTLINFO",
          "token_pattern": "2om",
          "semantic_meaning": "Secondary Audio Bitstream - out of mux",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "code_normalized": "2OM",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-adtlinfo.json",
            "source_key": "2om",
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:ADTLINFO:FDUB",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "ADTLINFO",
          "token_pattern": "FDub",
          "semantic_meaning": "Fully Dubbed Version",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "code_normalized": "FDUB",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-adtlinfo.json",
            "source_key": "FDub",
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:ADTLINFO:FINAL",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "ADTLINFO",
          "token_pattern": "Final",
          "semantic_meaning": "Final Production",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "code_normalized": "FINAL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-adtlinfo.json",
            "source_key": "Final",
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:ADTLINFO:IMU",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "ADTLINFO",
          "token_pattern": "Imu",
          "semantic_meaning": "Non-Secondary Audio Bitstream - in mux",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "code_normalized": "IMU",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-adtlinfo.json",
            "source_key": "Imu",
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:ADTLINFO:LAF",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "ADTLINFO",
          "token_pattern": "Laf",
          "semantic_meaning": "Laugh Track Version",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "code_normalized": "LAF",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-adtlinfo.json",
            "source_key": "Laf",
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:ADTLINFO:MR",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "ADTLINFO",
          "token_pattern": "Mr",
          "semantic_meaning": "Music Replacement Version",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "code_normalized": "MR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-adtlinfo.json",
            "source_key": "Mr",
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:ADTLINFO:NF",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "ADTLINFO",
          "token_pattern": "Nf",
          "semantic_meaning": "Nearfield Dynamic Mix",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "code_normalized": "NF",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-adtlinfo.json",
            "source_key": "Nf",
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:ADTLINFO:OMU",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "ADTLINFO",
          "token_pattern": "Omu",
          "semantic_meaning": "Non-Secondary Audio Bistream - out of mux",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "code_normalized": "OMU",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-adtlinfo.json",
            "source_key": "Omu",
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:ADTLINFO:PC",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "ADTLINFO",
          "token_pattern": "Pc",
          "semantic_meaning": "Pitch-corrected",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "code_normalized": "PC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-adtlinfo.json",
            "source_key": "Pc",
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:ADTLINFO:PIP",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "ADTLINFO",
          "token_pattern": "Pip",
          "semantic_meaning": "Picture-in-picture",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "code_normalized": "PIP",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-adtlinfo.json",
            "source_key": "Pip",
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:ADTLINFO:PRE",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "ADTLINFO",
          "token_pattern": "Pre",
          "semantic_meaning": "Dialog \"Premix\" (Lang must follow, ie  PreLSP)",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "code_normalized": "PRE",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-adtlinfo.json",
            "source_key": "Pre",
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:ADTLINFO:PRL",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "ADTLINFO",
          "token_pattern": "Prl",
          "semantic_meaning": "\"Pre-theatrical release\" Audio",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "code_normalized": "PRL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-adtlinfo.json",
            "source_key": "Prl",
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:ADTLINFO:TEMP",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "ADTLINFO",
          "token_pattern": "Temp",
          "semantic_meaning": "Temporary Production (non-final)",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "code_normalized": "TEMP",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-adtlinfo.json",
            "source_key": "Temp",
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:ADTLINFO:THL",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "ADTLINFO",
          "token_pattern": "Thl",
          "semantic_meaning": "Theatrical Dynamic Mix",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "code_normalized": "THL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-adtlinfo.json",
            "source_key": "Thl",
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:ADTLINFO:UK",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "ADTLINFO",
          "token_pattern": "Uk",
          "semantic_meaning": "UK Audio Version (Lang must follow, ie UkENG)*",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "code_normalized": "UK",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-adtlinfo.json",
            "source_key": "Uk",
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:ADTLINFO:UKAD",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "ADTLINFO",
          "token_pattern": "UkAd",
          "semantic_meaning": "UK Audio Descriptive Track",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "code_normalized": "UKAD",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-adtlinfo.json",
            "source_key": "UkAd",
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:ADTLINFO:USAD",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "ADTLINFO",
          "token_pattern": "UsAd",
          "semantic_meaning": "US Audio Descriptive Track",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "code_normalized": "USAD",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-adtlinfo.json",
            "source_key": "UsAd",
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:ADTLINFO:VO",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "ADTLINFO",
          "token_pattern": "Vo",
          "semantic_meaning": "Voice-over",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "code_normalized": "VO",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-adtlinfo.json",
            "source_key": "Vo",
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:ADTLINFO:VSL",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "ADTLINFO",
          "token_pattern": "vsl",
          "semantic_meaning": "Virtual Service Library",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "code_normalized": "VSL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-adtlinfo.json",
            "source_key": "vsl",
            "source_token_name": "code-definitions-fox-audio-adtlinfo",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:ADPUB",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "AdPub",
          "semantic_meaning": "International Advertising and Publicity",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "ADPUB",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "AdPub",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:BDDOM",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "BDdom",
          "semantic_meaning": "Blu-ray Domestic",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "BDDOM",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "BDdom",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:BDINT",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "BDint",
          "semantic_meaning": "Blu-ray International",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "BDINT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "BDint",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:CADV",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "CAdv",
          "semantic_meaning": "Creative Advertising",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "CADV",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "CAdv",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:DVDDOM",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "DVDdom",
          "semantic_meaning": "DVD Domestic",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "DVDDOM",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "DVDdom",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:DVDINT",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "DVDint",
          "semantic_meaning": "DVD International",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "DVDINT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "DVDint",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:FMSAPP",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "FMSapp",
          "semantic_meaning": "Fox Media Services - Apple",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "FMSAPP",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "FMSapp",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:FMSCP",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "FMScp",
          "semantic_meaning": "Fox Media Services - Content Protection",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "FMSCP",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "FMScp",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:FMSDC",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "FMSdc",
          "semantic_meaning": "Fox Media Services - Digital Copy",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "FMSDC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "FMSdc",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:FMSEST",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "FMSest",
          "semantic_meaning": "Fox Media Services - Electronic Sell Through",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "FMSEST",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "FMSest",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:FMSLOC",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "FMSloc",
          "semantic_meaning": "Fox Media Services - Localization",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "FMSLOC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "FMSloc",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:FMSMEZ",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "FMSmez",
          "semantic_meaning": "Fox Media Services - Mezzanine",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "FMSMEZ",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "FMSmez",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:FMSRET",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "FMSret",
          "semantic_meaning": "Fox Media Services - Retail",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "FMSRET",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "FMSret",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:FMSSRC",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "FMSsrc",
          "semantic_meaning": "Fox Media Services - Source",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "FMSSRC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "FMSsrc",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:FMSTVD",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "FMStvd",
          "semantic_meaning": "Fox Media Services - TV Distribution",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "FMSTVD",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "FMStvd",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:FPP",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "FPP",
          "semantic_meaning": "Feature Post Production",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "FPP",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "FPP",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:HEMRK",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "HEmrk",
          "semantic_meaning": "TSFHE - Marketing Services",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "HEMRK",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "HEmrk",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:HVDOM",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "HVdom",
          "semantic_meaning": "Home Video Domestic",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "HVDOM",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "HVdom",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:HVINT",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "HVint",
          "semantic_meaning": "Home Video International",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "HVINT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "HVint",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:INTTHL",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "IntThl",
          "semantic_meaning": "International Theatrical Services",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "INTTHL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "IntThl",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:LMCR",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "LMCr",
          "semantic_meaning": "L&M Creative",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "LMCR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "LMCr",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:NEWREG",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "NewReg",
          "semantic_meaning": "New Regency Productions",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "NEWREG",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "NewReg",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:PUBDOM",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "PubDom",
          "semantic_meaning": "Publicity - Domestic Theatrical",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "PUBDOM",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "PubDom",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:RESPRS",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "ResPrs",
          "semantic_meaning": "Restoration & Preservation",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "RESPRS",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "ResPrs",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:RSTPRS",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "RstPrs",
          "semantic_meaning": "Restoration & Preservation",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "RSTPRS",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "RstPrs",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:SLTMRK",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "SltMrk",
          "semantic_meaning": "Searchlight Marketing",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "SLTMRK",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "SltMrk",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:SLTPP",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "SltPP",
          "semantic_meaning": "Searchlight Post Production",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "SLTPP",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "SltPP",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:TSDIGC",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "TSdigc",
          "semantic_meaning": "Tech Services Digital Copy Mastering",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "TSDIGC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "TSdigc",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:TSMAS",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "TSmas",
          "semantic_meaning": "Tech Services Feature Mastering",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "TSMAS",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "TSmas",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:TVD",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "TVD",
          "semantic_meaning": "TV Distribution",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "TVD",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "TVD",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:TVPP",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "TVPP",
          "semantic_meaning": "TCFT Post Production",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "TVPP",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "TVPP",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:UMDDOM",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "UMDdom",
          "semantic_meaning": "UMD Domestic (Sony)",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "UMDDOM",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "UMDdom",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:JOBTYPE:UMDINT",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "JOBTYPE",
          "token_pattern": "UMDint",
          "semantic_meaning": "UMD International (Sony)",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "code_normalized": "UMDINT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-jobtype.json",
            "source_key": "UMDint",
            "source_token_name": "code-definitions-fox-audio-jobtype",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:LANGSND:ACOM",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "LANGSND",
          "token_pattern": "ACOM",
          "semantic_meaning": "Actor Commentary",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "ACOM",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "snd"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "ACOM",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "snd"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:LANGSND:CCOM",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "LANGSND",
          "token_pattern": "CCOM",
          "semantic_meaning": "Crew Commentary",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "CCOM",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "snd"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "CCOM",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "snd"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:LANGSND:COM",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "LANGSND",
          "token_pattern": "COM",
          "semantic_meaning": "Unspecified commentary",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "COM",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "snd"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "COM",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "snd"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:LANGSND:DCOM",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "LANGSND",
          "token_pattern": "DCOM",
          "semantic_meaning": "Director Commentary",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "DCOM",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "snd"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "DCOM",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "snd"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:LANGSND:DME",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "LANGSND",
          "token_pattern": "DME",
          "semantic_meaning": "Stems: Dialog, Music & Effects",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "DME",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "stem"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "DME",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "stem"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:LANGSND:DMEE",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "LANGSND",
          "token_pattern": "DMEE",
          "semantic_meaning": "Stems: Dialog, Music, Effects, Filled Effects",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "DMEE",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "stem"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "DMEE",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "stem"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:LANGSND:DSTM",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "LANGSND",
          "token_pattern": "Dstm",
          "semantic_meaning": "Dialog Stem (Lang abbrv must follow, ie DstmENG)",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "DSTM",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "stem"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "Dstm",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "stem"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:LANGSND:DSTMOPT",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "LANGSND",
          "token_pattern": "DstmOPT",
          "semantic_meaning": "Optional stem containing foreign production dx",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "DSTMOPT",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "stem"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "DstmOPT",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "stem"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:LANGSND:ECOM",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "LANGSND",
          "token_pattern": "ECOM",
          "semantic_meaning": "Visual Effects Commentary",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "ECOM",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "snd"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "ECOM",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "snd"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:LANGSND:ESTM",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "LANGSND",
          "token_pattern": "ESTM",
          "semantic_meaning": "Effects Stem (All CAPS)",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "ESTM",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "stem"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "ESTM",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "stem"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:LANGSND:FESTM",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "LANGSND",
          "token_pattern": "FESTM",
          "semantic_meaning": "Fully-filled Effects Stem (All CAPS)",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "FESTM",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "stem"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "FESTM",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "stem"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:LANGSND:FSTM",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "LANGSND",
          "token_pattern": "FSTM",
          "semantic_meaning": "Foley Stem (All CAPS)",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "FSTM",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "stem"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "FSTM",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "stem"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:LANGSND:ISOMUS",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "LANGSND",
          "token_pattern": "IsoMUS",
          "semantic_meaning": "Isolated music soundtrack",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "ISOMUS",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "iso"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "IsoMUS",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "iso"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:LANGSND:ME",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "LANGSND",
          "token_pattern": "ME",
          "semantic_meaning": "Composite or Discrete Music & Effects",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "ME",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "me"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "ME",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "me"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:LANGSND:MSTM",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "LANGSND",
          "token_pattern": "MSTM",
          "semantic_meaning": "Music Stem (All CAPS)",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "MSTM",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "stem"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "MSTM",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "stem"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:LANGSND:VOSTM",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "LANGSND",
          "token_pattern": "VOstm",
          "semantic_meaning": "VO Stem  (Lang. must follow, ie UkAdVOstmENG)",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "VOSTM",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "stem"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "VOstm",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "stem"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:LANGSND:VSTM",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "LANGSND",
          "token_pattern": "VSTM",
          "semantic_meaning": "Vocal Stem (ALL CAPS)",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "VSTM",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "stem"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "VSTM",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "stem"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:LANGSND:WCOM",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "LANGSND",
          "token_pattern": "WCOM",
          "semantic_meaning": "Writer Commentary",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "WCOM",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "snd"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "WCOM",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "snd"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:ADDSCN",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "AddScn",
          "semantic_meaning": "Add Scenes",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "ADDSCN",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "AddScn",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:AIR",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "Air",
          "semantic_meaning": "Aired Version",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "AIR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "Air",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:ALTEND",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "AltEnd",
          "semantic_meaning": "Alternate Ending",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "ALTEND",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "AltEnd",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:ASC",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "ASc",
          "semantic_meaning": "Academy Screener",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "ASC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "ASc",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:AUSVR",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "AusVr",
          "semantic_meaning": "Australian Version",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "AUSVR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "AusVr",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:CENVR",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "CenVr",
          "semantic_meaning": "Censored Version",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "CENVR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "CenVr",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:COLED",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "ColEd",
          "semantic_meaning": "Collector Edition",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "COLED",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "ColEd",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:DCUT",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "Dcut",
          "semantic_meaning": "Directors Cut",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "DCUT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "Dcut",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:DELSCN",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "DelScn",
          "semantic_meaning": "Deleted Scenes",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "DELSCN",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "DelScn",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:DIRCUT",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "DirCut",
          "semantic_meaning": "Directors Cut",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "DIRCUT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "DirCut",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:ENDTTL",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "EndTtl",
          "semantic_meaning": "End Title",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "ENDTTL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "EndTtl",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:EPNVR",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "EpnVr",
          "semantic_meaning": "Epsilon Version",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "EPNVR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "EpnVr",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:EXT",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "Ext",
          "semantic_meaning": "Extended Cut",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "EXT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "Ext",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:EXTRAS",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "Extras",
          "semantic_meaning": "Extras",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "EXTRAS",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "Extras",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:GERVR",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "GerVr",
          "semantic_meaning": "German Version",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "GERVR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "GerVr",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:HENTVR",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "HEntVr",
          "semantic_meaning": "Home Entertainment Version",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "HENTVR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "HEntVr",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:LIMCML",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "LimCml",
          "semantic_meaning": "Limited Commercial",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "LIMCML",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "LimCml",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:LONGVR",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "LongVr",
          "semantic_meaning": "Long Version",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "LONGVR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "LongVr",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:MENU",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "Menu",
          "semantic_meaning": "Menu Items",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "MENU",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "Menu",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:MNTTL",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "MnTtl",
          "semantic_meaning": "Main Title",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "MNTTL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "MnTtl",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:NETW",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "Netw",
          "semantic_meaning": "Network Cut",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "NETW",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "Netw",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:ORGVR",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "OrgVr",
          "semantic_meaning": "Original Version",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "ORGVR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "OrgVr",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:OUTTAK",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "Outtak",
          "semantic_meaning": "Outtakes",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "OUTTAK",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "Outtak",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:RDSVR",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "RdsVr",
          "semantic_meaning": "Roadshow Version",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "RDSVR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "RdsVr",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:RENVR",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "RenVr",
          "semantic_meaning": "Rental Version",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "RENVR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "RenVr",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:RETVR",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "RetVr",
          "semantic_meaning": "Retail Version",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "RETVR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "RetVr",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:RRTD",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "RRtd",
          "semantic_meaning": "R-Rated Version",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "RRTD",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "RRtd",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:SHRTVR",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "ShrtVr",
          "semantic_meaning": "Short Version",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "SHRTVR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "ShrtVr",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:SPED",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "SpEd",
          "semantic_meaning": "Special Edition",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "SPED",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "SpEd",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:SYND",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "Synd",
          "semantic_meaning": "Syndicated Cut",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "SYND",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "Synd",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:THL",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "Thl",
          "semantic_meaning": "Theatrical Cut",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "THL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "Thl",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:TRL",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "Trl",
          "semantic_meaning": "Trailer",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "TRL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "Trl",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:TSR",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "Tsr",
          "semantic_meaning": "Teaser",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "TSR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "Tsr",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:TXL",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "Txl",
          "semantic_meaning": "Textless",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "TXL",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "Txl",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:TXT",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "Txt",
          "semantic_meaning": "Texted",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "TXT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "Txt",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:UCENVR",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "UcenVr",
          "semantic_meaning": "Uncensored Version",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "UCENVR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "UcenVr",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:UKVR",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "UkVr",
          "semantic_meaning": "United  Kingdom Version",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "UKVR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "UkVr",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:UNAIR",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "Unair",
          "semantic_meaning": "Unaired Version",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "UNAIR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "Unair",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:UNCUT",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "Uncut",
          "semantic_meaning": "Uncut Version",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "UNCUT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "Uncut",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:UNRVR",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "UnrVr",
          "semantic_meaning": "Unrated Version",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "UNRVR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "UnrVr",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:PICCUT:VAM",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "PICCUT",
          "token_pattern": "VAM",
          "semantic_meaning": "Value added material",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-piccut",
            "code_normalized": "VAM",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-piccut.json",
            "source_key": "VAM",
            "source_token_name": "code-definitions-fox-audio-piccut",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:STANDARD:F",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "STANDARD",
          "token_pattern": "F",
          "semantic_meaning": "Film Speed (24 fps)",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "F",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "standard"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "F",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "standard"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:STANDARD:H",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "STANDARD",
          "token_pattern": "H",
          "semantic_meaning": "High Definition (23.976 fps)",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "H",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "standard"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "H",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "standard"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:STANDARD:N",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "STANDARD",
          "token_pattern": "N",
          "semantic_meaning": "NTSC (23.976 fps / 29.97 DFTC or NDFTC)",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "N",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "standard"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "N",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "standard"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:STANDARD:P",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "STANDARD",
          "token_pattern": "P",
          "semantic_meaning": "PAL (25 fps)",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "P",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "standard"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "P",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "standard"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:.AC3",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": ".ac3",
          "semantic_meaning": "Dolby Digital",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "code_normalized": ".AC3",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-bitrate.json",
            "source_key": ".ac3",
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:.CPT",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": ".cpt",
          "semantic_meaning": "dts Digital Surround (for DVD)",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "code_normalized": ".CPT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-bitrate.json",
            "source_key": ".cpt",
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:.CPT.LOG",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": ".cpt.log",
          "semantic_meaning": "dts (for DVD) log file (software encoder)",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "code_normalized": ".CPT.LOG",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-bitrate.json",
            "source_key": ".cpt.log",
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:.DTSHD",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": ".dtshd",
          "semantic_meaning": "dts-HD (for Blu-ray)",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "code_normalized": ".DTSHD",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-bitrate.json",
            "source_key": ".dtshd",
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:.DTSHDPBR",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": ".dtshdpbr",
          "semantic_meaning": "dts-MA lossless bit rate analysis log file (text doc)",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "code_normalized": ".DTSHDPBR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-bitrate.json",
            "source_key": ".dtshdpbr",
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:.DTSHD_LOG.TXT",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": ".dtshd_log.txt",
          "semantic_meaning": "dts (for Blu-ray) start timecode info and bit analysis",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "code_normalized": ".DTSHD_LOG.TXT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-bitrate.json",
            "source_key": ".dtshd_log.txt",
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:.PRJ",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": ".prj",
          "semantic_meaning": "dts (for DVD) log file (hardware encoder)",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "code_normalized": ".PRJ",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-bitrate.json",
            "source_key": ".prj",
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:ADD",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "Add",
          "semantic_meaning": "Add Dialog Track",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-track",
            "code_normalized": "ADD",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-track.json",
            "source_key": "Add",
            "source_token_name": "code-definitions-fox-audio-track",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:AIT",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "ait",
          "semantic_meaning": "Restored from AIT prior to 11/2007",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-suffix",
            "code_normalized": "AIT",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "transfer"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-suffix.json",
            "source_key": "ait",
            "source_token_name": "code-definitions-fox-audio-suffix",
            "source_metadata": {
              "format": "transfer"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:ASP",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "asp",
          "semantic_meaning": "Aspera delivery",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-suffix",
            "code_normalized": "ASP",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "transfer"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-suffix.json",
            "source_key": "asp",
            "source_token_name": "code-definitions-fox-audio-suffix",
            "source_metadata": {
              "format": "transfer"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:C",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "C",
          "semantic_meaning": "Center",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-track",
            "code_normalized": "C",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-track.json",
            "source_key": "C",
            "source_token_name": "code-definitions-fox-audio-track",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:D5",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "D5",
          "semantic_meaning": "D5 tape",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-tapetype",
            "code_normalized": "D5",
            "rule_kind": "code-definition",
            "source_metadata": {
              "notes": "TapeType variant; this may be a digital picture reference file. TapeType files may include multiple STANDARD codes separated by underscores."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-tapetype.json",
            "source_key": "D5",
            "source_token_name": "code-definitions-fox-audio-tapetype",
            "source_metadata": {
              "notes": "TapeType variant; this may be a digital picture reference file. TapeType files may include multiple STANDARD codes separated by underscores."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:DBC",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "DBC",
          "semantic_meaning": "Digital Betacam tape",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-tapetype",
            "code_normalized": "DBC",
            "rule_kind": "code-definition",
            "source_metadata": {
              "notes": "TapeType variant; this may be a digital picture reference file. TapeType files may include multiple STANDARD codes separated by underscores."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-tapetype.json",
            "source_key": "DBC",
            "source_token_name": "code-definitions-fox-audio-tapetype",
            "source_metadata": {
              "notes": "TapeType variant; this may be a digital picture reference file. TapeType files may include multiple STANDARD codes separated by underscores."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:DD192.AC3",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "DD192.ac3",
          "semantic_meaning": "Dolby Digital - ac3",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "code_normalized": "DD192.AC3",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "dolbydigital"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-bitrate.json",
            "source_key": "DD192.ac3",
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "source_metadata": {
              "format": "dolbydigital"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:DD448.AC3",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "DD448.ac3",
          "semantic_meaning": "Dolby Digital - ac3",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "code_normalized": "DD448.AC3",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "dolbydigital"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-bitrate.json",
            "source_key": "DD448.ac3",
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "source_metadata": {
              "format": "dolbydigital"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:DIG",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "dig",
          "semantic_meaning": "Digidelivery",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-suffix",
            "code_normalized": "DIG",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "transfer"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-suffix.json",
            "source_key": "dig",
            "source_token_name": "code-definitions-fox-audio-suffix",
            "source_metadata": {
              "format": "transfer"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:DL",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "dl",
          "semantic_meaning": "Session completed for deliverable (any non-conformed media. ie: rate converts, media in reels)",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-suffix",
            "code_normalized": "DL",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "suffix"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-suffix.json",
            "source_key": "dl",
            "source_token_name": "code-definitions-fox-audio-suffix",
            "source_metadata": {
              "format": "suffix"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:DLMX",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "dlmx",
          "semantic_meaning": "Deliverable mix session",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-suffix",
            "code_normalized": "DLMX",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-suffix.json",
            "source_key": "dlmx",
            "source_token_name": "code-definitions-fox-audio-suffix",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:DLT",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "dlt",
          "semantic_meaning": "Restored from DLT prior to 11/2007",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-suffix",
            "code_normalized": "DLT",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "transfer"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-suffix.json",
            "source_key": "dlt",
            "source_token_name": "code-definitions-fox-audio-suffix",
            "source_metadata": {
              "format": "transfer"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:DM.MLP",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "DM.mlp",
          "semantic_meaning": "Dolby MLP lossless - bitrate not indicated",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "code_normalized": "DM.MLP",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "dolbydigital",
              "notes": "not in use by FOX"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-bitrate.json",
            "source_key": "DM.mlp",
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "source_metadata": {
              "format": "dolbydigital",
              "notes": "not in use by FOX"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:DP1164.EC3",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "DP1164.ec3",
          "semantic_meaning": "Dolby Digital Plus",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "code_normalized": "DP1164.EC3",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "dolbydigital",
              "notes": "not in use by FOX"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-bitrate.json",
            "source_key": "DP1164.ec3",
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "source_metadata": {
              "format": "dolbydigital",
              "notes": "not in use by FOX"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:DS768.DTSHD",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "DS768.dtshd",
          "semantic_meaning": "dts-HD Digital Surround for Blu-ray",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "code_normalized": "DS768.DTSHD",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "dts"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-bitrate.json",
            "source_key": "DS768.dtshd",
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "source_metadata": {
              "format": "dts"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:DSTM",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "Dstm",
          "semantic_meaning": "Dialog Stem",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-track",
            "code_normalized": "DSTM",
            "rule_kind": "code-definition",
            "source_metadata": {
              "notes": "(Lang abbrv must follow, ie DstmENG)"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-track.json",
            "source_key": "Dstm",
            "source_token_name": "code-definitions-fox-audio-track",
            "source_metadata": {
              "notes": "(Lang abbrv must follow, ie DstmENG)"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:DT.MLP",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "DT.mlp",
          "semantic_meaning": "Dolby TrueHD lossless - bitrate not indicated",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "code_normalized": "DT.MLP",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "dolbydigital",
              "notes": "not in use by FOX"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-bitrate.json",
            "source_key": "DT.mlp",
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "source_metadata": {
              "format": "dolbydigital",
              "notes": "not in use by FOX"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:DVCAM",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "DVCAM",
          "semantic_meaning": "DVCam tape",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-tapetype",
            "code_normalized": "DVCAM",
            "rule_kind": "code-definition",
            "source_metadata": {
              "notes": "TapeType variant; this may be a digital picture reference file. TapeType files may include multiple STANDARD codes separated by underscores."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-tapetype.json",
            "source_key": "DVCAM",
            "source_token_name": "code-definitions-fox-audio-tapetype",
            "source_metadata": {
              "notes": "TapeType variant; this may be a digital picture reference file. TapeType files may include multiple STANDARD codes separated by underscores."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:ED",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "ed",
          "semantic_meaning": "Audio editorial session prepared for mix",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-suffix",
            "code_normalized": "ED",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "suffix"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-suffix.json",
            "source_key": "ed",
            "source_token_name": "code-definitions-fox-audio-suffix",
            "source_metadata": {
              "format": "suffix"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:ESP",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "esp",
          "semantic_meaning": "Esprit delivery",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-suffix",
            "code_normalized": "ESP",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "transfer"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-suffix.json",
            "source_key": "esp",
            "source_token_name": "code-definitions-fox-audio-suffix",
            "source_metadata": {
              "format": "transfer"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:ESTM",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "ESTM",
          "semantic_meaning": "Effects Stem",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-track",
            "code_normalized": "ESTM",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-track.json",
            "source_key": "ESTM",
            "source_token_name": "code-definitions-fox-audio-track",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:FMS",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "fms",
          "semantic_meaning": "Sessions transferred from Media Services",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-suffix",
            "code_normalized": "FMS",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "transfer"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-suffix.json",
            "source_key": "fms",
            "source_token_name": "code-definitions-fox-audio-suffix",
            "source_metadata": {
              "format": "transfer"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:FTP",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "ftp",
          "semantic_meaning": "ftp delivery",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-suffix",
            "code_normalized": "FTP",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "transfer"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-suffix.json",
            "source_key": "ftp",
            "source_token_name": "code-definitions-fox-audio-suffix",
            "source_metadata": {
              "format": "transfer"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:FW",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "fw",
          "semantic_meaning": "Firewire (or external) hard drive",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-suffix",
            "code_normalized": "FW",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "transfer"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-suffix.json",
            "source_key": "fw",
            "source_token_name": "code-definitions-fox-audio-suffix",
            "source_metadata": {
              "format": "transfer"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:GDE",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "Gde",
          "semantic_meaning": "Mono English Dialog Guide",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-track",
            "code_normalized": "GDE",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-track.json",
            "source_key": "Gde",
            "source_token_name": "code-definitions-fox-audio-track",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:HDCAM_SR",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "HDCAM_SR",
          "semantic_meaning": "HDCam SR tape",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-tapetype",
            "code_normalized": "HDCAM_SR",
            "rule_kind": "code-definition",
            "source_metadata": {
              "notes": "TapeType variant; this may be a digital picture reference file. TapeType files may include multiple STANDARD codes separated by underscores."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-tapetype.json",
            "source_key": "HDCAM_SR",
            "source_token_name": "code-definitions-fox-audio-tapetype",
            "source_metadata": {
              "notes": "TapeType variant; this may be a digital picture reference file. TapeType files may include multiple STANDARD codes separated by underscores."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:HR3018.DTSHD",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "HR3018.dtshd",
          "semantic_meaning": "dts-HD High Resolution Audio for Blu-ray",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "code_normalized": "HR3018.DTSHD",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "dts"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-bitrate.json",
            "source_key": "HR3018.dtshd",
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "source_metadata": {
              "format": "dts"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:IP",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "ip",
          "semantic_meaning": "In Progress",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-suffix",
            "code_normalized": "IP",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "suffix"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-suffix.json",
            "source_key": "ip",
            "source_token_name": "code-definitions-fox-audio-suffix",
            "source_metadata": {
              "format": "suffix"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:IPMX",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "ipmx",
          "semantic_meaning": "In-progress mix session",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-suffix",
            "code_normalized": "IPMX",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-suffix.json",
            "source_key": "ipmx",
            "source_token_name": "code-definitions-fox-audio-suffix",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:L",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "L",
          "semantic_meaning": "Left",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-track",
            "code_normalized": "L",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-track.json",
            "source_key": "L",
            "source_token_name": "code-definitions-fox-audio-track",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:LB",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "lb",
          "semantic_meaning": "(Legacy DO NOT USE) Session formatted for layback to tape media",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-suffix",
            "code_normalized": "LB",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "suffix"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-suffix.json",
            "source_key": "lb",
            "source_token_name": "code-definitions-fox-audio-suffix",
            "source_metadata": {
              "format": "suffix"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:LBMX",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "lbmx",
          "semantic_meaning": "Layback mix session",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-suffix",
            "code_normalized": "LBMX",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-suffix.json",
            "source_key": "lbmx",
            "source_token_name": "code-definitions-fox-audio-suffix",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:LC",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "Lc",
          "semantic_meaning": "Left Center",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-track",
            "code_normalized": "LC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-track.json",
            "source_key": "Lc",
            "source_token_name": "code-definitions-fox-audio-track",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:LFE",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "LFE",
          "semantic_meaning": "Low Frequency Effects",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-track",
            "code_normalized": "LFE",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-track.json",
            "source_key": "LFE",
            "source_token_name": "code-definitions-fox-audio-track",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:LRS",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "Lrs",
          "semantic_meaning": "Left Rear Surround",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-track",
            "code_normalized": "LRS",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-track.json",
            "source_key": "Lrs",
            "source_token_name": "code-definitions-fox-audio-track",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:LS",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "Ls",
          "semantic_meaning": "Left Surround",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-track",
            "code_normalized": "LS",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-track.json",
            "source_key": "Ls",
            "source_token_name": "code-definitions-fox-audio-track",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:LST",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "Lst",
          "semantic_meaning": "Left Surround Total",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-track",
            "code_normalized": "LST",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-track.json",
            "source_key": "Lst",
            "source_token_name": "code-definitions-fox-audio-track",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:LT",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "Lt",
          "semantic_meaning": "Left Total",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-track",
            "code_normalized": "LT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-track.json",
            "source_key": "Lt",
            "source_token_name": "code-definitions-fox-audio-track",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:LTO",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "lto",
          "semantic_meaning": "Restored from LTO prior to 11/2007",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-suffix",
            "code_normalized": "LTO",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "transfer"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-suffix.json",
            "source_key": "lto",
            "source_token_name": "code-definitions-fox-audio-suffix",
            "source_metadata": {
              "format": "transfer"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:M",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "M",
          "semantic_meaning": "Original physical asset MC# (ie: _M123456)",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-suffix",
            "code_normalized": "M",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "transfer",
              "notes": "Transfer-session heuristic tracking: candidate when label matches M followed directly by digits and naming follows the Track variant scheme in place of suffix."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-suffix.json",
            "source_key": "M",
            "source_token_name": "code-definitions-fox-audio-suffix",
            "source_metadata": {
              "format": "transfer",
              "notes": "Transfer-session heuristic tracking: candidate when label matches M followed directly by digits and naming follows the Track variant scheme in place of suffix."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:M1",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "m1",
          "semantic_meaning": "Mono Ch.1",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-track",
            "code_normalized": "M1",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-track.json",
            "source_key": "m1",
            "source_token_name": "code-definitions-fox-audio-track",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:M2",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "m2",
          "semantic_meaning": "Mono Ch.2",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-track",
            "code_normalized": "M2",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-track.json",
            "source_key": "m2",
            "source_token_name": "code-definitions-fox-audio-track",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:MA1509.DTSHD",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "MA1509.dtshd",
          "semantic_meaning": "dts-HD Master Audio - lossless for Blu-ray",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "code_normalized": "MA1509.DTSHD",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "dts"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-bitrate.json",
            "source_key": "MA1509.dtshd",
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "source_metadata": {
              "format": "dts"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:MN",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "mn",
          "semantic_meaning": "Mono (single channel)",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-track",
            "code_normalized": "MN",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-track.json",
            "source_key": "mn",
            "source_token_name": "code-definitions-fox-audio-track",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:MSTM",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "MSTM",
          "semantic_meaning": "Mono Stem",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-track",
            "code_normalized": "MSTM",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-track.json",
            "source_key": "MSTM",
            "source_token_name": "code-definitions-fox-audio-track",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:MX",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "mx",
          "semantic_meaning": "Mix session - edited/conformed/mixed media",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-suffix",
            "code_normalized": "MX",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "suffix"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-suffix.json",
            "source_key": "mx",
            "source_token_name": "code-definitions-fox-audio-suffix",
            "source_metadata": {
              "format": "suffix"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:NG",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "ng",
          "semantic_meaning": "Session \"no good\"/ unusable",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-suffix",
            "code_normalized": "NG",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "suffix"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-suffix.json",
            "source_key": "ng",
            "source_token_name": "code-definitions-fox-audio-suffix",
            "source_metadata": {
              "format": "suffix"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:OM",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "om",
          "semantic_meaning": "(Legacy DO NOT USE) Original large-scale mix session",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-suffix",
            "code_normalized": "OM",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "suffix"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-suffix.json",
            "source_key": "om",
            "source_token_name": "code-definitions-fox-audio-suffix",
            "source_metadata": {
              "format": "suffix"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:P",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "P",
          "semantic_meaning": "Original physical asset PP0# (ie: _P123456)",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-suffix",
            "code_normalized": "P",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "transfer",
              "notes": "Transfer-session heuristic tracking: candidate when label matches P followed directly by digits and naming follows the Track variant scheme in place of suffix."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-suffix.json",
            "source_key": "P",
            "source_token_name": "code-definitions-fox-audio-suffix",
            "source_metadata": {
              "format": "transfer",
              "notes": "Transfer-session heuristic tracking: candidate when label matches P followed directly by digits and naming follows the Track variant scheme in place of suffix."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:PM",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "pm",
          "semantic_meaning": "Printmaster session containing only continuous true-velocity mastered audio files for encode (Includes a single reference 1kHz-20dB audio file)",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-suffix",
            "code_normalized": "PM",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "suffix",
              "notes": "Printmaster heuristic tracking: likely printmaster when TITLE starts with 'p' and the filename follows the Track variant scheme in place of suffix."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-suffix.json",
            "source_key": "pm",
            "source_token_name": "code-definitions-fox-audio-suffix",
            "source_metadata": {
              "format": "suffix",
              "notes": "Printmaster heuristic tracking: likely printmaster when TITLE starts with 'p' and the filename follows the Track variant scheme in place of suffix."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:R",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "R",
          "semantic_meaning": "Right",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-track",
            "code_normalized": "R",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-track.json",
            "source_key": "R",
            "source_token_name": "code-definitions-fox-audio-track",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:RB",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "Rb",
          "semantic_meaning": "Right Boom",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-track",
            "code_normalized": "RB",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-track.json",
            "source_key": "Rb",
            "source_token_name": "code-definitions-fox-audio-track",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:RC",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "Rc",
          "semantic_meaning": "Right Center",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-track",
            "code_normalized": "RC",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-track.json",
            "source_key": "Rc",
            "source_token_name": "code-definitions-fox-audio-track",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:REF",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "Ref",
          "semantic_meaning": "Mono English Guide Track",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-track",
            "code_normalized": "REF",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-track.json",
            "source_key": "Ref",
            "source_token_name": "code-definitions-fox-audio-track",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:RRS",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "Rrs",
          "semantic_meaning": "Right Rear Surround",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-track",
            "code_normalized": "RRS",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-track.json",
            "source_key": "Rrs",
            "source_token_name": "code-definitions-fox-audio-track",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:RS",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "Rs",
          "semantic_meaning": "Right Surround",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-track",
            "code_normalized": "RS",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-track.json",
            "source_key": "Rs",
            "source_token_name": "code-definitions-fox-audio-track",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:RST",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "Rst",
          "semantic_meaning": "Right Surround Total",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-track",
            "code_normalized": "RST",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-track.json",
            "source_key": "Rst",
            "source_token_name": "code-definitions-fox-audio-track",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:RT",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "Rt",
          "semantic_meaning": "Right Total",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-track",
            "code_normalized": "RT",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-track.json",
            "source_key": "Rt",
            "source_token_name": "code-definitions-fox-audio-track",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:S",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "S",
          "semantic_meaning": "Mono Surround",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-track",
            "code_normalized": "S",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-track.json",
            "source_key": "S",
            "source_token_name": "code-definitions-fox-audio-track",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:SA224.EC3",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "SA224.ec3",
          "semantic_meaning": "Dolby Digital Plus - Secondary Audio for Blu-ray",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "code_normalized": "SA224.EC3",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "dolbydigital",
              "notes": "not in use by FOX"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-bitrate.json",
            "source_key": "SA224.ec3",
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "source_metadata": {
              "format": "dolbydigital",
              "notes": "not in use by FOX"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:SA96.DTSHD",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "SA96.dtshd",
          "semantic_meaning": "dts Express - Secondary Audio for Blu-ray",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "code_normalized": "SA96.DTSHD",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "dts"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-bitrate.json",
            "source_key": "SA96.dtshd",
            "source_token_name": "code-definitions-fox-audio-bitrate",
            "source_metadata": {
              "format": "dts"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:SND",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "snd",
          "semantic_meaning": "Sessions transferred from Bldg 29 Sound Transfer",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-suffix",
            "code_normalized": "SND",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "transfer"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-suffix.json",
            "source_key": "snd",
            "source_token_name": "code-definitions-fox-audio-suffix",
            "source_metadata": {
              "format": "transfer"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:SR",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "Sr",
          "semantic_meaning": "Mono Surround Rear",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-track",
            "code_normalized": "SR",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-track.json",
            "source_key": "Sr",
            "source_token_name": "code-definitions-fox-audio-track",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:TF",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "tf",
          "semantic_meaning": "(Legacy DO NOT USE) Transfer session",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-suffix",
            "code_normalized": "TF",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "suffix"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-suffix.json",
            "source_key": "tf",
            "source_token_name": "code-definitions-fox-audio-suffix",
            "source_metadata": {
              "format": "suffix"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:SUFFIX:UNV",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "SUFFIX",
          "token_pattern": "unv",
          "semantic_meaning": "Unverified media (media delivered digitally with no information and not verified prior to usage)",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-suffix",
            "code_normalized": "UNV",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "transfer",
              "notes": "Note: Unverified media labels should not contain unverified or assumed label information. In this case the label may be missing TrackConfig, STANDARD, etc."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-suffix.json",
            "source_key": "unv",
            "source_token_name": "code-definitions-fox-audio-suffix",
            "source_metadata": {
              "format": "transfer",
              "notes": "Note: Unverified media labels should not contain unverified or assumed label information. In this case the label may be missing TrackConfig, STANDARD, etc."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:TECHINFO:16B",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "TECHINFO",
          "token_pattern": "16b",
          "semantic_meaning": "16 bit",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-techinfo",
            "code_normalized": "16B",
            "rule_kind": "code-definition",
            "source_metadata": {
              "notes": "Appears if different than 24 bit standard."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-techinfo.json",
            "source_key": "16b",
            "source_token_name": "code-definitions-fox-audio-techinfo",
            "source_metadata": {
              "notes": "Appears if different than 24 bit standard."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:TECHINFO:24B",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "TECHINFO",
          "token_pattern": "24b",
          "semantic_meaning": "24 bit",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-techinfo",
            "code_normalized": "24B",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-techinfo.json",
            "source_key": "24b",
            "source_token_name": "code-definitions-fox-audio-techinfo",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:TECHINFO:44K",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "TECHINFO",
          "token_pattern": "44k",
          "semantic_meaning": "44.1 kHz",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-techinfo",
            "code_normalized": "44K",
            "rule_kind": "code-definition",
            "source_metadata": {
              "notes": "Appears if different than 48k standard."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-techinfo.json",
            "source_key": "44k",
            "source_token_name": "code-definitions-fox-audio-techinfo",
            "source_metadata": {
              "notes": "Appears if different than 48k standard."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:TECHINFO:48K",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "TECHINFO",
          "token_pattern": "48k",
          "semantic_meaning": "48 kHz",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-techinfo",
            "code_normalized": "48K",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-techinfo.json",
            "source_key": "48k",
            "source_token_name": "code-definitions-fox-audio-techinfo",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:TECHINFO:96K",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "TECHINFO",
          "token_pattern": "96k",
          "semantic_meaning": "96 kHz",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-techinfo",
            "code_normalized": "96K",
            "rule_kind": "code-definition",
            "source_metadata": {
              "notes": "Appears if different than 48k standard."
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-techinfo.json",
            "source_key": "96k",
            "source_token_name": "code-definitions-fox-audio-techinfo",
            "source_metadata": {
              "notes": "Appears if different than 48k standard."
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:TECHINFO:ACA",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "TECHINFO",
          "token_pattern": "Aca",
          "semantic_meaning": "Audio includes Academy Pre-emphasis",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-techinfo",
            "code_normalized": "ACA",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-techinfo.json",
            "source_key": "Aca",
            "source_token_name": "code-definitions-fox-audio-techinfo",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:TECHINFO:CMIX",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "TECHINFO",
          "token_pattern": "CMIX",
          "semantic_meaning": "Commentary Mix",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-techinfo",
            "code_normalized": "CMIX",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-techinfo.json",
            "source_key": "CMIX",
            "source_token_name": "code-definitions-fox-audio-techinfo",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:TECHINFO:CSTM",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "TECHINFO",
          "token_pattern": "CSTM",
          "semantic_meaning": "Commentary Dialog Stem",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-techinfo",
            "code_normalized": "CSTM",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-techinfo.json",
            "source_key": "CSTM",
            "source_token_name": "code-definitions-fox-audio-techinfo",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:TECHINFO:DOWN",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "TECHINFO",
          "token_pattern": "Down",
          "semantic_meaning": "Down restoration transfer pass",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-techinfo",
            "code_normalized": "DOWN",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-techinfo.json",
            "source_key": "Down",
            "source_token_name": "code-definitions-fox-audio-techinfo",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:TECHINFO:FBED",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "TECHINFO",
          "token_pattern": "FBED",
          "semantic_meaning": "'Filmbed' Soundtrack Stem",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-techinfo",
            "code_normalized": "FBED",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-techinfo.json",
            "source_key": "FBED",
            "source_token_name": "code-definitions-fox-audio-techinfo",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:TECHINFO:OSND",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "TECHINFO",
          "token_pattern": "OSND",
          "semantic_meaning": "Original Soundtrack",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-techinfo",
            "code_normalized": "OSND",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-techinfo.json",
            "source_key": "OSND",
            "source_token_name": "code-definitions-fox-audio-techinfo",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:TECHINFO:RAW",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "TECHINFO",
          "token_pattern": "Raw",
          "semantic_meaning": "Raw (untreated)",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-techinfo",
            "code_normalized": "RAW",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-techinfo.json",
            "source_key": "Raw",
            "source_token_name": "code-definitions-fox-audio-techinfo",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:TECHINFO:RES",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "TECHINFO",
          "token_pattern": "Res",
          "semantic_meaning": "Restored (processed for preservation)",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-techinfo",
            "code_normalized": "RES",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-techinfo.json",
            "source_key": "Res",
            "source_token_name": "code-definitions-fox-audio-techinfo",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:TECHINFO:UP",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "TECHINFO",
          "token_pattern": "Up",
          "semantic_meaning": "Up restoration transfer pass",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-techinfo",
            "code_normalized": "UP",
            "rule_kind": "code-definition",
            "source_metadata": {}
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-techinfo.json",
            "source_key": "Up",
            "source_token_name": "code-definitions-fox-audio-techinfo",
            "source_metadata": {}
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:TRACKCONFIG:30",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "TRACKCONFIG",
          "token_pattern": "30",
          "semantic_meaning": "L/C/R",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "30",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "trackConfig"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "30",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "trackConfig"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:TRACKCONFIG:40",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "TRACKCONFIG",
          "token_pattern": "40",
          "semantic_meaning": "L/C/R/S",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "40",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "trackConfig"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "40",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "trackConfig"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:TRACKCONFIG:50",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "TRACKCONFIG",
          "token_pattern": "50",
          "semantic_meaning": "L/C/R/Ls/Rs",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "50",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "trackConfig"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "50",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "trackConfig"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:TRACKCONFIG:51",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "TRACKCONFIG",
          "token_pattern": "51",
          "semantic_meaning": "5.1",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "51",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "trackConfig"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "51",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "trackConfig"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:TRACKCONFIG:5E",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "TRACKCONFIG",
          "token_pattern": "5e",
          "semantic_meaning": "5.1 EX",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "5E",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "trackConfig"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "5e",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "trackConfig"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:TRACKCONFIG:5P",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "TRACKCONFIG",
          "token_pattern": "5p",
          "semantic_meaning": "(Legacy DO NOT USE) Pseudo 5.1",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "5P",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "trackConfig"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "5p",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "trackConfig"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:TRACKCONFIG:61",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "TRACKCONFIG",
          "token_pattern": "61",
          "semantic_meaning": "6.1 discrete (non-EX encoded LstRst)",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "61",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "trackConfig"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "61",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "trackConfig"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:TRACKCONFIG:62",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "TRACKCONFIG",
          "token_pattern": "62",
          "semantic_meaning": "6+2 (5.1 M&E + Add/Dialog)",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "62",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "trackConfig"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "62",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "trackConfig"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:TRACKCONFIG:67",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "TRACKCONFIG",
          "token_pattern": "67",
          "semantic_meaning": "6Trk 70mm:  L/Lc/C/Rc/R/S",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "67",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "trackConfig"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "67",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "trackConfig"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:TRACKCONFIG:6B",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "TRACKCONFIG",
          "token_pattern": "6B",
          "semantic_meaning": "6Trk Baby Boom",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "6B",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "trackConfig"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "6B",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "trackConfig"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:TRACKCONFIG:71",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "TRACKCONFIG",
          "token_pattern": "71",
          "semantic_meaning": "7.1 (non-SDDS) home theater",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "71",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "trackConfig"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "71",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "trackConfig"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:TRACKCONFIG:7S",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "TRACKCONFIG",
          "token_pattern": "7S",
          "semantic_meaning": "7.1 SDDS",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "7S",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "trackConfig"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "7S",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "trackConfig"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:TRACKCONFIG:DS",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "TRACKCONFIG",
          "token_pattern": "ds",
          "semantic_meaning": "2.0 LtRt (Dolby Surround)",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "DS",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "trackConfig"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "ds",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "trackConfig"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:TRACKCONFIG:MN",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "TRACKCONFIG",
          "token_pattern": "mn",
          "semantic_meaning": "1.0 or 2.0 Mono",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "MN",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "trackConfig"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "mn",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "trackConfig"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        },
        {
          "rule_id": "FOX-AUDIO-SERVICES:TRACKCONFIG:ST",
          "convention_id": "FOX-AUDIO-SERVICES",
          "token_name": "TRACKCONFIG",
          "token_pattern": "st",
          "semantic_meaning": "2.0 Stereo",
          "constraints": {
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "code_normalized": "ST",
            "rule_kind": "code-definition",
            "source_metadata": {
              "format": "trackConfig"
            }
          },
          "precedence": 100,
          "source_reference": {
            "source_file": "data/raw/fox/audio_services/code-definitions-fox-audio-langsnd.json",
            "source_key": "st",
            "source_token_name": "code-definitions-fox-audio-langsnd",
            "source_metadata": {
              "format": "trackConfig"
            }
          },
          "confidence": 0.8,
          "status": "draft",
          "created_at": "2026-07-17T23:13:40Z",
          "updated_at": "2026-07-17T23:13:40Z"
        }
      ]
    }
  }
};


window.initMultiConventionDecoderRuntime = function initMultiConventionDecoderRuntime(runtimeConfig = {}) {
      const decodeButton = document.getElementById("decode-btn");
      const clearButton = document.getElementById("clear-btn");
      const filenameInput = document.getElementById("filename-input");
      const matchIdEl = document.getElementById("match-id");
      const matchConfidenceEl = document.getElementById("match-confidence");
      const detectedMaskTextEl = document.getElementById("detected-mask-text");
      const complianceNoteEl = document.getElementById("compliance-note");
      const definitionsNoteEl = document.getElementById("definitions-note");
      const definitionsListEl = document.getElementById("definitions-list");
      const batchResultsListEl = document.getElementById("batch-results-list");
      const statusChipEl = document.getElementById("status-chip");
      const mode = String((runtimeConfig && runtimeConfig.mode) || "single").toLowerCase() === "batch" ? "batch" : "single";
      const runBatchMode = mode === "batch" && Boolean(batchResultsListEl);
      const bundleOnlyMode = Boolean(runtimeConfig && runtimeConfig.bundleOnly);
      const bundleReadyMessage = String((runtimeConfig && runtimeConfig.bundleReadyMessage) || "").trim() || "Ready";
      const bundleMissingMessage = String((runtimeConfig && runtimeConfig.bundleMissingMessage) || "").trim() || "Embedded bundle data was not found.";

      const conventionSources = [
        "./data/conventions/disney-wonderland-modern/rules.draft.json",
        "./data/conventions/wmls/rules.draft.json",
        "./data/conventions/fox/rules.draft.json",
        "./data/conventions/fox-audio-services/rules.draft.json"
      ];
      const wmlsFileInfoSource = "./data/raw/wmls/code-definitions-wmls-fileinfo.json";
      const wmlsFileTypeSource = "./data/raw/wmls/code-definitions-wmls-filetype.json";
      const wmlsMaskVariantsSource = "./data/raw/wmls/wmls-naming-mask-variants.json";
      const dwcResAudRangeSource = "./data/raw/dwc-modern/code-definitions-res-aud-range.json";
      const dwcConfSource = "./data/raw/dwc-modern/code-definitions-conf.json";
      const dwcClassWipSource = "./data/raw/dwc-modern/code-definitions-class-wip.json";

      const conventionDisplayNames = {
        "DWC-MODERN": "Disney Wonderland Naming Convention",
        "WMLS": "Disney WMLS (Legacy)",
        "FOX": "Fox Enterprise Operations (Legacy)",
        "FOX-LEGACY": "Fox Enterprise Operations (Legacy)",
        "FOX-AUDIO-SERVICES": "Fox Audio Services (Legacy)"
      };

      const wmlsFileInfoFallbackMeanings = {
        "P": "Progressive",
        "I": "Interlaced",
        "23": "23 fps",
        "24": "24 fps",
        "25": "25 fps",
        "29DF": "29.97 fps Drop Frame",
        "29NDF": "29.97 fps Non-Drop Frame",
        "30": "30 fps",
        "50": "50 fps",
        "59DF": "59.94 fps Drop Frame",
        "59NDF": "59.94 fps Non-Drop Frame",
        "60": "60 fps"
      };

      const state = {
        ruleSets: [],
        loadErrors: [],
        familyPriorContext: null,
        wmlsFileInfoMeanings: new Map(),
        wmlsFileTypeMeanings: new Map(),
        wmlsFileTypeFormats: new Map(),
        wmlsMaskVariants: [],
        dwcResAudRangeByCode: new Map(),
        dwcConfMeanings: new Map(),
        dwcClassWipMeanings: new Map(),
        rawRuleEntriesBySource: new Map()
      };

      function getRulesDocByConventionIdPrefix(prefix) {
        const target = String(prefix || "").trim().toUpperCase();
        return state.ruleSets.find((entry) => {
          const conventionId = String((entry && entry.rulesDoc && entry.rulesDoc.conventionId) || "").trim().toUpperCase();
          return conventionId === target;
        });
      }

      function extractDefinitionsFromRules(ruleSetEntry, tokenName, sourceFileFragment) {
        const tokenKey = String(tokenName || "").trim().toUpperCase();
        const sourceFragment = String(sourceFileFragment || "").trim().toLowerCase();
        const rules = Array.isArray(ruleSetEntry && ruleSetEntry.rulesDoc && ruleSetEntry.rulesDoc.rules)
          ? ruleSetEntry.rulesDoc.rules
          : [];
        const byCode = new Map();

        for (const rule of rules) {
          const ruleTokenName = String((rule && rule.token_name) || "").trim().toUpperCase();
          if (ruleTokenName !== tokenKey) {
            continue;
          }

          const sourceFile = String((rule && rule.source_reference && rule.source_reference.source_file) || "").toLowerCase();
          if (sourceFragment && !sourceFile.includes(sourceFragment)) {
            continue;
          }

          const code = canonicalizeCodeKey((rule && rule.token_pattern) || "");
          const meaning = String((rule && rule.semantic_meaning) || "").trim();
          if (!code || !meaning) {
            continue;
          }

          if (!byCode.has(code)) {
            const sourceMetadata = (rule && rule.source_reference && rule.source_reference.source_metadata)
              || (rule && rule.constraints && rule.constraints.source_metadata)
              || {};
            byCode.set(code, {
              code,
              meaning,
              format: String((sourceMetadata && sourceMetadata.format) || "").trim()
            });
          }
        }

        return Array.from(byCode.values());
      }

      function buildWmlsMaskVariantsDocFromRuleSet(ruleSetEntry) {
        const rulesDoc = ruleSetEntry && ruleSetEntry.rulesDoc;
        const maskSpecs = Array.isArray(rulesDoc && rulesDoc.maskSpecs) && rulesDoc.maskSpecs.length > 0
          ? rulesDoc.maskSpecs
          : (rulesDoc && rulesDoc.maskSpec ? [rulesDoc.maskSpec] : []);

        return {
          variations: maskSpecs.map((maskSpec, index) => {
            const id = String((maskSpec && maskSpec.id) || `WMLS-mask-${index + 1}`);
            const idUpper = id.toUpperCase();
            const inferredRole = idUpper.includes("FOLDER") ? "folder" : (idUpper.includes("FILE") ? "file" : "unknown");
            return {
              id,
              name: String((maskSpec && maskSpec.name) || id),
              role: inferredRole,
              mask: String((maskSpec && maskSpec.mask) || ""),
              mainDelimiter: String((maskSpec && maskSpec.mainDelimiter) || "_"),
              subDelimiter: String((maskSpec && maskSpec.subDelimiter) || "-")
            };
          })
        };
      }

      function tryHydrateFromLocalBundle() {
        const bundle = window.NCL_LOCAL_DATA_BUNDLE;
        if (!bundle || typeof bundle !== "object") {
          return false;
        }

        const conventions = (bundle && bundle.conventions && typeof bundle.conventions === "object")
          ? bundle.conventions
          : {};

        state.ruleSets = [];
        for (const sourcePath of conventionSources) {
          const rulesDoc = conventions[sourcePath];
          if (!rulesDoc) {
            continue;
          }

          state.ruleSets.push({
            path: sourcePath,
            rulesDoc,
            index: buildRuleIndex(Array.isArray(rulesDoc.rules) ? rulesDoc.rules : [])
          });
        }

        const wmlsRuleSetEntry = getRulesDocByConventionIdPrefix("WMLS");
        const dwcRuleSetEntry = getRulesDocByConventionIdPrefix("DWC-MODERN");

        const wmlsFileInfoDefinitions = Array.isArray(bundle.wmlsFileInfoDefinitions)
          ? bundle.wmlsFileInfoDefinitions
          : extractDefinitionsFromRules(wmlsRuleSetEntry, "FILEINFO", "code-definitions-wmls-fileinfo");
        const wmlsFileTypeDefinitions = Array.isArray(bundle.wmlsFileTypeDefinitions)
          ? bundle.wmlsFileTypeDefinitions
          : extractDefinitionsFromRules(wmlsRuleSetEntry, "FILETYPE", "code-definitions-wmls-filetype");
        const wmlsMaskVariantsDoc = (bundle.wmlsMaskVariantsDoc && Array.isArray(bundle.wmlsMaskVariantsDoc.variations))
          ? bundle.wmlsMaskVariantsDoc
          : buildWmlsMaskVariantsDocFromRuleSet(wmlsRuleSetEntry);
        const dwcResAudRangeDoc = (bundle.dwcResAudRangeDoc && Array.isArray(bundle.dwcResAudRangeDoc.definitions))
          ? bundle.dwcResAudRangeDoc
          : { definitions: extractDefinitionsFromRules(dwcRuleSetEntry, "RES", "code-definitions-res-aud-range") };
        const dwcConfDoc = (bundle.dwcConfDoc && Array.isArray(bundle.dwcConfDoc.definitions))
          ? bundle.dwcConfDoc
          : { definitions: extractDefinitionsFromRules(dwcRuleSetEntry, "CONF", "code-definitions-conf") };
        const dwcClassWipDoc = (bundle.dwcClassWipDoc && Array.isArray(bundle.dwcClassWipDoc.definitions))
          ? bundle.dwcClassWipDoc
          : { definitions: extractDefinitionsFromRules(dwcRuleSetEntry, "CLASS", "code-definitions-class-wip") };

        state.wmlsFileInfoMeanings = parseWmlsFileInfoMeaningMap(wmlsFileInfoDefinitions);
        state.wmlsFileTypeMeanings = parseWmlsFileInfoMeaningMap(wmlsFileTypeDefinitions);
        state.wmlsFileTypeFormats = parseWmlsFileTypeFormatMap(wmlsFileTypeDefinitions);
        state.wmlsMaskVariants = parseWmlsMaskVariantsDoc(wmlsMaskVariantsDoc);
        state.dwcResAudRangeByCode = parseDwcResAudRangeMap(dwcResAudRangeDoc);
        state.dwcConfMeanings = parseWmlsFileInfoMeaningMap(dwcConfDoc && dwcConfDoc.definitions);
        state.dwcClassWipMeanings = parseWmlsFileInfoMeaningMap(dwcClassWipDoc && dwcClassWipDoc.definitions);

        const rawEntriesSource = (bundle && bundle.rawEntriesBySource && typeof bundle.rawEntriesBySource === "object")
          ? bundle.rawEntriesBySource
          : {};
        const rawBySource = new Map();
        for (const [sourcePath, entriesByCode] of Object.entries(rawEntriesSource)) {
          const normalizedEntries = new Map();
          for (const [code, entry] of Object.entries(entriesByCode || {})) {
            normalizedEntries.set(String(code || "").trim().toUpperCase(), {
              meaning: String((entry && entry.meaning) || "").trim(),
              notes: String((entry && entry.notes) || "").trim(),
              format: String((entry && entry.format) || "").trim()
            });
          }
          rawBySource.set(normalizeSourcePath(sourcePath), normalizedEntries);
        }
        state.rawRuleEntriesBySource = rawBySource;

        state.loadErrors = [];
        return state.ruleSets.length > 0;
      }

      function parseWmlsFileInfoMeaningMap(definitions) {
        const map = new Map();
        for (const entry of Array.isArray(definitions) ? definitions : []) {
          const code = canonicalizeCodeKey((entry && entry.code) || "");
          const meaning = String((entry && (entry.meaning || entry.definition)) || "").trim();
          if (!code || !meaning) {
            continue;
          }
          map.set(code, meaning);
        }
        return map;
      }

      function parseWmlsFileTypeFormatMap(definitions) {
        const map = new Map();
        for (const entry of Array.isArray(definitions) ? definitions : []) {
          const code = canonicalizeCodeKey((entry && entry.code) || "");
          const format = String((entry && entry.format) || "").trim().toUpperCase();
          if (!code || !format) {
            continue;
          }
          map.set(code, format);
        }
        return map;
      }

      function normalizeSourcePath(sourcePath) {
        return String(sourcePath || "")
          .replace(/^\.\//, "")
          .replaceAll("\\", "/")
          .replace(/^\/+/, "")
          .toLowerCase();
      }

      function parseRawDefinitionEntries(doc) {
        const entries = Array.isArray(doc)
          ? doc
          : (Array.isArray(doc && doc.definitions) ? doc.definitions : []);
        const map = new Map();

        for (const entry of entries) {
          const code = canonicalizeCodeKey((entry && entry.code) || "");
          if (!code) {
            continue;
          }

          const meaning = String((entry && (entry.meaning || entry.definition || entry.semantic_meaning)) || "").trim();
          const notes = String((entry && (entry.notes || entry.note || entry.description)) || "").trim();
          const format = String((entry && entry.format) || "").trim();
          const isSubdescriptor = Boolean(entry && entry.isSubdescriptor);

          map.set(code, {
            meaning,
            notes,
            format,
            isSubdescriptor
          });
        }

        return map;
      }

      async function loadRawRuleSourceEntries(ruleSets, readJsonBySourcePath) {
        const sourcePaths = new Set();
        for (const ruleSet of Array.isArray(ruleSets) ? ruleSets : []) {
          const rules = Array.isArray(ruleSet && ruleSet.rulesDoc && ruleSet.rulesDoc.rules)
            ? ruleSet.rulesDoc.rules
            : [];
          for (const rule of rules) {
            const sourcePath = String((rule && rule.source_reference && rule.source_reference.source_file) || "").trim();
            if (sourcePath) {
              sourcePaths.add(sourcePath);
            }
          }
        }

        const loadedBySource = new Map();
        const errors = [];

        for (const sourcePath of sourcePaths) {
          try {
            const doc = await readJsonBySourcePath(sourcePath);
            loadedBySource.set(normalizeSourcePath(sourcePath), parseRawDefinitionEntries(doc));
          } catch (error) {
            const message = String(error && error.message ? error.message : error);
            errors.push({ sourcePath, message });
          }
        }

        return { loadedBySource, errors };
      }

      function getRawEntryForRule(rule, rawValue) {
        const sourcePath = normalizeSourcePath(rule && rule.source_reference && rule.source_reference.source_file);
        if (!sourcePath) {
          return null;
        }

        const entriesByCode = state.rawRuleEntriesBySource.get(sourcePath);
        if (!entriesByCode) {
          return null;
        }

        const rawKey = String(rawValue || "").trim().toUpperCase();
        const sourceKey = String((rule && rule.source_reference && rule.source_reference.source_key) || "").trim().toUpperCase();

        if (rawKey && entriesByCode.has(rawKey)) {
          return entriesByCode.get(rawKey);
        }
        if (sourceKey && entriesByCode.has(sourceKey)) {
          return entriesByCode.get(sourceKey);
        }
        return null;
      }

      function applyRawEntryToMeaning(currentMeaning, rawEntry) {
        const baseMeaning = String(currentMeaning || "").trim();
        if (!rawEntry) {
          return baseMeaning || "No semantic meaning";
        }

        const rawMeaning = String(rawEntry.meaning || "").trim();
        const rawNotes = String(rawEntry.notes || "").trim();
        let finalMeaning = rawMeaning || baseMeaning || "No semantic meaning";

        if (rawNotes) {
          finalMeaning = `${finalMeaning} Notes: ${rawNotes}`;
        }

        return finalMeaning;
      }

      function parseDwcResAudRangeMap(doc) {
        const map = new Map();
        const entries = Array.isArray(doc && doc.definitions) ? doc.definitions : [];
        for (const entry of entries) {
          const code = String((entry && entry.code) || "").trim().toUpperCase();
          const meaning = String((entry && (entry.definition || entry.meaning)) || "").trim();
          const format = String((entry && entry.format) || "").trim().toLowerCase();
          if (!code || !meaning) {
            continue;
          }
          map.set(code, { meaning, format });
        }
        return map;
      }

      function resolveDwcResRangeMeaning(tokenName, segmentMask, rawValue) {
        const tokenKey = String(tokenName || "").toUpperCase();
        const segmentKey = String(segmentMask || "").toUpperCase();
        const raw = String(rawValue || "").trim().toUpperCase();
        if (!raw || segmentKey !== "RES-RANGE" || (tokenKey !== "RES" && tokenKey !== "RANGE")) {
          return null;
        }

        const entry = state.dwcResAudRangeByCode.get(raw);
        if (!entry) {
          return null;
        }

        const format = String(entry.format || "").trim().toLowerCase();
        const expectedFormat = tokenKey === "RES" ? "resolution" : "range";

        if (format && format !== expectedFormat) {
          return {
            known: false,
            meaning: `No active rule match`
          };
        }

        return {
          known: true,
          meaning: String(entry.meaning || "No semantic meaning").trim() || "No semantic meaning"
        };
      }

      function getWmlsFileInfoMeaning(code, fallbackMeaning) {
        const key = canonicalizeCodeKey(code);
        if (key && state.wmlsFileInfoMeanings.has(key)) {
          return state.wmlsFileInfoMeanings.get(key);
        }
        if (key && wmlsFileInfoFallbackMeanings[key]) {
          return wmlsFileInfoFallbackMeanings[key];
        }
        return String(fallbackMeaning || "").trim() || "No semantic meaning";
      }

      function findWmlsFileTypeMeaning(code) {
        const key = canonicalizeCodeKey(code);
        if (!key) {
          return null;
        }

        if (state.wmlsFileTypeMeanings.has(key)) {
          return state.wmlsFileTypeMeanings.get(key);
        }

        for (const [sourceCode, meaning] of state.wmlsFileTypeMeanings.entries()) {
          if (!String(sourceCode || "").includes("#")) {
            continue;
          }

          const regexSource = "^" + String(sourceCode)
            .replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
            .replace(/#/g, "\\d+") + "$";

          if (new RegExp(regexSource, "i").test(key)) {
            return meaning;
          }
        }

        if (key.includes("-")) {
          const parts = key.split("-").map((part) => canonicalizeCodeKey(part)).filter(Boolean);
          if (parts.length >= 2) {
            const resolvePartMeaning = (partCode) => {
              if (state.wmlsFileTypeMeanings.has(partCode)) {
                return String(state.wmlsFileTypeMeanings.get(partCode) || "").trim();
              }
              return String(findMeaningInRawEntries(partCode) || "").trim();
            };

            const baseMeaning = resolvePartMeaning(parts[0]);
            const modifierMeanings = parts.slice(1).map(resolvePartMeaning);
            const allModifiersResolved = modifierMeanings.length > 0
              && modifierMeanings.every((meaning) => Boolean(String(meaning || "").trim()));

            if (baseMeaning && allModifiersResolved) {
              return `${baseMeaning} - ${modifierMeanings.join(" - ")}`;
            }
          }
        }

        return null;
      }

      function getWmlsFileTypeMeaning(code, fallbackMeaning) {
        const resolved = findWmlsFileTypeMeaning(code);
        if (resolved) {
          return resolved;
        }

        return String(fallbackMeaning || "").trim() || "No semantic meaning";
      }

      function findWmlsFileTypeFormat(code) {
        const key = canonicalizeCodeKey(code);
        if (!key) {
          return "";
        }

        if (state.wmlsFileTypeFormats.has(key)) {
          return state.wmlsFileTypeFormats.get(key);
        }

        for (const [sourceCode, format] of state.wmlsFileTypeFormats.entries()) {
          if (!String(sourceCode || "").includes("#")) {
            continue;
          }

          const regexSource = "^" + String(sourceCode)
            .replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
            .replace(/#/g, "\\d+") + "$";

          if (new RegExp(regexSource, "i").test(key)) {
            return String(format || "").toUpperCase();
          }
        }

        if (key.includes("-")) {
          const parts = key.split("-").map((part) => canonicalizeCodeKey(part)).filter(Boolean);
          if (parts.length >= 2) {
            const resolvePartFormat = (partCode) => {
              if (state.wmlsFileTypeFormats.has(partCode)) {
                return String(state.wmlsFileTypeFormats.get(partCode) || "").trim().toUpperCase();
              }
              for (const entriesByCode of state.rawRuleEntriesBySource.values()) {
                const entry = entriesByCode && entriesByCode.get(partCode);
                const format = String((entry && entry.format) || "").trim().toUpperCase();
                if (format) {
                  return format;
                }
              }
              return "";
            };

            const baseFormat = resolvePartFormat(parts[0]);
            if (baseFormat) {
              return baseFormat;
            }

            for (const partCode of parts.slice(1)) {
              const format = resolvePartFormat(partCode);
              if (format) {
                return format;
              }
            }
          }
        }

        return "";
      }

      function getWmlsFileTypeFormat(code) {
        return findWmlsFileTypeFormat(code);
      }

      function getWmlsResolvedMeaning(tokenName, rawValue, fallbackMeaning) {
        const tokenKey = String(tokenName || "").toUpperCase();
        if (tokenKey === "FILEINFO") {
          return getWmlsFileInfoMeaning(rawValue, fallbackMeaning);
        }
        if (tokenKey === "FILETYPE") {
          return getWmlsFileTypeMeaning(rawValue, fallbackMeaning);
        }
        return String(fallbackMeaning || "").trim() || "No semantic meaning";
      }

      function describeWmlsFileInfoComponents(rawValue) {
        const value = canonicalizeCodeKey(rawValue);
        if (!value) {
          return "";
        }

        const frameRateCodePattern = /^(?:23|24|25|30|50|60|29(?:DF|NDF)|59(?:DF|NDF))$/i;
        const combinedPattern = /^(\d{3,4})([PI])(23|24|25|30|50|60|29(?:DF|NDF)|59(?:DF|NDF))$/i;

        let resolutionCode = "";
        let scanningCode = "";
        let frameRateCode = "";

        const combinedMatch = value.match(combinedPattern);
        if (combinedMatch) {
          resolutionCode = String(combinedMatch[1] || "").toUpperCase();
          scanningCode = String(combinedMatch[2] || "").toUpperCase();
          frameRateCode = String(combinedMatch[3] || "").toUpperCase();
        } else if (frameRateCodePattern.test(value)) {
          frameRateCode = value;
        } else if (/^\d{3,4}$/.test(value)) {
          resolutionCode = value;
        } else if (/^[PI]$/i.test(value)) {
          scanningCode = value;
        } else {
          return "";
        }

        const toMeaning = (code) => {
          if (!code) return "not provided";
          const mapMeaning = getWmlsFileInfoMeaning(code, "");
          if (mapMeaning && !/no semantic meaning/i.test(String(mapMeaning || ""))) {
            return `${code} (${mapMeaning})`;
          }
          const rawMeaning = findMeaningInRawEntries(code);
          if (rawMeaning) {
            return `${code} (${rawMeaning})`;
          }
          return `${code} (definition not found)`;
        };

        return `FILEINFO components checked. Resolution: ${toMeaning(resolutionCode)} -> Scanning: ${toMeaning(scanningCode)} -> Framerate: ${toMeaning(frameRateCode)}`;
      }

      function isSingleComponentWmlsFileInfo(rawValue) {
        const value = canonicalizeCodeKey(rawValue);
        return /^(?:23|24|25|30|50|60|29(?:DF|NDF)|59(?:DF|NDF)|\d{3,4}|[PI])$/i.test(value);
      }

      function findMeaningInRawEntries(code) {
        const key = canonicalizeCodeKey(code);
        if (!key) {
          return "";
        }

        for (const entriesByCode of state.rawRuleEntriesBySource.values()) {
          const entry = entriesByCode && entriesByCode.get(key);
          const meaning = String((entry && entry.meaning) || "").trim();
          if (meaning) {
            return meaning;
          }
        }

        return "";
      }

      function getDwcConfMeaning(code, fallbackMeaning) {
        const key = canonicalizeCodeKey(code);
        if (key && state.dwcConfMeanings.has(key)) {
          return state.dwcConfMeanings.get(key);
        }
        return String(fallbackMeaning || "").trim() || "No semantic meaning";
      }

      function getDwcClassWipMeaning(code, fallbackMeaning) {
        const key = canonicalizeCodeKey(code);
        if (key && state.dwcClassWipMeanings.has(key)) {
          return state.dwcClassWipMeanings.get(key);
        }
        const classSourcePath = normalizeSourcePath(dwcClassWipSource);
        const classRawEntries = state.rawRuleEntriesBySource.get(classSourcePath);
        if (key && classRawEntries && classRawEntries.has(key)) {
          const entry = classRawEntries.get(key);
          const meaning = String((entry && entry.meaning) || "").trim();
          if (meaning) {
            return meaning;
          }
        }
        return String(fallbackMeaning || "").trim() || "No semantic meaning";
      }

      function canonicalizeCodeKey(value) {
        return String(value || "")
          .replace(/[\u2010\u2011\u2012\u2013\u2014\u2212]/g, "-")
          .trim()
          .toUpperCase();
      }

      function normalizeDash(value) {
        return String(value || "").replace(/[\u2013\u2014\u2212]/g, "-");
      }

      function normalizeWmlsMaskTokenName(tokenName) {
        const upper = String(tokenName || "").trim().toUpperCase();
        if (!upper) {
          return "";
        }

        if (upper === "ELEMENTSUBELEMENTTYPE") {
          return "ELEMENTTYPE";
        }

        return upper;
      }

      function mergePassthroughUnknownTokens(result, tokenNameKey, passthroughUnknownTokens, dedupeByRaw = true) {
        const sourceResult = Array.isArray(result) ? result : [];
        const sourcePassthrough = Array.isArray(passthroughUnknownTokens) ? passthroughUnknownTokens : [];

        const existingUnknownTokens = sourceResult
          .filter((token) => tokenNameKey(token) === "UNKNOWN")
          .map((token) => {
            const passthroughRaw = String((token && token.passthroughRaw) || (token && token.raw) || "").trim();
            return {
              ...token,
              ...toPassthroughUnknownToken(passthroughRaw)
            };
          })
          .filter((token) => String((token && token.passthroughRaw) || "").trim().length > 0);

        let unknownMerged;
        if (dedupeByRaw) {
          unknownMerged = [];
          const unknownSeen = new Set();
          for (const token of existingUnknownTokens.concat(sourcePassthrough)) {
            const key = String((token && token.passthroughRaw) || "").trim().toUpperCase();
            if (!key || unknownSeen.has(key)) {
              continue;
            }
            unknownSeen.add(key);
            unknownMerged.push(token);
          }
        } else {
          unknownMerged = existingUnknownTokens
            .concat(sourcePassthrough)
            .filter((token) => String((token && token.passthroughRaw) || "").trim().length > 0);
        }

        const nonUnknown = sourceResult.filter((token) => tokenNameKey(token) !== "UNKNOWN");
        return nonUnknown.concat(unknownMerged);
      }

      function toPassthroughUnknownToken(rawValue) {
        return {
          tokenName: "UNKNOWN",
          displayTokenLabel: "UNKNOWN",
          raw: "undefined",
          segmentMask: "UNKNOWN",
          segmentPosition: 999,
          known: false,
          informational: true,
          meaning: "passthrough (source-provided)",
          passthroughRaw: String(rawValue || "").trim()
        };
      }

      function normalizeWmlsMaskString(maskString, mainDelimiter, subDelimiter) {
        const normalizedMask = normalizeDash(maskString);
        if (!normalizedMask) {
          return "";
        }

        const main = String(mainDelimiter || "_");
        const sub = String(subDelimiter || "-");

        return normalizedMask
          .split(main)
          .map((segment) => {
            const text = String(segment || "").trim();
            if (!text) {
              return text;
            }

            const segmentDelimiter = text.includes(".") ? "." : sub;
            return text
              .split(segmentDelimiter)
              .map((token) => normalizeWmlsMaskTokenName(token))
              .join(segmentDelimiter);
          })
          .join(main);
      }

      function parseWmlsMaskVariantsDoc(doc) {
        const variations = Array.isArray(doc && doc.variations) ? doc.variations : [];
        const mapped = [];
        for (const variation of variations) {
          if (!variation || typeof variation !== "object") {
            continue;
          }

          const mainDelimiter = String(variation.mainDelimiter || "_");
          const subDelimiter = String(variation.subDelimiter || "-");
          const normalizedMask = normalizeWmlsMaskString(variation.mask, mainDelimiter, subDelimiter);
          if (!normalizedMask) {
            continue;
          }

          mapped.push({
            id: String(variation.id || ""),
            name: String(variation.name || ""),
            role: String(variation.role || ""),
            mask: normalizedMask,
            mainDelimiter,
            subDelimiter
          });
        }

        return mapped;
      }

      function getMergedMaskSpecsForRuleSet(ruleSet) {
        const rulesDoc = ruleSet && ruleSet.rulesDoc;
        const conventionId = String((rulesDoc && rulesDoc.conventionId) || "").toUpperCase();
        const sourceMasks = Array.isArray(rulesDoc && rulesDoc.maskSpecs) && rulesDoc.maskSpecs.length > 0
          ? rulesDoc.maskSpecs
          : (rulesDoc && rulesDoc.maskSpec ? [rulesDoc.maskSpec] : []);

        if (conventionId !== "WMLS") {
          return sourceMasks;
        }

        const variants = Array.isArray(state.wmlsMaskVariants) ? state.wmlsMaskVariants : [];
        if (variants.length === 0) {
          return sourceMasks;
        }

        const merged = [];
        const seen = new Set();

        const addMask = (maskSpec) => {
          if (!maskSpec || typeof maskSpec !== "object") {
            return;
          }
          const key = `${String(maskSpec.id || "")}::${String(maskSpec.mask || "")}`;
          if (seen.has(key)) {
            return;
          }
          seen.add(key);
          merged.push(maskSpec);
        };

        for (const variant of variants) {
          const normalizedMask = normalizeWmlsMaskString(variant.mask, variant.mainDelimiter, variant.subDelimiter);
          const sourceMatch = sourceMasks.find((sourceMask) =>
            (sourceMask.id && variant.id && String(sourceMask.id) === String(variant.id))
            || normalizeWmlsMaskString(sourceMask.mask, sourceMask.mainDelimiter, sourceMask.subDelimiter) === normalizedMask
          );

          if (sourceMatch) {
            addMask({
              ...sourceMatch,
              id: String(sourceMatch.id || variant.id || ""),
              name: String(sourceMatch.name || variant.name || ""),
              role: String(sourceMatch.role || variant.role || ""),
              mask: normalizedMask,
              mainDelimiter: String(sourceMatch.mainDelimiter || variant.mainDelimiter || "_"),
              subDelimiter: String(sourceMatch.subDelimiter || variant.subDelimiter || "-")
            });
            continue;
          }

          addMask({ ...variant });
        }

        for (const sourceMask of sourceMasks) {
          addMask({
            ...sourceMask,
            mask: normalizeWmlsMaskString(sourceMask.mask, sourceMask.mainDelimiter, sourceMask.subDelimiter)
          });
        }

        return merged;
      }

      function escapeHtml(value) {
        return String(value)
          .replaceAll("&", "&amp;")
          .replaceAll("<", "&lt;")
          .replaceAll(">", "&gt;")
          .replaceAll('"', "&quot;")
          .replaceAll("'", "&#39;");
      }

      function displayConventionName(conventionId) {
        const key = String(conventionId || "").toUpperCase();
        return conventionDisplayNames[key] || String(conventionId || "UNKNOWN");
      }

      function isFoxConvention(conventionId) {
        const key = String(conventionId || "").toUpperCase();
        return key === "FOX" || key === "FOX-LEGACY" || key === "FOX-AUDIO-SERVICES";
      }

      function isWmlsConvention(conventionId) {
        return String(conventionId || "").toUpperCase().includes("WMLS");
      }

      function getSourceMetadata(rule) {
        return (rule && rule.constraints && rule.constraints.source_metadata)
          || (rule && rule.source_reference && rule.source_reference.source_metadata)
          || {};
      }

      function getRulePattern(rule) {
        const metadata = getSourceMetadata(rule);
        const pattern = String(metadata.matchPattern || metadata.pattern || "").trim();
        if (pattern) {
          return pattern;
        }

        const tokenPattern = String((rule && rule.token_pattern) || "").trim();
        const tokenName = String((rule && rule.token_name) || "").trim().toUpperCase();
        if (!tokenPattern || !tokenPattern.includes("#")) {
          return null;
        }

        const escaped = tokenPattern.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

        // DWC CONF DCB-# uses two-digit duration suffixes (e.g. DCB-30, DCB-60, DCB-90).
        if (tokenName === "CONF" && tokenPattern.toUpperCase() === "DCB-#") {
          return escaped.replace(/#/g, "\\d{2}");
        }

        return escaped.replace(/#/g, "\\d+");
      }

      function getRuleFormat(rule) {
        const metadata = getSourceMetadata(rule);
        return String(metadata.format || "").trim();
      }

      function matchesRulePattern(rule, value) {
        const pattern = getRulePattern(rule);
        if (!pattern) {
          return false;
        }
        try {
          return new RegExp("^" + pattern + "$", "i").test(String(value || ""));
        } catch (error) {
          return false;
        }
      }

      function parseMaskSpec(maskSpec) {
        if (!maskSpec || !maskSpec.mask) {
          return null;
        }

        const mask = normalizeDash(maskSpec.mask);
        const mainDelimiter = String(maskSpec.mainDelimiter || "_");
        const subDelimiter = String(maskSpec.subDelimiter || "-");

        const segments = mask.split(mainDelimiter)
          .map((segment, segmentIndex) => {
            const text = String(segment || "").trim();
            if (!text) {
              return null;
            }

            const segmentDelimiter = text.includes(".") ? "." : subDelimiter;
            const tokenNames = text.split(segmentDelimiter).map((token) => token.trim()).filter(Boolean);

            return {
              segmentIndex,
              segmentMask: text,
              segmentDelimiter,
              tokenNames
            };
          })
          .filter(Boolean);

        return {
          id: String(maskSpec.id || ""),
          name: String(maskSpec.name || ""),
          role: String(maskSpec.role || "").toUpperCase(),
          mask,
          mainDelimiter,
          subDelimiter,
          detectionAnchors: maskSpec && typeof maskSpec.detectionAnchors === "object"
            ? {
              family: String(maskSpec.detectionAnchors.family || "").toUpperCase(),
              maskPriority: Number(maskSpec.detectionAnchors.maskPriority) || 0,
              positivePatterns: Array.isArray(maskSpec.detectionAnchors.positivePatterns)
                ? maskSpec.detectionAnchors.positivePatterns.map((pattern) => String(pattern || "")).filter(Boolean)
                : [],
              negativePatterns: Array.isArray(maskSpec.detectionAnchors.negativePatterns)
                ? maskSpec.detectionAnchors.negativePatterns.map((pattern) => String(pattern || "")).filter(Boolean)
                : []
            }
            : null,
          optionalSegments: Array.isArray(maskSpec.optionalSegments)
            ? maskSpec.optionalSegments.map((segment) => String(segment || "").toUpperCase())
            : [],
          optionalSubTokenSegments: Array.isArray(maskSpec.optionalSubTokenSegments)
            ? maskSpec.optionalSubTokenSegments.map((segment) => String(segment || "").toUpperCase())
            : [],
          informationalTokens: Array.isArray(maskSpec.informationalTokens)
            ? maskSpec.informationalTokens.map((token) => String(token || "").toUpperCase())
            : [],
          segments
        };
      }

      function splitByMask(filename, maskSpec, ruleSet) {
        const parts = normalizeDash(filename).split(maskSpec.mainDelimiter).map((part) => part.trim());
        const tokens = [];
        const conventionId = String((ruleSet && ruleSet.rulesDoc && ruleSet.rulesDoc.conventionId) || "").toUpperCase();
        const isFoxAudioServices = conventionId === "FOX-AUDIO-SERVICES";
        const foxAudioTrackSuffixCodes = new Set([
          "L", "C", "R", "LS", "RS", "LFE", "LRS", "RRS", "SR", "LC", "RC", "S", "LB", "RB",
          "LST", "RST", "LT", "RT", "M1", "M2", "MN", "ADD", "GDE", "REF", "MSTM", "ESTM"
        ]);
        const foxAudioStandardCodes = new Set(["N", "P", "F", "H"]);

        function looksLikeFoxAudioLangsndComposite(rawSegment) {
          const raw = String(rawSegment || "").trim().toUpperCase();
          if (!raw || raw.length < 5 || !/^[A-Z]{3}[A-Z0-9]{1,8}[A-Z]$/.test(raw)) {
            return false;
          }

          const standard = raw.slice(-1);
          const trackConfig = raw.slice(3, -1);
          return foxAudioStandardCodes.has(standard) && foxAudioTrackSuffixCodes.has(trackConfig);
        }

        function foxAudioOptionalSegmentLooksPresent(segmentMaskName, rawSegmentCandidate) {
          const raw = String(rawSegmentCandidate || "").trim();
          if (!raw) {
            return false;
          }

          if (segmentMaskName === "PICCUT") {
            return Boolean(lookupStrictTokenRule(ruleSet.index, "PICCUT", raw));
          }
          if (segmentMaskName === "ADTLINFO") {
            return Boolean(lookupStrictTokenRule(ruleSet.index, "ADTLINFO", raw))
              || Boolean(parseFoxAdtlInfoLangsndTrackconfigStandardComposite(ruleSet.index, raw));
          }
          if (segmentMaskName === "R") {
            return /^R\d{1,2}$/i.test(raw) || /^([1-9]\d?)of([1-9]\d?)$/i.test(raw);
          }
          if (segmentMaskName === "TECHINFO") {
            return Boolean(lookupStrictTokenRule(ruleSet.index, "TECHINFO", raw))
              || Boolean(resolveFoxTechInfoCompositeMeaning(raw));
          }
          if (segmentMaskName === "VERSION") {
            return Boolean(lookupStrictTokenRule(ruleSet.index, "VERSION", raw))
              || Boolean(resolveFoxTransferAssetMeaning(raw));
          }
          if (segmentMaskName === "SUFFIX") {
            return Boolean(lookupStrictTokenRule(ruleSet.index, "SUFFIX", raw))
              || Boolean(resolveFoxSuffixCompositeMeaning(ruleSet, raw));
          }
          return false;
        }

        function dwcOptionalSegmentLooksPresent(segmentMaskName, rawSegmentCandidate) {
          if (conventionId !== "DWC-MODERN" || segmentMaskName !== "TEXL-IAR") {
            return false;
          }

          const raw = String(rawSegmentCandidate || "").trim().toUpperCase();
          const parts = raw.split("-").map((part) => part.trim()).filter(Boolean);
          if (parts.length < 2 || !/^[A-Z]{2,6}$/.test(parts[0])) {
            return false;
          }

          const suffix = parts.slice(1).join("-");
          if (!suffix) {
            return false;
          }

          const tfHit = Boolean(lookupStrictTokenRule(ruleSet.index, "TF", suffix));
          const iarHit = Boolean(lookupStrictTokenRule(ruleSet.index, "IAR", suffix))
            || /^[A-Z0-9]{2,8}(?:-[A-Z0-9]{1,6})?$/.test(suffix);

          return iarHit && !tfHit;
        }

        function shouldSkipDwcAudlTfForRec(segmentMaskName, rawSegmentCandidate, remainingParts, remainingSegments) {
          if (conventionId !== "DWC-MODERN" || segmentMaskName !== "AUDL-TF") {
            return false;
          }

          if (remainingParts >= remainingSegments) {
            return false;
          }

          const raw = String(rawSegmentCandidate || "").trim().toUpperCase();
          if (!raw) {
            return false;
          }

          return /^[A-Z0-9]{6,20}(?:\.[A-Z0-9]{1,8}){0,3}$/i.test(raw);
        }
        const optionalSegments = new Set(
          Array.isArray(maskSpec.optionalSegments)
            ? maskSpec.optionalSegments.map((segment) => String(segment || "").toUpperCase())
            : []
        );
        const optionalSubTokenSegments = new Set(
          Array.isArray(maskSpec.optionalSubTokenSegments)
            ? maskSpec.optionalSubTokenSegments.map((segment) => String(segment || "").toUpperCase())
            : []
        );

        let partIndex = 0;
        for (const segment of maskSpec.segments) {
          const segmentMaskName = String(segment.segmentMask || "").toUpperCase();
          const remainingSegments = maskSpec.segments.length - Number(segment.segmentIndex || 0);
          const remainingParts = parts.length - partIndex;
          const rawSegmentCandidate = partIndex < parts.length ? parts[partIndex] : "";

          const shouldSkipFoxAudioOptionalAdtlInfo = isFoxAudioServices
            && segmentMaskName === "ADTLINFO"
            && Boolean(rawSegmentCandidate)
            && (
              Boolean(parseFoxLangsndTrackconfigStandardComposite(ruleSet, rawSegmentCandidate))
              || looksLikeFoxAudioLangsndComposite(rawSegmentCandidate)
            )
            && !parseFoxAdtlInfoLangsndTrackconfigStandardComposite(ruleSet.index, rawSegmentCandidate);

          const shouldSkipOptionalForCount = remainingParts < remainingSegments
            && optionalSegments.has(segmentMaskName)
            && (!isFoxAudioServices
              || !foxAudioOptionalSegmentLooksPresent(segmentMaskName, rawSegmentCandidate))
            && !dwcOptionalSegmentLooksPresent(segmentMaskName, rawSegmentCandidate);

          const shouldSkipDwcAudlTf = shouldSkipDwcAudlTfForRec(
            segmentMaskName,
            rawSegmentCandidate,
            remainingParts,
            remainingSegments
          );

          if (shouldSkipOptionalForCount || shouldSkipFoxAudioOptionalAdtlInfo || shouldSkipDwcAudlTf) {
            for (let i = 0; i < segment.tokenNames.length; i += 1) {
              tokens.push({
                tokenName: segment.tokenNames[i],
                rawValue: "",
                segmentMask: segment.segmentMask,
                segmentPosition: segment.segmentIndex + 1
              });
            }
            continue;
          }

          if (conventionId === "FOX"
            && segmentMaskName === "REND"
            && remainingParts > remainingSegments
            && Array.isArray(segment.tokenNames)
            && segment.tokenNames.length === 1) {
            const expectedTokenName = String(segment.tokenNames[0] || "").toUpperCase();
            const currentCandidate = String(rawSegmentCandidate || "").trim();
            const nextCandidate = partIndex + 1 < parts.length
              ? String(parts[partIndex + 1] || "").trim()
              : "";
            const currentLooksLikeRend = Boolean(lookupStrictTokenRule(ruleSet.index, expectedTokenName, currentCandidate));
            const nextLooksLikeRend = Boolean(lookupStrictTokenRule(ruleSet.index, expectedTokenName, nextCandidate));

            if (!currentLooksLikeRend && nextLooksLikeRend) {
              tokens.push({
                tokenName: "EXTRA_SEGMENT",
                rawValue: currentCandidate,
                segmentMask: null,
                segmentPosition: 999
              });
              partIndex += 1;
            }
          }

          const rawSegment = partIndex < parts.length ? parts[partIndex] : "";
          partIndex += 1;

          if (segment.tokenNames.length === 1) {
            tokens.push({
              tokenName: segment.tokenNames[0],
              rawValue: rawSegment,
              segmentMask: segment.segmentMask,
              segmentPosition: segment.segmentIndex + 1
            });
            continue;
          }

          let subParts = normalizeDash(rawSegment).split(segment.segmentDelimiter).map((part) => part.trim());
          if (segment.tokenNames.length === 2 && subParts.length > 2) {
            const isDwcStrictTailSegment = conventionId === "DWC-MODERN"
              && ["TEXL-IAR", "AUDL-TF", "TTL-TYPE"].includes(segmentMaskName);
            if (isDwcStrictTailSegment) {
              subParts = [subParts[0], subParts.slice(1).join(segment.segmentDelimiter)];
            } else {
              subParts = [subParts.slice(0, -1).join(segment.segmentDelimiter), subParts[subParts.length - 1]];
            }
          }

          if (optionalSubTokenSegments.has(segmentMaskName) && subParts.length < segment.tokenNames.length) {
            subParts = subParts.concat(Array(segment.tokenNames.length - subParts.length).fill(""));
          }

          for (let i = 0; i < segment.tokenNames.length; i += 1) {
            tokens.push({
              tokenName: segment.tokenNames[i],
              rawValue: subParts[i] || "",
              segmentMask: segment.segmentMask,
              segmentPosition: segment.segmentIndex + 1
            });
          }
        }

        const trailingParts = partIndex < parts.length ? parts.slice(partIndex).filter(Boolean) : [];
        if (trailingParts.length > 0) {
          const noteToken = tokens.find((token) => String(token.tokenName || "").toUpperCase() === "NOTE");
          if (noteToken) {
            const trailing = trailingParts.join(maskSpec.mainDelimiter);
            noteToken.rawValue = String(noteToken.rawValue || "").trim()
              ? `${String(noteToken.rawValue || "").trim()}${maskSpec.mainDelimiter}${trailing}`
              : trailing;
          }
        }

        return tokens;
      }

      function normalizeFoxRepeatedClcuTfAndRt(ruleSet, tokens, maskSpec) {
        const conventionId = String((ruleSet.rulesDoc && ruleSet.rulesDoc.conventionId) || "").toUpperCase();
        if (!isFoxConvention(conventionId)) {
          return tokens;
        }

        const sourceTokens = Array.isArray(tokens) ? tokens.map((token) => ({ ...token })) : [];
        const clcuIdx = sourceTokens.findIndex((token) => String(token.tokenName || "").toUpperCase() === "CL/CU");
        const tfIdx = sourceTokens.findIndex((token, idx) => idx > clcuIdx && String(token.tokenName || "").toUpperCase() === "TF");
        const rtIdx = sourceTokens.findIndex((token, idx) => idx > tfIdx && String(token.tokenName || "").toUpperCase() === "RT");
        if (clcuIdx < 0 || tfIdx < 0 || rtIdx < 0) {
          return sourceTokens;
        }

        const noteIdx = sourceTokens.findIndex((token, idx) => idx > rtIdx && String(token.tokenName || "").toUpperCase() === "NOTE");
        const queue = [String(sourceTokens[rtIdx].rawValue || "").trim()];
        if (noteIdx >= 0) {
          queue.push(String(sourceTokens[noteIdx].rawValue || "").trim());
        }

        const repeatedPairs = [];
        while (queue.length > 0) {
          const raw = String(queue[0] || "").trim();
          const parts = raw.split("-").map((part) => part.trim()).filter(Boolean);
          if (parts.length < 2) {
            break;
          }

          const tf = parts[parts.length - 1];
          const clcu = parts.slice(0, -1).join("-");
          if (!/^[A-Z]{2,6}(?:-[A-Z0-9]{2,8})?$/i.test(clcu) || !/^[A-Z0-9]{1,6}$/i.test(tf)) {
            break;
          }

          repeatedPairs.push({ clcu, tf });
          queue.shift();
        }

        if (repeatedPairs.length > 0) {
          sourceTokens[rtIdx].rawValue = queue.shift() || "";

          if (noteIdx >= 0) {
            const noteDelimiter = String((maskSpec && maskSpec.mainDelimiter) || "_");
            sourceTokens[noteIdx].rawValue = queue.length > 0 ? queue.join(noteDelimiter) : "";
          }

          const repeatedTokens = [];
          for (const pair of repeatedPairs) {
            repeatedTokens.push({
              tokenName: "CL/CU",
              rawValue: pair.clcu,
              segmentMask: sourceTokens[clcuIdx].segmentMask,
              segmentPosition: sourceTokens[clcuIdx].segmentPosition
            });
            repeatedTokens.push({
              tokenName: "TF",
              rawValue: pair.tf,
              segmentMask: sourceTokens[tfIdx].segmentMask,
              segmentPosition: sourceTokens[tfIdx].segmentPosition
            });
          }

          sourceTokens.splice(tfIdx + 1, 0, ...repeatedTokens);
        }

        const normalizedRt = sourceTokens.find((token) => String(token.tokenName || "").toUpperCase() === "RT");
        if (!normalizedRt) {
          return sourceTokens;
        }

        const rtRaw = String(normalizedRt.rawValue || "").trim();
        const rtMatch = rtRaw.match(/^(RT\d{6})(?:[_.-]?(.*))?$/i);
        if (!rtMatch) {
          return sourceTokens;
        }

        normalizedRt.rawValue = String(rtMatch[1] || "").toUpperCase();
        const trailingRaw = String(rtMatch[2] || "").trim();
        if (!trailingRaw) {
          return sourceTokens;
        }

        const noteToken = sourceTokens.find((token, idx) => idx > rtIdx && String(token.tokenName || "").toUpperCase() === "NOTE");
        const noteDelimiter = String((maskSpec && maskSpec.mainDelimiter) || "_");
        if (noteToken) {
          noteToken.rawValue = String(noteToken.rawValue || "").trim()
            ? `${String(noteToken.rawValue || "").trim()}${noteDelimiter}${trailingRaw}`
            : trailingRaw;
        }

        return sourceTokens;
      }

      function realignFoxAudioShiftedTailTokens(ruleSet, tokens) {
        const conventionId = String((ruleSet && ruleSet.rulesDoc && ruleSet.rulesDoc.conventionId) || "").toUpperCase();
        if (conventionId !== "FOX-AUDIO-SERVICES") {
          return tokens;
        }

        const sourceTokens = Array.isArray(tokens) ? tokens.map((token) => ({ ...token })) : [];
        const findByName = (name) => sourceTokens.find((token) => String(token.tokenName || "").toUpperCase() === name);
        const trackSuffixCodes = new Set([
          "L", "C", "R", "LS", "RS", "LFE", "LRS", "RRS", "SR", "LC", "RC", "S", "LB", "RB",
          "LST", "RST", "LT", "RT", "M1", "M2", "MN", "ADD", "GDE", "REF", "MSTM", "ESTM"
        ]);

        const langsndToken = findByName("LANGSND");
        const jobTypeToken = findByName("JOBTYPE");
        const piccutToken = findByName("PICCUT");
        const adtlInfoToken = findByName("ADTLINFO");
        const trackConfigToken = findByName("TRACKCONFIG");
        const standardToken = findByName("STANDARD");
        const reelToken = findByName("R");
        const techInfoToken = findByName("TECHINFO");
        const versionToken = findByName("VERSION");
        const suffixToken = findByName("SUFFIX");

        if (!langsndToken || !trackConfigToken || !standardToken || !reelToken) {
          return sourceTokens;
        }

        const langsndRaw = String(langsndToken.rawValue || "").trim();
        const jobTypeRaw = String((jobTypeToken && jobTypeToken.rawValue) || "").trim();
        const piccutRaw = String((findByName("PICCUT") && findByName("PICCUT").rawValue) || "").trim();
        const adtlInfoRaw = String((adtlInfoToken && adtlInfoToken.rawValue) || "").trim();
        const trackConfigRaw = String(trackConfigToken.rawValue || "").trim();
        const standardRaw = String(standardToken.rawValue || "").trim();
        const reelRaw = String(reelToken.rawValue || "").trim();
        const techInfoRaw = String((techInfoToken && techInfoToken.rawValue) || "").trim();
        const versionRaw = String((versionToken && versionToken.rawValue) || "").trim();
        const suffixRaw = String((suffixToken && suffixToken.rawValue) || "").trim();

        const jobTypeUpper = String(jobTypeRaw || "").toUpperCase();
        const piccutUpper = String(piccutRaw || "").toUpperCase();
        const adtlUpper = String(adtlInfoRaw || "").toUpperCase();
        const langsndUpper = String(langsndRaw || "").toUpperCase();
        const trackUpper = String(trackConfigRaw || "").toUpperCase();
        const standardUpper = String(standardRaw || "").toUpperCase();
        const splitTailSuffix = lookupStrictTokenRule(ruleSet.index, "SUFFIX", `${trackUpper}_${standardUpper}`)
          ? `${trackUpper}_${standardUpper}`
          : "";
        const compactSuffixRaw = splitTailSuffix
          || (lookupStrictTokenRule(ruleSet.index, "SUFFIX", trackUpper) ? trackUpper : "");
        const splitLangsndTrackSuffix = lookupStrictTokenRule(ruleSet.index, "SUFFIX", `${langsndUpper}_${trackUpper}`)
          ? `${langsndUpper}_${trackUpper}`
          : "";
        const langsndSuffixRaw = lookupStrictTokenRule(ruleSet.index, "SUFFIX", langsndUpper)
          ? langsndUpper
          : "";

        // Compact short-form variant:
        // TITLE_WPR_STANDARD_STANDARD_VERSION_SUFFIX
        // Example: Cocoon_005923_H_N_M123456_DBC
        // Example (split tapetype tail): DrDoli_321456_H_N_P019136_HDCAM_SR
        if (jobTypeToken
          && piccutToken
          && lookupStrictTokenRule(ruleSet.index, "STANDARD", jobTypeUpper)
          && lookupStrictTokenRule(ruleSet.index, "STANDARD", piccutUpper)
          && /^[MP]\d{3,}$/i.test(langsndRaw)
          && compactSuffixRaw
          && !reelRaw
          && !techInfoRaw
          && !versionRaw) {
          jobTypeToken.rawValue = "";
          piccutToken.rawValue = "";

          langsndToken.rawValue = "";
          trackConfigToken.rawValue = "";

          standardToken.rawValue = `${jobTypeUpper}_${piccutUpper}`;
          standardToken.tokenName = "STANDARD";
          standardToken.segmentMask = "STANDARD";
          standardToken.segmentPosition = 8;

          if (versionToken) {
            versionToken.rawValue = String(langsndRaw || "").toUpperCase();
            versionToken.tokenName = "VERSION";
            versionToken.segmentMask = "VERSION";
            versionToken.segmentPosition = 11;
          } else {
            sourceTokens.push({
              tokenName: "VERSION",
              rawValue: String(langsndRaw || "").toUpperCase(),
              segmentMask: "VERSION",
              segmentPosition: 11
            });
          }

          if (suffixToken) {
            suffixToken.rawValue = compactSuffixRaw;
            suffixToken.tokenName = "SUFFIX";
            suffixToken.segmentMask = "SUFFIX";
            suffixToken.segmentPosition = 12;
          } else {
            sourceTokens.push({
              tokenName: "SUFFIX",
              rawValue: compactSuffixRaw,
              segmentMask: "SUFFIX",
              segmentPosition: 12
            });
          }

          return sourceTokens;
        }

        // Compact TapeType variant with shifted optional slots:
        // TITLE_WPR_STANDARD_STANDARD_TRANSFERASSET_TAPETYPE
        // Example: DrDoli_321456_H_N_P019136_HDCAM_SR
        if (jobTypeToken
          && piccutToken
          && adtlInfoToken
          && lookupStrictTokenRule(ruleSet.index, "STANDARD", jobTypeUpper)
          && lookupStrictTokenRule(ruleSet.index, "STANDARD", piccutUpper)
          && /^[MP]\d{3,}$/i.test(adtlUpper)
          && splitLangsndTrackSuffix
          && !standardRaw
          && !reelRaw
          && !techInfoRaw
          && !versionRaw
          && !suffixRaw) {
          jobTypeToken.rawValue = "";
          piccutToken.rawValue = "";
          adtlInfoToken.rawValue = "";
          langsndToken.rawValue = "";
          trackConfigToken.rawValue = "";

          standardToken.rawValue = `${jobTypeUpper}_${piccutUpper}`;
          standardToken.tokenName = "STANDARD";
          standardToken.segmentMask = "STANDARD";
          standardToken.segmentPosition = 8;

          if (versionToken) {
            versionToken.rawValue = adtlUpper;
            versionToken.tokenName = "VERSION";
            versionToken.segmentMask = "VERSION";
            versionToken.segmentPosition = 11;
          } else {
            sourceTokens.push({
              tokenName: "VERSION",
              rawValue: adtlUpper,
              segmentMask: "VERSION",
              segmentPosition: 11
            });
          }

          if (suffixToken) {
            suffixToken.rawValue = splitLangsndTrackSuffix;
            suffixToken.tokenName = "SUFFIX";
            suffixToken.segmentMask = "SUFFIX";
            suffixToken.segmentPosition = 12;
          } else {
            sourceTokens.push({
              tokenName: "SUFFIX",
              rawValue: splitLangsndTrackSuffix,
              segmentMask: "SUFFIX",
              segmentPosition: 12
            });
          }

          return sourceTokens;
        }

        // Compact TapeType variant with single suffix token:
        // TITLE_WPR_STANDARD_STANDARD_TRANSFERASSET_TAPETYPE
        // Example: Cocoon_005923_H_N_M123456_DBC
        if (jobTypeToken
          && piccutToken
          && adtlInfoToken
          && lookupStrictTokenRule(ruleSet.index, "STANDARD", jobTypeUpper)
          && lookupStrictTokenRule(ruleSet.index, "STANDARD", piccutUpper)
          && /^[MP]\d{3,}$/i.test(adtlUpper)
          && langsndSuffixRaw
          && !trackConfigRaw
          && !standardRaw
          && !reelRaw
          && !techInfoRaw
          && !versionRaw
          && !suffixRaw) {
          jobTypeToken.rawValue = "";
          piccutToken.rawValue = "";
          adtlInfoToken.rawValue = "";
          langsndToken.rawValue = "";

          standardToken.rawValue = `${jobTypeUpper}_${piccutUpper}`;
          standardToken.tokenName = "STANDARD";
          standardToken.segmentMask = "STANDARD";
          standardToken.segmentPosition = 8;

          if (versionToken) {
            versionToken.rawValue = adtlUpper;
            versionToken.tokenName = "VERSION";
            versionToken.segmentMask = "VERSION";
            versionToken.segmentPosition = 11;
          } else {
            sourceTokens.push({
              tokenName: "VERSION",
              rawValue: adtlUpper,
              segmentMask: "VERSION",
              segmentPosition: 11
            });
          }

          if (suffixToken) {
            suffixToken.rawValue = langsndSuffixRaw;
            suffixToken.tokenName = "SUFFIX";
            suffixToken.segmentMask = "SUFFIX";
            suffixToken.segmentPosition = 12;
          } else {
            sourceTokens.push({
              tokenName: "SUFFIX",
              rawValue: langsndSuffixRaw,
              segmentMask: "SUFFIX",
              segmentPosition: 12
            });
          }

          return sourceTokens;
        }

        const adtlCompositeFromAdtlInfo = parseFoxAdtlInfoLangsndTrackconfigStandardComposite(ruleSet.index, adtlInfoRaw);
        if (adtlCompositeFromAdtlInfo
          && !trackConfigRaw
          && !standardRaw
          && !reelRaw
          && !techInfoRaw
          && !versionRaw
          && !suffixRaw
          && (!langsndRaw || lookupStrictTokenRule(ruleSet.index, "SUFFIX", langsndRaw))) {
          if (adtlInfoToken) {
            adtlInfoToken.rawValue = adtlCompositeFromAdtlInfo.adtlInfoRaw;
            adtlInfoToken.tokenName = "ADTLINFO";
            adtlInfoToken.segmentMask = "ADTLINFO";
            adtlInfoToken.segmentPosition = 5;
          }

          langsndToken.rawValue = adtlCompositeFromAdtlInfo.compositeParts.langsndCode;
          langsndToken.tokenName = "LANGSND";
          langsndToken.segmentMask = "LANGSND";
          langsndToken.segmentPosition = 6;

          trackConfigToken.rawValue = adtlCompositeFromAdtlInfo.compositeParts.trackConfigCode;
          trackConfigToken.tokenName = "TRACKCONFIG";
          trackConfigToken.segmentMask = "TRACKCONFIG";
          trackConfigToken.segmentPosition = 7;

          standardToken.rawValue = adtlCompositeFromAdtlInfo.compositeParts.standardCode;
          standardToken.tokenName = "STANDARD";
          standardToken.segmentMask = "STANDARD";
          standardToken.segmentPosition = 8;

          if (langsndRaw && lookupStrictTokenRule(ruleSet.index, "SUFFIX", langsndRaw)) {
            sourceTokens.push({
              tokenName: "SUFFIX",
              rawValue: String(langsndRaw || "").toUpperCase(),
              segmentMask: "SUFFIX",
              segmentPosition: 12
            });
          }

          return sourceTokens;
        }

        const piccutComposite = parseFoxAdtlInfoLangsndTrackconfigStandardComposite(ruleSet.index, piccutRaw);
        const piccutLangsndComposite = parseFoxLangsndTrackconfigStandardComposite(ruleSet, piccutRaw);
        if (piccutLangsndComposite
          && !langsndRaw
          && !trackConfigRaw
          && !standardRaw
          && !reelRaw
          && !techInfoRaw
          && !versionRaw
          && !suffixRaw) {
          const piccutToken = findByName("PICCUT");
          if (piccutToken) {
            piccutToken.rawValue = "";
          }

          langsndToken.rawValue = piccutLangsndComposite.langCode;
          langsndToken.tokenName = "LANGSND";
          langsndToken.segmentMask = "LANGSND";
          langsndToken.segmentPosition = 6;

          trackConfigToken.rawValue = piccutLangsndComposite.trackCode;
          trackConfigToken.tokenName = "TRACKCONFIG";
          trackConfigToken.segmentMask = "TRACKCONFIG";
          trackConfigToken.segmentPosition = 7;

          standardToken.rawValue = piccutLangsndComposite.standardRaw;
          standardToken.tokenName = "STANDARD";
          standardToken.segmentMask = "STANDARD";
          standardToken.segmentPosition = 8;

          // In compact footprints, the trailing token after PICCUT can carry
          // suffix-style metadata (for example IPDLMX). Preserve it as SUFFIX
          // rather than dropping it from the decode stream.
          if (adtlInfoToken && adtlInfoRaw && !lookupStrictTokenRule(ruleSet.index, "ADTLINFO", adtlInfoRaw)) {
            const normalizedTail = String(adtlInfoRaw || "").trim().toUpperCase();
            adtlInfoToken.rawValue = "";
            if (normalizedTail) {
              if (suffixToken) {
                suffixToken.rawValue = normalizedTail;
                suffixToken.tokenName = "SUFFIX";
                suffixToken.segmentMask = "SUFFIX";
                suffixToken.segmentPosition = 12;
              } else {
                sourceTokens.push({
                  tokenName: "SUFFIX",
                  rawValue: normalizedTail,
                  segmentMask: "SUFFIX",
                  segmentPosition: 12
                });
              }
            }
          }

          return sourceTokens;
        }
        if (piccutLangsndComposite
          && langsndRaw
          && !trackConfigRaw
          && !standardRaw
          && !reelRaw
          && !techInfoRaw
          && !versionRaw
          && !suffixRaw
          && lookupStrictTokenRule(ruleSet.index, "SUFFIX", langsndRaw)) {
          const piccutToken = findByName("PICCUT");
          if (piccutToken) {
            piccutToken.rawValue = "";
          }

          langsndToken.rawValue = piccutLangsndComposite.langCode;
          langsndToken.tokenName = "LANGSND";
          langsndToken.segmentMask = "LANGSND";
          langsndToken.segmentPosition = 6;

          trackConfigToken.rawValue = piccutLangsndComposite.trackCode;
          trackConfigToken.tokenName = "TRACKCONFIG";
          trackConfigToken.segmentMask = "TRACKCONFIG";
          trackConfigToken.segmentPosition = 7;

          standardToken.rawValue = piccutLangsndComposite.standardRaw;
          standardToken.tokenName = "STANDARD";
          standardToken.segmentMask = "STANDARD";
          standardToken.segmentPosition = 8;

          if (suffixToken) {
            suffixToken.rawValue = String(langsndRaw || "").toUpperCase();
            suffixToken.tokenName = "SUFFIX";
            suffixToken.segmentMask = "SUFFIX";
            suffixToken.segmentPosition = 12;
          } else {
            sourceTokens.push({
              tokenName: "SUFFIX",
              rawValue: String(langsndRaw || "").toUpperCase(),
              segmentMask: "SUFFIX",
              segmentPosition: 12
            });
          }

          return sourceTokens;
        }

        if (piccutComposite
          && !trackConfigRaw
          && !standardRaw
          && !reelRaw
          && !techInfoRaw
          && !versionRaw
          && !suffixRaw) {
          const piccutToken = findByName("PICCUT");
          if (piccutToken) {
            piccutToken.rawValue = piccutComposite.adtlInfoRaw;
            piccutToken.tokenName = "ADTLINFO";
            piccutToken.segmentMask = "ADTLINFO";
            piccutToken.segmentPosition = 5;
          }

          langsndToken.rawValue = piccutComposite.compositeParts.langsndCode;
          langsndToken.tokenName = "LANGSND";
          langsndToken.segmentMask = "LANGSND";
          langsndToken.segmentPosition = 6;

          trackConfigToken.rawValue = piccutComposite.compositeParts.trackConfigCode;
          trackConfigToken.tokenName = "TRACKCONFIG";
          trackConfigToken.segmentMask = "TRACKCONFIG";
          trackConfigToken.segmentPosition = 7;

          standardToken.rawValue = piccutComposite.compositeParts.standardCode;
          standardToken.tokenName = "STANDARD";
          standardToken.segmentMask = "STANDARD";
          standardToken.segmentPosition = 8;

          if (langsndRaw && lookupStrictTokenRule(ruleSet.index, "SUFFIX", langsndRaw)) {
            sourceTokens.push({
              tokenName: "SUFFIX",
              rawValue: String(langsndRaw || "").toUpperCase(),
              segmentMask: "SUFFIX",
              segmentPosition: 12
            });
          }

          return sourceTokens;
        }

        const compactSuffixRule = lookupStrictTokenRule(ruleSet.index, "SUFFIX", langsndRaw);
        if (langsndRaw
          && !trackConfigRaw
          && !standardRaw
          && !reelRaw
          && !techInfoRaw
          && !versionRaw
          && !suffixRaw
          && compactSuffixRule) {
          langsndToken.tokenName = "SUFFIX";
          langsndToken.segmentMask = "SUFFIX";
          return sourceTokens;
        }

        const langsndLooksComposite = Boolean(parseFoxLangsndTrackconfigStandardComposite(ruleSet, langsndToken.rawValue));
        const trackLooksReel = /^R\d{1,2}$/i.test(String(trackConfigToken.rawValue || "").trim())
            || /^R\d{1,2}-\d{1,2}$/i.test(String(trackConfigToken.rawValue || "").trim())
            || /^([1-9]\d?)of([1-9]\d?)$/i.test(String(trackConfigToken.rawValue || "").trim());
        const standardLooksReelTotal = /^\d{1,2}$/i.test(String(standardToken.rawValue || "").trim());
        const standardLooksTechInfo = Boolean(resolveFoxTechInfoCompositeMeaning(standardToken.rawValue));
        const reelLooksTransfer = Boolean(resolveFoxTransferAssetMeaning(reelToken.rawValue));
        const reelLooksTechInfo = Boolean(resolveFoxTechInfoCompositeMeaning(reelToken.rawValue));
        const techInfoLooksTransfer = Boolean(resolveFoxTransferAssetMeaning((techInfoToken && techInfoToken.rawValue) || ""));
        const compositeLangsndParts = parseFoxLangsndTrackconfigStandardComposite(ruleSet, langsndToken.rawValue);

        if (compositeLangsndParts
          && trackLooksReel
          && standardLooksReelTotal
          && reelLooksTechInfo
          && techInfoLooksTransfer
          && !versionRaw
          && !suffixRaw) {
          const trackRawUpper = String(trackConfigToken.rawValue || "").trim().toUpperCase();
          const totalReels = String(standardToken.rawValue || "").trim();
          const reelMatch = trackRawUpper.match(/^R(\d{1,2})$/i);
          const reelCombined = reelMatch ? `${reelMatch[1]}of${totalReels}` : trackRawUpper;
          const rawTechInfoFromReel = String(reelToken.rawValue || "").trim();
          const rawVersionFromTechInfo = String((techInfoToken && techInfoToken.rawValue) || "").trim();

          langsndToken.rawValue = compositeLangsndParts.langCode;
          langsndToken.tokenName = "LANGSND";
          langsndToken.segmentMask = "LANGSND";
          langsndToken.segmentPosition = 6;

          trackConfigToken.rawValue = compositeLangsndParts.trackCode;
          trackConfigToken.tokenName = "TRACKCONFIG";
          trackConfigToken.segmentMask = "TRACKCONFIG";
          trackConfigToken.segmentPosition = 7;

          standardToken.rawValue = compositeLangsndParts.standardRaw;
          standardToken.tokenName = "STANDARD";
          standardToken.segmentMask = "STANDARD";
          standardToken.segmentPosition = 8;

          reelToken.rawValue = reelCombined;
          reelToken.tokenName = "R";
          reelToken.segmentMask = "R";
          reelToken.segmentPosition = 9;

          if (techInfoToken) {
            techInfoToken.rawValue = rawTechInfoFromReel;
            techInfoToken.tokenName = "TECHINFO";
            techInfoToken.segmentMask = "TECHINFO";
            techInfoToken.segmentPosition = 10;
          }

          if (versionToken) {
            versionToken.rawValue = rawVersionFromTechInfo;
            versionToken.tokenName = "VERSION";
            versionToken.segmentMask = "VERSION";
            versionToken.segmentPosition = 11;
          } else {
            sourceTokens.push({
              tokenName: "VERSION",
              rawValue: rawVersionFromTechInfo,
              segmentMask: "VERSION",
              segmentPosition: 11
            });
          }

          return sourceTokens;
        }

          if (compositeLangsndParts
            && /^R\d{1,2}-\d{1,2}$/i.test(String(trackConfigToken.rawValue || "").trim())
            && standardLooksTechInfo
            && !reelRaw
            && techInfoLooksTransfer
            && !versionRaw
            && !suffixRaw) {
            const trackRawUpper = String(trackConfigToken.rawValue || "").trim().toUpperCase();
            const rawTechInfoFromStandard = String(standardToken.rawValue || "").trim();
            const rawVersionFromTechInfo = String((techInfoToken && techInfoToken.rawValue) || "").trim();

            langsndToken.rawValue = compositeLangsndParts.langCode;
            langsndToken.tokenName = "LANGSND";
            langsndToken.segmentMask = "LANGSND";
            langsndToken.segmentPosition = 6;

            trackConfigToken.rawValue = compositeLangsndParts.trackCode;
            trackConfigToken.tokenName = "TRACKCONFIG";
            trackConfigToken.segmentMask = "TRACKCONFIG";
            trackConfigToken.segmentPosition = 7;

            standardToken.rawValue = compositeLangsndParts.standardRaw;
            standardToken.tokenName = "STANDARD";
            standardToken.segmentMask = "STANDARD";
            standardToken.segmentPosition = 8;

            reelToken.rawValue = trackRawUpper;
            reelToken.tokenName = "R";
            reelToken.segmentMask = "R";
            reelToken.segmentPosition = 9;

            if (techInfoToken) {
              techInfoToken.rawValue = rawTechInfoFromStandard;
              techInfoToken.tokenName = "TECHINFO";
              techInfoToken.segmentMask = "TECHINFO";
              techInfoToken.segmentPosition = 10;
            }

            if (versionToken) {
              versionToken.rawValue = rawVersionFromTechInfo;
              versionToken.tokenName = "VERSION";
              versionToken.segmentMask = "VERSION";
              versionToken.segmentPosition = 11;
            } else {
              sourceTokens.push({
                tokenName: "VERSION",
                rawValue: rawVersionFromTechInfo,
                segmentMask: "VERSION",
                segmentPosition: 11
              });
            }

            return sourceTokens;
          }

        if (compositeLangsndParts
          && /^R\d{1,2}-\d{1,2}$/i.test(String(trackConfigToken.rawValue || "").trim())
          && standardLooksTechInfo
          && reelLooksTransfer
          && !techInfoRaw
          && !versionRaw
          && !suffixRaw) {
          const trackRawUpper = String(trackConfigToken.rawValue || "").trim().toUpperCase();
          const rawTechInfoFromStandard = String(standardToken.rawValue || "").trim();
          const rawVersionFromReel = String(reelToken.rawValue || "").trim();

          langsndToken.rawValue = compositeLangsndParts.langCode;
          langsndToken.tokenName = "LANGSND";
          langsndToken.segmentMask = "LANGSND";
          langsndToken.segmentPosition = 6;

          trackConfigToken.rawValue = compositeLangsndParts.trackCode;
          trackConfigToken.tokenName = "TRACKCONFIG";
          trackConfigToken.segmentMask = "TRACKCONFIG";
          trackConfigToken.segmentPosition = 7;

          standardToken.rawValue = compositeLangsndParts.standardRaw;
          standardToken.tokenName = "STANDARD";
          standardToken.segmentMask = "STANDARD";
          standardToken.segmentPosition = 8;

          reelToken.rawValue = trackRawUpper;
          reelToken.tokenName = "R";
          reelToken.segmentMask = "R";
          reelToken.segmentPosition = 9;

          if (techInfoToken) {
            techInfoToken.rawValue = rawTechInfoFromStandard;
            techInfoToken.tokenName = "TECHINFO";
            techInfoToken.segmentMask = "TECHINFO";
            techInfoToken.segmentPosition = 10;
          }

          if (versionToken) {
            versionToken.rawValue = rawVersionFromReel;
            versionToken.tokenName = "VERSION";
            versionToken.segmentMask = "VERSION";
            versionToken.segmentPosition = 11;
          } else {
            sourceTokens.push({
              tokenName: "VERSION",
              rawValue: rawVersionFromReel,
              segmentMask: "VERSION",
              segmentPosition: 11
            });
          }

          return sourceTokens;
        }

        if (!(langsndLooksComposite && trackLooksReel && standardLooksTechInfo && reelLooksTransfer)) {
          return sourceTokens;
        }

        trackConfigToken.tokenName = "R";
        trackConfigToken.segmentMask = "R";

        standardToken.tokenName = "TECHINFO";
        standardToken.segmentMask = "TECHINFO";

        reelToken.tokenName = "VERSION";
        reelToken.segmentMask = "VERSION";

        if (techInfoToken) {
          const techUpper = String(techInfoToken.rawValue || "").trim().toUpperCase();
          if (trackSuffixCodes.has(techUpper)) {
            techInfoToken.tokenName = "SUFFIX";
            techInfoToken.segmentMask = "SUFFIX";
          }
        }

        return sourceTokens;
      }

      function applyDwcShortFormFallback(ruleSet, maskSpec, tokens) {
        const conventionId = String((ruleSet.rulesDoc && ruleSet.rulesDoc.conventionId) || "").toUpperCase();
        if (conventionId !== "DWC-MODERN") {
          return tokens;
        }

        const mask = String(maskSpec.mask || "").toUpperCase();
        if (!mask.includes("RES-RANGE") || !mask.includes("TTL-TYPE")) {
          return tokens;
        }

        const findToken = (segmentMask, tokenName) => tokens.find((token) =>
          String(token.segmentMask || "").toUpperCase() === String(segmentMask || "").toUpperCase()
          && String(token.tokenName || "").toUpperCase() === String(tokenName || "").toUpperCase());

        const resToken = findToken("RES-RANGE", "RES");
        const rangeToken = findToken("RES-RANGE", "RANGE");
        const fpsToken = findToken("FPS", "FPS");
        const texlToken = findToken("TEXL-IAR", "TEXL");
        const iarToken = findToken("TEXL-IAR", "IAR");
        const audlToken = findToken("AUDL-TF", "AUDL");
        const tfToken = findToken("AUDL-TF", "TF");
        const ttlToken = findToken("TTL-TYPE", "TTL");
        const ttlTypeToken = findToken("TTL-TYPE", "TYPE");
        const recToken = findToken("REC", "REC");
        const specToken = findToken("SPEC", "SPEC");

        if (!resToken || !fpsToken || !texlToken || !iarToken || !audlToken || !ttlToken || !ttlTypeToken || !recToken || !specToken) {
          return tokens;
        }

        const resRaw = String(resToken.rawValue || "").trim().toUpperCase();
        const fpsRaw = String(fpsToken.rawValue || "").trim().toUpperCase();
        const texlRaw = String(texlToken.rawValue || "").trim().toUpperCase();
        const iarRaw = String(iarToken.rawValue || "").trim().toUpperCase();
        const audlRaw = String(audlToken.rawValue || "").trim();
        const specRaw = String(specToken.rawValue || "").trim().toUpperCase();
        const hasExistingTailValues = String(ttlToken.rawValue || "").trim() || String(ttlTypeToken.rawValue || "").trim() || String(recToken.rawValue || "").trim();

        const looksShortFormTail = Boolean(
          specRaw
          && /^\d{2,3}$/.test(resRaw)
          && /^[A-Z]{2,6}-[A-Z0-9]{2,8}$/.test(fpsRaw)
          && /^[A-Z]{2,6}$/.test(texlRaw)
          && /^[A-Z0-9]{2,12}$/.test(iarRaw)
          && /^[A-Z0-9]{6,20}(?:\.[A-Z0-9]{1,8}){0,3}$/i.test(audlRaw)
          && !hasExistingTailValues
        );
        if (!looksShortFormTail) {
          return tokens;
        }

        const fpsParts = fpsRaw.split("-");
        const fallbackTEXL = fpsParts[0] || "";
        const fallbackIAR = fpsParts.slice(1).join("-");

        fpsToken.rawValue = resRaw;
        resToken.rawValue = "";
        if (rangeToken) {
          rangeToken.rawValue = "";
        }

        texlToken.rawValue = fallbackTEXL;
        iarToken.rawValue = fallbackIAR;

        ttlToken.rawValue = texlRaw;
        ttlTypeToken.rawValue = iarRaw;
        recToken.rawValue = audlRaw;

        audlToken.rawValue = "";
        if (tfToken) {
          tfToken.rawValue = "";
        }

        return tokens;
      }

      function applyDwcAudioOnlyFallback(ruleSet, maskSpec, tokens) {
        const conventionId = String((ruleSet.rulesDoc && ruleSet.rulesDoc.conventionId) || "").toUpperCase();
        if (conventionId !== "DWC-MODERN") {
          return tokens;
        }

        const mask = String(maskSpec.mask || "").toUpperCase();
        if (!mask.includes("TEXL-IAR") || !mask.includes("AUDL-TF") || !mask.includes("REC")) {
          return tokens;
        }

        const findToken = (segmentMask, tokenName) => tokens.find((token) =>
          String(token.segmentMask || "").toUpperCase() === String(segmentMask || "").toUpperCase()
          && String(token.tokenName || "").toUpperCase() === String(tokenName || "").toUpperCase());

        const fpsToken = findToken("FPS", "FPS");
        const specToken = findToken("SPEC", "SPEC");
        const texlToken = findToken("TEXL-IAR", "TEXL");
        const iarToken = findToken("TEXL-IAR", "IAR");
        const audlToken = findToken("AUDL-TF", "AUDL");
        const tfToken = findToken("AUDL-TF", "TF");
        const recToken = findToken("REC", "REC");

        if (!fpsToken || !specToken || !texlToken || !iarToken || !audlToken || !tfToken || !recToken) {
          return tokens;
        }

        const fpsRaw = String(fpsToken.rawValue || "").trim().toUpperCase();
        const specRaw = String(specToken.rawValue || "").trim().toUpperCase();
        const texlRaw = String(texlToken.rawValue || "").trim().toUpperCase();
        const iarRaw = String(iarToken.rawValue || "").trim().toUpperCase();
        const audlRaw = String(audlToken.rawValue || "").trim();
        const tfRaw = String(tfToken.rawValue || "").trim();
        const recRaw = String(recToken.rawValue || "").trim();

        let normalizedTEXL = texlRaw;
        let normalizedIAR = iarRaw;

        const texlIarParts = texlRaw.match(/^([A-Z]{2,6})-([A-Z0-9]{2,8})$/);
        if (texlIarParts && /^[A-Z0-9]{1,4}$/.test(iarRaw)) {
          normalizedTEXL = texlIarParts[1];
          normalizedIAR = `${texlIarParts[2]}-${iarRaw}`;
        }

        const isAudioSpec = /^(?:WAV|ADMBWF|DAMF|RMU|EAC3|PT|SS|MIX|TMPL-LAN|TMPL-PMR)(?:-[A-Z0-9]+)*$/.test(specRaw);

        const looksAudioOnly = Boolean(
          isAudioSpec
          &&
          /^\d{2,3}$/.test(fpsRaw)
          && /^[A-Z]{2,6}$/.test(texlRaw)
          && /^[A-Z0-9]{1,4}$/.test(iarRaw)
          && /^[A-Z0-9]{6,20}(?:\.[A-Z0-9]{1,8}){0,3}$/i.test(audlRaw)
          && !tfRaw
          && !recRaw
        );

        if (!looksAudioOnly) {
          return tokens;
        }

        audlToken.rawValue = normalizedTEXL;
        tfToken.rawValue = normalizedIAR;
        recToken.rawValue = audlRaw;

        texlToken.rawValue = "";
        iarToken.rawValue = "";

        return tokens;
      }

      function applyDwcResRangeSingleValueFallback(ruleSet, maskSpec, tokens) {
        const conventionId = String((ruleSet.rulesDoc && ruleSet.rulesDoc.conventionId) || "").toUpperCase();
        if (conventionId !== "DWC-MODERN") {
          return tokens;
        }

        const findToken = (segmentMask, tokenName) => tokens.find((token) =>
          String(token.segmentMask || "").toUpperCase() === String(segmentMask || "").toUpperCase()
          && String(token.tokenName || "").toUpperCase() === String(tokenName || "").toUpperCase());

        const resToken = findToken("RES-RANGE", "RES");
        const rangeToken = findToken("RES-RANGE", "RANGE");
        if (!resToken || !rangeToken) {
          return tokens;
        }

        const resRaw = String(resToken.rawValue || "").trim();
        const rangeRaw = String(rangeToken.rawValue || "").trim();

        if (!resRaw && !rangeRaw) {
          return tokens;
        }

        if (resRaw && rangeRaw) {
          return tokens;
        }

        const sourceRaw = resRaw || rangeRaw;
        const entry = state.dwcResAudRangeByCode.get(String(sourceRaw).toUpperCase());
        if (!entry) {
          return tokens;
        }

        const format = String(entry.format || "").trim().toLowerCase();
        if (format === "range") {
          rangeToken.rawValue = sourceRaw;
          resToken.rawValue = "";
          return tokens;
        }

        if (format === "resolution") {
          resToken.rawValue = sourceRaw;
          rangeToken.rawValue = "";
          return tokens;
        }

        return tokens;
      }

      function applyDwcNonAudioTailFallback(ruleSet, maskSpec, tokens) {
        const conventionId = String((ruleSet.rulesDoc && ruleSet.rulesDoc.conventionId) || "").toUpperCase();
        if (conventionId !== "DWC-MODERN") {
          return tokens;
        }

        const mask = String(maskSpec.mask || "").toUpperCase();
        if (!mask.includes("TEXL-IAR") || !mask.includes("AUDL-TF") || !mask.includes("TTL-TYPE") || !mask.includes("REC")) {
          return tokens;
        }

        const findToken = (segmentMask, tokenName) => tokens.find((token) =>
          String(token.segmentMask || "").toUpperCase() === String(segmentMask || "").toUpperCase()
          && String(token.tokenName || "").toUpperCase() === String(tokenName || "").toUpperCase());

        const specToken = findToken("SPEC", "SPEC");
        const texlToken = findToken("TEXL-IAR", "TEXL");
        const iarToken = findToken("TEXL-IAR", "IAR");
        const audlToken = findToken("AUDL-TF", "AUDL");
        const tfToken = findToken("AUDL-TF", "TF");
        const ttlToken = findToken("TTL-TYPE", "TTL");
        const ttlTypeToken = findToken("TTL-TYPE", "TYPE");
        const recToken = findToken("REC", "REC");

        if (!specToken || !texlToken || !iarToken || !audlToken || !tfToken || !ttlToken || !ttlTypeToken || !recToken) {
          return tokens;
        }

        const specRaw = String(specToken.rawValue || "").trim().toUpperCase();
        const texlRaw = String(texlToken.rawValue || "").trim().toUpperCase();
        const iarRaw = String(iarToken.rawValue || "").trim().toUpperCase();
        const audlRaw = String(audlToken.rawValue || "").trim();
        const tfRaw = String(tfToken.rawValue || "").trim();
        const ttlRaw = String(ttlToken.rawValue || "").trim();
        const ttlTypeRaw = String(ttlTypeToken.rawValue || "").trim();
        const recRaw = String(recToken.rawValue || "").trim();

        let normalizedTEXL = texlRaw;
        let normalizedIAR = iarRaw;

        const texlIarParts = texlRaw.match(/^([A-Z]{2,6})-([A-Z0-9]{2,8})$/);
        if (texlIarParts && /^[A-Z0-9]{1,4}$/.test(iarRaw)) {
          normalizedTEXL = texlIarParts[1];
          normalizedIAR = `${texlIarParts[2]}-${iarRaw}`;
        }

        const isAudioSpec = /^(?:WAV|ADMBWF|DAMF|RMU|EAC3|PT|SS|MIX|TMPL-LAN|TMPL-PMR)(?:-[A-Z0-9]+)*$/.test(specRaw);
        const looksNonAudioTail = Boolean(
          !isAudioSpec
          && /^[A-Z]{2,6}$/.test(normalizedTEXL)
          && /^[A-Z0-9]{2,8}(?:-[A-Z0-9]{1,6})?$/.test(normalizedIAR)
          && /^[A-Z0-9]{6,20}(?:\.[A-Z0-9]{1,8}){0,3}$/i.test(audlRaw)
          && !tfRaw
          && !ttlRaw
          && !ttlTypeRaw
          && !recRaw
        );

        if (!looksNonAudioTail) {
          return tokens;
        }

        texlToken.rawValue = normalizedTEXL;
        iarToken.rawValue = normalizedIAR;

        recToken.rawValue = audlRaw;
        audlToken.rawValue = "";
        tfToken.rawValue = "";

        return tokens;
      }

      function applyDwcMissingTtlTypeFallback(ruleSet, maskSpec, tokens) {
        const conventionId = String((ruleSet.rulesDoc && ruleSet.rulesDoc.conventionId) || "").toUpperCase();
        if (conventionId !== "DWC-MODERN") {
          return tokens;
        }

        const mask = String(maskSpec.mask || "").toUpperCase();
        if (!mask.includes("TTL-TYPE") || !mask.includes("REC")) {
          return tokens;
        }

        const findToken = (segmentMask, tokenName) => tokens.find((token) =>
          String(token.segmentMask || "").toUpperCase() === String(segmentMask || "").toUpperCase()
          && String(token.tokenName || "").toUpperCase() === String(tokenName || "").toUpperCase());

        const ttlToken = findToken("TTL-TYPE", "TTL");
        const ttlTypeToken = findToken("TTL-TYPE", "TYPE");
        const recToken = findToken("REC", "REC");

        if (!ttlToken || !ttlTypeToken || !recToken) {
          return tokens;
        }

        const ttlRaw = String(ttlToken.rawValue || "").trim();
        const ttlTypeRaw = String(ttlTypeToken.rawValue || "").trim();
        const recRaw = String(recToken.rawValue || "").trim();

        // If REC is missing and TTL-TYPE is omitted, treat a trailing ID-like value as REC.
        if (!ttlRaw || ttlTypeRaw || recRaw) {
          return tokens;
        }

        const looksLikeRecordId = /^[A-Z0-9]{8,20}(?:\.[A-Z0-9]{1,8}){0,2}$/i.test(ttlRaw)
          || /^WMLS(?:#+|\d+)$/i.test(ttlRaw);
        if (!looksLikeRecordId) {
          return tokens;
        }

        recToken.rawValue = ttlRaw;
        ttlToken.rawValue = "";
        ttlTypeToken.rawValue = "";

        return tokens;
      }

      function resolveDwcSpecCompound(ruleSet, tokenName, raw) {
        const conventionId = String((ruleSet.rulesDoc && ruleSet.rulesDoc.conventionId) || "").toUpperCase();
        const tokenKey = String(tokenName || "").toUpperCase();
        const rawValue = String(raw || "").trim().toUpperCase();
        if (conventionId !== "DWC-MODERN" || tokenKey !== "SPEC" || !rawValue.includes("-")) {
          return null;
        }

        const parts = rawValue.split("-").map((part) => part.trim()).filter(Boolean);
        if (parts.length < 2) {
          return null;
        }

        const matched = [];
        for (const part of parts) {
          const rule = lookupExactRule(ruleSet.index, "SPEC", part) || lookupPatternRule(ruleSet.index, "SPEC", part);
          if (!rule) {
            return null;
          }
          matched.push({
            code: part,
            meaning: String(rule.semantic_meaning || "").trim() || "No semantic meaning"
          });
        }

        return `Compound SPEC parsed: ${matched.map((item) => `${item.code} (${item.meaning})`).join(" + ")}`;
      }

      function buildRuleIndex(rules) {
        const tokenExact = new Map();
        const tokenPattern = new Map();

        for (const rule of rules || []) {
          const tokenName = String(rule.token_name || "").toUpperCase();
          const tokenPatternKey = String(rule.token_pattern || "").toUpperCase();
          if (!tokenName || !tokenPatternKey) {
            continue;
          }

          if (!tokenExact.has(tokenName)) {
            tokenExact.set(tokenName, new Map());
          }

          const exactMap = tokenExact.get(tokenName);
          if (!exactMap.has(tokenPatternKey)) {
            exactMap.set(tokenPatternKey, []);
          }
          exactMap.get(tokenPatternKey).push(rule);

          if (getRulePattern(rule)) {
            if (!tokenPattern.has(tokenName)) {
              tokenPattern.set(tokenName, []);
            }
            tokenPattern.get(tokenName).push(rule);
          }
        }

        return { tokenExact, tokenPattern };
      }

      function lookupExactRule(index, tokenName, rawValue) {
        const tokenKey = String(tokenName || "").toUpperCase();
        const valueKey = String(rawValue || "").toUpperCase();
        if (!tokenKey || !valueKey) {
          return null;
        }

        const exactMap = index.tokenExact.get(tokenKey);
        if (!exactMap) {
          return null;
        }

        const direct = exactMap.get(valueKey);
        return direct && direct.length > 0 ? direct[0] : null;
      }

      function lookupPatternRule(index, tokenName, rawValue) {
        const tokenKey = String(tokenName || "").toUpperCase();
        const candidates = index.tokenPattern.get(tokenKey) || [];

        for (const rule of candidates) {
          if (matchesRulePattern(rule, rawValue)) {
            return rule;
          }
        }

        return null;
      }

      function lookupWithSegmentAliases(index, tokenName, segmentMask, rawValue) {
        const tokenKey = String(tokenName || "").toUpperCase();
        const segmentKey = String(segmentMask || "").toUpperCase();
        const candidateTokenNames = [tokenKey];

        if (segmentKey === "TEXL-IAR") {
          if (tokenKey === "IAR") candidateTokenNames.push("TEXL");
          if (tokenKey === "TEXL") candidateTokenNames.push("IAR");
        }

        if (segmentKey === "AUDL-TF") {
          // Keep AUDL and TF scoped to their own token definitions to avoid
          // reporting TEXL-IAR style codes under AUDL-TF labels.
        }

        if (segmentKey === "RES-RANGE") {
          if (tokenKey === "RANGE") candidateTokenNames.push("RES");
          if (tokenKey === "RES") candidateTokenNames.push("RANGE");
        }

        if (segmentKey === "CLASS-WIP") {
          if (tokenKey === "WIP") candidateTokenNames.push("CLASS");
          if (tokenKey === "CLASS") candidateTokenNames.push("WIP");
        }

        if (segmentKey === "FILEINFO" && tokenKey === "FILEINFO") {
          candidateTokenNames.push("FRAMERATE", "RESOLUTION", "ASPECTRATIO");
        }

        for (const candidateTokenName of candidateTokenNames) {
          const exact = lookupExactRule(index, candidateTokenName, rawValue);
          if (exact) {
            return exact;
          }
        }

        for (const candidateTokenName of candidateTokenNames) {
          const pattern = lookupPatternRule(index, candidateTokenName, rawValue);
          if (pattern) {
            return pattern;
          }
        }

        return null;
      }

      function lookupStrictTokenRule(index, tokenName, rawValue) {
        const exact = lookupExactRule(index, tokenName, rawValue);
        if (exact) {
          return exact;
        }
        return lookupPatternRule(index, tokenName, rawValue);
      }

      function listGlobalExactMatchRules(index, rawValue) {
        const raw = String(rawValue || "").trim().toUpperCase();
        if (!raw || !index || !index.tokenExact || typeof index.tokenExact.entries !== "function") {
          return [];
        }

        const matches = [];
        for (const [tokenKey, exactMap] of index.tokenExact.entries()) {
          if (!exactMap || typeof exactMap.get !== "function") {
            continue;
          }
          const rules = exactMap.get(raw);
          if (!Array.isArray(rules) || rules.length === 0) {
            continue;
          }
          for (const rule of rules) {
            if (rule) {
              matches.push(rule);
            }
          }
        }

        return matches;
      }

      function resolveDwcLanguageWithSuffix(ruleSet, token, parsedTokens) {
        const segmentMask = String(token.segmentMask || "").toUpperCase();
        const tokenName = String(token.tokenName || "").toUpperCase();
        const raw = String(token.rawValue || "").trim().toUpperCase();

        const segmentMap = {
          "TEXL-IAR": { primary: "TEXL", suffix: "IAR", primaryFormat: "TEXL", suffixFormat: "IAR" },
          "AUDL-TF": { primary: "AUDL", suffix: "TF", primaryFormat: "AUDL", suffixFormat: "TF" },
          "TTL-TYPE": { primary: "TTL", suffix: "TYPE", primaryFormat: "TTL", suffixFormat: "TYPE" }
        };

        const mapping = segmentMap[segmentMask];
        if (!mapping || tokenName !== mapping.primary) {
          return null;
        }

        if (!/^[A-Z]{2,6}(?:-[A-Z0-9]{2,8})?$/.test(raw)) {
          return null;
        }

        const suffixTokenNames = [mapping.suffix];

        const sibling = (parsedTokens || []).find((candidate) =>
          Number(candidate.segmentPosition) === Number(token.segmentPosition)
          && String(candidate.segmentMask || "").toUpperCase() === segmentMask
          && suffixTokenNames.includes(String(candidate.tokenName || "").toUpperCase())
          && String(candidate.rawValue || "").trim()
        );

        if (!sibling) {
          return null;
        }

        const suffixRaw = String(sibling.rawValue || "").trim().toUpperCase();
        const suffixRule = lookupStrictTokenRule(ruleSet.index, mapping.suffix, suffixRaw);

        const formatMatches = (rule, expected, rawValueForRule) => {
          const rawEntryForFormat = getRawEntryForRule(rule, rawValueForRule);
          const rawFormat = String((rawEntryForFormat && rawEntryForFormat.format) || "").trim().toUpperCase();
          const actual = rawFormat || String(getRuleFormat(rule) || "").trim().toUpperCase();
          if (!actual || !expected) {
            return true;
          }
          return actual === String(expected).toUpperCase();
        };

        let effectivePrimary = raw;
        let effectiveSuffix = suffixRaw;
        let effectiveSuffixRule = suffixRule;
        let effectiveSuffixLabel = mapping.suffix;
        const primaryFromSuffixRule = lookupStrictTokenRule(ruleSet.index, mapping.suffix, raw);
        const directPrimaryRule = lookupStrictTokenRule(ruleSet.index, mapping.primary, raw) || primaryFromSuffixRule;
        let directPrimaryFormatMatch = Boolean(
          directPrimaryRule && formatMatches(directPrimaryRule, mapping.primaryFormat, raw)
        );

        let directFormatMatch = Boolean(suffixRule) && formatMatches(suffixRule, mapping.suffixFormat, suffixRaw);

        if (!directPrimaryFormatMatch) {
          return null;
        }

        if (!directFormatMatch) {
          const primaryRuleForSuffix = lookupStrictTokenRule(ruleSet.index, mapping.primary, suffixRaw);
          const suffixRuleForPrimary = lookupStrictTokenRule(ruleSet.index, mapping.suffix, raw);
          const swappedMatch = Boolean(
            primaryRuleForSuffix
            && suffixRuleForPrimary
            && formatMatches(primaryRuleForSuffix, mapping.primaryFormat, suffixRaw)
            && formatMatches(suffixRuleForPrimary, mapping.suffixFormat, raw)
          );

          if (!swappedMatch) {
            return null;
          }

          effectivePrimary = suffixRaw;
          effectiveSuffix = raw;
          effectiveSuffixRule = suffixRuleForPrimary;
        }

        const suffixMeaning = applyRawEntryToMeaning(
          String(effectiveSuffixRule.semantic_meaning || "").trim(),
          getRawEntryForRule(effectiveSuffixRule, effectiveSuffix)
        );
        if (!suffixMeaning) {
          return null;
        }

        return `${mapping.primary} language code: ${effectivePrimary}; ${effectiveSuffixLabel} suffix ${effectiveSuffix}: ${suffixMeaning}`;
      }

      function resolveDwcIarCompositeMeaning(ruleSet, rawValue) {
        const raw = String(rawValue || "").trim().toUpperCase();
        if (!/^\d{3}(?:-[A-Z0-9]{1,6})+$/.test(raw)) {
          return null;
        }

        const parts = raw.split("-").map((part) => part.trim()).filter(Boolean);
        if (parts.length < 2) {
          return null;
        }

        const definitions = [];
        for (const part of parts) {
          const rule = lookupStrictTokenRule(ruleSet.index, "IAR", part);
          if (!rule) {
            return null;
          }

          const rawEntry = getRawEntryForRule(rule, part);
          const format = String((rawEntry && rawEntry.format) || getRuleFormat(rule) || "").trim().toUpperCase();
          if (format && format !== "IAR") {
            return null;
          }

          const meaning = applyRawEntryToMeaning(String(rule.semantic_meaning || "").trim(), rawEntry);
          if (!meaning) {
            return null;
          }

          definitions.push(`${part}: ${meaning}`);
        }

        return `${definitions.join("; ")}`;
      }

      function lookupWmlsFileInfoByFormat(index, rawValue, expectedFormat) {
        const exactMap = index.tokenExact.get("FILEINFO") || new Map();
        const valueKey = String(rawValue || "").toUpperCase();
        if (!valueKey) {
          return null;
        }

        const rules = exactMap.get(valueKey) || [];
        const expected = String(expectedFormat || "").toUpperCase();
        return rules.find((rule) => String(getRuleFormat(rule) || "").toUpperCase() === expected) || null;
      }

      function lookupFoxClcuByFormat(index, rawValue, expectedFormat) {
        const exactMap = index && index.tokenExact ? index.tokenExact.get("CL/CU") : null;
        const valueKey = String(rawValue || "").toUpperCase();
        if (!exactMap || !valueKey) {
          return null;
        }

        const rules = exactMap.get(valueKey) || [];
        const expected = String(expectedFormat || "").toUpperCase();
        return rules.find((rule) => String(getRuleFormat(rule) || "").toUpperCase() === expected) || null;
      }

      function resolveReelMeaning(value) {
        const raw = String(value || "").trim().toUpperCase();
        if (!raw) {
          return null;
        }
        if (raw === "C") return "Continuous (Consolidated; Long Play).";
        if (/^C[A-Z0-9]+$/.test(raw)) return `Continuous variant: ${raw}`;
        if (raw === "RC") return "Reel Continuous (non-Consolidated).";
        if (raw === "PC") return "Part Continuous (non-Consolidated).";
        if (/^R\d{1,2}$/.test(raw)) return `Single reel reference: Reel ${raw.slice(1)}`;
        if (/^R\d{1,2}-\d{1,2}$/.test(raw)) return `Reel range reference: Reels ${raw.slice(1)}`;
        if (/^PART\d+$/.test(raw)) return `Part reference: ${raw}`;
        if (/^PARTS\d+-\d+$/.test(raw)) return `Part range reference: ${raw}`;
        return null;
      }

      function resolveFoxEpisodeMeaning(tokenName, value) {
        const tokenKey = String(tokenName || "").toUpperCase();
        const raw = String(value || "").trim().toUpperCase();
        if ((tokenKey !== "EP" && tokenKey !== "WPR") || !raw) {
          return null;
        }

        if (/^F\d{3}$/.test(raw)) {
          return `Foreign episode number: ${raw}`;
        }

        if (/^\d{3}$/.test(raw)) {
          const season = raw.slice(0, 1);
          const episode = raw.slice(1);
          return `Season ${season}, Episode ${episode} (from ${tokenKey}=${raw})`;
        }

        if (raw === "XX") {
          return `${tokenKey}=XX indicates not episodic content (no episode/WPR number provided).`;
        }

        if (/^[A-Z0-9]{6}$/.test(raw)) {
          return `${tokenKey} token interpreted as WPR fallback: ${raw}`;
        }

        return null;
      }

      function parseFoxLangsndTrackconfigStandardComposite(ruleSet, rawValue) {
        const raw = String(rawValue || "").trim().toUpperCase();
        if (!raw || raw.length < 4) {
          return null;
        }

        const standardRaw = raw.slice(-1);
        const lookupLangsndByFormat = (code, expectedFormat) => {
          const exactMap = (ruleSet && ruleSet.index && ruleSet.index.tokenExact && ruleSet.index.tokenExact.get("LANGSND")) || new Map();
          const rules = exactMap.get(String(code || "").toUpperCase()) || [];
          const expected = String(expectedFormat || "").toUpperCase();
          return rules.find((rule) => String(getRuleFormat(rule) || "").toUpperCase() === expected) || null;
        };

        const standardRule = lookupStrictTokenRule(ruleSet.index, "STANDARD", standardRaw)
          || lookupLangsndByFormat(standardRaw, "STANDARD");
        if (!standardRule) {
          return null;
        }

        const body = raw.slice(0, -1);
        const trackMap = (ruleSet && ruleSet.index && ruleSet.index.tokenExact && ruleSet.index.tokenExact.get("TRACKCONFIG")) || new Map();
        const trackCodes = Array.from(trackMap.keys()).filter(Boolean).sort((a, b) => b.length - a.length);

        for (const trackCode of trackCodes) {
          if (!body.endsWith(trackCode)) {
            continue;
          }

          const langCode = body.slice(0, -trackCode.length);
          if (!/^[A-Z]{2,6}$/.test(langCode)) {
            continue;
          }

          const trackRule = lookupStrictTokenRule(ruleSet.index, "TRACKCONFIG", trackCode)
            || lookupLangsndByFormat(trackCode, "TRACKCONFIG");
          if (!trackRule) {
            continue;
          }

          const trackMeaning = applyRawEntryToMeaning(
            String(trackRule.semantic_meaning || "").trim(),
            getRawEntryForRule(trackRule, trackCode)
          );
          const standardMeaning = applyRawEntryToMeaning(
            String(standardRule.semantic_meaning || "").trim(),
            getRawEntryForRule(standardRule, standardRaw)
          );

          return {
            langCode,
            trackCode,
            standardRaw,
            meaning: `Composite LANGSND/TRACKCONFIG/STANDARD parsed: LANG=${langCode} (external language code reference); TRACKCONFIG=${trackCode} (${trackMeaning || "known TRACKCONFIG"}); STANDARD=${standardRaw} (${standardMeaning || "known STANDARD"})`
          };
        }

        return null;
      }

      function parseFoxAdtlInfoStack(index, rawValue) {
        const raw = String(rawValue || "").trim().toUpperCase();
        if (!raw) {
          return null;
        }

        const exact = lookupStrictTokenRule(index, "ADTLINFO", raw);
        if (exact) {
          return {
            codes: [raw],
            raw
          };
        }

        const adtlMap = (index && index.tokenExact && index.tokenExact.get("ADTLINFO")) || new Map();
        const codes = Array.from(adtlMap.keys())
          .filter((code) => /^[A-Z0-9]+$/i.test(String(code || "")))
          .map((code) => String(code || "").toUpperCase())
          .sort((a, b) => b.length - a.length);

        if (codes.length === 0) {
          return null;
        }

        const parts = [];
        let cursor = 0;
        while (cursor < raw.length) {
          const match = codes.find((code) => raw.startsWith(code, cursor));
          if (!match) {
            return null;
          }
          parts.push(match);
          cursor += match.length;
        }

        if (parts.length === 0) {
          return null;
        }

        return {
          codes: parts,
          raw
        };
      }

      function parseFoxAdtlInfoLangsndTrackconfigStandardComposite(index, rawValue) {
        const raw = String(rawValue || "").trim().toUpperCase();
        if (!raw || raw.length < 8) {
          return null;
        }

        for (let splitAt = raw.length - 6; splitAt >= 2; splitAt -= 1) {
          const adtlRaw = raw.slice(0, splitAt);
          const compositeRaw = raw.slice(splitAt);
          const adtlParts = parseFoxAdtlInfoStack(index, adtlRaw);
          if (!adtlParts) {
            continue;
          }

          const compositeParts = parseFoxLangsndTrackconfigStandardComposite({ index }, compositeRaw);
          if (!compositeParts) {
            continue;
          }

          return {
            adtlInfoRaw: adtlRaw,
            adtlInfoParts: adtlParts,
            compositeParts: {
              langsndCode: compositeParts.langCode,
              trackConfigCode: compositeParts.trackCode,
              standardCode: compositeParts.standardRaw
            }
          };
        }

        return null;
      }

      function parseFoxSuffixStack(index, rawValue) {
        const raw = String(rawValue || "").trim().toUpperCase();
        if (!raw) {
          return null;
        }

        const exact = lookupStrictTokenRule(index, "SUFFIX", raw);
        if (exact) {
          return {
            codes: [raw],
            raw
          };
        }

        const suffixMap = (index && index.tokenExact && index.tokenExact.get("SUFFIX")) || new Map();
        const codes = Array.from(suffixMap.keys())
          .filter((code) => /^[A-Z0-9]+$/.test(String(code || "")))
          .sort((a, b) => b.length - a.length);

        if (codes.length === 0) {
          return null;
        }

        const parts = [];
        let cursor = 0;
        while (cursor < raw.length) {
          const match = codes.find((code) => raw.startsWith(code, cursor));
          if (!match) {
            return null;
          }
          parts.push(match);
          cursor += match.length;
        }

        if (parts.length === 0) {
          return null;
        }

        return {
          codes: parts,
          raw
        };
      }

      function resolveFoxSuffixCompositeMeaning(ruleSet, rawValue) {
        const parsed = parseFoxSuffixStack(ruleSet && ruleSet.index, rawValue);
        if (!parsed || !Array.isArray(parsed.codes) || parsed.codes.length < 2) {
          return null;
        }

        const partsWithMeaning = parsed.codes.map((code) => {
          const rule = lookupStrictTokenRule(ruleSet.index, "SUFFIX", code);
          const meaning = rule
            ? applyRawEntryToMeaning(String(rule.semantic_meaning || "").trim(), getRawEntryForRule(rule, code))
            : "known SUFFIX";
          return `${code} (${meaning || "known SUFFIX"})`;
        });

        return `Composite SUFFIX parsed: ${partsWithMeaning.join(" + ")}`;
      }

      function resolveFoxTechInfoCompositeMeaning(rawValue) {
        const raw = String(rawValue || "").trim().toUpperCase();
        const techComposite = raw.match(/^(RAW|RES)(ACA)?(16B|24B)?(44K|48K|96K)$/);
        if (!techComposite) {
          return null;
        }

        const treatmentCode = techComposite[1];
        const academyCode = techComposite[2];
        const bitDepthCode = techComposite[3];
        const sampleRateCode = techComposite[4];

        const treatmentLabel = treatmentCode === "RAW"
          ? "Raw (untreated)"
          : "Restored (processed for preservation)";
        const academyLabel = academyCode === "ACA" ? "Academy pre-emphasis" : null;
        const bitDepthLabel = bitDepthCode
          ? (bitDepthCode === "16B" ? "16 bit" : "24 bit")
          : null;
        const sampleRateLabel = sampleRateCode === "44K"
          ? "44.1 kHz"
          : sampleRateCode === "48K"
            ? "48 kHz"
            : "96 kHz";
        const componentLabels = [treatmentLabel, academyLabel, bitDepthLabel, sampleRateLabel].filter(Boolean);

        return `TECHINFO composite parsed: ${componentLabels.join("; ")}`;
      }

      function resolveFoxTechInfoMeaning(ruleSet, rawValue) {
        const raw = String(rawValue || "").trim().toUpperCase();
        if (!raw) {
          return null;
        }

        const techInfoRule = lookupStrictTokenRule(ruleSet && ruleSet.index, "TECHINFO", raw);
        if (techInfoRule) {
          return applyRawEntryToMeaning(
            String(techInfoRule.semantic_meaning || "").trim(),
            getRawEntryForRule(techInfoRule, raw)
          ) || `TECHINFO: ${raw}`;
        }

        return resolveFoxTechInfoCompositeMeaning(raw);
      }

      function resolveFoxTransferAssetMeaning(rawValue) {
        const raw = String(rawValue || "").trim().toUpperCase();
        const transferAsset = raw.match(/^([MP])(\d{3,})$/);
        if (!transferAsset) {
          return null;
        }

        const assetType = transferAsset[1] === "M" ? "MC" : "PP0";
        return `Transfer-style source asset label: ${transferAsset[1]}${transferAsset[2]} (original physical asset ${assetType}#)`;
      }

      function resolveRtDurationMeaning(tokenName, value) {
        const tokenKey = String(tokenName || "").toUpperCase();
        const raw = String(value || "").trim().toUpperCase();
        if (tokenKey !== "RT" || !raw) {
          return null;
        }

        const match = raw.match(/^(?:RT)?(\d{2})(\d{2})(\d{2})$/);
        if (!match) {
          return null;
        }

        const hours = Number(match[1]);
        const minutes = Number(match[2]);
        const seconds = Number(match[3]);
        const tokenDisplay = raw.startsWith("RT") ? raw : `RT${match[1]}${match[2]}${match[3]}`;

        return `${tokenDisplay} -> ${hours}h ${minutes}m ${seconds}s`;
      }

      function resolveWmlsIdMeaning(tokenName, value) {
        const tokenKey = String(tokenName || "").toUpperCase();
        const raw = String(value || "").trim();
        if (!/^WMLS#+$/.test(tokenKey) || !raw) {
          return null;
        }
        return `WMLS ID number: ${raw.replace(/\.[^.]+$/, "")}`;
      }

      function resolveWmlsLanguageMeaning(tokenName, segmentMask, value) {
        const tokenKey = String(tokenName || "").toUpperCase();
        const segmentKey = String(segmentMask || "").toUpperCase();
        const raw = String(value || "").trim().toUpperCase();
        if (!raw) {
          return null;
        }

        if (tokenKey === "LANGUAGE" && segmentKey === "LANGUAGE" && /^[A-Z]{2,6}(?:-[A-Z0-9]{2,8})?$/.test(raw)) {
          return `LANGUAGE token routed to language decoder reference: ${raw}`;
        }

        return null;
      }

      function resolveWmlsStackedElementType(index, tokenName, value) {
        const tokenKey = String(tokenName || "").toUpperCase();
        const raw = String(value || "").trim().toUpperCase();

        if (tokenKey !== "ELEMENTTYPE" || !raw || raw.includes("-") || raw.includes(".")) {
          return null;
        }

        const exactMap = index.tokenExact.get("ELEMENTTYPE") || new Map();
        if (exactMap.has(raw)) {
          return null;
        }

        const componentRules = [];
        for (const [code, rules] of exactMap.entries()) {
          if (!/^[A-Z0-9]+$/.test(code) || code.includes("_")) {
            continue;
          }
          const exactRule = (rules || []).find((rule) => !getRulePattern(rule));
          if (exactRule) {
            componentRules.push([code, exactRule]);
          }
        }
        componentRules.sort((a, b) => b[0].length - a[0].length);

        const parts = [];
        let cursor = 0;
        while (cursor < raw.length) {
          const found = componentRules.find(([code]) => raw.startsWith(code, cursor));
          if (!found) {
            return null;
          }
          const [code, rule] = found;
          parts.push({
            code,
            meaning: getWmlsFileInfoMeaning(code, String(rule.semantic_meaning || "").trim() || "No semantic meaning"),
            family: getRuleFormat(rule) || "unspecified",
            rule
          });
          cursor += code.length;
        }

        if (parts.length < 2) {
          return null;
        }

        return {
          meaning: parts.map((part) => `${part.code} (${part.meaning})`).join(" -> "),
          rule: parts[0].rule
        };
      }

      function resolveWmlsStackedFileInfo(index, tokenName, value) {
        const tokenKey = String(tokenName || "").toUpperCase();
        const raw = String(value || "").trim().toUpperCase();

        if (tokenKey !== "FILEINFO" || !raw || raw.includes("-") || raw.includes(".")) {
          return null;
        }

        const exactMap = index.tokenExact.get("FILEINFO") || new Map();
        if (exactMap.has(raw)) {
          return null;
        }

        const componentRules = [];
        for (const [code, rules] of exactMap.entries()) {
          if (!/^[A-Z0-9]+$/.test(code) || code.includes("_")) {
            continue;
          }
          const exactRule = (rules || []).find((rule) => !getRulePattern(rule));
          if (exactRule) {
            componentRules.push([code, exactRule]);
          }
        }
        componentRules.sort((a, b) => b[0].length - a[0].length);

        const parts = [];
        let cursor = 0;
        while (cursor < raw.length) {
          const found = componentRules.find(([code]) => raw.startsWith(code, cursor));
          if (!found) {
            return null;
          }
          const [code, rule] = found;
          parts.push({
            code,
            meaning: getWmlsFileInfoMeaning(code, String(rule.semantic_meaning || "").trim() || "No semantic meaning"),
            family: getRuleFormat(rule) || "unspecified",
            rule
          });
          cursor += code.length;
        }

        if (parts.length < 2) {
          return null;
        }

        return {
          meaning: parts.map((part) => `${part.code} (${part.meaning})`).join(" -> "),
          rule: parts[0].rule
        };
      }

      function resolveWmlsPartialStackedRasterRate(index, tokenName, value) {
        const tokenKey = String(tokenName || "").toUpperCase();
        const raw = String(value || "").trim().toUpperCase();

        if (tokenKey !== "FILEINFO" || !raw || raw.includes("-") || raw.includes(".")) {
          return null;
        }

        const exactMap = index.tokenExact.get("FILEINFO") || new Map();
        const scanCode = exactMap.has("P") ? "P" : (exactMap.has("I") ? "I" : null);
        if (!scanCode) {
          return null;
        }

        const partialMatch = raw.match(/^([A-Z0-9]+?)(P|I)(\d{2}(?:NDF|DF)?)$/);
        if (!partialMatch) {
          return null;
        }

        const [, leadingCode, scanCodeValue, frameRateCode] = partialMatch;
        const parts = [
          { code: leadingCode, label: "raster/size component" },
          { code: scanCodeValue, label: "scan component" },
          { code: frameRateCode, label: "frame-rate component" }
        ].map((part) => {
          const aliasRule = lookupWithSegmentAliases(index, "FILEINFO", "FILEINFO", part.code);
          const rules = exactMap.get(part.code) || [];
          const directRule = rules.find((entry) => !getRulePattern(entry)) || null;
          const rule = aliasRule || directRule;
          const hasRawMeaning = state.wmlsFileInfoMeanings.has(String(part.code || "").toUpperCase());
          const isKnown = Boolean(rule) || hasRawMeaning;
          return {
            ...part,
            known: isKnown,
            meaning: isKnown
              ? getWmlsFileInfoMeaning(part.code, String((rule && rule.semantic_meaning) || "No semantic meaning").trim())
              : "undefined"
          };
        });

        const knownParts = parts.filter((part) => part.known);
        const unknownParts = parts.filter((part) => !part.known);
        if (knownParts.length === 0) {
          return null;
        }

        const credit = knownParts.length / parts.length;
        const fullyKnown = unknownParts.length === 0;

        return {
          meaning: parts.map((part) => `${part.code} (${part.known ? part.meaning : "undefined"})`).join(" -> "),
          confidence: fullyKnown ? "composite" : "partial",
          known: fullyKnown,
          credit
        };
      }

      function resolveWmlsPartialFileType(index, tokenName, value) {
        const tokenKey = String(tokenName || "").toUpperCase();
        const raw = String(value || "").trim().toUpperCase();

        if (tokenKey !== "FILETYPE" || !raw || !raw.includes("-")) {
          return null;
        }

        const exactMap = index.tokenExact.get("FILETYPE") || new Map();
        if (exactMap.has(raw)) {
          return null;
        }

        if (state.wmlsFileTypeMeanings.has(raw)) {
          const resolved = getWmlsFileTypeMeaning(raw, "");
          const hasUsefulMeaning = Boolean(String(resolved || "").trim())
            && !/no semantic meaning/i.test(String(resolved || "").trim());
          return {
            meaning: getWmlsFileTypeMeaning(raw, "No semantic meaning"),
            confidence: hasUsefulMeaning ? "composite" : "partial",
            known: hasUsefulMeaning,
            credit: hasUsefulMeaning ? 1 : 0.5
          };
        }

        const pieces = raw.split("-").filter(Boolean);
        if (pieces.length < 2) {
          return null;
        }

        const knownPieces = pieces.filter((piece) => exactMap.has(piece) || state.wmlsFileTypeMeanings.has(piece));
        if (knownPieces.length === 0) {
          return {
            meaning: `FILETYPE undefined value: ${raw}.`,
            confidence: "partial",
            known: false,
            credit: 0
          };
        }

        const unknownPieces = pieces.filter((piece) => !exactMap.has(piece) && !state.wmlsFileTypeMeanings.has(piece));
        const knownWithMeaning = knownPieces.map((piece) => {
          const rule = (exactMap.get(piece) || []).find((entry) => !getRulePattern(entry));
          const semantic = getWmlsFileTypeMeaning(piece, String((rule && rule.semantic_meaning) || "known FILETYPE rule").trim());
          return `${piece} (${semantic})`;
        });
        const unknownWithTag = unknownPieces.map((piece) => `${piece} (undefined)`);

        return {
          meaning: unknownPieces.length > 0
            ? `FILETYPE connector mismatch: ${[...unknownWithTag, ...knownWithMeaning].join(" -> ")}`
            : knownWithMeaning.join(" -> "),
          confidence: unknownPieces.length === 0 ? "composite" : "partial",
          known: unknownPieces.length === 0,
          credit: knownPieces.length / pieces.length
        };
      }

      function resolveWmlsPartialVersion(index, tokenName, value) {
        const tokenKey = String(tokenName || "").toUpperCase();
        const raw = String(value || "").trim().toUpperCase();

        if (tokenKey !== "VERSION" || !raw || !raw.includes("-")) {
          return null;
        }

        const exactMap = index.tokenExact.get("VERSION") || new Map();
        if (exactMap.has(raw)) {
          return null;
        }

        const pieces = raw.split("-").filter(Boolean);
        if (pieces.length < 2) {
          return null;
        }

        const knownPieces = pieces.filter((piece) => exactMap.has(piece));
        if (knownPieces.length === 0) {
          return null;
        }

        const unknownPieces = pieces.filter((piece) => !exactMap.has(piece));
        const knownWithMeaning = knownPieces.map((piece) => {
          const rule = (exactMap.get(piece) || []).find((entry) => !getRulePattern(entry));
          const semantic = String((rule && rule.semantic_meaning) || "known VERSION rule").trim();
          return `${piece} (${semantic})`;
        });
        const unknownWithTag = unknownPieces.map((piece) => `${piece} (undefined)`);

        return {
          meaning: [...unknownWithTag, ...knownWithMeaning].join(" -> "),
          confidence: unknownPieces.length === 0 ? "composite" : "partial",
          known: unknownPieces.length === 0
        };
      }

      function resolveWmlsEpisodeNumber(tokenName, value) {
        const tokenKey = String(tokenName || "").toUpperCase();
        const raw = String(value || "").trim().toUpperCase();
        if (tokenKey !== "VERSION" || !raw) {
          return null;
        }

        const episodeMatch = raw.match(/^(\d{4})-(F\d{3,4})$/);
        if (episodeMatch) {
          const [, domesticEpisode, foreignEpisode] = episodeMatch;
          return {
            known: true,
            informational: true,
            meaning: `This appears to be an episode number: ${domesticEpisode} (domestic episode number) -> ${foreignEpisode} (foreign episode number)`
          };
        }

        if (/^[F\d]/.test(raw)) {
          return {
            known: false,
            informational: true,
            meaning: "This might be an episode number but doesn't match the WMLS format"
          };
        }

        return null;
      }

      function evaluateToken(ruleSet, maskSpec, token, informationalTokens, parsedTokens) {
        const conventionId = String((ruleSet.rulesDoc && ruleSet.rulesDoc.conventionId) || "").toUpperCase();
        const tokenName = String(token.tokenName || "").toUpperCase();
        const raw = String(token.rawValue || "").trim();
        const defaultInformational = new Set(["TITLE", "VID", "REC"]);
        const isInformational = informationalTokens.has(tokenName) || defaultInformational.has(tokenName);

        if (tokenName === "NOTE" && !raw) {
          return {
            tokenName,
            raw,
            segmentMask: token.segmentMask,
            known: true,
            informational: true,
            meaning: "NOTE: not provided (optional)"
          };
        }

        if (!raw) {
          return {
            tokenName,
            raw,
            segmentMask: token.segmentMask,
            known: false,
            informational: false,
            meaning: "Token not included"
          };
        }

        if (isWmlsConvention(conventionId) && tokenName === "FILEINFO") {
          const maskId = String((maskSpec && maskSpec.id) || "").toUpperCase();
          const maskPattern = String((maskSpec && maskSpec.mask) || "").toUpperCase();
          const isAudMask = maskId.includes("AUDSUB") || maskPattern.includes("FILEINFO_AUD");
          const isSubcapMask = maskId.includes("SUBCAP") || maskPattern.includes("FILEINFO_TXT");
          if (isAudMask || isSubcapMask) {
            const frameRateRule = lookupWmlsFileInfoByFormat(ruleSet.index, raw, "FRAMERATE");
            if (frameRateRule) {
              return {
                tokenName,
                displayTokenLabel: "PICCUT",
                raw,
                segmentMask: token.segmentMask,
                known: true,
                informational: false,
                confidenceCredit: 1,
                meaning: getWmlsFileInfoMeaning(raw, String(frameRateRule.semantic_meaning || "").trim() || "No semantic meaning"),
                matchedRule: frameRateRule
              };
            }

            const aspectRatioRule = lookupWmlsFileInfoByFormat(ruleSet.index, raw, "ASPECTRATIO");
            if (aspectRatioRule) {
              return {
                tokenName,
                raw,
                segmentMask: token.segmentMask,
                known: false,
                informational: false,
                confidenceCredit: 0,
                meaning: `FILEINFO mismatch: ${raw} is an aspect-ratio code (3 digits); this mask expects frame-rate FILEINFO.`
              };
            }
          }
        }

        const rtDurationMeaning = resolveRtDurationMeaning(tokenName, raw);
        if (rtDurationMeaning) {
          return {
            tokenName,
            raw,
            segmentMask: token.segmentMask,
            known: true,
            informational: false,
            confidenceCredit: 1,
            meaning: rtDurationMeaning
          };
        }

        if (isInformational) {
          if (tokenName === "TITLE") {
            return {
              tokenName,
              raw,
              segmentMask: token.segmentMask,
              known: true,
              informational: true,
              meaning: raw
                ? `Title: ${raw} (source-provided)`
                : "Title: not provided"
            };
          }

          if (tokenName === "SHOW") {
            return {
              tokenName,
              raw,
              segmentMask: token.segmentMask,
              known: true,
              informational: true,
              meaning: raw
                ? `Show: ${raw} (source-provided)`
                : "Show: not provided"
            };
          }

          if (tokenName === "VID") {
            if (isFoxConvention(conventionId)) {
              const globalExactRules = listGlobalExactMatchRules(ruleSet.index, raw);
              const nonVidRule = globalExactRules.find((rule) => String((rule && rule.token_name) || "").toUpperCase() !== "VID");
              if (nonVidRule) {
                const detectedTokenName = String(nonVidRule.token_name || tokenName).toUpperCase();
                const outOfSlotDetection = Boolean(detectedTokenName && detectedTokenName !== tokenName);
                const detectedMeaning = applyRawEntryToMeaning(
                  String(nonVidRule.semantic_meaning || "").trim(),
                  getRawEntryForRule(nonVidRule, raw)
                );
                return {
                  tokenName,
                  displayTokenLabel: detectedTokenName,
                  appearsInTokenSlot: outOfSlotDetection ? tokenName : "",
                  raw,
                  segmentMask: token.segmentMask,
                  known: true,
                  informational: false,
                  meaning: detectedMeaning,
                  matchedRule: nonVidRule
                };
              }
            }

            const isDisneyVid = conventionId === "DWC-MODERN" && /^V\d{3,16}$/i.test(raw);
            const isDefaultVid = conventionId !== "DWC-MODERN" && /^V[A-Z0-9]{0,11}$/i.test(raw);
            if (isDisneyVid || isDefaultVid) {
              return {
                tokenName,
                raw,
                segmentMask: token.segmentMask,
                known: true,
                informational: true,
                meaning: `VID: ${raw} (source-provided)`
              };
            }
          }

          if (tokenName === "REC") {
            return {
              tokenName,
              raw,
              segmentMask: token.segmentMask,
              known: true,
              informational: true,
              meaning: `Record: ${raw} (source-provided)`
            };
          }

          if (tokenName === "NOTE") {
            return {
              tokenName,
              raw,
              segmentMask: token.segmentMask,
              known: true,
              informational: true,
              meaning: `NOTE: ${raw} (optional, source-provided)`
            };
          }

          return {
            tokenName,
            raw,
            segmentMask: token.segmentMask,
            known: true,
            informational: true,
            meaning: raw
              ? `${tokenName}: ${raw} (source-provided)`
              : `${tokenName}: not provided`
          };
        }

        if (isWmlsConvention(conventionId)) {
          const wmlsId = resolveWmlsIdMeaning(tokenName, raw);
          if (wmlsId) {
            return {
              tokenName,
              raw,
              segmentMask: token.segmentMask,
              known: true,
              informational: true,
              meaning: wmlsId
            };
          }
        }

        if (conventionId === "DWC-MODERN") {
          const dwcResRangeMeaning = resolveDwcResRangeMeaning(tokenName, token.segmentMask, raw);
          if (dwcResRangeMeaning) {
            return {
              tokenName,
              raw,
              segmentMask: token.segmentMask,
              known: Boolean(dwcResRangeMeaning.known),
              informational: false,
              meaning: dwcResRangeMeaning.meaning
            };
          }
        }

        if (tokenName === "REEL#") {
          const reelMeaning = resolveReelMeaning(raw);
          if (reelMeaning) {
            return {
              tokenName,
              raw,
              segmentMask: token.segmentMask,
              known: true,
              informational: false,
              meaning: reelMeaning
            };
          }

        }

        if (isFoxConvention(conventionId)) {
          const foxEpisodeMeaning = resolveFoxEpisodeMeaning(tokenName, raw);
          if (foxEpisodeMeaning) {
            return {
              tokenName,
              raw,
              segmentMask: token.segmentMask,
              known: true,
              informational: false,
              confidenceCredit: 1,
              meaning: foxEpisodeMeaning
            };
          }

          if (conventionId === "FOX-AUDIO-SERVICES") {
            const piccutRule = lookupStrictTokenRule(ruleSet.index, "PICCUT", raw);
            const adtlComposite = parseFoxAdtlInfoLangsndTrackconfigStandardComposite(ruleSet.index, raw);
            if (adtlComposite && tokenName === "PICCUT") {
              const adtlCodes = Array.isArray(adtlComposite.adtlInfoParts && adtlComposite.adtlInfoParts.codes)
                ? adtlComposite.adtlInfoParts.codes
                : [];
              const adtlLabel = adtlCodes.length > 0 ? adtlCodes.join("+") : adtlComposite.adtlInfoRaw;
              return {
                tokenName: "ADTLINFO",
                displayTokenLabel: "ADTLINFO",
                raw: adtlComposite.adtlInfoRaw,
                segmentMask: "ADTLINFO",
                known: true,
                informational: false,
                confidenceCredit: 1,
                meaning: `Composite parsed from compact tail block (AdtlInfo optional): ADTLINFO=${adtlLabel}; LANGSND=${adtlComposite.compositeParts.langsndCode}; TRACKCONFIG=${adtlComposite.compositeParts.trackConfigCode}; STANDARD=${adtlComposite.compositeParts.standardCode}`
              };
            }

            if (piccutRule && tokenName === "PICCUT") {
              const piccutMeaning = applyRawEntryToMeaning(
                String(piccutRule.semantic_meaning || "").trim(),
                getRawEntryForRule(piccutRule, raw)
              );
              return {
                tokenName,
                displayTokenLabel: "PICCUT",
                raw,
                segmentMask: token.segmentMask,
                known: true,
                informational: false,
                confidenceCredit: 1,
                meaning: piccutMeaning || `PICCUT: ${raw}`
              };
            }

            const reelMeaning = resolveReelMeaning(raw) || (/^([1-9]\d?)OF([1-9]\d?)$/i.test(raw) ? `Reel parts token: ${raw}` : null);
            if (tokenName === "R" && reelMeaning) {
              return {
                tokenName,
                displayTokenLabel: "R",
                raw,
                segmentMask: token.segmentMask,
                known: true,
                informational: false,
                confidenceCredit: 1,
                meaning: reelMeaning
              };
            }

            const techInfoRule = lookupStrictTokenRule(ruleSet.index, "TECHINFO", raw);
            if (techInfoRule) {
              const techInfoMeaning = applyRawEntryToMeaning(
                String(techInfoRule.semantic_meaning || "").trim(),
                getRawEntryForRule(techInfoRule, raw)
              );
              return {
                tokenName,
                displayTokenLabel: "TECHINFO",
                raw,
                segmentMask: token.segmentMask,
                known: true,
                informational: false,
                confidenceCredit: 1,
                meaning: techInfoMeaning || `TECHINFO: ${raw}`
              };
            }

            const techInfoCompositeMeaning = resolveFoxTechInfoCompositeMeaning(raw);
            if (techInfoCompositeMeaning) {
              return {
                tokenName,
                displayTokenLabel: "TECHINFO",
                raw,
                segmentMask: token.segmentMask,
                known: true,
                informational: false,
                confidenceCredit: 1,
                meaning: techInfoCompositeMeaning
              };
            }

            const transferMeaning = resolveFoxTransferAssetMeaning(raw);
            if (transferMeaning) {
              return {
                tokenName,
                displayTokenLabel: "VERSION",
                raw,
                segmentMask: token.segmentMask,
                known: true,
                informational: false,
                confidenceCredit: 1,
                meaning: transferMeaning
              };
            }

            const suffixRule = lookupStrictTokenRule(ruleSet.index, "SUFFIX", raw);
            if (suffixRule) {
              const suffixMeaning = applyRawEntryToMeaning(
                String(suffixRule.semantic_meaning || "").trim(),
                getRawEntryForRule(suffixRule, raw)
              );
              return {
                tokenName,
                displayTokenLabel: "SUFFIX",
                raw,
                segmentMask: token.segmentMask,
                known: true,
                informational: false,
                confidenceCredit: 1,
                meaning: suffixMeaning || `SUFFIX: ${raw}`
              };
            }

            const suffixCompositeMeaning = resolveFoxSuffixCompositeMeaning(ruleSet, raw);
            if (suffixCompositeMeaning) {
              return {
                tokenName,
                displayTokenLabel: "SUFFIX",
                raw,
                segmentMask: token.segmentMask,
                known: true,
                informational: false,
                confidenceCredit: 1,
                meaning: suffixCompositeMeaning
              };
            }
          }

          if (tokenName === "ADTLINFO") {
            const shiftedPiccutRule = lookupStrictTokenRule(ruleSet.index, "PICCUT", raw);
            if (shiftedPiccutRule) {
              const shiftedPiccutMeaning = applyRawEntryToMeaning(
                String(shiftedPiccutRule.semantic_meaning || "").trim(),
                getRawEntryForRule(shiftedPiccutRule, raw)
              );

              return {
                tokenName,
                displayTokenLabel: "PICCUT",
                raw,
                segmentMask: token.segmentMask,
                known: true,
                informational: false,
                confidenceCredit: 1,
                meaning: shiftedPiccutMeaning || `PICCUT: ${raw}`
              };
            }
          }

          if (tokenName === "R") {
            const reelMeaning = resolveReelMeaning(raw);
            if (reelMeaning) {
              return {
                tokenName,
                displayTokenLabel: "R",
                raw,
                segmentMask: token.segmentMask,
                known: true,
                informational: false,
                confidenceCredit: 1,
                meaning: reelMeaning
              };
            }
          }

          if (tokenName === "LANGSND") {
            const composite = parseFoxLangsndTrackconfigStandardComposite(ruleSet, raw);
            if (composite) {
              return {
                tokenName,
                displayTokenLabel: "LANGSND",
                raw,
                segmentMask: token.segmentMask,
                known: true,
                informational: false,
                confidenceCredit: 1,
                meaning: composite.meaning
              };
            }
          }

          if (tokenName === "TRACKCONFIG") {
            const shiftedTechInfoRule = lookupStrictTokenRule(ruleSet.index, "TECHINFO", raw);
            if (shiftedTechInfoRule) {
              const shiftedTechMeaning = applyRawEntryToMeaning(
                String(shiftedTechInfoRule.semantic_meaning || "").trim(),
                getRawEntryForRule(shiftedTechInfoRule, raw)
              );

              return {
                tokenName,
                displayTokenLabel: "TECHINFO",
                raw,
                segmentMask: token.segmentMask,
                known: true,
                informational: false,
                confidenceCredit: 1,
                meaning: shiftedTechMeaning || `TECHINFO: ${raw}`
              };
            }

            // Keep TRACKCONFIG in its own slot; reel semantics should only come from R slot after remap.
          }

          if (tokenName === "STANDARD") {
            if (conventionId === "FOX-AUDIO-SERVICES") {
              const hasTapeTypeSignal = (Array.isArray(parsedTokens) ? parsedTokens : []).some((candidate) => {
                const candidateName = String((candidate && candidate.tokenName) || "").toUpperCase();
                const candidateRaw = String((candidate && candidate.rawValue) || "").trim().toUpperCase();
                return candidateName === "SUFFIX"
                  && candidateRaw
                  && Boolean(lookupStrictTokenRule(ruleSet.index, "SUFFIX", candidateRaw));
              });

              if (hasTapeTypeSignal && raw.includes("_")) {
                const standardPieces = raw
                  .split("_")
                  .map((piece) => String(piece || "").trim().toUpperCase())
                  .filter(Boolean);

                if (standardPieces.length >= 2) {
                  const resolvedPieces = standardPieces.map((piece) => {
                    const standardRule = lookupStrictTokenRule(ruleSet.index, "STANDARD", piece);
                    const standardMeaning = standardRule
                      ? applyRawEntryToMeaning(
                        String(standardRule.semantic_meaning || "").trim(),
                        getRawEntryForRule(standardRule, piece)
                      )
                      : "No active rule match";

                    return {
                      piece,
                      known: Boolean(standardRule),
                      meaning: standardMeaning
                    };
                  });

                  const knownCount = resolvedPieces.filter((piece) => piece.known).length;
                  if (knownCount > 0) {
                    const detail = resolvedPieces
                      .map((piece) => `${piece.piece} (${piece.meaning})`)
                      .join("; ");

                    return {
                      tokenName,
                      raw,
                      segmentMask: token.segmentMask,
                      known: knownCount === resolvedPieces.length,
                      informational: false,
                      confidenceCredit: knownCount === resolvedPieces.length ? 1 : 0.7,
                      meaning: `STANDARD composite parsed: ${detail}`
                    };
                  }
                }
              }
            }

            const shiftedSuffixRule = lookupStrictTokenRule(ruleSet.index, "SUFFIX", raw);
            if (shiftedSuffixRule) {
              const shiftedSuffixMeaning = applyRawEntryToMeaning(
                String(shiftedSuffixRule.semantic_meaning || "").trim(),
                getRawEntryForRule(shiftedSuffixRule, raw)
              );

              return {
                tokenName,
                displayTokenLabel: "SUFFIX",
                raw,
                segmentMask: token.segmentMask,
                known: true,
                informational: false,
                confidenceCredit: 1,
                meaning: shiftedSuffixMeaning || `SUFFIX: ${raw}`
              };
            }

            const shiftedSuffixCompositeMeaning = resolveFoxSuffixCompositeMeaning(ruleSet, raw);
            if (shiftedSuffixCompositeMeaning) {
              return {
                tokenName,
                displayTokenLabel: "SUFFIX",
                raw,
                segmentMask: token.segmentMask,
                known: true,
                informational: false,
                confidenceCredit: 1,
                meaning: shiftedSuffixCompositeMeaning
              };
            }

            const shiftedTechInfoCompositeMeaning = resolveFoxTechInfoCompositeMeaning(raw);
            if (shiftedTechInfoCompositeMeaning) {
              return {
                tokenName,
                displayTokenLabel: "TECHINFO",
                raw,
                segmentMask: token.segmentMask,
                known: true,
                informational: false,
                confidenceCredit: 1,
                meaning: shiftedTechInfoCompositeMeaning
              };
            }
          }

          if (tokenName === "R" || tokenName === "VERSION" || tokenName === "SUFFIX") {
            const transferMeaning = resolveFoxTransferAssetMeaning(raw);
            if (transferMeaning) {
              const detectedTokenName = "VER";
              const outOfSlotDetection = detectedTokenName !== tokenName;
              return {
                tokenName,
                displayTokenLabel: detectedTokenName,
                appearsInTokenSlot: outOfSlotDetection ? tokenName : "",
                raw,
                segmentMask: token.segmentMask,
                known: true,
                informational: false,
                confidenceCredit: 1,
                meaning: transferMeaning
              };
            }
          }
        }

        if (isWmlsConvention(conventionId)) {
          if (tokenName === "FILETYPE") {
            const rawFileTypeMeaning = getWmlsFileTypeMeaning(raw, "");
            if (rawFileTypeMeaning) {
              return {
                tokenName,
                raw,
                segmentMask: token.segmentMask,
                known: true,
                informational: false,
                confidenceCredit: 1,
                meaning: rawFileTypeMeaning
              };
            }
          }

          const languageMeaning = resolveWmlsLanguageMeaning(tokenName, token.segmentMask, raw);
          if (languageMeaning) {
            return {
              tokenName,
              raw,
              segmentMask: token.segmentMask,
              known: true,
              informational: true,
              meaning: languageMeaning
            };
          }

          if ((tokenName === "AUD" || tokenName === "TXT") && /^[A-Z]{2,6}(?:-[A-Z0-9]{2,8})?$/.test(raw.toUpperCase())) {
            return {
              tokenName,
              raw,
              segmentMask: token.segmentMask,
              known: true,
              informational: true,
              meaning: `${tokenName} language code: ${raw.toUpperCase()}`
            };
          }

          const partialVersionMeaning = resolveWmlsPartialVersion(ruleSet.index, tokenName, raw);
          if (partialVersionMeaning) {
            return {
              tokenName,
              raw,
              segmentMask: token.segmentMask,
              known: Boolean(partialVersionMeaning.known),
              confidenceCredit: Number.isFinite(partialVersionMeaning.credit) ? partialVersionMeaning.credit : undefined,
              informational: false,
              meaning: partialVersionMeaning.meaning
            };
          }

          const episodeMeaning = resolveWmlsEpisodeNumber(tokenName, raw);
          if (episodeMeaning) {
            return {
              tokenName,
              displayTokenLabel: "EPISODE",
              raw,
              segmentMask: token.segmentMask,
              known: Boolean(episodeMeaning.known),
              informational: Boolean(episodeMeaning.informational),
              meaning: episodeMeaning.meaning
            };
          }
        }

        if (isWmlsConvention(conventionId)) {
          const stackedMeaning = resolveWmlsStackedElementType(ruleSet.index, tokenName, raw);
          if (stackedMeaning) {
            return {
              tokenName,
              raw,
              segmentMask: token.segmentMask,
              known: true,
              informational: false,
              meaning: stackedMeaning.meaning,
              matchedRule: stackedMeaning.rule
            };
          }

          const stackedFileInfoMeaning = resolveWmlsStackedFileInfo(ruleSet.index, tokenName, raw);
          if (stackedFileInfoMeaning) {
            return {
              tokenName,
              raw,
              segmentMask: token.segmentMask,
              known: true,
              informational: false,
              meaning: stackedFileInfoMeaning.meaning,
              matchedRule: stackedFileInfoMeaning.rule
            };
          }

          const partialStackedMeaning = resolveWmlsPartialStackedRasterRate(ruleSet.index, tokenName, raw);
          if (partialStackedMeaning) {
            return {
              tokenName,
              raw,
              segmentMask: token.segmentMask,
              known: Boolean(partialStackedMeaning.known),
              confidenceCredit: Number.isFinite(partialStackedMeaning.credit) ? partialStackedMeaning.credit : undefined,
              informational: false,
              meaning: partialStackedMeaning.meaning
            };
          }

          const partialFileTypeMeaning = resolveWmlsPartialFileType(ruleSet.index, tokenName, raw);
          if (partialFileTypeMeaning) {
            return {
              tokenName,
              raw,
              segmentMask: token.segmentMask,
              known: Boolean(partialFileTypeMeaning.known),
              confidenceCredit: Number.isFinite(partialFileTypeMeaning.credit) ? partialFileTypeMeaning.credit : undefined,
              informational: false,
              meaning: partialFileTypeMeaning.meaning
            };
          }
        }

        const isDwcStrictTailSegment = conventionId === "DWC-MODERN"
          && ["TEXL-IAR", "AUDL-TF", "TTL-TYPE"].includes(String(token.segmentMask || "").toUpperCase());
        let scopedRule = null;

        if (isFoxConvention(conventionId) && tokenName === "TF") {
          scopedRule = lookupFoxClcuByFormat(ruleSet.index, raw, "TRACKFORMAT");
        } else if (isFoxConvention(conventionId) && tokenName === "CL/CU") {
          scopedRule = lookupFoxClcuByFormat(ruleSet.index, raw, "CHANNELUSAGE");
        }

        if (!scopedRule) {
          scopedRule = isDwcStrictTailSegment
            ? lookupStrictTokenRule(ruleSet.index, tokenName, raw)
            : lookupWithSegmentAliases(ruleSet.index, tokenName, token.segmentMask, raw);
        }

        if (scopedRule && isDwcStrictTailSegment) {
          const scopedRuleTokenName = String(scopedRule.token_name || "").toUpperCase();
          if (scopedRuleTokenName && scopedRuleTokenName !== tokenName) {
            scopedRule = null;
          }
        }

        if (scopedRule) {
          if (isWmlsConvention(conventionId) && tokenName === "FILETYPE") {
            const exactMap = (ruleSet && ruleSet.index && ruleSet.index.tokenExact && ruleSet.index.tokenExact.get("FILETYPE")) || new Map();
            const isDashed = raw.includes("-");
            const hasExactRule = exactMap.has(raw);
            const scopedSemantic = String(scopedRule.semantic_meaning || "").trim();
            const rawMeaning = String(findWmlsFileTypeMeaning(raw) || "").trim();
            const hasRawMeaning = Boolean(rawMeaning) && !/no semantic meaning/i.test(rawMeaning);
            const semanticLooksPlaceholder = !scopedSemantic || /no semantic meaning/i.test(scopedSemantic);

            if (isDashed) {
              const pieces = raw.split("-").filter(Boolean);
              if (pieces.length >= 2) {
                const knownPieces = pieces.filter((piece) => exactMap.has(piece) || state.wmlsFileTypeMeanings.has(piece));
                const unknownPieces = pieces.filter((piece) => !exactMap.has(piece) && !state.wmlsFileTypeMeanings.has(piece));
                if (unknownPieces.length > 0) {
                  const knownWithMeaning = knownPieces.map((piece) => {
                    const rule = (exactMap.get(piece) || []).find((entry) => !getRulePattern(entry));
                    const semantic = getWmlsFileTypeMeaning(piece, String((rule && rule.semantic_meaning) || "known FILETYPE rule").trim());
                    return `${piece} (${semantic})`;
                  });
                  const unknownWithTag = unknownPieces.map((piece) => `${piece} (undefined)`);

                  return {
                    tokenName,
                    raw,
                    segmentMask: token.segmentMask,
                    known: false,
                    informational: false,
                    confidenceCredit: knownPieces.length / pieces.length,
                    meaning: `FILETYPE connector mismatch: ${[...unknownWithTag, ...knownWithMeaning].join(" -> ")}`
                  };
                }

                if (!hasExactRule) {
                  const knownWithMeaning = knownPieces.map((piece) => {
                    const rule = (exactMap.get(piece) || []).find((entry) => !getRulePattern(entry));
                    const semantic = getWmlsFileTypeMeaning(piece, String((rule && rule.semantic_meaning) || "known FILETYPE rule").trim());
                    return `${piece} (${semantic})`;
                  });

                  return {
                    tokenName,
                    raw,
                    segmentMask: token.segmentMask,
                    known: false,
                    informational: false,
                    confidenceCredit: Math.min(0.75, knownPieces.length / pieces.length),
                    meaning: `FILETYPE composite not explicitly defined: ${knownWithMeaning.join(" -> ")}`
                  };
                }
              }
            }

            if ((isDashed && !hasExactRule) || (semanticLooksPlaceholder && !hasRawMeaning)) {
              return {
                tokenName,
                raw,
                segmentMask: token.segmentMask,
                known: false,
                informational: false,
                confidenceCredit: 0,
                meaning: `FILETYPE undefined value: ${raw}.`
              };
            }
          }

          let scopedMeaning = String(scopedRule.semantic_meaning || "").trim();
          if (isWmlsConvention(conventionId)) {
            scopedMeaning = getWmlsResolvedMeaning(tokenName, raw, scopedMeaning);
          } else if (conventionId === "DWC-MODERN" && tokenName === "CONF") {
            scopedMeaning = getDwcConfMeaning(raw, scopedMeaning);
          }

          // Keep rule-matching authoritative, but source rich text (definition/meaning/notes)
          // from raw files when available so copy updates do not require rule regeneration.
          scopedMeaning = applyRawEntryToMeaning(scopedMeaning, getRawEntryForRule(scopedRule, raw));

          const detectedTokenName = String(scopedRule.token_name || tokenName).toUpperCase();
          const outOfSlotDetection = Boolean(detectedTokenName && detectedTokenName !== tokenName);
          return {
            tokenName,
            displayTokenLabel: outOfSlotDetection ? detectedTokenName : undefined,
            appearsInTokenSlot: outOfSlotDetection ? tokenName : "",
            raw,
            segmentMask: token.segmentMask,
            known: true,
            informational: false,
            meaning: scopedMeaning,
            matchedRule: scopedRule
          };
        }

        const globalExactRules = listGlobalExactMatchRules(ruleSet.index, raw);
        const globalDetectedRule = globalExactRules[0] || null;
        if (globalDetectedRule) {
          const detectedTokenName = String(globalDetectedRule.token_name || "").toUpperCase();
          const outOfSlotDetection = Boolean(detectedTokenName && detectedTokenName !== tokenName);
          let detectedMeaning = String(globalDetectedRule.semantic_meaning || "").trim();
          if (isWmlsConvention(conventionId)) {
            detectedMeaning = getWmlsResolvedMeaning(detectedTokenName || tokenName, raw, detectedMeaning);
          } else if (conventionId === "DWC-MODERN" && detectedTokenName === "CONF") {
            detectedMeaning = getDwcConfMeaning(raw, detectedMeaning);
          }
          detectedMeaning = applyRawEntryToMeaning(detectedMeaning, getRawEntryForRule(globalDetectedRule, raw));

          return {
            tokenName,
            displayTokenLabel: detectedTokenName || undefined,
            appearsInTokenSlot: outOfSlotDetection ? tokenName : "",
            raw,
            segmentMask: token.segmentMask,
            known: true,
            informational: false,
            meaning: detectedMeaning,
            matchedRule: globalDetectedRule
          };
        }

        const specCompoundMeaning = resolveDwcSpecCompound(ruleSet, tokenName, raw);
        if (specCompoundMeaning) {
          return {
            tokenName,
            raw,
            segmentMask: token.segmentMask,
            known: true,
            informational: false,
            meaning: specCompoundMeaning
          };
        }

        if (conventionId === "DWC-MODERN") {
          const dwcSuffixAwareMeaning = resolveDwcLanguageWithSuffix(ruleSet, token, parsedTokens);
          if (dwcSuffixAwareMeaning) {
            return {
              tokenName,
              raw,
              segmentMask: token.segmentMask,
              known: true,
              informational: true,
              meaning: dwcSuffixAwareMeaning
            };
          }

          if (tokenName === "CONF" && /^R\d{1,2}(?:-\d{1,2})?$/i.test(raw)) {
            return {
              tokenName,
              raw,
              segmentMask: token.segmentMask,
              known: true,
              informational: false,
              meaning: `Legacy reel-range helper routed through CONF: ${raw.toUpperCase()}`
            };
          }

          if ((tokenName === "TEXL" || tokenName === "AUDL") && /^[A-Z]{2,6}(?:-[A-Z0-9]{2,8})?$/.test(raw.toUpperCase())) {
            return {
              tokenName,
              raw,
              segmentMask: token.segmentMask,
              known: true,
              informational: true,
              meaning: `${tokenName} language code: ${raw.toUpperCase()}`
            };
          }

          if (tokenName === "TTL" && String(token.segmentMask || "").toUpperCase() === "TTL-TYPE" && /^[A-Z]{2,6}(?:-[A-Z0-9]{2,8})?$/.test(raw.toUpperCase())) {
            const ttlFromTypeRule = lookupStrictTokenRule(ruleSet.index, "TYPE", raw);
            const ttlRule = lookupStrictTokenRule(ruleSet.index, "TTL", raw) || ttlFromTypeRule;
            const ttlRawEntry = getRawEntryForRule(ttlRule, raw);
            const ttlFormat = String((ttlRawEntry && ttlRawEntry.format) || getRuleFormat(ttlRule) || "").trim().toUpperCase();

            const audlRule = lookupStrictTokenRule(ruleSet.index, "AUDL", raw);
            const audlRawEntry = getRawEntryForRule(audlRule, raw);
            const audlFormat = String((audlRawEntry && audlRawEntry.format) || getRuleFormat(audlRule) || "").trim().toUpperCase();

            const texlRule = lookupStrictTokenRule(ruleSet.index, "TEXL", raw);
            const texlRawEntry = getRawEntryForRule(texlRule, raw);
            const texlFormat = String((texlRawEntry && texlRawEntry.format) || getRuleFormat(texlRule) || "").trim().toUpperCase();

            const isReservedNonTtlCode = Boolean(
              (audlRule && audlFormat === "AUDL")
              || (texlRule && texlFormat === "TEXL")
            );

            if (!ttlRule || (ttlFormat && ttlFormat !== "TTL")) {
              if (!isReservedNonTtlCode) {
                return {
                  tokenName,
                  raw,
                  segmentMask: token.segmentMask,
                  known: true,
                  informational: true,
                  meaning: `${tokenName} language code: ${raw.toUpperCase()}`
                };
              }

              return {
                tokenName,
                raw,
                segmentMask: token.segmentMask,
                known: false,
                informational: false,
                confidenceCredit: 0,
                meaning: `TTL value is undefined for this token in this naming convention: ${raw}.`
              };
            }

            return {
              tokenName,
              raw,
              segmentMask: token.segmentMask,
              known: true,
              informational: true,
              meaning: `${tokenName} language code: ${raw.toUpperCase()}`
            };
          }

          if (tokenName === "IAR" && String(token.segmentMask || "").toUpperCase() === "TEXL-IAR" && /^[A-Z0-9]{2,8}(?:-[A-Z0-9]{1,6})?$/.test(raw.toUpperCase())) {
            const compositeIarMeaning = resolveDwcIarCompositeMeaning(ruleSet, raw);
            if (compositeIarMeaning) {
              return {
                tokenName,
                raw,
                segmentMask: token.segmentMask,
                known: true,
                informational: false,
                meaning: compositeIarMeaning
              };
            }

            return {
              tokenName,
              raw,
              segmentMask: token.segmentMask,
              known: true,
              informational: false,
              meaning: `IAR token with subdescriptor: ${raw.toUpperCase()}`
            };
          }

          
        }

        if (isFoxConvention(conventionId)) {
          if ((tokenName === "TL" || tokenName === "CL/CU") && /^[A-Z]{2,6}(?:-[A-Z0-9]{2,8})?$/.test(raw.toUpperCase())) {
            return {
              tokenName,
              raw,
              segmentMask: token.segmentMask,
              known: true,
              informational: true,
              meaning: `${tokenName} language code: ${raw.toUpperCase()}`
            };
          }
        }

        if (isWmlsConvention(conventionId) && tokenName === "FILETYPE" && raw) {
          return {
            tokenName,
            raw,
            segmentMask: token.segmentMask,
            known: false,
            informational: false,
            confidenceCredit: 0,
            meaning: `FILETYPE undefined value: ${raw}.`
          };
        }

        return {
          tokenName,
          raw,
          segmentMask: token.segmentMask,
          known: false,
          informational: false,
          meaning: ["TEXL", "AUDL", "TTL", "TL", "CL/CU", "LANGUAGE"].includes(String(tokenName || "").toUpperCase()) && raw
            ? `${String(tokenName || "").toUpperCase()} value is undefined for this token in this naming convention: ${raw}.`
            : conventionId === "DWC-MODERN" && tokenName === "CONF" && raw
              ? `CONF undefined value: ${raw}.`
              : conventionId === "DWC-MODERN" && tokenName === "TF" && String(token.segmentMask || "").toUpperCase() === "AUDL-TF" && raw
                ? `TF undefined value: ${raw}.`
              : "No active rule match"
        };
      }

      function scoreCandidate(ruleSet, maskSpec, tokenResults, rawTokenResults) {
        const scoredTokens = tokenResults.filter((token) => token.raw && !token.informational);
        const unresolvedUnknownCount = tokenResults.filter((token) => String((token && token.tokenName) || "").toUpperCase() === "UNKNOWN").length;
        const populated = scoredTokens.length;
        const known = scoredTokens.filter((token) => token.known).length;
        const credited = scoredTokens.reduce((sum, token) => {
          const explicitCredit = Number(token.confidenceCredit);
          if (Number.isFinite(explicitCredit)) {
            return sum + Math.max(0, Math.min(1, explicitCredit));
          }
          return sum + (token.known ? 1 : 0);
        }, 0);
        let confidence = populated > 0 ? credited / populated : 1;
        const hasUndefinedMeaning = (token) => /undefined value|value is undefined|no active rule match|no value provided/i.test(String((token && token.meaning) || ""));
        const hasRawValue = (token) => String((token && token.raw) || "").trim().length > 0;
        const isUnknownTail = (token) => String((token && token.tokenName) || "").toUpperCase() === "UNKNOWN";
        const isGoodToken = (token) => {
          if (!hasRawValue(token)) return false;
          if (token && token.known) return true;
          const tokenName = String((token && token.tokenName) || "").toUpperCase();
          const meaning = String((token && token.meaning) || "");
          if (tokenName === "TITLE") return /source-provided/i.test(meaning);
          if (tokenName === "AUD" || tokenName === "TXT") return /language code routed/i.test(meaning);
          if (tokenName === "WMLS#" || tokenName === "WMLS##") return /WMLS ID number/i.test(meaning) && /^\d{6,10}$/i.test(String(token.raw || "").trim());
          return !hasUndefinedMeaning(token);
        };
        const isBadToken = (token) => hasRawValue(token) && (isUnknownTail(token) || hasUndefinedMeaning(token));
        const linearTokens = tokenResults.filter((token) => hasRawValue(token) && !token.informational);
        const undefinedWithRawCount = linearTokens.filter((token) => hasUndefinedMeaning(token)).length;
        const unknownWithRawCount = tokenResults.filter((token) => {
          if (!isUnknownTail(token)) return false;
          const passthroughRaw = String((token && token.passthroughRaw) || "").trim();
          const raw = String((token && token.raw) || "").trim();
          return Boolean(passthroughRaw || (raw && raw.toUpperCase() !== "UNDEFINED"));
        }).length;
        const badEvidenceCount = undefinedWithRawCount + unknownWithRawCount;
        let confidenceCeiling = 1;
        let surroundedBadCount = 0;
        let orphanBadCount = 0;
        for (let i = 0; i < linearTokens.length; i += 1) {
          const token = linearTokens[i];
          if (!isBadToken(token)) {
            continue;
          }
          const prev = linearTokens[i - 1];
          const next = linearTokens[i + 1];
          const surrounded = Boolean(prev && next && isGoodToken(prev) && isGoodToken(next));
          if (surrounded) {
            surroundedBadCount += 1;
          } else {
            orphanBadCount += 1;
          }
        }
        confidence = Math.min(1, Math.max(0, confidence + Math.min(0.16, surroundedBadCount * 0.08) - Math.min(0.28, orphanBadCount * 0.07)));
        confidence = Math.min(1, Math.max(0, confidence - Math.min(0.5, badEvidenceCount * 0.08 + orphanBadCount * 0.05)));
        if (badEvidenceCount >= 1) confidenceCeiling = Math.min(confidenceCeiling, 0.9);
        if (badEvidenceCount >= 2) confidenceCeiling = Math.min(confidenceCeiling, 0.75);
        if (badEvidenceCount >= 3) confidenceCeiling = Math.min(confidenceCeiling, 0.6);
        if (orphanBadCount >= 2) confidenceCeiling = Math.min(confidenceCeiling, 0.55);
        if (orphanBadCount >= 3) confidenceCeiling = Math.min(confidenceCeiling, 0.45);
        // Heavy unknown passthrough is a strong signal the candidate is a weak fit.
        if (unknownWithRawCount >= 4) confidenceCeiling = Math.min(confidenceCeiling, 0.45);
        if (unknownWithRawCount >= 5) confidenceCeiling = Math.min(confidenceCeiling, 0.35);
        if (unknownWithRawCount >= known + 2) confidenceCeiling = Math.min(confidenceCeiling, 0.4);
        if (known <= 2 && unknownWithRawCount >= 4) confidenceCeiling = Math.min(confidenceCeiling, 0.25);
        if (populated > 0 && badEvidenceCount >= populated) confidenceCeiling = Math.min(confidenceCeiling, 0.3);
        const knownTokenNames = scoredTokens.filter((token) => token.known).map((token) => String(token.tokenName || "").toUpperCase());
        const maskIdUpper = String(maskSpec && maskSpec.id || "").toUpperCase();

        const tokenMatchesName = (token, desiredName) => {
          const desired = String(desiredName || "").toUpperCase();
          const primary = String(token && token.tokenName || "").toUpperCase();
          const display = String(token && token.displayTokenLabel || "").toUpperCase();
          return primary === desired || display === desired;
        };

        const tokenValue = (tokenName) => {
          const match = tokenResults.find((token) => tokenMatchesName(token, tokenName));
          return match ? String(match.raw || "").trim().toUpperCase() : "";
        };

        const tokenValueBySegment = (segmentMask) => {
          const segmentKey = String(segmentMask || "").toUpperCase();
          const match = tokenResults.find((token) => String(token.segmentMask || "").toUpperCase() === segmentKey);
          return match ? String(match.raw || "").trim().toUpperCase() : "";
        };

        const tokenKnown = (tokenName) => {
          const match = tokenResults.find((token) => tokenMatchesName(token, tokenName));
          return Boolean(match && match.known);
        };

        const isPlausibleForSlot = (tokenName, raw) => {
          const name = String(tokenName || "").toUpperCase();
          const value = String(raw || "").trim().toUpperCase();
          if (!value) return false;
          if (["TITLE", "VID", "REC"].includes(name)) return true;
          if (["CLASS", "WIP", "TYPE", "CONF", "SPEC", "RES", "RANGE", "FPS", "IAR", "TF", "MAST", "DIV", "REND", "CL/CU"].includes(name)) {
            if (lookupStrictTokenRule(ruleSet.index, name, value)) return true;
          }
          if (["TEXL", "AUDL", "TTL", "AUD", "TXT", "LANGUAGE", "TL"].includes(name)) {
            return /^[A-Z]{2,6}(?:-[A-Z0-9]{2,8})?$/.test(value);
          }
          if (["WMLS#", "WMLS##"].includes(name)) {
            return /^\d{6,10}$/.test(value);
          }
          if (name === "VID") return /^V\d{7,12}$/.test(value);
          return false;
        };

        const computeContentFitScore = () => {
          const segments = Array.isArray(maskSpec && maskSpec.segments) ? maskSpec.segments : [];
          let fitScore = 0;
          let considered = 0;

          for (const segment of segments) {
            const slotSegmentPosition = Number(segment && segment.segmentIndex) + 1;
            const slotTokenNames = Array.isArray(segment && segment.tokenNames) ? segment.tokenNames : [];
            for (const slotTokenNameRaw of slotTokenNames) {
              const slotTokenName = String(slotTokenNameRaw || "").toUpperCase();
              const token = tokenResults.find((entry) =>
                tokenMatchesName(entry, slotTokenName)
                && Number(entry && entry.segmentPosition) === slotSegmentPosition
              ) || tokenResults.find((entry) => tokenMatchesName(entry, slotTokenName));

              const raw = String((token && token.raw) || "").trim();
              if (!raw) {
                continue;
              }

              considered += 1;
              if (Boolean(token && token.known)) {
                fitScore += 2;
                continue;
              }
              if (isPlausibleForSlot(slotTokenName, raw)) {
                fitScore += 1;
              } else {
                fitScore -= 2;
              }
            }
          }

          return {
            score: fitScore,
            considered,
            coverage: considered > 0 ? fitScore / (considered * 2) : 0
          };
        };

        const conventionId = String((ruleSet.rulesDoc && ruleSet.rulesDoc.conventionId) || "").toUpperCase();
        let maskFitScore = known;
        const familyPrior = computeFamilyPriorAdjustment(conventionId, state.familyPriorContext);
        maskFitScore += familyPrior.maskFitDelta;
        confidence = Math.min(1, Math.max(0, confidence + familyPrior.confidenceDelta));
        const maskAnchorSignal = computeMaskAnchorAdjustment(maskSpec, state.familyPriorContext);
        maskFitScore += maskAnchorSignal.maskFitDelta;
        confidence = Math.min(1, Math.max(0, confidence + maskAnchorSignal.confidenceDelta));
        let foxMaskPreferenceScore = 0;
        let foxAudioAnchorScore = 0;
        let foxAudioWeakSignal = false;
        let wmlsMaskPreferenceScore = 0;

        if (isWmlsConvention(conventionId)) {
          const language = tokenValue("LANGUAGE");
          const frameRate = tokenValue("FRAMERATE");
          const elementType = tokenValue("ELEMENTTYPE");
          const reel = tokenValue("REEL#");
          const wmlsId = tokenValue("WMLS#") || tokenValue("WMLS##");
          const fileTypeValue = tokenValueBySegment("FILETYPE") || tokenValue("FILETYPE");
          const fileInfoValue = tokenValue("FILEINFO");
          const txtValue = tokenValue("TXT");
          const fileTypeExactMap = (ruleSet && ruleSet.index && ruleSet.index.tokenExact && ruleSet.index.tokenExact.get("FILETYPE")) || new Map();
          const hasNonExactFileType = Boolean(fileTypeValue && !fileTypeExactMap.has(fileTypeValue));
          const fileTypeFormat = getWmlsFileTypeFormat(fileTypeValue);
          const isAudioMask = maskIdUpper.includes("AUDSUB");
          const isSubtitleMask = maskIdUpper.includes("SUBCAP");
          const isGeneralMask = !isAudioMask && !isSubtitleMask;
          const isAudioMasterMask = maskIdUpper.includes("AUDIO-MASTER");
          const aspectRatioValue = tokenValue("ASPECTRATIO");
          const audValue = tokenValue("AUD");
          const wmlsTailValue = tokenValue("WMLS##") || tokenValue("WMLS#");
          const looksNumericTail = /^\d{6,10}$/.test(wmlsTailValue);
          const looksLanguageLikeAud = /^[A-Z]{2,6}(?:-[A-Z0-9]{2,8})?$/.test(audValue);
          const looksLanguageLikeTxt = /^[A-Z]{2,6}(?:-[A-Z0-9]{2,8})?$/.test(txtValue);
          const shiftedTailInAud = /^\d{6,10}$/.test(audValue)
            && /^[A-Z]{2,6}(?:-[A-Z0-9]{2,8})?$/.test(aspectRatioValue);
          const looksCombinedFileInfo = /^\d{3,4}[PI]\d{2}(?:NDF|DF)?$/.test(fileInfoValue);
          const frameRateLooksCombinedFileInfo = /^\d{3,4}[PI]\d{2}(?:NDF|DF)?$/.test(frameRate);
          const languageLooksLikeFileType = Boolean(getWmlsFileTypeFormat(language));

          const frameRateIsNumeric = /^\d{2,4}(?:NDF|DF)?$/.test(frameRate);
          const reelHasAlnumPattern = /^(?=.*[A-Z])(?=.*\d)[A-Z0-9-]+$/.test(reel);
          const looksAudioMaster = frameRateIsNumeric && (Boolean(language) || tokenKnown("ELEMENTTYPE") || /^(?:PM|DPA|FXPA|CRDPA|FOLPA|BGPA|GRPA)/.test(elementType) || reelHasAlnumPattern);
          if (looksAudioMaster) {
            if (/^[A-Z]{2,6}(?:-[A-Z0-9]{2,8})?$/.test(language)) maskFitScore += 2;
            if (frameRateIsNumeric) maskFitScore += 2;
            if (tokenKnown("ELEMENTTYPE") || /^(?:PM|DPA|FXPA|CRDPA|FOLPA|BGPA|GRPA)/.test(elementType)) maskFitScore += 3;
            if (/^(?:C|C[A-Z0-9]+|RC|PC|R\d+|R\d+-\d+|PART\d+|PARTS\d+-\d+)$/.test(reel)) maskFitScore += 2;
            if (/^[A-Z0-9]+$/.test(wmlsId)) maskFitScore += 2;
          }

          if (fileTypeFormat === "AUDIO") {
            if (isAudioMask) wmlsMaskPreferenceScore += 25;
            if (isSubtitleMask) wmlsMaskPreferenceScore -= 25;
            if (isGeneralMask) wmlsMaskPreferenceScore -= 5;
          } else if (fileTypeFormat === "SUBTITLE") {
            if (isSubtitleMask) wmlsMaskPreferenceScore += 25;
            if (isAudioMask) wmlsMaskPreferenceScore -= 25;
            if (isGeneralMask) wmlsMaskPreferenceScore -= 5;
          } else if (fileTypeFormat) {
            if (isGeneralMask) wmlsMaskPreferenceScore += 5;
            if (isAudioMask || isSubtitleMask) wmlsMaskPreferenceScore -= 5;
          }

          if (shiftedTailInAud && isGeneralMask) {
            wmlsMaskPreferenceScore -= 15;
          }

          if (isGeneralMask) {
            if (looksCombinedFileInfo) wmlsMaskPreferenceScore += 12;
            if (looksLanguageLikeAud && looksLanguageLikeTxt) wmlsMaskPreferenceScore += 8;
            if (looksNumericTail) wmlsMaskPreferenceScore += 6;
          }

          if (isAudioMasterMask) {
            if (frameRateLooksCombinedFileInfo) wmlsMaskPreferenceScore -= 35;
            if (languageLooksLikeFileType) wmlsMaskPreferenceScore -= 20;
            if (/^\d{3}$/.test(elementType)) wmlsMaskPreferenceScore -= 8;
            if (/^[A-Z]{2,6}(?:-[A-Z0-9]{2,8})?$/.test(reel)) wmlsMaskPreferenceScore -= 8;
          }

          if (looksNumericTail && looksLanguageLikeAud && (isAudioMask || isSubtitleMask)) {
            wmlsMaskPreferenceScore += 12;
          }

          // Preserve legacy fit signal as a later tie-breaker.
          maskFitScore += wmlsMaskPreferenceScore;

          if (hasNonExactFileType) {
            confidence = Math.min(confidence, 0.85);
          }
        }

        if (isFoxConvention(conventionId)) {
          const wprValue = tokenValue("WPR");
          const verValue = tokenValue("VER");
          const epValue = tokenValue("EP");
          const classValue = tokenValue("CLASS");
          const rawByName = (name) => {
            const target = String(name || "").toUpperCase();
            const match = (Array.isArray(rawTokenResults) ? rawTokenResults : []).find((token) =>
              String((token && token.tokenName) || "").toUpperCase() === target
            );
            return match ? String(match.raw || "").trim().toUpperCase() : "";
          };
          const foxRawJobType = rawByName("JOBTYPE");
          const foxRawPiccut = rawByName("PICCUT");
          const foxRawLangsnd = rawByName("LANGSND");
          const foxRawTrackConfig = rawByName("TRACKCONFIG");
          const foxLooksLikeAudioCompact = Boolean(
            conventionId !== "FOX-AUDIO-SERVICES"
            && lookupStrictTokenRule(ruleSet.index, "STANDARD", foxRawJobType)
            && lookupStrictTokenRule(ruleSet.index, "STANDARD", foxRawPiccut)
            && /^[MP]\d{3,}$/i.test(foxRawLangsnd)
            && lookupStrictTokenRule(ruleSet.index, "SUFFIX", foxRawTrackConfig)
          );

          const isValidWpr = tokenKnown("WPR") || /^[A-Z0-9]{6}$/i.test(wprValue);
          const isValidVer = tokenKnown("VER");
          const isEpFallbackWpr = tokenResults.some((token) =>
            String(token.tokenName || "").toUpperCase() === "EP"
            && /WPR fallback/i.test(String(token.meaning || ""))
          ) || /^[A-Z0-9]{6}$/i.test(epValue);
          const isEpPrimaryV10 = /^F\d{3}$/i.test(epValue)
            || /^\d{3}$/i.test(epValue)
            || /^XX$/i.test(epValue);
          const classDefined = tokenKnown("CLASS");

          if (maskIdUpper.includes("V9")) {
            if (isValidWpr) {
              foxMaskPreferenceScore += 3;
            } else if (wprValue) {
              foxMaskPreferenceScore -= 4;
            }

            if (isValidVer) {
              foxMaskPreferenceScore += 4;
            } else if (verValue) {
              foxMaskPreferenceScore -= 3;
            }
          }

          if (maskIdUpper.includes("V10")) {
            if (isEpPrimaryV10) {
              foxMaskPreferenceScore += 4;
            }

            if (isEpFallbackWpr) {
              foxMaskPreferenceScore -= 4;
            }

            if (classDefined) {
              foxMaskPreferenceScore += 3;
            }

            if (classValue && !classDefined) {
              foxMaskPreferenceScore -= 3;
            }

            // Legacy FOX v9 patterns sometimes appear under v10 only as EP fallback
            // and undefined CLASS; treat that as a weak v10 fit.
            if (isEpFallbackWpr && !classDefined) {
              confidence = Math.min(confidence, 0.22);
              maskFitScore -= 10;
            }
          }

          if (foxLooksLikeAudioCompact) {
            confidence = Math.min(confidence, 0.18);
            foxMaskPreferenceScore -= 20;
            maskFitScore -= 24;
          }

          if (conventionId === "FOX-AUDIO-SERVICES") {
            const langsndRaw = tokenValue("LANGSND");
            const versionRaw = tokenValue("VERSION");
            const standardRaw = tokenValue("STANDARD");
            const rawByName = (name) => {
              const target = String(name || "").toUpperCase();
              const match = (Array.isArray(rawTokenResults) ? rawTokenResults : []).find((token) =>
                String((token && token.tokenName) || "").toUpperCase() === target
              );
              return match ? String(match.raw || "").trim().toUpperCase() : "";
            };
            const rawJobType = rawByName("JOBTYPE");
            const rawPiccut = rawByName("PICCUT");
            const rawLangsnd = rawByName("LANGSND");
            const rawTrackConfig = rawByName("TRACKCONFIG");
            const looksCompositeLangsnd = /^[A-Z]{3}[A-Z0-9]{1,8}[A-Z]$/.test(langsndRaw);
            const langsndRule = langsndRaw ? lookupStrictTokenRule(ruleSet.index, "LANGSND", langsndRaw) : null;
            const langsndFormat = String(getRuleFormat(langsndRule) || "").toUpperCase();
            const looksKnownLangsndCode = Boolean(langsndRule && ["SND", "STEM", "ME", "ISO"].includes(langsndFormat));
            const looksCompactTapeShortForm = Boolean(
              lookupStrictTokenRule(ruleSet.index, "STANDARD", rawJobType)
              && lookupStrictTokenRule(ruleSet.index, "STANDARD", rawPiccut)
              && /^[MP]\d{3,}$/i.test(rawLangsnd)
              && lookupStrictTokenRule(ruleSet.index, "SUFFIX", rawTrackConfig)
            );
            if (tokenKnown("JOBTYPE")) foxAudioAnchorScore += 2;
            if (tokenKnown("PICCUT")) foxAudioAnchorScore += 2;
            if (tokenKnown("LANGSND") || looksCompositeLangsnd || looksKnownLangsndCode) foxAudioAnchorScore += 2;
            if (tokenKnown("ADTLINFO")) foxAudioAnchorScore += 1;
            if (tokenKnown("TRACKCONFIG")) foxAudioAnchorScore += 1;
            if (tokenKnown("STANDARD")) foxAudioAnchorScore += 1;
            if (tokenKnown("WPR") || /^[A-Z0-9]{6}$/i.test(wprValue)) foxAudioAnchorScore += 1;
            if (tokenKnown("SUFFIX")) foxAudioAnchorScore += 1;
            if (/^[MP]\d{3,}$/i.test(versionRaw)) foxAudioAnchorScore += 1;
            if (/^[A-Z]_[A-Z]$/i.test(standardRaw)) foxAudioAnchorScore += 1;
            if (looksCompactTapeShortForm) foxAudioAnchorScore += 4;

            if (foxAudioAnchorScore >= 3) {
              confidence = Math.max(confidence, 0.45);
              maskFitScore += foxAudioAnchorScore * 3;
            } else {
              foxAudioWeakSignal = true;
              confidence = Math.min(confidence, 0.34);
              maskFitScore -= 12;
            }

            // Guardrail: legacy FOX video-style runtime tails should not be classified
            // as FOX Audio Services simply because compact anchors were found.
            const rawPool = (Array.isArray(rawTokenResults) ? rawTokenResults : [])
              .map((token) => String((token && token.raw) || "").trim().toUpperCase())
              .filter(Boolean);
            const hasLegacyRuntimeTail = rawPool.some((value) => /(?:^|[_-])RT\d{6}(?:$|[_-])/i.test(value));
            const hasLegacyVideoFormat = rawPool.some((value) => /(XDCAM\d{3,4}[IP]?|PRORES(?:HQ|LT|4444)?|DNXHD|HDCAM|HDV|MPEG2|IMF|DPX|EXR)/i.test(value));
            const hasLegacyAspectHint = rawPool.some((value) => /(?:^|[_-])\d{3}(?:$|[_-])/i.test(value));

            if (hasLegacyRuntimeTail && (hasLegacyVideoFormat || hasLegacyAspectHint)) {
              foxAudioWeakSignal = true;
              confidence = Math.min(confidence, 0.12);
              maskFitScore -= 30;
            }
          }

        }

        let hasWeakSignal = false;
        if (foxAudioWeakSignal) {
          hasWeakSignal = true;
        }
        if (isWmlsConvention(conventionId)) {
          const hasWmlsAnchor = knownTokenNames.some((name) => ["LANGUAGE", "FRAMERATE", "ELEMENTTYPE", "REEL#", "WMLS#", "WMLS##", "FILETYPE", "PRODUCTTYPE", "FILEINFO", "ASPECTRATIO", "AUD", "TXT"].includes(name));
          const versionOnlySignal = known > 0 && !hasWmlsAnchor && knownTokenNames.every((name) => name === "VERSION");
          const strongWmlsAnchor = knownTokenNames.some((name) => ["LANGUAGE", "FRAMERATE", "ELEMENTTYPE", "REEL#", "WMLS#", "WMLS##", "FILEINFO", "ASPECTRATIO", "AUD", "TXT"].includes(name));
          const weakSparseSignal = !strongWmlsAnchor && known <= 2;
          if (versionOnlySignal) {
            hasWeakSignal = true;
          }
          if (weakSparseSignal) {
            hasWeakSignal = true;
          }
        }

        if (conventionId === "DWC-MODERN") {
          const vid = tokenValue("VID");
          const ttl = tokenValue("TTL");
          const typeTail = tokenValue("TYPE");
          const fps = tokenValue("FPS");
          const conf = tokenValue("CONF");
          const spec = tokenValue("SPEC");
          const mainType = tokenValueBySegment("TYPE") || tokenValue("TYPE");
          const texl = tokenValue("TEXL");
          const iar = tokenValue("IAR");
          const looksLikeWmlsId = (value) => /^WMLS(?:#+|\d+)$/i.test(String(value || "").trim());
          const looksNumericWmlsTail = /^\d{6,10}$/.test(typeTail);
          const vidIsAccepted = /^V\d{3,16}$/.test(vid);
          const vidIsPreferred = /^V\d{7,10}$/.test(vid);

          // DWC files require a numeric VID anchor; preferred length strengthens ranking.
          if (!vidIsAccepted) {
            hasWeakSignal = true;
          }

          // WMLS IDs should never be treated as DWC TTL/TYPE values.
          if (looksLikeWmlsId(ttl) || looksLikeWmlsId(typeTail) || looksNumericWmlsTail) {
            hasWeakSignal = true;
          }

          if (vidIsAccepted) maskFitScore += 1;
          if (vidIsPreferred) maskFitScore += 1;
          if (/^\d{2,3}$/.test(fps)) maskFitScore += 1;
          if (/^[A-Z0-9-]{2,10}$/.test(conf)) maskFitScore += 1;
          if (/^[A-Z0-9-]{2,12}$/.test(spec)) maskFitScore += 1;

          const dwcAnchorScore =
            (vidIsAccepted ? 1 : 0)
            + (Boolean(lookupStrictTokenRule(ruleSet.index, "TYPE", mainType)) ? 1 : 0)
            + (Boolean(lookupStrictTokenRule(ruleSet.index, "CONF", conf)) ? 1 : 0)
            + (Boolean(lookupStrictTokenRule(ruleSet.index, "SPEC", spec)) ? 1 : 0)
            + ((/^[A-Z]{2,6}(?:-[A-Z0-9]{2,8})?$/.test(texl) && /^\d{3}$/.test(iar)) ? 1 : 0)
            + (/^\d{2,3}(?:\.\d+)?$/.test(fps) ? 1 : 0);

          if (dwcAnchorScore >= 4) {
            confidence = Math.max(confidence, 0.45);
            maskFitScore += 10;
          }
        }

        if (isFoxConvention(conventionId)) {
          const foxVid = tokenValue("VID");
          const foxMast = tokenValue("MAST");
          const foxType = tokenValue("TYPE");
          const foxDiv = tokenValue("DIV");
          const foxRend = tokenValue("REND");
          const foxTl = tokenValue("TL");
          const foxIar = tokenValue("IAR");
          const foxFps = tokenValue("FPS");

          const looksDwcVid = /^V\d{7,12}$/.test(foxVid);
          const looksDwcType = Boolean(lookupStrictTokenRule(ruleSet.index, "TYPE", foxMast))
            || /^(FP|MEZZ|MAIN|SUB|CAP)$/i.test(foxMast)
            || /^(FP|MEZZ|MAIN|SUB|CAP)$/i.test(foxType);
          const looksDwcConf = /^(DPO|CPO|D10|C10|DPRO|CPRO)$/i.test(foxType);
          const looksDwcSpec = /^(DOVI\d+|PXYC|IMSC|IMFD|HDR\d*|SDR)$/i.test(foxDiv);
          const looksDwcResRange = /^[A-Z0-9]{2,8}-[A-Z0-9]{2,8}$/.test(foxRend);
          const looksDwcFps = /^\d{2,3}(?:\.\d+)?$/.test(foxFps);
          const looksDwcLangIar = (/^[A-Z]{2,6}(?:-[A-Z0-9]{2,8})?$/.test(foxTl) && /^\d{3}$/.test(foxIar))
            || /^[A-Z]{2,6}-\d{3}$/.test(foxTl);

          const dwcSignatureCount = [looksDwcVid, looksDwcType, looksDwcConf, looksDwcSpec, looksDwcResRange, looksDwcFps, looksDwcLangIar]
            .filter(Boolean)
            .length;

          if (dwcSignatureCount >= 4) {
            hasWeakSignal = true;
            confidence = Math.min(confidence, 0.2);
            maskFitScore -= 20;
          }

          // Guard against cross-family drift: if raw values strongly match
          // WMLS value signatures, FOX should not win even when segment
          // positions are noisy.
          const rawPool = [];
          for (const token of tokenResults || []) {
            const raw = String((token && token.raw) || "").trim().toUpperCase();
            if (raw) {
              rawPool.push(raw);
            }
            const passthroughRaw = String((token && token.passthroughRaw) || "").trim().toUpperCase();
            if (passthroughRaw) {
              rawPool.push(passthroughRaw);
            }
          }

          const hasWmlsFileTypeSignature = rawPool.some((value) => {
            if (getWmlsFileTypeFormat(value)) {
              return true;
            }
            return /^(?:ACES|DPX|EXR|IMF|TIF|CNF|MP2)-[A-Z0-9#]+$/i.test(String(value || ""));
          });
          const hasWmlsCombinedFileInfoSignature = rawPool.some((value) => /^\d{3,4}[PI]\d{2}(?:NDF|DF)?$/i.test(String(value || "")));
          const hasWmlsAspectRatioSignature = rawPool.some((value) => /^\d{3}$/i.test(String(value || "")));
          const hasWmlsLanguagePairSignature = rawPool.some((value) => /^[A-Z]{2,6}(?:-[A-Z0-9]{2,8})?-[A-Z]{2,6}(?:-[A-Z0-9]{2,8})?$/i.test(String(value || "")));
          const hasWmlsTailSignature = rawPool.some((value) => {
            const stripped = String(value || "").replace(/\.[A-Z0-9]{2,8}$/i, "");
            return /^\d{6,10}$/.test(stripped);
          });
          const wmlsSignatureCount = [
            hasWmlsFileTypeSignature,
            hasWmlsCombinedFileInfoSignature,
            hasWmlsAspectRatioSignature,
            hasWmlsLanguagePairSignature,
            hasWmlsTailSignature
          ].filter(Boolean).length;

          if (wmlsSignatureCount >= 4
            && hasWmlsFileTypeSignature
            && hasWmlsCombinedFileInfoSignature
            && hasWmlsTailSignature) {
            hasWeakSignal = true;
            confidence = Math.min(confidence, 0.18);
            maskFitScore -= 24;
          }

          if (conventionId === "FOX") {
            const foxRawPool = [];
            for (const token of tokenResults || []) {
              const raw = String((token && token.raw) || "").trim().toUpperCase();
              if (raw) {
                foxRawPool.push(raw);
              }
            }
            const hasLegacyRuntimeTail = foxRawPool.some((value) => /(?:^|[_-])RT\d{6}(?:$|[_-])/i.test(value));
            const hasLegacyVideoFormat = foxRawPool.some((value) => /(XDCAM\d{3,4}[IP]?|PRORES(?:HQ|LT|4444)?|DNXHD|HDCAM|HDV|MPEG2|IMF|DPX|EXR)/i.test(value));
            if (hasLegacyRuntimeTail && hasLegacyVideoFormat) {
              confidence = Math.max(confidence, 0.45);
              maskFitScore += 16;
            }
          }
        }

        if (unresolvedUnknownCount > 0) {
          confidenceCeiling = Math.min(confidenceCeiling, 0.95);
        }

        const productTypeValues = tokenResults.filter((token) => token.tokenName === "PRODUCTTYPE" && token.raw);
        const productTypeKnown = productTypeValues.some((token) => token.known);
        const hasProductType = productTypeValues.length > 0;
        const hasProductTypeToken = Array.isArray(maskSpec && maskSpec.segments)
          && maskSpec.segments.some((segment) =>
            Array.isArray(segment.tokenNames)
            && segment.tokenNames.some((tokenName) => String(tokenName || "").toUpperCase() === "PRODUCTTYPE")
          );

        let roleAlignmentScore = 0;
        if (maskSpec.role === "FOLDER") {
          if (hasProductType && productTypeKnown) {
            roleAlignmentScore = 2;
          } else if (hasProductType && !productTypeKnown) {
            roleAlignmentScore = -1;
          } else {
            roleAlignmentScore = -2;
          }
        } else if (maskSpec.role === "FILE") {
          roleAlignmentScore = hasProductType ? -2 : 2;
        }

        const contentFit = computeContentFitScore();
        confidence = Math.min(1, Math.max(0, confidence + Math.max(-0.2, Math.min(0.2, contentFit.coverage * 0.25))));
        confidence = Math.min(confidence, confidenceCeiling);

        return {
          ruleSet,
          maskSpec,
          tokenResults,
          rawTokenResults: Array.isArray(rawTokenResults) ? rawTokenResults.map((token) => ({ ...token })) : [],
          populated,
          known,
          credited,
          confidence,
          unresolvedUnknownCount,
          hasWeakSignal,
          maskFitScore,
          familyPriorScore: familyPrior.maskFitDelta,
          maskAnchorSignalScore: maskAnchorSignal.maskFitDelta,
          foxMaskPreferenceScore,
          foxAudioAnchorScore,
          wmlsMaskPreferenceScore,
          contentFitScore: contentFit.score,
          contentFitCoverage: contentFit.coverage,
          productTypeSignal: hasProductTypeToken === hasProductType,
          maskMismatchWarnings: 0,
          roleAlignmentScore
        };
      }

      function rankCandidates(a, b) {
        if (Boolean(a.hasWeakSignal) !== Boolean(b.hasWeakSignal)) {
          return (Boolean(a.hasWeakSignal) ? 1 : 0) - (Boolean(b.hasWeakSignal) ? 1 : 0);
        }
        if ((a.familyPriorScore || 0) !== (b.familyPriorScore || 0)) {
          return (b.familyPriorScore || 0) - (a.familyPriorScore || 0);
        }
        if ((a.maskAnchorSignalScore || 0) !== (b.maskAnchorSignalScore || 0)) {
          return (b.maskAnchorSignalScore || 0) - (a.maskAnchorSignalScore || 0);
        }
        if ((a.contentFitScore || 0) !== (b.contentFitScore || 0)) {
          return (b.contentFitScore || 0) - (a.contentFitScore || 0);
        }
        if ((a.contentFitCoverage || 0) !== (b.contentFitCoverage || 0)) {
          return (b.contentFitCoverage || 0) - (a.contentFitCoverage || 0);
        }
        if ((a.foxAudioAnchorScore || 0) !== (b.foxAudioAnchorScore || 0)) {
          return (b.foxAudioAnchorScore || 0) - (a.foxAudioAnchorScore || 0);
        }
        if (a.known !== b.known) return b.known - a.known;
        if ((a.foxMaskPreferenceScore || 0) !== (b.foxMaskPreferenceScore || 0)) {
          return (b.foxMaskPreferenceScore || 0) - (a.foxMaskPreferenceScore || 0);
        }
        if ((a.wmlsMaskPreferenceScore || 0) !== (b.wmlsMaskPreferenceScore || 0)) {
          return (b.wmlsMaskPreferenceScore || 0) - (a.wmlsMaskPreferenceScore || 0);
        }
        if (a.roleAlignmentScore !== b.roleAlignmentScore) return b.roleAlignmentScore - a.roleAlignmentScore;
        if (a.populated !== b.populated) return b.populated - a.populated;
        if (Boolean(a.productTypeSignal) !== Boolean(b.productTypeSignal)) {
          return (Boolean(b.productTypeSignal) ? 1 : 0) - (Boolean(a.productTypeSignal) ? 1 : 0);
        }
        if (a.confidence !== b.confidence) return b.confidence - a.confidence;
        if (a.maskFitScore !== b.maskFitScore) return b.maskFitScore - a.maskFitScore;
        return (a.maskMismatchWarnings || 0) - (b.maskMismatchWarnings || 0);
      }

      function isReliableCandidate(candidate) {
        return Boolean(candidate)
          && Number(candidate.known) > 0
          && Number(candidate.confidence) > 0
          && !candidate.hasWeakSignal;
      }

      function buildFamilyPriorContext(filename, ruleSets) {
        const normalizedFilename = String(filename || "").trim().toUpperCase();
        const filenameTokens = normalizedFilename.split(/[_.-]+/).map((token) => token.trim()).filter(Boolean);
        const targetConventions = new Set(["DWC-MODERN", "WMLS", "FOX"]);
        const codeOwners = new Map();

        for (const ruleSet of (Array.isArray(ruleSets) ? ruleSets : [])) {
          const rulesDoc = ruleSet && ruleSet.rulesDoc;
          const conventionId = String((rulesDoc && rulesDoc.conventionId) || "").toUpperCase();
          if (!targetConventions.has(conventionId)) {
            continue;
          }
          for (const rule of (Array.isArray(rulesDoc && rulesDoc.rules) ? rulesDoc.rules : [])) {
            const code = String((rule && rule.token_pattern) || "").trim().toUpperCase();
            if (!code) {
              continue;
            }
            if (!codeOwners.has(code)) {
              codeOwners.set(code, new Set());
            }
            codeOwners.get(code).add(conventionId);
          }
        }

        const uniqueCodeByConvention = new Map();
        for (const conventionId of targetConventions) {
          uniqueCodeByConvention.set(conventionId, new Set());
        }
        for (const [code, owners] of codeOwners.entries()) {
          if (owners.size !== 1) {
            continue;
          }
          const [ownerConvention] = Array.from(owners);
          uniqueCodeByConvention.get(ownerConvention).add(code);
        }

        const uniqueHits = {};
        for (const conventionId of targetConventions) {
          uniqueHits[conventionId] = 0;
        }
        for (const token of filenameTokens) {
          for (const conventionId of targetConventions) {
            if (uniqueCodeByConvention.get(conventionId).has(token)) {
              uniqueHits[conventionId] += 1;
            }
          }
        }

        const hitEntries = Object.entries(uniqueHits).sort((a, b) => b[1] - a[1]);
        const bestConvention = hitEntries.length > 0 ? hitEntries[0][0] : "";
        const bestHits = hitEntries.length > 0 ? hitEntries[0][1] : 0;
        const secondHits = hitEntries.length > 1 ? hitEntries[1][1] : 0;
        const tied = hitEntries.filter((entry) => entry[1] === bestHits).length > 1;
        const margin = bestHits - secondHits;

        let strength = "none";
        if (bestHits >= 3 && margin >= 2 && !tied) {
          strength = "strong";
        } else if (bestHits >= 2 && margin >= 1 && !tied) {
          strength = "medium";
        } else if (bestHits >= 1 && margin >= 1 && !tied) {
          strength = "weak";
        }

        return {
          upperFilename: normalizedFilename,
          uniqueHits,
          bestConvention,
          bestHits,
          secondHits,
          margin,
          tied,
          strength,
          hasUsableSignal: strength !== "none"
        };
      }

      function computeFamilyPriorAdjustment(conventionId, familyPriorContext) {
        if (!familyPriorContext || !familyPriorContext.hasUsableSignal) {
          return { confidenceDelta: 0, maskFitDelta: 0 };
        }

        const targetConventions = new Set(["DWC-MODERN", "WMLS", "FOX"]);
        const bestConvention = String(familyPriorContext.bestConvention || "").toUpperCase();
        const strength = String(familyPriorContext.strength || "none");

        const positiveByStrength = {
          weak: { confidenceDelta: 0.05, maskFitDelta: 3 },
          medium: { confidenceDelta: 0.1, maskFitDelta: 5 },
          strong: { confidenceDelta: 0.15, maskFitDelta: 8 }
        };
        const negativeByStrength = {
          weak: { confidenceDelta: -0.03, maskFitDelta: -3 },
          medium: { confidenceDelta: -0.05, maskFitDelta: -5 },
          strong: { confidenceDelta: -0.08, maskFitDelta: -8 }
        };

        if (targetConventions.has(conventionId)) {
          if (conventionId === bestConvention) {
            return positiveByStrength[strength] || { confidenceDelta: 0, maskFitDelta: 0 };
          }
          return negativeByStrength[strength] || { confidenceDelta: 0, maskFitDelta: 0 };
        }

        if (strength === "medium" || strength === "strong") {
          return { confidenceDelta: -0.03, maskFitDelta: -4 };
        }

        return { confidenceDelta: 0, maskFitDelta: 0 };
      }

      function computeMaskAnchorAdjustment(maskSpec, familyPriorContext) {
        const anchors = maskSpec && maskSpec.detectionAnchors;
        const upperFilename = String((familyPriorContext && familyPriorContext.upperFilename) || "");
        if (!anchors || !upperFilename) {
          return { confidenceDelta: 0, maskFitDelta: 0 };
        }

        const positivePatterns = Array.isArray(anchors.positivePatterns) ? anchors.positivePatterns : [];
        const negativePatterns = Array.isArray(anchors.negativePatterns) ? anchors.negativePatterns : [];
        const positiveHits = positivePatterns.reduce((count, pattern) => {
          try {
            return count + (new RegExp(String(pattern || ""), "i").test(upperFilename) ? 1 : 0);
          } catch (error) {
            return count;
          }
        }, 0);
        const negativeHits = negativePatterns.reduce((count, pattern) => {
          try {
            return count + (new RegExp(String(pattern || ""), "i").test(upperFilename) ? 1 : 0);
          } catch (error) {
            return count;
          }
        }, 0);

        const weightedScore = (positiveHits * 2) - (negativeHits * 3) + ((Number(anchors.maskPriority) || 0) / 100);
        if (weightedScore >= 4) {
          return { confidenceDelta: 0.04, maskFitDelta: 6 };
        }
        if (weightedScore >= 2) {
          return { confidenceDelta: 0.02, maskFitDelta: 3 };
        }
        if (weightedScore <= -3) {
          return { confidenceDelta: -0.05, maskFitDelta: -6 };
        }
        if (weightedScore <= -1) {
          return { confidenceDelta: -0.02, maskFitDelta: -3 };
        }
        return { confidenceDelta: 0, maskFitDelta: 0 };
      }

      function pickBestRenderableCandidate(sortedCandidates, inputFilename = "") {
        if (!Array.isArray(sortedCandidates) || sortedCandidates.length === 0) {
          return null;
        }

        const upperFilename = String(inputFilename || "").toUpperCase();
        const looksLegacyFoxRuntimeVideo = /(?:^|[_-])RT\d{6}(?:$|[_-])/.test(upperFilename)
          && /(XDCAM\d{3,4}[IP]?|PRORES(?:HQ|LT|4444)?|DNXHD|HDCAM|HDV|MPEG2|IMF|DPX|EXR)/.test(upperFilename);

        const chooseBest = (candidates) => candidates.reduce((best, candidate) => {
          if (!best) {
            return candidate;
          }
          if (Number(candidate.confidence) !== Number(best.confidence)) {
            return Number(candidate.confidence) > Number(best.confidence) ? candidate : best;
          }
          if (Number(candidate.known) !== Number(best.known)) {
            return Number(candidate.known) > Number(best.known) ? candidate : best;
          }
          return rankCandidates(candidate, best) < 0 ? candidate : best;
        }, null);

        if (looksLegacyFoxRuntimeVideo) {
          const legacyFoxCandidates = sortedCandidates.filter((candidate) => {
            const conventionId = String((candidate && candidate.ruleSet && candidate.ruleSet.rulesDoc && candidate.ruleSet.rulesDoc.conventionId) || "").toUpperCase();
            return conventionId === "FOX"
              && Number(candidate.known) > 0
              && !candidate.hasWeakSignal;
          });
          if (legacyFoxCandidates.length > 0) {
            const legacyFoxV9Candidates = legacyFoxCandidates.filter((candidate) =>
              String((candidate && candidate.maskSpec && candidate.maskSpec.id) || "").toUpperCase().includes("V9")
            );
            if (legacyFoxV9Candidates.length > 0) {
              return chooseBest(legacyFoxV9Candidates);
            }
            return chooseBest(legacyFoxCandidates);
          }
        }

        const strongCandidates = sortedCandidates.filter((candidate) => {
          const thresholdRaw = Number(candidate && candidate.ruleSet && candidate.ruleSet.rulesDoc && candidate.ruleSet.rulesDoc.matchThreshold);
          const threshold = Number.isFinite(thresholdRaw) ? thresholdRaw : 0.35;
          return !candidate.hasWeakSignal
            && Number(candidate.known) > 0
            && Number(candidate.confidence) >= threshold;
        });

        if (strongCandidates.length > 0) {
          return chooseBest(strongCandidates);
        }

        const reliable = sortedCandidates.find((candidate) => isReliableCandidate(candidate));
        return reliable || sortedCandidates[0];
      }

      function extractDwcTitleEpisodeSuffix(rawTitle) {
        const value = String(rawTitle || "").trim();
        if (!value.includes("-")) {
          return "";
        }

        const parts = value.split("-").map((part) => part.trim()).filter(Boolean);
        if (parts.length < 2) {
          return "";
        }

        const tail = String(parts[parts.length - 1] || "").trim();
        if (!/^E\d{3,5}$/i.test(tail)) {
          return "";
        }

        return tail.toUpperCase();
      }

      function applyDwcTitleEpisodeMeaning(tokenResults, conventionId, confidence) {
        if (String(conventionId || "").toUpperCase() !== "DWC-MODERN" || Number(confidence) < 0.75) {
          return tokenResults;
        }

        return (tokenResults || []).map((token) => {
          if (String(token && token.tokenName || "").toUpperCase() !== "TITLE") {
            return token;
          }

          const rawTitle = String(token && token.raw || "").trim();
          if (!rawTitle) {
            return token;
          }

          const episodeCode = extractDwcTitleEpisodeSuffix(rawTitle);
          if (!episodeCode) {
            return token;
          }

          return {
            ...token,
            meaning: `Title: ${rawTitle} (source-provided); includes episode number ${episodeCode}`
          };
        });
      }

      function normalizeFoxAudioDisplayTokens(ruleSet, tokenResults) {
        const conventionId = String((ruleSet && ruleSet.rulesDoc && ruleSet.rulesDoc.conventionId) || "").toUpperCase();
        if (conventionId !== "FOX-AUDIO-SERVICES") {
          return Array.isArray(tokenResults) ? tokenResults : [];
        }

        const result = (Array.isArray(tokenResults) ? tokenResults : []).map((token) => ({ ...token }));
        const getByTokenName = (name) => result.find((token) => String(token.tokenName || "").toUpperCase() === String(name || "").toUpperCase());

        const wprToken = getByTokenName("WPR");
        const jobTypeToken = getByTokenName("JOBTYPE");
        const picCutToken = getByTokenName("PICCUT");
        const adtlInfoToken = getByTokenName("ADTLINFO");
        const langsndToken = getByTokenName("LANGSND");
        const trackConfigToken = getByTokenName("TRACKCONFIG");
        const standardToken = getByTokenName("STANDARD");
        const reelToken = getByTokenName("R");
        const techInfoToken = getByTokenName("TECHINFO");
        const versionToken = getByTokenName("VERSION");
        const suffixToken = getByTokenName("SUFFIX");

        if (!wprToken || !jobTypeToken || !picCutToken || !adtlInfoToken || !langsndToken || !trackConfigToken || !standardToken || !reelToken || !techInfoToken || !versionToken || !suffixToken) {
          return result;
        }

        const candidateTokenNames = new Set(["WPR", "JOBTYPE", "PICCUT", "ADTLINFO", "LANGSND", "TRACKCONFIG", "STANDARD", "R", "TECHINFO", "VERSION", "SUFFIX"]);
        const rawPool = result
          .filter((token) => candidateTokenNames.has(String(token.tokenName || "").toUpperCase()))
          .map((token) => String(token.raw || "").trim())
          .filter(Boolean);

        const isWprLike = (value) => /^\d{6}$/.test(String(value || "").trim());

        const assignment = {
          wpr: "",
          jobType: "",
          picCut: "",
          adtlInfo: "",
          langsnd: "",
          trackConfig: "",
          standard: "",
          reel: "",
          techInfo: "",
          version: "",
          suffix: ""
        };

        const originalLangsndRaw = String(langsndToken.raw || "").trim().toUpperCase();
        const originalPicCutRaw = String(picCutToken.raw || "").trim().toUpperCase();
        const originalAdtlInfoRaw = String(adtlInfoToken.raw || "").trim().toUpperCase();

        const consumed = new Set();
        let compositeConsumedFromPicCut = false;

        const originalWprRaw = String(wprToken.raw || "").trim().toUpperCase();
        if (isWprLike(originalWprRaw)) {
          assignment.wpr = originalWprRaw;
          consumed.add(originalWprRaw);
        }

        for (const raw of rawPool) {
          const upper = raw.toUpperCase();
          const composite = parseFoxLangsndTrackconfigStandardComposite(ruleSet, upper);
          if (composite) {
            assignment.langsnd = composite.langCode;
            assignment.trackConfig = composite.trackCode;
            assignment.standard = composite.standardRaw;
            consumed.add(upper);
            if (originalPicCutRaw && upper === originalPicCutRaw) {
              compositeConsumedFromPicCut = true;
            }
            break;
          }
        }

        for (const raw of rawPool) {
          const upper = raw.toUpperCase();
          if (consumed.has(upper)) {
            continue;
          }

          if (!assignment.wpr && isWprLike(upper)) {
            assignment.wpr = upper;
            consumed.add(upper);
            continue;
          }

          // Preserve explicit slot values that may already be split from composite
          // (e.g., LANGSND=ENG) so they are never reassigned to SUFFIX overflow.
          if (originalLangsndRaw && upper === originalLangsndRaw && (!assignment.langsnd || upper === assignment.langsnd)) {
            if (!assignment.langsnd) {
              assignment.langsnd = upper;
            }
            consumed.add(upper);
            continue;
          }

          // If composite already split, consume matching single-part fragments
          // so they do not leak into leftover overflow slots like SUFFIX.
          if (assignment.langsnd && upper === assignment.langsnd) {
            consumed.add(upper);
            continue;
          }
          if (assignment.trackConfig && upper === assignment.trackConfig) {
            consumed.add(upper);
            continue;
          }
          if (assignment.standard && upper === assignment.standard) {
            consumed.add(upper);
            continue;
          }

          if (!assignment.langsnd) {
            const langsndRule = lookupStrictTokenRule(ruleSet.index, "LANGSND", upper);
            if (langsndRule) {
              assignment.langsnd = upper;
              consumed.add(upper);
              continue;
            }
          }

          if (!assignment.trackConfig) {
            const trackConfigRule = lookupStrictTokenRule(ruleSet.index, "TRACKCONFIG", upper);
            if (trackConfigRule) {
              assignment.trackConfig = upper;
              consumed.add(upper);
              continue;
            }
          }

          if (!assignment.standard) {
            const standardRule = lookupStrictTokenRule(ruleSet.index, "STANDARD", upper);
            if (standardRule) {
              assignment.standard = upper;
              consumed.add(upper);
              continue;
            }
          }

          if (!assignment.jobType) {
            const jobTypeRule = lookupStrictTokenRule(ruleSet.index, "JOBTYPE", upper);
            if (jobTypeRule) {
              assignment.jobType = upper;
              consumed.add(upper);
              continue;
            }
          }

          if (!assignment.picCut) {
            const picCutRule = lookupStrictTokenRule(ruleSet.index, "PICCUT", upper);
            if (picCutRule) {
              assignment.picCut = upper;
              consumed.add(upper);
              continue;
            }
          }

          if (!assignment.adtlInfo) {
            const adtlInfoRule = lookupStrictTokenRule(ruleSet.index, "ADTLINFO", upper);
            if (adtlInfoRule) {
              assignment.adtlInfo = upper;
              consumed.add(upper);
              continue;
            }
          }

          if (!assignment.techInfo) {
            const techInfoRule = lookupStrictTokenRule(ruleSet.index, "TECHINFO", upper);
            if (techInfoRule || resolveFoxTechInfoCompositeMeaning(upper)) {
              assignment.techInfo = upper;
              consumed.add(upper);
              continue;
            }
          }

          if (!assignment.reel && (resolveReelMeaning(upper) || /^([1-9]\d?)OF([1-9]\d?)$/i.test(upper) || /^R\d{1,2}(?:-\d{1,2})?$/i.test(upper))) {
            assignment.reel = upper;
            consumed.add(upper);
            continue;
          }

          if (!assignment.version && resolveFoxTransferAssetMeaning(upper)) {
            assignment.version = upper;
            consumed.add(upper);
            continue;
          }

          if (!assignment.suffix) {
            const suffixRule = lookupStrictTokenRule(ruleSet.index, "SUFFIX", upper);
            const suffixCompositeMeaning = suffixRule ? null : resolveFoxSuffixCompositeMeaning(ruleSet, upper);
            if (suffixRule || suffixCompositeMeaning) {
              assignment.suffix = upper;
              consumed.add(upper);
              continue;
            }
          }
        }

        let passthroughUnknownTokens = [];

        if (!assignment.wpr) {
          assignment.wpr = originalWprRaw;
        }
        if (!assignment.jobType) {
          assignment.jobType = String(jobTypeToken.raw || "").trim().toUpperCase();
        }
        if (!assignment.picCut) {
          assignment.picCut = compositeConsumedFromPicCut
            ? ""
            : originalPicCutRaw;
        }
        if (!assignment.adtlInfo) {
          if (compositeConsumedFromPicCut) {
            const adtlRule = lookupStrictTokenRule(ruleSet.index, "ADTLINFO", originalAdtlInfoRaw);
            assignment.adtlInfo = adtlRule ? originalAdtlInfoRaw : "";
          } else {
            assignment.adtlInfo = originalAdtlInfoRaw;
          }
        }

        if (!assignment.langsnd) {
          assignment.langsnd = String(langsndToken.raw || "").trim().toUpperCase();
        }
        if (!assignment.trackConfig) {
          assignment.trackConfig = String(trackConfigToken.raw || "").trim().toUpperCase();
        }
        if (!assignment.standard) {
          assignment.standard = String(standardToken.raw || "").trim().toUpperCase();
        }
        if (!assignment.reel) {
          assignment.reel = String(reelToken.raw || "").trim().toUpperCase();
        }
        if (!assignment.techInfo) {
          assignment.techInfo = String(techInfoToken.raw || "").trim().toUpperCase();
        }
        if (!assignment.version) {
          assignment.version = String(versionToken.raw || "").trim().toUpperCase();
        }
        if (!assignment.suffix) {
          assignment.suffix = String(suffixToken.raw || "").trim().toUpperCase();
        }

        wprToken.raw = assignment.wpr;
        wprToken.displayTokenLabel = "WPR";
        if (assignment.wpr) {
          if (isWprLike(assignment.wpr)) {
            wprToken.known = true;
            wprToken.meaning = `WPR token interpreted as WPR fallback: ${assignment.wpr}`;
          } else {
            wprToken.known = false;
            wprToken.meaning = `WPR undefined value: ${assignment.wpr}.`;
          }
        }

        jobTypeToken.raw = assignment.jobType;
        jobTypeToken.displayTokenLabel = "JOBTYPE";
        if (assignment.jobType) {
          const jobTypeRule = lookupStrictTokenRule(ruleSet.index, "JOBTYPE", assignment.jobType);
          if (jobTypeRule) {
            jobTypeToken.known = true;
            jobTypeToken.meaning = applyRawEntryToMeaning(
              String(jobTypeRule.semantic_meaning || "").trim(),
              getRawEntryForRule(jobTypeRule, assignment.jobType)
            ) || `JOBTYPE: ${assignment.jobType}`;
          } else {
            jobTypeToken.known = false;
            jobTypeToken.meaning = `JOBTYPE undefined value: ${assignment.jobType}.`;
          }
        }

        picCutToken.raw = assignment.picCut;
        picCutToken.displayTokenLabel = "PICCUT";
        if (assignment.picCut) {
          const picCutRule = lookupStrictTokenRule(ruleSet.index, "PICCUT", assignment.picCut);
          if (picCutRule) {
            picCutToken.known = true;
            picCutToken.meaning = applyRawEntryToMeaning(
              String(picCutRule.semantic_meaning || "").trim(),
              getRawEntryForRule(picCutRule, assignment.picCut)
            ) || `PICCUT: ${assignment.picCut}`;
          } else {
            picCutToken.known = false;
            picCutToken.meaning = `PICCUT undefined value: ${assignment.picCut}.`;
          }
        } else {
          picCutToken.known = false;
          picCutToken.meaning = "Token not included";
        }

        adtlInfoToken.raw = assignment.adtlInfo;
        adtlInfoToken.displayTokenLabel = "ADTLINFO";
        if (assignment.adtlInfo) {
          const adtlInfoRule = lookupStrictTokenRule(ruleSet.index, "ADTLINFO", assignment.adtlInfo);
          if (adtlInfoRule) {
            adtlInfoToken.known = true;
            adtlInfoToken.meaning = applyRawEntryToMeaning(
              String(adtlInfoRule.semantic_meaning || "").trim(),
              getRawEntryForRule(adtlInfoRule, assignment.adtlInfo)
            ) || `ADTLINFO: ${assignment.adtlInfo}`;
          } else {
            const stackedAdtlInfo = parseFoxAdtlInfoStack(ruleSet.index, assignment.adtlInfo);
            if (stackedAdtlInfo && Array.isArray(stackedAdtlInfo.codes) && stackedAdtlInfo.codes.length > 1) {
              const meaningParts = stackedAdtlInfo.codes.map((code) => {
                const rule = lookupStrictTokenRule(ruleSet.index, "ADTLINFO", code);
                return rule ? `${code} (${String(rule.semantic_meaning || "").trim() || code})` : code;
              });
              adtlInfoToken.known = true;
              adtlInfoToken.meaning = `ADTLINFO stacked parsed: ${meaningParts.join("; ")}`;
            } else {
              adtlInfoToken.known = false;
              adtlInfoToken.meaning = `ADTLINFO undefined value: ${assignment.adtlInfo}.`;
            }
          }
        }

        langsndToken.raw = assignment.langsnd;
        langsndToken.displayTokenLabel = "LANGSND";
        if (assignment.langsnd) {
          const langRule = lookupStrictTokenRule(ruleSet.index, "LANGSND", assignment.langsnd);
          langsndToken.known = Boolean(langRule) || Boolean(assignment.langsnd);
          langsndToken.meaning = `LANG=${assignment.langsnd} (external language code reference)`;
        }

        trackConfigToken.raw = assignment.trackConfig;
        trackConfigToken.displayTokenLabel = "TRACKCONFIG";
        const trackRule = lookupStrictTokenRule(ruleSet.index, "TRACKCONFIG", assignment.trackConfig);
        if (trackRule) {
          trackConfigToken.known = true;
          trackConfigToken.meaning = applyRawEntryToMeaning(
            String(trackRule.semantic_meaning || "").trim(),
            getRawEntryForRule(trackRule, assignment.trackConfig)
          ) || `TRACKCONFIG: ${assignment.trackConfig}`;
        }

        standardToken.raw = assignment.standard;
        standardToken.displayTokenLabel = "STANDARD";
        const standardRule = lookupStrictTokenRule(ruleSet.index, "STANDARD", assignment.standard);
        if (standardRule) {
          standardToken.known = true;
          standardToken.meaning = applyRawEntryToMeaning(
            String(standardRule.semantic_meaning || "").trim(),
            getRawEntryForRule(standardRule, assignment.standard)
          ) || `STANDARD: ${assignment.standard}`;
        }

        reelToken.raw = assignment.reel;
        reelToken.displayTokenLabel = "R";
        const reelMeaning = resolveReelMeaning(reelToken.raw) || `Reel parts token: ${reelToken.raw}`;
        if (reelToken.raw) {
          reelToken.known = true;
          reelToken.meaning = reelMeaning;
        }

        techInfoToken.raw = assignment.techInfo;
        techInfoToken.displayTokenLabel = "TECHINFO";
        if (assignment.techInfo) {
          const techMeaning = resolveFoxTechInfoMeaning(ruleSet, assignment.techInfo);

          if (techMeaning) {
            techInfoToken.known = true;
            techInfoToken.meaning = techMeaning;
          } else {
            techInfoToken.known = false;
            techInfoToken.meaning = `TECHINFO undefined value: ${assignment.techInfo}.`;
          }
        }

        versionToken.raw = assignment.version;
        versionToken.displayTokenLabel = "VERSION";
        if (assignment.version) {
          const transferMeaning = resolveFoxTransferAssetMeaning(assignment.version);
          if (transferMeaning) {
            versionToken.known = true;
            versionToken.meaning = transferMeaning;
          }
        }

        suffixToken.raw = assignment.suffix;
        suffixToken.displayTokenLabel = "SUFFIX";
        if (assignment.suffix) {
          const suffixRule = lookupStrictTokenRule(ruleSet.index, "SUFFIX", assignment.suffix);
          if (suffixRule) {
            suffixToken.known = true;
            suffixToken.meaning = applyRawEntryToMeaning(
              String(suffixRule.semantic_meaning || "").trim(),
              getRawEntryForRule(suffixRule, assignment.suffix)
            ) || `SUFFIX: ${assignment.suffix}`;
          } else {
            const suffixCompositeMeaning = resolveFoxSuffixCompositeMeaning(ruleSet, assignment.suffix);
            if (suffixCompositeMeaning) {
              suffixToken.known = true;
              suffixToken.meaning = suffixCompositeMeaning;
            } else {
              suffixToken.known = false;
              suffixToken.meaning = `SUFFIX undefined value: ${assignment.suffix}.`;
            }
          }
        }

        const markConsumed = (value) => {
          const upper = String(value || "").trim().toUpperCase();
          if (upper) {
            consumed.add(upper);
          }
        };

        // Keep composite parts from reappearing as passthrough UNKNOWN rows.
        markConsumed(assignment.wpr);
        markConsumed(assignment.jobType);
        markConsumed(assignment.picCut);
        markConsumed(assignment.adtlInfo);
        markConsumed(assignment.langsnd);
        markConsumed(assignment.trackConfig);
        markConsumed(assignment.standard);
        markConsumed(assignment.reel);
        markConsumed(assignment.techInfo);
        markConsumed(assignment.version);
        markConsumed(assignment.suffix);

        for (const piece of String(assignment.standard || "").split("_")) {
          markConsumed(piece);
        }
        for (const piece of String(assignment.suffix || "").split("_")) {
          markConsumed(piece);
        }

        const leftovers = rawPool
          .map((raw) => raw.toUpperCase())
          .filter((raw) => !consumed.has(raw));

        passthroughUnknownTokens = leftovers.map((raw) => toPassthroughUnknownToken(raw));

        const filteredResult = result.filter((token) => {
          if (String(token && token.tokenName || "").toUpperCase() !== "UNKNOWN") {
            return true;
          }
          const passthroughRaw = String((token && token.passthroughRaw) || (token && token.raw) || "").trim().toUpperCase();
          return !passthroughRaw || !consumed.has(passthroughRaw);
        });

        return filteredResult.concat(passthroughUnknownTokens);
      }

      function normalizeWmlsDisplayTokens(ruleSet, tokenResults) {
        const conventionId = String((ruleSet && ruleSet.rulesDoc && ruleSet.rulesDoc.conventionId) || "").toUpperCase();
        if (!isWmlsConvention(conventionId)) {
          return Array.isArray(tokenResults) ? tokenResults : [];
        }

        const result = (Array.isArray(tokenResults) ? tokenResults : []).map((token) => ({ ...token }));
        const tokenNameKey = (token) => String((token && token.tokenName) || "").toUpperCase();
        const byName = (name) => result.find((token) => tokenNameKey(token) === String(name || "").toUpperCase());

        const poolTokenNames = new Set([
          "VERSION",
          "PRODUCTTYPE",
          "FILETYPE",
          "FILEINFO",
          "ASPECTRATIO",
          "AUD",
          "TXT",
          "WMLS##",
          "WMLS#",
          "WMLS#.EXT",
          "LANGUAGE",
          "FRAMERATE",
          "ELEMENTTYPE",
          "REEL#",
          "UNKNOWN",
          "EXTRA_SEGMENT"
        ]);
        const pool = result
          .map((token, index) => ({
            token,
            index,
            tokenName: tokenNameKey(token),
            raw: (() => {
              const tokenName = tokenNameKey(token);
              const rawValue = String(token.raw || "").trim();
              if (tokenName === "UNKNOWN" && (!rawValue || rawValue.toUpperCase() === "UNDEFINED")) {
                return String(token.passthroughRaw || "").trim();
              }
              return rawValue;
            })(),
            upper: (() => {
              const tokenName = tokenNameKey(token);
              const rawValue = String(token.raw || "").trim();
              const passthroughRaw = String(token.passthroughRaw || "").trim();
              const effective = tokenName === "UNKNOWN" && (!rawValue || rawValue.toUpperCase() === "UNDEFINED")
                ? passthroughRaw
                : rawValue;
              return String(effective || "").trim().toUpperCase();
            })()
          }))
          .filter((entry) => entry.raw && poolTokenNames.has(entry.tokenName));

        const consumed = new Set();
        const pickFirst = (predicate) => {
          const found = pool.find((entry) => !consumed.has(entry.index) && predicate(entry));
          if (found) {
            consumed.add(found.index);
          }
          return found;
        };

        const isLanguageCode = (value) => /^[A-Z]{2,6}(?:-[A-Z0-9]{2,8})?$/.test(String(value || "").toUpperCase());
        const isWmlsId = (value) => /^\d{6,10}$/.test(String(value || ""));
        const isFileInfoLike = (value) => {
          const raw = String(value || "").toUpperCase();
          if (!raw) return false;
          if (lookupStrictTokenRule(ruleSet.index, "FILEINFO", raw)) return true;
          if (resolveWmlsStackedFileInfo(ruleSet.index, "FILEINFO", raw)) return true;
          if (resolveWmlsPartialStackedRasterRate(ruleSet.index, "FILEINFO", raw)) return true;
          return /^\d{3,4}[PI]\d{2}(?:NDF|DF)?$/.test(raw);
        };

        const assignment = {
          version: "",
          productType: "",
          fileType: "",
          fileInfo: "",
          aspectRatio: "",
          aud: "",
          txt: "",
          wmlsId: ""
        };

        const versionEntry = pickFirst((entry) => Boolean(lookupStrictTokenRule(ruleSet.index, "VERSION", entry.upper)));
        if (versionEntry) assignment.version = versionEntry.upper;

        const productEntry = pickFirst((entry) => Boolean(lookupStrictTokenRule(ruleSet.index, "PRODUCTTYPE", entry.upper)));
        if (productEntry) assignment.productType = productEntry.upper;

        const fileTypeEntry = pickFirst((entry) => {
          if (lookupStrictTokenRule(ruleSet.index, "FILETYPE", entry.upper)) return true;
          const rawMeaning = getWmlsFileTypeMeaning(entry.upper, "");
          return Boolean(rawMeaning) && !/no semantic meaning/i.test(String(rawMeaning || ""));
        });
        if (fileTypeEntry) assignment.fileType = fileTypeEntry.upper;

        const fileInfoEntry = pickFirst((entry) => isFileInfoLike(entry.upper));
        if (fileInfoEntry) assignment.fileInfo = fileInfoEntry.upper;

        const aspectEntry = pickFirst((entry) => Boolean(lookupStrictTokenRule(ruleSet.index, "ASPECTRATIO", entry.upper)));
        if (aspectEntry) assignment.aspectRatio = aspectEntry.upper;

        const isLikelyVersionPair = (value) => {
          const upper = String(value || "").toUpperCase();
          if (!upper.includes("-")) {
            return false;
          }
          if (lookupStrictTokenRule(ruleSet.index, "VERSION", upper)) {
            return true;
          }
          const versionPair = resolveWmlsPartialVersion(ruleSet.index, "VERSION", upper);
          return Boolean(versionPair);
        };

        const audTxtCombined = pickFirst((entry) => {
          if (!/^([A-Z]{2,6}(?:-[A-Z0-9]{2,8})?)-([A-Z]{2,6}(?:-[A-Z0-9]{2,8})?)$/.test(entry.upper)) {
            return false;
          }

          const segmentPosition = Number(entry && entry.token && entry.token.segmentPosition);
          const tokenName = String(entry && entry.tokenName || "").toUpperCase();
          const isAudTxtSegment = Number.isFinite(segmentPosition) && segmentPosition === 7;
          const isTailExtra = tokenName === "WMLS##" || tokenName === "EXTRA_SEGMENT";
          if (!isAudTxtSegment && !isTailExtra) {
            return false;
          }

          // Avoid stealing VERSION-like pairs (for example TH-HDR) as AUD-TXT.
          if (isLikelyVersionPair(entry.upper)) {
            return false;
          }

          return true;
        });
        if (audTxtCombined) {
          const combinedMatch = audTxtCombined.upper.match(/^([A-Z]{2,6}(?:-[A-Z0-9]{2,8})?)-([A-Z]{2,6}(?:-[A-Z0-9]{2,8})?)$/);
          if (combinedMatch) {
            assignment.aud = combinedMatch[1];
            assignment.txt = combinedMatch[2];
          }
        }

        if (!assignment.aud) {
          const audEntry = pickFirst((entry) => isLanguageCode(entry.upper));
          if (audEntry) assignment.aud = audEntry.upper;
        }
        if (!assignment.txt) {
          const txtEntry = pickFirst((entry) => isLanguageCode(entry.upper));
          if (txtEntry) assignment.txt = txtEntry.upper;
        }

        const wmlsIdEntry = pickFirst((entry) => isWmlsId(entry.upper));
        if (wmlsIdEntry) assignment.wmlsId = wmlsIdEntry.upper;

        const fallbackFromSlot = (slotName) => {
          const slotToken = byName(slotName);
          return String((slotToken && slotToken.raw) || "").trim().toUpperCase();
        };
        if (!assignment.version) assignment.version = fallbackFromSlot("VERSION");
        if (!assignment.productType) assignment.productType = fallbackFromSlot("PRODUCTTYPE");
        if (!assignment.fileType) assignment.fileType = fallbackFromSlot("FILETYPE");
        if (!assignment.fileInfo) assignment.fileInfo = fallbackFromSlot("FILEINFO");
        if (!assignment.aspectRatio) assignment.aspectRatio = fallbackFromSlot("ASPECTRATIO");
        if (!assignment.aud) assignment.aud = fallbackFromSlot("AUD");
        if (!assignment.txt) assignment.txt = fallbackFromSlot("TXT");
        if (!assignment.wmlsId) {
          const slotTail = fallbackFromSlot("WMLS##") || fallbackFromSlot("WMLS#");
          assignment.wmlsId = isWmlsId(slotTail) ? slotTail : "";
        }

        const bySegmentPosition = (segmentPosition) => {
          const pos = Number(segmentPosition);
          const found = pool.find((entry) => Number(entry && entry.token && entry.token.segmentPosition) === pos && entry.upper);
          return found ? found.upper : "";
        };

        // Positional fallback for WMLS file-style names when mask selection drifts.
        const segment3 = bySegmentPosition(3);
        const segment4 = bySegmentPosition(4);
        const segment5 = bySegmentPosition(5);
        const segment6 = bySegmentPosition(6);
        const segment7 = bySegmentPosition(7);

        if (!assignment.fileType && segment3 && !isFileInfoLike(segment3) && !isWmlsId(segment3)) {
          assignment.fileType = segment3;
        }
        if (!assignment.fileInfo && segment4 && isFileInfoLike(segment4)) {
          assignment.fileInfo = segment4;
        }
        if (!assignment.aspectRatio && segment5 && /^\d{3}$/.test(segment5)) {
          assignment.aspectRatio = segment5;
        }
        if ((!assignment.aud || !assignment.txt) && segment6) {
          const pair = segment6.match(/^([A-Z]{2,6}(?:-[A-Z0-9]{2,8})?)-([A-Z]{2,6}(?:-[A-Z0-9]{2,8})?)$/);
          if (pair) {
            if (!assignment.aud) assignment.aud = pair[1];
            if (!assignment.txt) assignment.txt = pair[2];
          }
        }
        if (!assignment.wmlsId && segment7 && isWmlsId(segment7)) {
          assignment.wmlsId = segment7;
        }

        const ensureToken = (name, segmentPosition, segmentMask) => {
          const upper = String(name || "").toUpperCase();
          let token = result.find((entry) => tokenNameKey(entry) === upper);
          if (!token && upper === "WMLS##") {
            token = result.find((entry) => tokenNameKey(entry) === "WMLS#");
          }
          if (!token) {
            token = {
              tokenName: upper,
              displayTokenLabel: upper,
              raw: "",
              segmentMask: segmentMask || upper,
              segmentPosition,
              known: false,
              informational: false,
              meaning: "Token not included"
            };
            result.push(token);
          }
          token.tokenName = upper;
          token.displayTokenLabel = upper;
          token.segmentPosition = segmentPosition;
          token.segmentMask = segmentMask || upper;
          return token;
        };

        const versionToken = ensureToken("VERSION", 2, "Version");
        const productToken = ensureToken("PRODUCTTYPE", 3, "ProductType");
        const fileTypeToken = ensureToken("FILETYPE", 4, "FileType");
        const fileInfoToken = ensureToken("FILEINFO", 5, "FileInfo");
        const aspectToken = ensureToken("ASPECTRATIO", 6, "AspectRatio");
        const audToken = ensureToken("AUD", 7, "AUD-TXT");
        const txtToken = ensureToken("TXT", 7, "AUD-TXT");
        const wmlsToken = ensureToken("WMLS##", 8, "WMLS##");

        const applyExactRuleToken = (token, tokenName, raw) => {
          token.raw = String(raw || "").toUpperCase();
          if (!token.raw) {
            token.known = false;
            token.informational = false;
            token.meaning = "Token not included";
            return;
          }

          const rule = lookupStrictTokenRule(ruleSet.index, tokenName, token.raw);
          if (rule) {
            token.known = true;
            token.informational = false;
            token.meaning = applyRawEntryToMeaning(
              String(rule.semantic_meaning || "").trim(),
              getRawEntryForRule(rule, token.raw)
            ) || `${tokenName}: ${token.raw}`;
          } else {
            token.known = false;
            token.informational = false;
            token.meaning = `${tokenName} undefined value: ${token.raw}.`;
          }
        };

        applyExactRuleToken(versionToken, "VERSION", assignment.version);
        if (!versionToken.known && versionToken.raw) {
          const partialVersionMeaning = resolveWmlsPartialVersion(ruleSet.index, "VERSION", versionToken.raw);
          if (partialVersionMeaning) {
            versionToken.known = Boolean(partialVersionMeaning.known);
            versionToken.informational = false;
            versionToken.meaning = partialVersionMeaning.meaning;
            if (Number.isFinite(partialVersionMeaning.credit)) {
              versionToken.confidenceCredit = Math.max(0, Math.min(1, Number(partialVersionMeaning.credit)));
            }
          }
        }
        applyExactRuleToken(productToken, "PRODUCTTYPE", assignment.productType);
        applyExactRuleToken(fileTypeToken, "FILETYPE", assignment.fileType);
        if (!fileTypeToken.known && fileTypeToken.raw) {
          const mappedMeaning = getWmlsFileTypeMeaning(fileTypeToken.raw, "");
          if (mappedMeaning && !/no semantic meaning/i.test(String(mappedMeaning || ""))) {
            fileTypeToken.known = true;
            fileTypeToken.informational = false;
            fileTypeToken.confidenceCredit = 1;
            fileTypeToken.meaning = mappedMeaning;
          } else {
            const partialFileTypeMeaning = resolveWmlsPartialFileType(ruleSet.index, "FILETYPE", fileTypeToken.raw);
            if (partialFileTypeMeaning) {
              fileTypeToken.known = Boolean(partialFileTypeMeaning.known);
              fileTypeToken.informational = false;
              fileTypeToken.meaning = partialFileTypeMeaning.meaning;
              if (Number.isFinite(partialFileTypeMeaning.credit)) {
                fileTypeToken.confidenceCredit = Math.max(0, Math.min(1, Number(partialFileTypeMeaning.credit)));
              }
            }
          }
        }

        fileInfoToken.raw = String(assignment.fileInfo || "").toUpperCase();
        if (!fileInfoToken.raw) {
          fileInfoToken.known = false;
          fileInfoToken.informational = false;
          fileInfoToken.meaning = "Token not included";
        } else {
          const fileInfoRule = lookupStrictTokenRule(ruleSet.index, "FILEINFO", fileInfoToken.raw);
          const stackedMeaning = resolveWmlsStackedFileInfo(ruleSet.index, "FILEINFO", fileInfoToken.raw);
          const partialMeaning = resolveWmlsPartialStackedRasterRate(ruleSet.index, "FILEINFO", fileInfoToken.raw);
          const mapMeaning = getWmlsFileInfoMeaning(fileInfoToken.raw, "");
          if (fileInfoRule) {
            fileInfoToken.known = true;
            fileInfoToken.informational = false;
            const directMeaning = applyRawEntryToMeaning(
              String(fileInfoRule.semantic_meaning || "").trim(),
              getRawEntryForRule(fileInfoRule, fileInfoToken.raw)
            ) || `FILEINFO: ${fileInfoToken.raw}`;
            const placeholderMeaning = isSingleComponentWmlsFileInfo(fileInfoToken.raw)
              ? describeWmlsFileInfoComponents(fileInfoToken.raw)
              : "";
            fileInfoToken.meaning = placeholderMeaning || directMeaning;
          } else if (stackedMeaning) {
            fileInfoToken.known = true;
            fileInfoToken.informational = false;
            fileInfoToken.meaning = stackedMeaning.meaning;
          } else if (partialMeaning) {
            fileInfoToken.known = Boolean(partialMeaning.known);
            fileInfoToken.informational = false;
            fileInfoToken.meaning = partialMeaning.meaning;
            if (Number.isFinite(partialMeaning.credit)) {
              fileInfoToken.confidenceCredit = Math.max(0, Math.min(1, Number(partialMeaning.credit)));
            }
          } else if (mapMeaning && !/no semantic meaning/i.test(String(mapMeaning || ""))) {
            fileInfoToken.known = true;
            fileInfoToken.informational = false;
            const placeholderMeaning = isSingleComponentWmlsFileInfo(fileInfoToken.raw)
              ? describeWmlsFileInfoComponents(fileInfoToken.raw)
              : "";
            fileInfoToken.meaning = placeholderMeaning || mapMeaning;
          } else {
            const placeholderMeaning = describeWmlsFileInfoComponents(fileInfoToken.raw);
            fileInfoToken.known = false;
            fileInfoToken.informational = false;
            fileInfoToken.meaning = placeholderMeaning || `FILEINFO undefined value: ${fileInfoToken.raw}.`;
          }
        }

        applyExactRuleToken(aspectToken, "ASPECTRATIO", assignment.aspectRatio);

        audToken.raw = String(assignment.aud || "").toUpperCase();
        if (audToken.raw && isLanguageCode(audToken.raw)) {
          audToken.known = true;
          audToken.informational = true;
          audToken.meaning = `AUD language code routed to external language decoder report: ${audToken.raw}`;
        } else {
          audToken.known = false;
          audToken.informational = false;
          audToken.meaning = audToken.raw ? `AUD undefined value: ${audToken.raw}.` : "Token not included";
        }

        txtToken.raw = String(assignment.txt || "").toUpperCase();
        if (txtToken.raw && isLanguageCode(txtToken.raw)) {
          txtToken.known = true;
          txtToken.informational = true;
          txtToken.meaning = `TXT language code routed to external language decoder report: ${txtToken.raw}`;
        } else {
          txtToken.known = false;
          txtToken.informational = false;
          txtToken.meaning = txtToken.raw ? `TXT undefined value: ${txtToken.raw}.` : "Token not included";
        }

        wmlsToken.raw = String(assignment.wmlsId || "").toUpperCase();
        if (wmlsToken.raw && isWmlsId(wmlsToken.raw)) {
          wmlsToken.known = true;
          wmlsToken.informational = true;
          wmlsToken.meaning = `WMLS ID number: ${wmlsToken.raw.replace(/\.[^.]+$/, "")}`;
        } else {
          wmlsToken.known = false;
          wmlsToken.informational = false;
          wmlsToken.meaning = wmlsToken.raw ? `WMLS## undefined value: ${wmlsToken.raw}.` : "Token not included";
        }

        const consumedRaw = new Set(
          [
            assignment.version,
            assignment.productType,
            assignment.fileType,
            assignment.fileInfo,
            assignment.aspectRatio,
            assignment.aud,
            assignment.txt,
            assignment.wmlsId,
            (assignment.aud && assignment.txt) ? `${assignment.aud}-${assignment.txt}` : ""
          ]
            .map((value) => String(value || "").toUpperCase())
            .filter(Boolean)
        );

        const passthroughUnknownTokens = pool
          .map((entry) => entry.upper)
          .filter((raw) => !consumedRaw.has(raw))
          .map((raw) => toPassthroughUnknownToken(raw));

        return mergePassthroughUnknownTokens(result, tokenNameKey, passthroughUnknownTokens, true);
      }

      function normalizeDwcDisplayTokens(ruleSet, tokenResults) {
        const conventionId = String((ruleSet && ruleSet.rulesDoc && ruleSet.rulesDoc.conventionId) || "").toUpperCase();
        if (conventionId !== "DWC-MODERN") {
          return Array.isArray(tokenResults) ? tokenResults : [];
        }

        const result = (Array.isArray(tokenResults) ? tokenResults : []).map((token) => ({ ...token }));
        const tokenNameKey = (token) => String((token && token.tokenName) || "").toUpperCase();
        const byName = (name) => result.find((token) => tokenNameKey(token) === String(name || "").toUpperCase());
        const byNameAndSegment = (name, segmentPosition) => result.find((token) => tokenNameKey(token) === String(name || "").toUpperCase() && Number(token.segmentPosition) === Number(segmentPosition));

        const poolTokenNames = new Set(["CLASS", "WIP", "VID", "TYPE", "CONF", "SPEC", "RES", "RANGE", "FPS", "TEXL", "IAR", "AUDL", "TF", "TTL", "REC", "EXTRA_SEGMENT"]);
        const pool = result
          .map((token, index) => ({
            token,
            index,
            tokenName: tokenNameKey(token),
            raw: String(token.raw || "").trim(),
            upper: String(token.raw || "").trim().toUpperCase()
          }))
          .filter((entry) => entry.raw && poolTokenNames.has(entry.tokenName));

        const consumed = new Set();
        const pickFirst = (predicate) => {
          const found = pool.find((entry) => !consumed.has(entry.index) && predicate(entry));
          if (found) {
            consumed.add(found.index);
          }
          return found;
        };

        const isLanguageCode = (value) => /^[A-Z]{2,6}(?:-[A-Z0-9]{2,8})?$/.test(String(value || "").toUpperCase());
        const isDwcLanguageCode = (value) => /^[A-Z]{2,3}(?:-[A-Z0-9]{2,8})?$/.test(String(value || "").toUpperCase());
        const isVid = (value) => /^V\d{7,12}$/i.test(String(value || ""));
        const hasAnyRulesForToken = (tokenName) => {
          const upper = String(tokenName || "").toUpperCase();
          const rules = Array.isArray(ruleSet && ruleSet.rulesDoc && ruleSet.rulesDoc.rules) ? ruleSet.rulesDoc.rules : [];
          return rules.some((rule) => String(rule && rule.token_name || "").toUpperCase() === upper);
        };
        const segmentValues = (segmentPosition) => result
          .filter((token) => Number(token && token.segmentPosition) === Number(segmentPosition))
          .map((token) => String(token && token.raw || "").trim().toUpperCase())
          .filter(Boolean);

        const assignment = {
          classCode: "",
          wipCode: "",
          vid: "",
          typeMain: "",
          conf: "",
          spec: "",
          res: "",
          range: "",
          fps: "",
          texl: "",
          iar: "",
          audl: "",
          tf: "",
          ttl: "",
          typeTail: "",
          rec: ""
        };
        let mappedSegment10AsTtlType = false;

        const resHasRules = hasAnyRulesForToken("RES");
        const segment7Values = segmentValues(7);
        const segment9Values = segmentValues(9);
        const segment10Values = segmentValues(10);
        const segment11Values = segmentValues(11);
        const segment10HasTfLike = segment10Values.some((value) =>
          Boolean(lookupStrictTokenRule(ruleSet.index, "TF", value)) || /^\d{2,5}$/.test(value)
        );
        const allowAudlTfFromSegment10 = segment10HasTfLike;

        if (resHasRules) {
          assignment.res = segment7Values.find((value) => Boolean(lookupStrictTokenRule(ruleSet.index, "RES", value))) || "";
        } else if (segment7Values.length >= 2) {
          assignment.res = segment7Values[0];
        }
        if (segment7Values.length >= 2) {
          assignment.range = segment7Values.slice(1).find((value) => Boolean(lookupStrictTokenRule(ruleSet.index, "RANGE", value))) || segment7Values[1];
        } else {
          assignment.range = segment7Values.find((value) => Boolean(lookupStrictTokenRule(ruleSet.index, "RANGE", value))) || "";
        }
        assignment.texl = segment9Values.find((value) => isDwcLanguageCode(value)) || "";
        assignment.iar = segment9Values.find((value) => {
          if (Boolean(lookupStrictTokenRule(ruleSet.index, "IAR", value)) || /^\d{3}$/.test(value)) {
            return true;
          }
          return Boolean(resolveDwcIarCompositeMeaning(ruleSet, value));
        }) || "";
        assignment.audl = allowAudlTfFromSegment10
          ? (segment10Values.find((value) => isDwcLanguageCode(value)) || "")
          : "";
        assignment.tf = allowAudlTfFromSegment10
          ? (segment10Values.find((value) => Boolean(lookupStrictTokenRule(ruleSet.index, "TF", value)) || /^\d{2,5}$/.test(value)) || "")
          : "";
        assignment.ttl = segment11Values.find((value) => isDwcLanguageCode(value)) || "";
        assignment.typeTail = segment11Values.find((value) => Boolean(lookupStrictTokenRule(ruleSet.index, "TYPE", value))) || "";

        const pairPattern = /^([A-Z0-9]{2,8})-([A-Z0-9]{2,8})$/;
        const looksTemplateType = (value) => /^TMPL[A-Z0-9]*$/.test(String(value || "").toUpperCase());
        const isIarLikeValue = (value) => {
          const upper = String(value || "").toUpperCase();
          if (!upper) {
            return false;
          }
          if (Boolean(lookupStrictTokenRule(ruleSet.index, "IAR", upper)) || /^\d{3}$/.test(upper)) {
            return true;
          }
          return Boolean(resolveDwcIarCompositeMeaning(ruleSet, upper));
        };
        const subtitleTypeCodes = new Set(["FULL", "CC", "SDH", "FRCD", "BURN", "TMPLFL", "TMPLFR"]);
        const pairEntries = pool
          .filter((entry) => pairPattern.test(entry.upper))
          .map((entry) => {
            const match = entry.upper.match(pairPattern);
            return {
              entry,
              left: match ? match[1] : "",
              right: match ? match[2] : ""
            };
          });

        for (const pair of pairEntries) {
          if (consumed.has(pair.entry.index)) {
            continue;
          }
          if (assignment.res && assignment.range) {
            break;
          }
          const leftIsRes = resHasRules && Boolean(lookupStrictTokenRule(ruleSet.index, "RES", pair.left));
          const rightIsRes = resHasRules && Boolean(lookupStrictTokenRule(ruleSet.index, "RES", pair.right));
          const leftIsRange = Boolean(lookupStrictTokenRule(ruleSet.index, "RANGE", pair.left));
          const rightIsRange = Boolean(lookupStrictTokenRule(ruleSet.index, "RANGE", pair.right));
          if ((leftIsRes && rightIsRange) || (rightIsRes && leftIsRange) || (!resHasRules && (leftIsRange || rightIsRange))) {
            if (!assignment.res) assignment.res = leftIsRes ? pair.left : (rightIsRes ? pair.right : pair.left);
            if (!assignment.range) assignment.range = rightIsRange ? pair.right : (leftIsRange ? pair.left : pair.right);
            consumed.add(pair.entry.index);
          }
        }

        for (const pair of pairEntries) {
          if (consumed.has(pair.entry.index) || (assignment.texl && assignment.iar)) {
            continue;
          }
          if (isDwcLanguageCode(pair.left) && isIarLikeValue(pair.right)) {
            if (!assignment.texl) assignment.texl = pair.left;
            if (!assignment.iar) assignment.iar = pair.right;
            consumed.add(pair.entry.index);
          }
        }

        for (const pair of pairEntries) {
          if (!allowAudlTfFromSegment10) {
            break;
          }
          if (consumed.has(pair.entry.index) || (assignment.audl && assignment.tf)) {
            continue;
          }
          const rightLooksTf = Boolean(lookupStrictTokenRule(ruleSet.index, "TF", pair.right)) || /^\d{2,5}$/.test(pair.right);
          if (isDwcLanguageCode(pair.left) && rightLooksTf) {
            if (!assignment.audl || (assignment.texl && assignment.audl === assignment.texl)) assignment.audl = pair.left;
            if (!assignment.tf) assignment.tf = pair.right;
            consumed.add(pair.entry.index);
          }
        }

        const classEntry = pickFirst((entry) => Boolean(lookupStrictTokenRule(ruleSet.index, "CLASS", entry.upper)));
        if (classEntry) assignment.classCode = classEntry.upper;

        const wipEntry = pickFirst((entry) => Boolean(lookupStrictTokenRule(ruleSet.index, "WIP", entry.upper)));
        if (wipEntry) assignment.wipCode = wipEntry.upper;

        const vidEntry = pickFirst((entry) => isVid(entry.upper));
        if (vidEntry) assignment.vid = vidEntry.upper;

        const typeMainEntry = pickFirst((entry) => Boolean(lookupStrictTokenRule(ruleSet.index, "TYPE", entry.upper)));
        if (typeMainEntry) assignment.typeMain = typeMainEntry.upper;

        const confEntry = pickFirst((entry) => Boolean(lookupStrictTokenRule(ruleSet.index, "CONF", entry.upper)));
        if (confEntry) assignment.conf = confEntry.upper;

        const specEntry = pickFirst((entry) => Boolean(lookupStrictTokenRule(ruleSet.index, "SPEC", entry.upper)) || Boolean(resolveDwcSpecCompound(ruleSet, "SPEC", entry.upper)));
        if (specEntry) assignment.spec = specEntry.upper;

        if (resHasRules && !assignment.res) {
          const resEntry = pickFirst((entry) => Boolean(lookupStrictTokenRule(ruleSet.index, "RES", entry.upper)));
          if (resEntry) assignment.res = resEntry.upper;
        }
        if (!assignment.range) {
          const rangeEntry = pickFirst((entry) => Boolean(lookupStrictTokenRule(ruleSet.index, "RANGE", entry.upper)));
          if (rangeEntry) assignment.range = rangeEntry.upper;
        }

        const fpsEntry = pickFirst((entry) => Boolean(lookupStrictTokenRule(ruleSet.index, "FPS", entry.upper)) || /^\d{2,3}(?:\.\d+)?$/.test(entry.upper));
        if (fpsEntry) assignment.fps = fpsEntry.upper;

        if (!assignment.texl) {
          const texlEntry = pickFirst((entry) => isDwcLanguageCode(entry.upper));
          if (texlEntry) assignment.texl = texlEntry.upper;
        }
        if (!assignment.iar) {
          const iarEntry = pickFirst((entry) => isIarLikeValue(entry.upper));
          if (iarEntry) assignment.iar = iarEntry.upper;
        }

        if (!assignment.audl && allowAudlTfFromSegment10) {
          const audlEntry = pickFirst((entry) => isDwcLanguageCode(entry.upper));
          if (audlEntry) assignment.audl = audlEntry.upper;
        }
        if (!assignment.tf && allowAudlTfFromSegment10) {
          const tfEntry = pickFirst((entry) => Boolean(lookupStrictTokenRule(ruleSet.index, "TF", entry.upper)));
          if (tfEntry) assignment.tf = tfEntry.upper;
        }

        if (segment11Values.length === 0) {
          const ttlTypeBridge = pairEntries.find((pair) => {
            if (consumed.has(pair.entry.index)) {
              return false;
            }
            const leftIsLang = isDwcLanguageCode(pair.left);
            const rightIsType = Boolean(lookupStrictTokenRule(ruleSet.index, "TYPE", pair.right));
            const rightIsTf = Boolean(lookupStrictTokenRule(ruleSet.index, "TF", pair.right));
            return leftIsLang && rightIsType && !rightIsTf;
          });

          if (ttlTypeBridge) {
            if (!assignment.ttl) assignment.ttl = ttlTypeBridge.left;
            if (!assignment.typeTail) assignment.typeTail = ttlTypeBridge.right;
            if (!assignment.audl || assignment.audl === ttlTypeBridge.left) assignment.audl = "";
            if (!assignment.tf || assignment.tf === ttlTypeBridge.right) assignment.tf = "";
            consumed.add(ttlTypeBridge.entry.index);
            mappedSegment10AsTtlType = true;
          } else {
            const ttlTemplateBridge = pairEntries.find((pair) => {
              if (consumed.has(pair.entry.index)) {
                return false;
              }
              const leftIsLang = isDwcLanguageCode(pair.left);
              const rightLooksTemplate = looksTemplateType(pair.right);
              const rightIsTf = Boolean(lookupStrictTokenRule(ruleSet.index, "TF", pair.right));
              return leftIsLang && rightLooksTemplate && !rightIsTf;
            });

            if (ttlTemplateBridge) {
              if (!assignment.ttl) assignment.ttl = ttlTemplateBridge.left;
              if (!assignment.typeTail) assignment.typeTail = ttlTemplateBridge.right;
              if (!assignment.audl || assignment.audl === ttlTemplateBridge.left) assignment.audl = "";
              if (!assignment.tf || assignment.tf === ttlTemplateBridge.right) assignment.tf = "";
              consumed.add(ttlTemplateBridge.entry.index);
              mappedSegment10AsTtlType = true;
            }
          }
        }

        if (segment11Values.length > 0 || mappedSegment10AsTtlType) {
          const ttlEntry = pickFirst((entry) => isDwcLanguageCode(entry.upper));
          if (!assignment.ttl && ttlEntry) assignment.ttl = ttlEntry.upper;
        }

        const typeTailEntry = pickFirst((entry) => Boolean(lookupStrictTokenRule(ruleSet.index, "TYPE", entry.upper)) || looksTemplateType(entry.upper));
        if (!assignment.typeTail && typeTailEntry) assignment.typeTail = typeTailEntry.upper;

        if (!mappedSegment10AsTtlType && segment11Values.length === 0) {
          const tailLooksTemplate = Boolean(assignment.typeTail) && looksTemplateType(assignment.typeTail);
          const tailLooksSubtitleType = Boolean(assignment.typeTail) && subtitleTypeCodes.has(String(assignment.typeTail || "").toUpperCase());
          const tailLooksSubtitleLike = tailLooksTemplate || tailLooksSubtitleType;
          const hasTailType = Boolean(assignment.typeTail)
            && (Boolean(lookupStrictTokenRule(ruleSet.index, "TYPE", assignment.typeTail)) || tailLooksTemplate);
          const tailTypeIsTf = Boolean(assignment.typeTail) && Boolean(lookupStrictTokenRule(ruleSet.index, "TF", assignment.typeTail));
          const canPromoteAudlToTtl = Boolean(assignment.audl)
            && isDwcLanguageCode(assignment.audl)
            && (assignment.audl !== assignment.texl || tailLooksTemplate)
            && (!assignment.tf || assignment.tf === assignment.typeTail)
            && hasTailType
            && tailLooksSubtitleLike
            && !tailTypeIsTf;
          if (canPromoteAudlToTtl) {
            assignment.ttl = assignment.audl;
            assignment.audl = "";
            assignment.tf = "";
            mappedSegment10AsTtlType = true;
          }
        }

        if (!assignment.rec) {
          const recCandidates = pool
            .filter((entry) => !consumed.has(entry.index) && /^[A-Z0-9]{6,}(?:\.[A-Z0-9]{2,8})?$/.test(entry.upper))
            .map((entry) => {
              const value = String(entry.upper || "");
              const rawOriginal = String(entry.raw || "");
              const segmentPosition = Number(entry.token && entry.token.segmentPosition);
              let score = 0;
              if (!value.includes("-")) score += 3;
              if (/^[A-Z0-9]{8,}$/.test(value)) score += 2;
              if (/^[A-Z0-9]{10,}$/.test(value)) score += 3;
              if (/^[A-Z]{10,}$/.test(value)) score += 3;
              if (/[A-Z]/.test(value) && /\d/.test(value)) score += 1;
              if (isLanguageCode(value)) score -= 3;
              if (/^\d{2,5}$/.test(value)) score -= 3;
              if (/^V\d{7,12}$/.test(value)) score -= 2;
              if (value.includes("-")) score -= 1;
              if (/[a-z]/.test(rawOriginal)) score -= 4;
              if (Number.isFinite(segmentPosition) && segmentPosition >= 12) score += 4;
              if (Number.isFinite(segmentPosition) && segmentPosition <= 11) score -= 2;
              score += Math.min(3, entry.index * 0.01);
              return { entry, score, segmentPosition: Number.isFinite(segmentPosition) ? segmentPosition : 0 };
            })
            .sort((a, b) => {
              if (a.segmentPosition !== b.segmentPosition) return b.segmentPosition - a.segmentPosition;
              if (a.score !== b.score) return b.score - a.score;
              return b.entry.index - a.entry.index;
            });
          const tailCandidate = recCandidates.find((candidate) => candidate.segmentPosition >= 12);
          const recCandidate = tailCandidate || recCandidates[0];
          if (recCandidate && recCandidate.score > 0) {
            consumed.add(recCandidate.entry.index);
            assignment.rec = recCandidate.entry.upper;
          }
        }

        const fallbackFromSlot = (slotName, segmentPosition) => {
          const slotToken = Number.isFinite(Number(segmentPosition))
            ? byNameAndSegment(slotName, segmentPosition)
            : byName(slotName);
          return String((slotToken && slotToken.raw) || "").trim().toUpperCase();
        };

        if (!assignment.classCode) assignment.classCode = fallbackFromSlot("CLASS");
        if (!assignment.wipCode) assignment.wipCode = fallbackFromSlot("WIP");
        if (!assignment.vid) assignment.vid = fallbackFromSlot("VID");
        if (!assignment.typeMain) assignment.typeMain = fallbackFromSlot("TYPE", 4) || fallbackFromSlot("TYPE");
        if (!assignment.conf) assignment.conf = fallbackFromSlot("CONF");
        if (!assignment.spec) assignment.spec = fallbackFromSlot("SPEC");
        if (resHasRules && !assignment.res) {
          const resSlot = fallbackFromSlot("RES", 7) || fallbackFromSlot("RES");
          if (resSlot && lookupStrictTokenRule(ruleSet.index, "RES", resSlot)) {
            assignment.res = resSlot;
          }
        }
        if (!assignment.range) {
          const rangeSlot = fallbackFromSlot("RANGE", 7) || fallbackFromSlot("RANGE");
          if (rangeSlot && lookupStrictTokenRule(ruleSet.index, "RANGE", rangeSlot)) {
            assignment.range = rangeSlot;
          }
        }
        if (!assignment.fps) assignment.fps = fallbackFromSlot("FPS");
        if (!assignment.texl && segment9Values.length > 0) {
          const texlSlot = fallbackFromSlot("TEXL", 9) || fallbackFromSlot("TEXL");
          if (texlSlot && isDwcLanguageCode(texlSlot)) {
            assignment.texl = texlSlot;
          }
        }
        if (!assignment.iar && segment9Values.length > 0) {
          const iarSlot = fallbackFromSlot("IAR", 9) || fallbackFromSlot("IAR");
          if (iarSlot && isIarLikeValue(iarSlot)) {
            assignment.iar = iarSlot;
          }
        }
        if (!assignment.audl && !mappedSegment10AsTtlType && allowAudlTfFromSegment10) {
          const audlSlot = fallbackFromSlot("AUDL", 10);
          if (audlSlot && isDwcLanguageCode(audlSlot)) {
            assignment.audl = audlSlot;
          }
        }
        if (!assignment.tf && !mappedSegment10AsTtlType && allowAudlTfFromSegment10) {
          const tfSlot = fallbackFromSlot("TF", 10);
          if (tfSlot && (lookupStrictTokenRule(ruleSet.index, "TF", tfSlot) || /^\d{2,5}$/.test(tfSlot))) {
            assignment.tf = tfSlot;
          }
        }
        if (!assignment.ttl && segment11Values.length > 0) assignment.ttl = fallbackFromSlot("TTL", 11);
        if (!assignment.typeTail && segment11Values.length > 0) assignment.typeTail = fallbackFromSlot("TYPE", 11);
        if (!assignment.rec) assignment.rec = fallbackFromSlot("REC", 12) || fallbackFromSlot("REC");

        const claimedTokenIndexes = new Set();
        const findUnclaimedTokenIndex = (predicate) => {
          for (let i = 0; i < result.length; i += 1) {
            if (claimedTokenIndexes.has(i)) {
              continue;
            }
            if (predicate(result[i])) {
              return i;
            }
          }
          return -1;
        };

        const ensureToken = (name, segmentPosition, segmentMask) => {
          const upper = String(name || "").toUpperCase();
          let tokenIndex = findUnclaimedTokenIndex((token) =>
            tokenNameKey(token) === upper
            && Number(token.segmentPosition) === Number(segmentPosition)
          );
          if (tokenIndex < 0) {
            tokenIndex = findUnclaimedTokenIndex((token) => tokenNameKey(token) === upper);
          }

          let token = tokenIndex >= 0 ? result[tokenIndex] : null;
          if (!token) {
            token = {
              tokenName: upper,
              displayTokenLabel: upper,
              raw: "",
              segmentMask: segmentMask || upper,
              segmentPosition,
              known: false,
              informational: false,
              meaning: "Token not included"
            };
            result.push(token);
            tokenIndex = result.length - 1;
          }
          if (tokenIndex >= 0) {
            claimedTokenIndexes.add(tokenIndex);
          }
          token.tokenName = upper;
          token.displayTokenLabel = upper;
          token.segmentPosition = segmentPosition;
          token.segmentMask = segmentMask || upper;
          return token;
        };

        const classToken = ensureToken("CLASS", 2, "CLASS-WIP");
        const wipToken = ensureToken("WIP", 2, "CLASS-WIP");
        const vidToken = ensureToken("VID", 3, "VID");
        const typeMainToken = ensureToken("TYPE", 4, "TYPE");
        const confToken = ensureToken("CONF", 5, "CONF");
        const specToken = ensureToken("SPEC", 6, "SPEC");
        const resToken = ensureToken("RES", 7, "RES-RANGE");
        const rangeToken = ensureToken("RANGE", 7, "RES-RANGE");
        const fpsToken = ensureToken("FPS", 8, "FPS");
        const texlToken = ensureToken("TEXL", 9, "TEXL-IAR");
        const iarToken = ensureToken("IAR", 9, "TEXL-IAR");
        const audlToken = ensureToken("AUDL", 10, "AUDL-TF");
        const tfToken = ensureToken("TF", 10, "AUDL-TF");
        const ttlToken = ensureToken("TTL", 11, "TTL-TYPE");
        const typeTailToken = ensureToken("TYPE", 11, "TTL-TYPE");
        const recToken = ensureToken("REC", 12, "REC");

        const applyExactRuleToken = (token, tokenName, raw) => {
          token.raw = String(raw || "").toUpperCase();
          if (!token.raw) {
            token.known = false;
            token.informational = false;
            token.meaning = "Token not included";
            return;
          }
          const rule = lookupStrictTokenRule(ruleSet.index, tokenName, token.raw);
          if (rule) {
            token.known = true;
            token.informational = false;
            token.meaning = applyRawEntryToMeaning(
              String(rule.semantic_meaning || "").trim(),
              getRawEntryForRule(rule, token.raw)
            ) || `${tokenName}: ${token.raw}`;
          } else {
            token.known = false;
            token.informational = false;
            token.meaning = `${tokenName} undefined value: ${token.raw}.`;
          }
        };

        applyExactRuleToken(classToken, "CLASS", assignment.classCode);
        wipToken.raw = String(assignment.wipCode || "").toUpperCase();
        if (wipToken.raw) {
          const wipRule = lookupStrictTokenRule(ruleSet.index, "WIP", wipToken.raw);
          if (wipRule) {
            wipToken.known = true;
            wipToken.informational = false;
            wipToken.meaning = getDwcClassWipMeaning(
              wipToken.raw,
              applyRawEntryToMeaning(String(wipRule.semantic_meaning || "").trim(), getRawEntryForRule(wipRule, wipToken.raw))
            ) || `WIP: ${wipToken.raw}`;
          } else {
            const classDesignatorRule = lookupStrictTokenRule(ruleSet.index, "CLASS", wipToken.raw);
            if (classDesignatorRule) {
              wipToken.known = true;
              wipToken.informational = false;
              wipToken.meaning = getDwcClassWipMeaning(
                wipToken.raw,
                applyRawEntryToMeaning(
                  String(classDesignatorRule.semantic_meaning || "").trim(),
                  getRawEntryForRule(classDesignatorRule, wipToken.raw)
                )
              ) || `CLASS designator: ${wipToken.raw}`;
            } else {
              wipToken.known = false;
              wipToken.informational = true;
              wipToken.meaning = "WIP not provided (optional sub-token).";
            }
          }
        } else {
          wipToken.known = false;
          wipToken.informational = true;
          wipToken.meaning = "WIP not provided (optional sub-token).";
        }

        vidToken.raw = String(assignment.vid || "").toUpperCase();
        if (vidToken.raw) {
          vidToken.known = true;
          vidToken.informational = true;
          vidToken.meaning = `VID: ${vidToken.raw} (source-provided)`;
        } else {
          vidToken.known = false;
          vidToken.informational = false;
          vidToken.meaning = "Token not included";
        }

        applyExactRuleToken(typeMainToken, "TYPE", assignment.typeMain);
        applyExactRuleToken(confToken, "CONF", assignment.conf);
        if (!confToken.known && confToken.raw) {
          const confUpper = String(confToken.raw || "").toUpperCase();
          const reelMeaning = resolveReelMeaning(confUpper);
          if (reelMeaning) {
            confToken.known = true;
            confToken.informational = false;
            confToken.meaning = reelMeaning;
          } else if (confUpper === "TXTL") {
            confToken.known = true;
            confToken.informational = false;
            confToken.meaning = "Textless conform element";
          }
        }
        applyExactRuleToken(specToken, "SPEC", assignment.spec);
        if (!specToken.known && specToken.raw) {
          const compoundSpecMeaning = resolveDwcSpecCompound(ruleSet, "SPEC", specToken.raw);
          if (compoundSpecMeaning) {
            specToken.known = true;
            specToken.informational = false;
            specToken.meaning = compoundSpecMeaning;
          }
        }
        applyExactRuleToken(resToken, "RES", assignment.res);
        applyExactRuleToken(rangeToken, "RANGE", assignment.range);
        applyExactRuleToken(fpsToken, "FPS", assignment.fps);
        applyExactRuleToken(iarToken, "IAR", assignment.iar);
        if (!iarToken.known && iarToken.raw) {
          const compositeIarMeaning = resolveDwcIarCompositeMeaning(ruleSet, iarToken.raw);
          if (compositeIarMeaning) {
            iarToken.known = true;
            iarToken.informational = false;
            iarToken.meaning = compositeIarMeaning;
          }
        }
        applyExactRuleToken(tfToken, "TF", assignment.tf);
        applyExactRuleToken(typeTailToken, "TYPE", assignment.typeTail);

        texlToken.raw = String(assignment.texl || "").toUpperCase();
        if (texlToken.raw && isLanguageCode(texlToken.raw)) {
          texlToken.known = true;
          texlToken.informational = true;
          texlToken.meaning = `TEXL language code routed to external language decoder report: ${texlToken.raw}`;
        } else {
          texlToken.known = false;
          texlToken.informational = false;
          texlToken.meaning = texlToken.raw ? `TEXL undefined value: ${texlToken.raw}.` : "Token not included";
        }

        audlToken.raw = String(assignment.audl || "").toUpperCase();
        if (audlToken.raw && isLanguageCode(audlToken.raw)) {
          audlToken.known = true;
          audlToken.informational = true;
          audlToken.meaning = `AUDL language code routed to external language decoder report: ${audlToken.raw}`;
        } else {
          audlToken.known = false;
          audlToken.informational = false;
          audlToken.meaning = audlToken.raw ? `AUDL undefined value: ${audlToken.raw}.` : "Token not included";
        }

        ttlToken.raw = String(assignment.ttl || "").toUpperCase();
        if (ttlToken.raw && isLanguageCode(ttlToken.raw)) {
          ttlToken.known = true;
          ttlToken.informational = true;
          ttlToken.meaning = `TTL language code routed to external language decoder report: ${ttlToken.raw}`;
        } else {
          ttlToken.known = false;
          ttlToken.informational = false;
          ttlToken.meaning = ttlToken.raw ? `TTL undefined value: ${ttlToken.raw}.` : "Token not included";
        }

        recToken.raw = String(assignment.rec || "").toUpperCase();
        if (recToken.raw) {
          recToken.known = true;
          recToken.informational = true;
          recToken.meaning = `Record: ${recToken.raw} (source-provided)`;
        } else {
          recToken.known = false;
          recToken.informational = false;
          recToken.meaning = "Token not included";
        }

        const consumedRaw = new Set(
          [
            assignment.classCode,
            assignment.wipCode,
            assignment.vid,
            assignment.typeMain,
            assignment.conf,
            assignment.spec,
            assignment.res,
            assignment.range,
            assignment.fps,
            assignment.texl,
            assignment.iar,
            assignment.audl,
            assignment.tf,
            assignment.ttl,
            assignment.typeTail,
            assignment.rec,
            (assignment.res && assignment.range) ? `${assignment.res}-${assignment.range}` : "",
            (assignment.texl && assignment.iar) ? `${assignment.texl}-${assignment.iar}` : "",
            (assignment.audl && assignment.tf) ? `${assignment.audl}-${assignment.tf}` : "",
            ...segment7Values.filter((value) => Boolean(lookupStrictTokenRule(ruleSet.index, "RANGE", value)))
          ]
            .map((value) => String(value || "").toUpperCase())
            .filter(Boolean)
        );

        const filteredResult = result.filter((token) => {
          if (tokenNameKey(token) !== "UNKNOWN") {
            return true;
          }
          const passthroughRaw = String((token && token.passthroughRaw) || (token && token.raw) || "").trim().toUpperCase();
          return !passthroughRaw || !consumedRaw.has(passthroughRaw);
        });

        const passthroughUnknownTokens = pool
          .map((entry) => entry.upper)
          .filter((raw) => !consumedRaw.has(raw))
          .map((raw) => toPassthroughUnknownToken(raw));

        return mergePassthroughUnknownTokens(filteredResult, tokenNameKey, passthroughUnknownTokens, false);
      }

      function normalizeConventionDisplayTokens(ruleSet, tokenResults) {
        return normalizeDwcDisplayTokens(ruleSet, normalizeWmlsDisplayTokens(ruleSet, normalizeFoxAudioDisplayTokens(ruleSet, tokenResults)));
      }

      function projectTokenResultsToMaskOrder(maskSpec, tokenResults) {
        const segments = Array.isArray(maskSpec && maskSpec.segments) ? maskSpec.segments : [];
        const source = Array.isArray(tokenResults) ? tokenResults : [];
        const used = new Set();
        const normalize = (value) => String(value || "").trim().toUpperCase();
        const projected = [];

        const scoreCandidateForSlot = (token, slotTokenName, slotSegmentPosition) => {
          const tokenName = normalize(token && token.tokenName);
          const displayTokenName = normalize(token && token.displayTokenLabel);
          const segmentMask = normalize(token && token.segmentMask);
          const raw = String((token && token.raw) || "").trim();
          const hasRaw = raw.length > 0;
          const tokenSegmentPosition = Number(token && token.segmentPosition);
          const hasSegmentPosition = Number.isFinite(tokenSegmentPosition) && tokenSegmentPosition > 0;
          const sameSegment = !hasSegmentPosition || tokenSegmentPosition === Number(slotSegmentPosition);
          const exactName = tokenName === slotTokenName || displayTokenName === slotTokenName;
          const maskNameMatch = segmentMask === slotTokenName;

          if (!sameSegment || (!exactName && !maskNameMatch)) {
            return -1;
          }

          let score = 0;
          if (exactName) score += 40;
          if (maskNameMatch) score += 30;
          if (hasRaw) score += 20;
          return score;
        };

        for (const segment of segments) {
          const slotSegmentPosition = Number(segment && segment.segmentIndex) + 1;
          const slotTokenNames = Array.isArray(segment && segment.tokenNames) ? segment.tokenNames : [];

          for (const tokenNameRaw of slotTokenNames) {
            const slotTokenName = normalize(tokenNameRaw);
            let bestIndex = -1;
            let bestScore = -1;

            for (let i = 0; i < source.length; i += 1) {
              if (used.has(i)) {
                continue;
              }
              const score = scoreCandidateForSlot(source[i], slotTokenName, slotSegmentPosition);
              if (score > bestScore) {
                bestScore = score;
                bestIndex = i;
              }
            }

            if (bestIndex >= 0) {
              used.add(bestIndex);
              projected.push(source[bestIndex]);
            } else {
              projected.push({
                tokenName: slotTokenName,
                displayTokenLabel: slotTokenName,
                raw: "",
                segmentMask: slotTokenName,
                segmentPosition: slotSegmentPosition,
                known: false,
                informational: false,
                meaning: "No value provided"
              });
            }
          }
        }

        for (let i = 0; i < source.length; i += 1) {
          if (used.has(i)) {
            continue;
          }
          const token = source[i] || {};
          if (String(token.tokenName || "").toUpperCase() === "UNKNOWN") {
            projected.push(token);
          }
        }

        const unknownSourceValues = new Set(
          projected
            .filter((token) => String((token && token.tokenName) || "").toUpperCase() === "UNKNOWN")
            .map((token) => String((token && token.passthroughRaw) || "").trim().toUpperCase())
            .filter(Boolean)
        );
        const isUndefinedMeaning = (value) => /undefined value|value is undefined|no active rule match/i.test(String(value || ""));
        const isPlausibleForSlot = (tokenName, raw) => {
          const name = String(tokenName || "").toUpperCase();
          const value = String(raw || "").trim().toUpperCase();
          if (!value) return false;
          if (name === "RES" || name === "RANGE") return /^[A-Z0-9]{2,8}(?:-[A-Z0-9]{2,8})?$/.test(value);
          if (name === "FILEINFO") return /^\d{3,4}[PI]\d{2}(?:NDF|DF)?$/.test(value);
          if (name === "ASPECTRATIO" || name === "IAR") return /^\d{3}$/.test(value);
          if (name === "FPS") return /^\d{2,3}(?:\.\d+)?(?:NDF|DF)?$/.test(value);
          if (["AUD", "TXT", "TEXL", "AUDL", "LANGUAGE"].includes(name)) return /^[A-Z]{2,6}(?:-[A-Z0-9]{2,8})?$/.test(value);
          if (name === "WMLS#" || name === "WMLS##") return /^\d{6,10}$/.test(value);
          return false;
        };
        for (const token of projected) {
          const tokenName = String((token && token.tokenName) || "").toUpperCase();
          const raw = String((token && token.raw) || "").trim();
          if (!raw || tokenName === "UNKNOWN") {
            continue;
          }
          if (Boolean(token && token.known) || Boolean(token && token.informational)) {
            continue;
          }
          if (!isUndefinedMeaning(token && token.meaning)) {
            continue;
          }
          if (isPlausibleForSlot(tokenName, raw)) {
            continue;
          }
          const rawUpper = raw.toUpperCase();
          if (unknownSourceValues.has(rawUpper)) {
            continue;
          }
          unknownSourceValues.add(rawUpper);
          projected.push(toPassthroughUnknownToken(raw));
        }

        return projected;
      }

      function buildFamilyLikePresentationState(displayConfidence, threshold, conventionId, maskLabel, evaluatedTokenResults) {
        const tokens = Array.isArray(evaluatedTokenResults) ? evaluatedTokenResults : [];
        const hasRaw = (token) => String((token && token.raw) || "").trim().length > 0;
        const isUndefinedMeaning = (value) => /undefined value|value is undefined|no active rule match|no value provided/i.test(String(value || ""));
        const normalizeLabel = (value) => String(value || "").trim().toUpperCase();

        const identifiableTokens = tokens.filter((token) => {
          if (!hasRaw(token) || Boolean(token && token.informational)) {
            return false;
          }
          if (Boolean(token && token.known)) {
            return true;
          }
          return !isUndefinedMeaning(token && token.meaning);
        });

        let mismatchCount = 0;
        const detectedCounts = new Map();
        for (const token of identifiableTokens) {
          const detectedName = normalizeLabel((token && token.displayTokenLabel) || (token && token.tokenName));
          const slotName = normalizeLabel(token && token.tokenName);
          if (detectedName && slotName && detectedName !== slotName) {
            mismatchCount += 1;
          }
          if (detectedName && detectedName !== "UNKNOWN") {
            detectedCounts.set(detectedName, (detectedCounts.get(detectedName) || 0) + 1);
          }
        }

        let duplicateCount = 0;
        for (const count of detectedCounts.values()) {
          if (count > 1) {
            duplicateCount += (count - 1);
          }
        }

        const dynamicGate = Math.max(Number(threshold || 0) - 0.1, 0.25);
        const isFamilyLikeOutOfOrder = identifiableTokens.length >= 2
          && mismatchCount >= 1
          && Number(displayConfidence || 0) >= dynamicGate;

        return {
          isFamilyLikeOutOfOrder,
          dynamicGate,
          mismatchCount,
          duplicateCount,
          identifiableTokenCount: identifiableTokens.length,
          likelyConventionLabel: displayConventionName(conventionId),
          maskLabel
        };
      }

      function buildFilenameOrderedDefinitionsTokenResults(evaluatedTokenResults, fallbackTokenResults) {
        const source = Array.isArray(evaluatedTokenResults) ? evaluatedTokenResults : [];
        const fallback = Array.isArray(fallbackTokenResults) ? fallbackTokenResults : [];
        const normalize = (value) => String(value || "").trim().toUpperCase();
        const hasRaw = (token) => String((token && token.raw) || "").trim().length > 0;

        const ordered = source
          .map((token, index) => ({ token: { ...token }, index }))
          .filter((entry) => hasRaw(entry.token))
          .sort((a, b) => {
            const posA = Number(a && a.token && a.token.segmentPosition);
            const posB = Number(b && b.token && b.token.segmentPosition);
            const hasPosA = Number.isFinite(posA) && posA > 0;
            const hasPosB = Number.isFinite(posB) && posB > 0;
            if (hasPosA && hasPosB && posA !== posB) {
              return posA - posB;
            }
            if (hasPosA !== hasPosB) {
              return hasPosA ? -1 : 1;
            }
            return a.index - b.index;
          })
          .map((entry) => entry.token);

        const seenUnknownPassthrough = new Set(
          ordered
            .filter((token) => normalize(token && token.tokenName) === "UNKNOWN")
            .map((token) => normalize((token && token.passthroughRaw) || (token && token.raw)))
            .filter(Boolean)
        );

        for (const token of fallback) {
          if (normalize(token && token.tokenName) !== "UNKNOWN") {
            continue;
          }
          const passthroughUpper = normalize((token && token.passthroughRaw) || (token && token.raw));
          if (!passthroughUpper || seenUnknownPassthrough.has(passthroughUpper)) {
            continue;
          }
          seenUnknownPassthrough.add(passthroughUpper);
          ordered.push({ ...token });
        }

        return ordered;
      }

      function renderDefinitions(tokenResults, options = {}) {
        const classWipDisplayFallback = {
          "3DL": "Left eye master",
          "3DR": "Right eye master",
          "3DSBS": "Side by side 3D master",
          "3DTAB": "Top and bottom 3D master"
        };
        const visibleTokens = tokenResults.filter((token) => {
          const tokenName = String(token.tokenName || "").toUpperCase();
          const raw = String(token.raw || "").trim();
          if (tokenName === "WIP" && !raw) {
            return false;
          }
          if (tokenName === "EXT" && !raw) {
            return false;
          }
          return true;
        });

        const regularTokens = visibleTokens.filter((token) => String(token.tokenName || "").toUpperCase() !== "UNKNOWN");
        const unknownTokens = visibleTokens.filter((token) => String(token.tokenName || "").toUpperCase() === "UNKNOWN");

        const consumedCompositeParts = new Set();
        const collectCompositeParts = (rawValue) => {
          const raw = String(rawValue || "").trim().toUpperCase();
          if (!raw) {
            return;
          }
          consumedCompositeParts.add(raw);
          for (const piece of raw.split(/[_.-]+/)) {
            const part = String(piece || "").trim().toUpperCase();
            if (part) {
              consumedCompositeParts.add(part);
            }
          }
          // Keep progressive dot-prefixes for bitrate-like suffixes (e.g., DS768.DTSHD).
          if (raw.includes(".")) {
            const dotParts = raw.split(".").map((piece) => String(piece || "").trim().toUpperCase()).filter(Boolean);
            let prefix = "";
            for (const piece of dotParts) {
              prefix = prefix ? `${prefix}.${piece}` : piece;
              consumedCompositeParts.add(prefix);
            }
            if (dotParts.length > 1) {
              consumedCompositeParts.add(dotParts.slice(0, -1).join("."));
            }
          }
        };
        for (const token of regularTokens) {
          const tokenName = String(token && token.tokenName || "").toUpperCase();
          if (tokenName === "STANDARD" || tokenName === "SUFFIX") {
            collectCompositeParts(token && token.raw);
          }
        }

        // Suppress passthrough UNKNOWN values that are reconstructed from paired segment tokens.
        // Example: TEXL=ENG + IAR=132-FA implies composite source ENG-132-FA.
        const collectPairedCompositeParts = (leftTokenName, rightTokenName) => {
          const leftName = String(leftTokenName || "").toUpperCase();
          const rightName = String(rightTokenName || "").toUpperCase();
          const rightTokens = regularTokens.filter((token) => String(token && token.tokenName || "").toUpperCase() === rightName);

          for (const rightToken of rightTokens) {
            const segmentPosition = Number(rightToken && rightToken.segmentPosition);
            const rightRaw = String((rightToken && rightToken.raw) || "").trim().toUpperCase();
            if (!rightRaw) {
              continue;
            }

            const leftToken = regularTokens.find((token) =>
              Number(token && token.segmentPosition) === segmentPosition
              && String(token && token.tokenName || "").toUpperCase() === leftName
            );
            const leftRaw = String((leftToken && leftToken.raw) || "").trim().toUpperCase();
            if (!leftRaw) {
              continue;
            }

            collectCompositeParts(`${leftRaw}-${rightRaw}`);
            collectCompositeParts(`${leftRaw}_${rightRaw}`);
          }
        };

        collectPairedCompositeParts("TEXL", "IAR");
        collectPairedCompositeParts("AUDL", "TF");
        collectPairedCompositeParts("TTL", "TYPE");

        const filteredUnknownTokens = unknownTokens.filter((token) => {
          const passthroughRaw = String(token && token.passthroughRaw || "").trim().toUpperCase();
          return !passthroughRaw || !consumedCompositeParts.has(passthroughRaw);
        });

        const rows = regularTokens.map((token) => {
          const tokenNameUpper = String((token && token.tokenName) || "").toUpperCase();
          const segmentMaskUpper = String((token && token.segmentMask) || "").toUpperCase();
          const tokenRawUpper = String((token && token.raw) || "").trim().toUpperCase();
          const baseMeaning = String((token && token.meaning) || "").trim();
          const looksCodeLikeMeaning = baseMeaning.toUpperCase() === tokenRawUpper
            || baseMeaning.toUpperCase() === `WIP: ${tokenRawUpper}`
            || baseMeaning.toUpperCase() === `CLASS DESIGNATOR: ${tokenRawUpper}`;
          const isClassWipToken = segmentMaskUpper === "CLASS-WIP" && (tokenNameUpper === "WIP" || tokenNameUpper === "CLASS");
          const effectiveMeaning = isClassWipToken
            && tokenRawUpper
            && (looksCodeLikeMeaning || classWipDisplayFallback[tokenRawUpper])
            ? getDwcClassWipMeaning(tokenRawUpper, classWipDisplayFallback[tokenRawUpper] || baseMeaning)
            : baseMeaning;
          const stateClass = token.known ? "definition-known" : "definition-unmatched";
          const baseTokenLabel = `${token.displayTokenLabel || token.tokenName}`;
          const slotHint = String((token && token.appearsInTokenSlot) || "").trim();
          const tokenLabel = slotHint
            ? `${baseTokenLabel} (appears in token slot ${slotHint})`
            : baseTokenLabel;
          const tokenValue = token.raw || "not included";
          return `<li class="definition-row"><span class="definition-label">${escapeHtml(tokenLabel)}</span><span class="definition-code">${escapeHtml(tokenValue)}</span><span class="definition-meaning ${stateClass}">${escapeHtml(effectiveMeaning)}</span></li>`;
        });

        const unknownRows = filteredUnknownTokens.map((token) => {
          const tokenLabel = `${token.displayTokenLabel || token.tokenName}`;
          const tokenValue = token.raw || "undefined";
          const passthroughRaw = String(token.passthroughRaw || "").trim();
          const meaning = passthroughRaw
            ? `${String(token.meaning || "")} [source value: ${passthroughRaw}]`
            : String(token.meaning || "");
          return `<li class="definition-row"><span class="definition-label">${escapeHtml(tokenLabel)}</span><span class="definition-code">${escapeHtml(tokenValue)}</span><span class="definition-meaning definition-unmatched">${escapeHtml(meaning)}</span></li>`;
        });

        const regularTable = rows.length > 0
          ? `<li class="definition-row definition-header"><span class="definition-label">Token</span><span class="definition-code">Value</span><span class="definition-meaning">Definition</span></li>${rows.join("")}`
          : "";

        const unknownTable = unknownRows.length > 0
          ? `<li class="definition-row" aria-hidden="true"><span class="definition-label">&nbsp;</span><span class="definition-code">&nbsp;</span><span class="definition-meaning">&nbsp;</span></li><li class="definition-row definition-header"><span class="definition-label">Unknown Token</span><span class="definition-code">Value</span><span class="definition-meaning">Definition</span></li>${unknownRows.join("")}`
          : "";

        definitionsListEl.innerHTML = (regularTable || unknownTable)
          ? `${regularTable}${unknownTable}`
          : '<li class="empty-row">No decoded definitions yet.</li>';
      }

      function renderDecodeResult(candidate, filename) {
        const conventionId = String((candidate.ruleSet.rulesDoc && candidate.ruleSet.rulesDoc.conventionId) || "UNKNOWN");
        const thresholdRaw = Number(candidate.ruleSet.rulesDoc && candidate.ruleSet.rulesDoc.matchThreshold);
        const threshold = Number.isFinite(thresholdRaw) ? thresholdRaw : 0.35;
        const hasNoReliableSignal = candidate.known === 0 || candidate.confidence <= 0;
        const isWmlsConventionId = isWmlsConvention(conventionId);
        const maskLabel = isWmlsConventionId
          ? String(candidate.maskSpec.id || "").trim()
          : String(candidate.maskSpec.name || candidate.maskSpec.id || "").trim()
            || `${displayConventionName(conventionId)} Mask`;
        detectedMaskTextEl.textContent = hasNoReliableSignal
          ? `No reliable naming mask detected. Closest mask candidate: ${maskLabel}: ${candidate.maskSpec.mask}`
          : `${maskLabel}: ${candidate.maskSpec.mask}`;
        const evaluatedTokenResults = applyDwcTitleEpisodeMeaning(candidate.tokenResults || [], conventionId, candidate.confidence);
        const displayTokenResults = projectTokenResultsToMaskOrder(
          candidate.maskSpec,
          evaluatedTokenResults
        );
        const filenameSegments = String(filename || "")
          .replace(/\..*$/, "")
          .split("_")
          .map((segment) => String(segment || "").trim())
          .filter(Boolean);

        if (String(conventionId || "").toUpperCase() === "FOX-AUDIO-SERVICES") {
          const suffixToken = displayTokenResults.find((token) => {
            const tokenName = String((token && token.tokenName) || "").toUpperCase();
            const displayTokenLabel = String((token && token.displayTokenLabel) || "").toUpperCase();
            return tokenName === "SUFFIX" || displayTokenLabel === "SUFFIX";
          });
          const suffixRaw = String((suffixToken && suffixToken.raw) || "").trim();
          if (suffixToken && !suffixRaw) {
            const unknownSourceValues = displayTokenResults
              .filter((token) => String((token && token.tokenName) || "").toUpperCase() === "UNKNOWN")
              .map((token) => String((token && token.passthroughRaw) || "").trim())
              .filter(Boolean);
            const candidates = [...filenameSegments, ...unknownSourceValues];
            const promoted = candidates.find((value) => {
              const upper = String(value || "").trim().toUpperCase();
              if (!upper) {
                return false;
              }
              return Boolean(lookupStrictTokenRule(candidate.ruleSet.index, "SUFFIX", upper))
                || Boolean(resolveFoxSuffixCompositeMeaning(candidate.ruleSet, upper));
            });

            if (promoted) {
              const promotedUpper = String(promoted).trim().toUpperCase();
              const suffixRule = lookupStrictTokenRule(candidate.ruleSet.index, "SUFFIX", promotedUpper);
              const suffixCompositeMeaning = suffixRule ? null : resolveFoxSuffixCompositeMeaning(candidate.ruleSet, promotedUpper);
              suffixToken.raw = promotedUpper;
              if (suffixRule) {
                suffixToken.known = true;
                suffixToken.meaning = applyRawEntryToMeaning(
                  String(suffixRule.semantic_meaning || "").trim(),
                  getRawEntryForRule(suffixRule, promotedUpper)
                ) || `SUFFIX: ${promotedUpper}`;
              } else if (suffixCompositeMeaning) {
                suffixToken.known = true;
                suffixToken.meaning = suffixCompositeMeaning;
              }

              for (let i = displayTokenResults.length - 1; i >= 0; i -= 1) {
                const token = displayTokenResults[i];
                if (String((token && token.tokenName) || "").toUpperCase() !== "UNKNOWN") {
                  continue;
                }
                const passthroughRaw = String((token && token.passthroughRaw) || "").trim().toUpperCase();
                if (passthroughRaw === promotedUpper) {
                  displayTokenResults.splice(i, 1);
                }
              }
            }
          }
        }

        let displacedWmlsTailRaw = "";
        if (isWmlsConvention(conventionId)) {
          const getTokenByNames = (names) => {
            const wanted = new Set((Array.isArray(names) ? names : [names]).map((name) => String(name || "").toUpperCase()));
            return displayTokenResults.find((token) => {
              const tokenName = String((token && token.tokenName) || "").toUpperCase();
              const displayTokenName = String((token && token.displayTokenLabel) || "").toUpperCase();
              return wanted.has(tokenName) || wanted.has(displayTokenName);
            });
          };

          // Recover canonical WMLS tail ordering from right to left:
          // ... FILETYPE_FILEINFO_ASPECTRATIO_AUD-TXT_WMLS##
          const inferWmlsTailOrdering = (segments) => {
            const normalized = (Array.isArray(segments) ? segments : [])
              .map((segment) => String(segment || "").trim().toUpperCase())
              .filter(Boolean);

            const inferred = {
              fileType: "",
              fileInfo: "",
              aspectRatio: "",
              langPair: "",
              wmlsTail: ""
            };

            const isWmlsFrameRateCode = (value) => /^(?:23|24|25|30|50|60|29(?:DF|NDF)|59(?:DF|NDF))$/i.test(String(value || "").trim());

            const tailIndex = [...normalized]
              .map((value, index) => ({ value, index }))
              .reverse()
              .find((item) => /^\d{6,10}$/.test(item.value));
            if (!tailIndex) return inferred;

            inferred.wmlsTail = tailIndex.value;
            let cursor = tailIndex.index - 1;

            if (cursor >= 0 && /^[A-Z]{2,6}(?:-[A-Z0-9]{2,8})?-[A-Z]{2,6}(?:-[A-Z0-9]{2,8})?$/.test(normalized[cursor])) {
              inferred.langPair = normalized[cursor];
              cursor -= 1;
            }

            if (cursor >= 0 && /^\d{3}$/.test(normalized[cursor])) {
              inferred.aspectRatio = normalized[cursor];
              cursor -= 1;
            }

            if (cursor >= 0 && (/^\d{3,4}[PI]\d{2}(?:NDF|DF)?$/i.test(normalized[cursor]) || isWmlsFrameRateCode(normalized[cursor]))) {
              inferred.fileInfo = normalized[cursor];
              cursor -= 1;
            }

            if (cursor >= 0) {
              inferred.fileType = normalized[cursor];
            }

            return inferred;
          };

          const fallbackPool = [...filenameSegments,
            ...displayTokenResults
              .filter((token) => String((token && token.tokenName) || "").toUpperCase() === "UNKNOWN")
              .map((token) => String((token && token.passthroughRaw) || "").trim())
              .filter(Boolean)
          ].map((value) => String(value || "").trim()).filter(Boolean);

          const uniqueFallbackPool = [];
          const seenFallback = new Set();
          for (const value of fallbackPool) {
            const upper = value.toUpperCase();
            if (seenFallback.has(upper)) continue;
            seenFallback.add(upper);
            uniqueFallbackPool.push(value);
          }

          const inferredTail = inferWmlsTailOrdering(filenameSegments);

          const versionToken = getTokenByNames("VERSION");
          const fileTypeToken = getTokenByNames("FILETYPE");
          const fileInfoToken = getTokenByNames("FILEINFO");
          const aspectToken = getTokenByNames("ASPECTRATIO");
          const audToken = getTokenByNames("AUD");
          const txtToken = getTokenByNames("TXT");
          const wmlsTailTokenCurrent = getTokenByNames(["WMLS##", "WMLS#"]);

          const normalizeRecoveryRaw = (value) => {
            const upper = String(value || "").trim().toUpperCase();
            if (!upper || upper === "UNDEFINED" || upper === "NULL" || upper === "N/A" || upper === "NO VALUE PROVIDED") {
              return "";
            }
            return upper;
          };

          const versionRaw = normalizeRecoveryRaw((versionToken && versionToken.raw) || "");
          const fileTypeRaw = normalizeRecoveryRaw((fileTypeToken && fileTypeToken.raw) || "");
          const fileInfoRaw = normalizeRecoveryRaw((fileInfoToken && fileInfoToken.raw) || "");
          const aspectRaw = normalizeRecoveryRaw((aspectToken && aspectToken.raw) || "");
          const audRaw = normalizeRecoveryRaw((audToken && audToken.raw) || "");
          const txtRaw = normalizeRecoveryRaw((txtToken && txtToken.raw) || "");
          const wmlsRawCurrent = normalizeRecoveryRaw((wmlsTailTokenCurrent && wmlsTailTokenCurrent.raw) || "");

          const isWmlsFrameRateCode = (value) => /^(?:23|24|25|30|50|60|29(?:DF|NDF)|59(?:DF|NDF))$/i.test(String(value || "").trim());
          const fileInfoCandidate = uniqueFallbackPool.find((value) => /^\d{3,4}[PI]\d{2}(?:NDF|DF)?$/i.test(value) || isWmlsFrameRateCode(value));
          const aspectCandidate = uniqueFallbackPool.find((value) => /^\d{3}$/.test(value));
          const wmlsTailCandidate = [...uniqueFallbackPool].reverse().find((value) => /^\d{6,10}$/.test(value));

          const isKnownFileTypeValue = (value) => {
            const upper = String(value || "").toUpperCase();
            if (!upper) return false;
            if (lookupStrictTokenRule(candidate.ruleSet.index, "FILETYPE", upper)) return true;
            const rawMeaning = getWmlsFileTypeMeaning(upper, "");
            return Boolean(rawMeaning) && !/no semantic meaning/i.test(String(rawMeaning || ""));
          };

          const fileTypeCandidate = uniqueFallbackPool.find((value) => {
            const upper = String(value || "").toUpperCase();
            if (!upper) return false;
            if (isKnownFileTypeValue(upper)) return true;
            if (upper === versionRaw) return false;
            if (/^\d{3,4}[PI]\d{2}(?:NDF|DF)?$/.test(upper)) return false;
            if (/^\d{3}$/.test(upper)) return false;
            if (/^\d{6,10}$/.test(upper)) return false;
            if (/^[A-Z]{2,6}(?:-[A-Z0-9]{2,8})?$/.test(upper)) return false;
            return /[A-Z]/.test(upper);
          });

          const langPairCandidate = inferredTail.langPair || uniqueFallbackPool.find((value) => {
            const upper = String(value || "").toUpperCase();
            if (!/^[A-Z]{2,6}(?:-[A-Z0-9]{2,8})?-[A-Z]{2,6}(?:-[A-Z0-9]{2,8})?$/i.test(upper)) return false;
            if (isKnownFileTypeValue(upper)) return false;
            const pair = upper.match(/^([A-Z]{2,6}(?:-[A-Z0-9]{2,8})?)-([A-Z]{2,6}(?:-[A-Z0-9]{2,8})?)$/);
            if (!pair) return false;
            return /^[A-Z]{2,6}(?:-[A-Z0-9]{2,8})?$/.test(pair[1]) && /^[A-Z]{2,6}(?:-[A-Z0-9]{2,8})?$/.test(pair[2]);
          });

          if (fileInfoToken && !fileInfoRaw && (inferredTail.fileInfo || fileInfoCandidate)) {
            fileInfoToken.raw = String(inferredTail.fileInfo || fileInfoCandidate).toUpperCase();
          }
          if (aspectToken && !aspectRaw && (inferredTail.aspectRatio || aspectCandidate)) {
            aspectToken.raw = String(inferredTail.aspectRatio || aspectCandidate).toUpperCase();
          }
          if (fileTypeToken && !fileTypeRaw && (inferredTail.fileType || fileTypeCandidate)) {
            fileTypeToken.raw = String(inferredTail.fileType || fileTypeCandidate).toUpperCase();
          }
          if ((audToken || txtToken) && (!audRaw || !txtRaw) && langPairCandidate) {
            const pairMatch = String(langPairCandidate).toUpperCase().match(/^([A-Z]{2,6}(?:-[A-Z0-9]{2,8})?)-([A-Z]{2,6}(?:-[A-Z0-9]{2,8})?)$/);
            if (pairMatch) {
              if (audToken && !audRaw) audToken.raw = pairMatch[1];
              if (txtToken && !txtRaw) txtToken.raw = pairMatch[2];
            }
          }
          if (wmlsTailTokenCurrent && !wmlsRawCurrent && (inferredTail.wmlsTail || wmlsTailCandidate)) {
            wmlsTailTokenCurrent.raw = String(inferredTail.wmlsTail || wmlsTailCandidate).toUpperCase();
          }

          const resolveWmlsDisplayMeaning = (token) => {
            if (!token) return;
            const tokenName = String((token.tokenName || token.displayTokenLabel || "")).toUpperCase();
            const raw = normalizeRecoveryRaw(token.raw || "");
            if (!raw) {
              token.known = false;
              token.informational = false;
              token.meaning = "No value provided";
              return;
            }

            if (tokenName === "FILETYPE") {
              const rule = lookupStrictTokenRule(candidate.ruleSet.index, "FILETYPE", raw);
              let meaning = getWmlsFileTypeMeaning(raw, String((rule && rule.semantic_meaning) || "").trim());
              if (!meaning || /no semantic meaning/i.test(String(meaning || ""))) {
                const rawFallbackMeaning = findMeaningInRawEntries(raw);
                if (rawFallbackMeaning) {
                  meaning = rawFallbackMeaning;
                }
              }
              token.known = Boolean(rule) || !/no semantic meaning/i.test(String(meaning || ""));
              token.informational = false;
              token.meaning = meaning || `FILETYPE undefined value: ${raw}.`;
              return;
            }

            if (tokenName === "FILEINFO") {
              const fileInfoRule = lookupStrictTokenRule(candidate.ruleSet.index, "FILEINFO", raw);
              const stackedMeaning = resolveWmlsStackedFileInfo(candidate.ruleSet.index, "FILEINFO", raw);
              const partialMeaning = resolveWmlsPartialStackedRasterRate(candidate.ruleSet.index, "FILEINFO", raw);
              const mapMeaning = getWmlsFileInfoMeaning(raw, "");
              if (fileInfoRule) {
                token.known = true;
                token.informational = false;
                const directMeaning = applyRawEntryToMeaning(String(fileInfoRule.semantic_meaning || "").trim(), getRawEntryForRule(fileInfoRule, raw)) || `FILEINFO: ${raw}`;
                const placeholderMeaning = isSingleComponentWmlsFileInfo(raw)
                  ? describeWmlsFileInfoComponents(raw)
                  : "";
                token.meaning = placeholderMeaning || directMeaning;
              } else if (stackedMeaning) {
                token.known = true;
                token.informational = false;
                token.meaning = stackedMeaning.meaning;
              } else if (partialMeaning) {
                token.known = Boolean(partialMeaning.known);
                token.informational = false;
                token.meaning = partialMeaning.meaning;
              } else if (mapMeaning && !/no semantic meaning/i.test(String(mapMeaning || ""))) {
                token.known = true;
                token.informational = false;
                const placeholderMeaning = isSingleComponentWmlsFileInfo(raw)
                  ? describeWmlsFileInfoComponents(raw)
                  : "";
                token.meaning = placeholderMeaning || mapMeaning;
              } else {
                const placeholderMeaning = describeWmlsFileInfoComponents(raw);
                token.known = false;
                token.informational = false;
                token.meaning = placeholderMeaning || "No value provided";
              }
              return;
            }

            if (tokenName === "ASPECTRATIO") {
              const rule = lookupStrictTokenRule(candidate.ruleSet.index, "ASPECTRATIO", raw);
              token.known = Boolean(rule);
              token.informational = false;
              token.meaning = rule
                ? applyRawEntryToMeaning(String(rule.semantic_meaning || "").trim(), getRawEntryForRule(rule, raw)) || `ASPECTRATIO: ${raw}`
                : "No value provided";
              return;
            }

            if (tokenName === "AUD" || tokenName === "TXT") {
              token.known = /^[A-Z]{2,6}(?:-[A-Z0-9]{2,8})?$/.test(raw);
              token.informational = true;
              token.meaning = token.known
                ? `${tokenName} language code routed to external language decoder report: ${raw}`
                : "No value provided";
              return;
            }

            if (tokenName === "WMLS##" || tokenName === "WMLS#") {
              token.known = /^\d{6,10}$/.test(raw);
              token.informational = true;
              token.meaning = token.known ? `WMLS ID number: ${raw}` : "No value provided";
            }
          };

          [fileTypeToken, fileInfoToken, aspectToken, audToken, txtToken, wmlsTailTokenCurrent].forEach(resolveWmlsDisplayMeaning);

          const wmlsTailToken = displayTokenResults.find((token) => {
            const tokenName = String((token && token.tokenName) || "").toUpperCase();
            const displayTokenLabel = String((token && token.displayTokenLabel) || "").toUpperCase();
            return tokenName === "WMLS##" || tokenName === "WMLS#" || displayTokenLabel === "WMLS##" || displayTokenLabel === "WMLS#";
          });

          const wmlsRaw = String((wmlsTailToken && wmlsTailToken.raw) || "").trim();
          const looksLanguagePairTail = /^[A-Z]{2,6}-[A-Z]{2,6}$/i.test(wmlsRaw);
          const numericTail = [...filenameSegments].reverse().find((segment) => /^\d{6,10}$/.test(segment)) || "";
          if (wmlsTailToken && looksLanguagePairTail && numericTail) {
            displacedWmlsTailRaw = wmlsRaw;
            wmlsTailToken.raw = numericTail;

            const numericTailUpper = String(numericTail || "").trim().toUpperCase();
            for (let i = displayTokenResults.length - 1; i >= 0; i -= 1) {
              const token = displayTokenResults[i];
              const tokenName = String((token && token.tokenName) || "").toUpperCase();
              if (tokenName !== "UNKNOWN") {
                continue;
              }
              const raw = String((token && token.raw) || "").trim().toUpperCase();
              const passthroughRaw = String((token && token.passthroughRaw) || "").trim().toUpperCase();
              if (raw === numericTailUpper || passthroughRaw === numericTailUpper) {
                displayTokenResults.splice(i, 1);
              }
            }

            const resolvedTokenName = String((wmlsTailToken && wmlsTailToken.tokenName) || "").toUpperCase();
            const ruleTokenName = resolvedTokenName === "WMLS#" ? "WMLS#" : "WMLS##";
            const matchedTailRule = lookupStrictTokenRule(candidate.ruleSet.index, ruleTokenName, numericTail)
              || lookupStrictTokenRule(candidate.ruleSet.index, "WMLS##", numericTail)
              || lookupStrictTokenRule(candidate.ruleSet.index, "WMLS#", numericTail);
            if (matchedTailRule) {
              const rawEntry = getRawEntryForRule(matchedTailRule, numericTail);
              wmlsTailToken.known = true;
              wmlsTailToken.meaning = applyRawEntryToMeaning(String(matchedTailRule.semantic_meaning || "").trim(), rawEntry);
            } else {
              wmlsTailToken.known = false;
              wmlsTailToken.meaning = `${ruleTokenName} value is undefined for this token in this naming convention: ${numericTail}.`;
            }
          }
        }

        const representedKnownValues = new Set(
          displayTokenResults
            .filter((token) => String((token && token.tokenName) || "").toUpperCase() !== "UNKNOWN")
            .flatMap((token) => [
              String((token && token.raw) || "").trim().toUpperCase(),
              String((token && token.passthroughRaw) || "").trim().toUpperCase()
            ])
            .filter(Boolean)
        );
        const representedCompositeFragments = new Set();
        for (const token of displayTokenResults) {
          const tokenName = String((token && token.tokenName) || "").toUpperCase();
          const rawUpper = String((token && token.raw) || "").trim().toUpperCase();
          if (tokenName !== "FILEINFO" || !rawUpper) {
            continue;
          }
          const compositeMatch = rawUpper.match(/^(\d{3,4})([PI])(\d{2}(?:NDF|DF)?)$/i);
          if (!compositeMatch) {
            continue;
          }
          representedCompositeFragments.add(String(compositeMatch[1] || "").toUpperCase());
          representedCompositeFragments.add(String(compositeMatch[2] || "").toUpperCase());
          representedCompositeFragments.add(String(compositeMatch[3] || "").toUpperCase());
        }
        const canComposeFromPieces = (rawUpper, piecesSet) => {
          const target = String(rawUpper || "").trim().toUpperCase();
          if (!target) {
            return false;
          }
          const pieces = [...piecesSet]
            .map((value) => String(value || "").trim().toUpperCase())
            .filter((value) => value && value !== target && value.length <= target.length);
          if (pieces.length === 0) {
            return false;
          }
          const memo = new Map();
          const visit = (index, partsUsed) => {
            const key = `${index}:${partsUsed}`;
            if (memo.has(key)) {
              return memo.get(key);
            }
            if (index === target.length) {
              return partsUsed >= 2;
            }
            for (const piece of pieces) {
              if (target.startsWith(piece, index) && visit(index + piece.length, partsUsed + 1)) {
                memo.set(key, true);
                return true;
              }
            }
            memo.set(key, false);
            return false;
          };
          return visit(0, 0);
        };
        const isRepresentedByKnown = (rawUpper) => {
          if (!rawUpper) {
            return false;
          }
          if (representedCompositeFragments.has(rawUpper)) {
            return true;
          }
          if (representedKnownValues.has(rawUpper)) {
            return true;
          }
          const parts = rawUpper.split(/[_.-]+/).map((part) => part.trim()).filter(Boolean);
          if (parts.length > 1 && parts.every((part) => representedKnownValues.has(part))) {
            return true;
          }
          return canComposeFromPieces(rawUpper, representedKnownValues);
        };
        for (let i = displayTokenResults.length - 1; i >= 0; i -= 1) {
          const token = displayTokenResults[i];
          if (String((token && token.tokenName) || "").toUpperCase() !== "UNKNOWN") {
            continue;
          }
          const rawUpper = String((token && (token.passthroughRaw || token.raw)) || "").trim().toUpperCase();
          if (!rawUpper) {
            continue;
          }
          if (isRepresentedByKnown(rawUpper)) {
            displayTokenResults.splice(i, 1);
          }
        }

        const shownRawValues = new Set(
          displayTokenResults
            .flatMap((token) => [
              String((token && token.raw) || "").trim().toUpperCase(),
              String((token && token.passthroughRaw) || "").trim().toUpperCase()
            ])
            .filter(Boolean)
        );
        const concatenatedBySegmentPosition = new Set();
        const segmentPositions = [...new Set(
          displayTokenResults
            .map((token) => Number(token && token.segmentPosition))
            .filter((value) => Number.isFinite(value) && value > 0 && value < 999)
        )];
        for (const segmentPosition of segmentPositions) {
          const segmentTokens = displayTokenResults.filter((token) =>
            Number(token && token.segmentPosition) === segmentPosition
            && String((token && token.tokenName) || "").toUpperCase() !== "UNKNOWN"
          );
          const compact = segmentTokens
            .map((token) => String((token && token.raw) || "").trim())
            .filter(Boolean)
            .join("")
            .toUpperCase();
          if (compact.length > 1) {
            concatenatedBySegmentPosition.add(compact);
          }
        }
        const isRepresentedRaw = (rawUpper) => {
          if (!rawUpper) {
            return false;
          }
          if (shownRawValues.has(rawUpper)) {
            return true;
          }
          if (concatenatedBySegmentPosition.has(rawUpper)) {
            return true;
          }
          const compoundParts = rawUpper.split(/[_.-]+/).map((part) => part.trim()).filter(Boolean);
          if (compoundParts.length > 1 && compoundParts.every((part) => shownRawValues.has(part))) {
            return true;
          }
          return canComposeFromPieces(rawUpper, representedKnownValues);
        };
        const appendUnknownPassthrough = (rawValue) => {
          const raw = String(rawValue || "").trim();
          if (!raw) {
            return;
          }
          const rawUpper = raw.toUpperCase();
          if (isRepresentedRaw(rawUpper)) {
            return;
          }
          shownRawValues.add(rawUpper);
          displayTokenResults.push(toPassthroughUnknownToken(raw));
        };
        const unresolvedFromRaw = Array.isArray(candidate && candidate.rawTokenResults)
          ? candidate.rawTokenResults
          : [];
        const isUndefinedLikeMeaning = (value) => /undefined value|value is undefined|no active rule match/i.test(String(value || ""));
        for (const token of unresolvedFromRaw) {
          const raw = String((token && token.raw) || "").trim();
          if (!raw) {
            continue;
          }
          const rawUpper = raw.toUpperCase();
          if (isRepresentedRaw(rawUpper)) {
            continue;
          }
          const tokenName = String((token && token.tokenName) || "").toUpperCase();
          const unresolved = tokenName === "EXTRA_SEGMENT"
            || tokenName === "UNKNOWN"
            || isUndefinedLikeMeaning(token && token.meaning);
          if (!unresolved) {
            continue;
          }
          appendUnknownPassthrough(raw);
        }
        if (displacedWmlsTailRaw) {
          appendUnknownPassthrough(displacedWmlsTailRaw);
        }
        for (const segment of filenameSegments) {
          appendUnknownPassthrough(segment);
        }
        const unresolvedPassthroughUnknownCount = displayTokenResults.filter((token) => {
          const tokenName = String((token && token.tokenName) || "").toUpperCase();
          if (tokenName !== "UNKNOWN") {
            return false;
          }
          return String((token && token.passthroughRaw) || "").trim().length > 0;
        }).length;
        const unknownPenalty = unresolvedPassthroughUnknownCount <= 0
          ? 0
          : Math.min(0.35, 0.1 + Math.max(0, unresolvedPassthroughUnknownCount - 1) * 0.08);
        const displayConfidence = Math.max(0, Math.min(1, Math.min(Number(candidate.confidence) || 0, 1 - unknownPenalty)));
        const matched = !hasNoReliableSignal && displayConfidence >= threshold;

        const presentationState = buildFamilyLikePresentationState(
          displayConfidence,
          threshold,
          conventionId,
          maskLabel,
          evaluatedTokenResults
        );

        const familyLikeFootnote = presentationState.isFamilyLikeOutOfOrder
          ? `This file name appears to be a ${presentationState.likelyConventionLabel} name but the arrangement may be out of order.`
          : "";
        const definitionTokens = presentationState.isFamilyLikeOutOfOrder
          ? buildFilenameOrderedDefinitionsTokenResults(evaluatedTokenResults, displayTokenResults)
          : displayTokenResults;

        matchIdEl.textContent = matched ? displayConventionName(conventionId) : "NO_MATCH";
        matchConfidenceEl.textContent = displayConfidence.toFixed(3);
        complianceNoteEl.textContent = presentationState.isFamilyLikeOutOfOrder
          ? `Likely convention: ${presentationState.likelyConventionLabel}. Candidate mask: ${presentationState.maskLabel}.`
          : "";
        if (definitionsNoteEl) {
          definitionsNoteEl.textContent = familyLikeFootnote;
        }
        statusChipEl.textContent = matched ? "Decode Ready" : "Low Confidence";

        renderDefinitions(definitionTokens);
      }

      async function decodeFilename() {
        const input = String(filenameInput.value || "").trim();
        if (!input) {
          statusChipEl.textContent = "Missing Filename";
          return;
        }

        if (!Array.isArray(state.ruleSets) || state.ruleSets.length === 0) {
          const fileMode = window.location.protocol === "file:";
          if (fileMode) {
            if (!tryHydrateFromLocalBundle()) {
              statusChipEl.textContent = "Rules Not Loaded";
              complianceNoteEl.textContent = "Local bundle unavailable. Open this page via localhost or regenerate ui/local_data_bundle.js.";
              return;
            }
          } else {
            statusChipEl.textContent = "Rules Not Loaded";
            complianceNoteEl.textContent = state.loadErrors.join(" | ") || "No rules loaded";
            return;
          }
        }

        const filename = input.replace(/[\\/]+$/, "").split(/[\\/]/).pop();
        state.familyPriorContext = buildFamilyPriorContext(filename, state.ruleSets);
        const deriveDecodeTargetForRuleSet = (rawFilename, ruleSet) => {
          const original = String(rawFilename || "").trim();
          if (!original || !original.includes(".")) {
            return original;
          }

          const parts = original.split("_");
          const last = String(parts[parts.length - 1] || "").trim();
          if (!last || !last.includes(".")) {
            return original;
          }

          const upperLast = last.toUpperCase();
          const tokenExact = ruleSet && ruleSet.index && ruleSet.index.tokenExact;
          if (tokenExact && typeof tokenExact.values === "function") {
            for (const exactMap of tokenExact.values()) {
              if (exactMap && exactMap.has(upperLast)) {
                return original;
              }
            }
          }

          // Keep structured bitrate-like dotted codes intact (for example DS768.dtshd).
          if (/^[A-Z]{2,}\d+(?:\.[A-Z0-9]+)+$/i.test(last)) {
            return original;
          }

          parts[parts.length - 1] = last.replace(/\.[^.]+$/, "");
          return parts.join("_");
        };
        const allCandidates = [];

        for (const ruleSet of state.ruleSets) {
          const decodeTarget = deriveDecodeTargetForRuleSet(filename, ruleSet);
          const sourceMasks = getMergedMaskSpecsForRuleSet(ruleSet);

          for (const sourceMask of sourceMasks) {
            const parsedMask = parseMaskSpec(sourceMask);
            if (!parsedMask) {
              continue;
            }

            const tokens = realignFoxAudioShiftedTailTokens(
              ruleSet,
              normalizeFoxRepeatedClcuTfAndRt(
                ruleSet,
                applyDwcResRangeSingleValueFallback(
                  ruleSet,
                  parsedMask,
                  splitByMask(decodeTarget, parsedMask, ruleSet)
                ),
                parsedMask
              )
            );
            const informationalTokens = new Set(parsedMask.informationalTokens || []);
            const tokenResults = tokens.map((token) => evaluateToken(ruleSet, parsedMask, token, informationalTokens, tokens));
            const normalizedTokenResults = normalizeConventionDisplayTokens(ruleSet, tokenResults);
            allCandidates.push(scoreCandidate(ruleSet, parsedMask, normalizedTokenResults, tokenResults));
          }
        }

        if (allCandidates.length === 0) {
          statusChipEl.textContent = "No Masks Found";
          return;
        }

        allCandidates.sort(rankCandidates);
        const bestCandidate = pickBestRenderableCandidate(allCandidates, filename);
        renderDecodeResult(bestCandidate, filename);
      }

      function computeTopCandidate(filenameInputRaw) {
        const filename = String(filenameInputRaw || "").replace(/[\\/]+$/, "").split(/[\\/]/).pop();
        const filenameWithoutExtension = String(filename || "").replace(/\..*$/, "");
        const allCandidates = [];

        for (const ruleSet of state.ruleSets) {
          const sourceMasks = getMergedMaskSpecsForRuleSet(ruleSet);

          for (const sourceMask of sourceMasks) {
            const parsedMask = parseMaskSpec(sourceMask);
            if (!parsedMask) {
              continue;
            }

            const tokens = realignFoxAudioShiftedTailTokens(
              ruleSet,
              normalizeFoxRepeatedClcuTfAndRt(
                ruleSet,
                applyDwcResRangeSingleValueFallback(
                  ruleSet,
                  parsedMask,
                  splitByMask(filenameWithoutExtension, parsedMask, ruleSet)
                ),
                parsedMask
              )
            );
            const informationalTokens = new Set(parsedMask.informationalTokens || []);
            const tokenResults = tokens.map((token) => evaluateToken(ruleSet, parsedMask, token, informationalTokens, tokens));
            const normalizedTokenResults = normalizeConventionDisplayTokens(ruleSet, tokenResults);
            allCandidates.push(scoreCandidate(ruleSet, parsedMask, normalizedTokenResults));
          }
        }

        if (allCandidates.length === 0) {
          return null;
        }

        allCandidates.sort(rankCandidates);
        return pickBestRenderableCandidate(allCandidates);
      }

      function renderBatchResults(results) {
        if (!batchResultsListEl) {
          return;
        }

        if (!Array.isArray(results) || results.length === 0) {
          batchResultsListEl.innerHTML = '<li class="empty-row">No sample run yet.</li>';
          return;
        }

        const rows = ['<li class="definition-row definition-header"><span class="definition-label">Sample</span><span class="definition-code">Convention</span><span class="definition-meaning">Confidence</span></li>'];

        for (const result of results) {
          rows.push(
            `<li class="definition-row"><span class="definition-label" title="${escapeHtml(result.filename)}">${escapeHtml(result.filename)}</span><span class="definition-code">${escapeHtml(result.convention)}</span><span class="definition-meaning">${escapeHtml(result.confidence)}</span></li>`
          );
        }

        batchResultsListEl.innerHTML = rows.join("");
      }

      async function runSampleBatch() {
        const input = String(filenameInput.value || "").trim();
        if (!input) {
          statusChipEl.textContent = "Missing Samples";
          return;
        }

        if (!Array.isArray(state.ruleSets) || state.ruleSets.length === 0) {
          await decodeFilename();
          if (!Array.isArray(state.ruleSets) || state.ruleSets.length === 0) {
            return;
          }
        }

        const samples = input.split(/\r?\n/).map((line) => line.trim()).filter(Boolean);
        const batchRows = [];

        for (const sample of samples) {
          const candidate = computeTopCandidate(sample);
          if (!candidate) {
            batchRows.push({ filename: sample, convention: "NO_MATCH", confidence: "0.000" });
            continue;
          }

          const conventionId = String((candidate.ruleSet.rulesDoc && candidate.ruleSet.rulesDoc.conventionId) || "UNKNOWN");
          const thresholdRaw = Number(candidate.ruleSet.rulesDoc && candidate.ruleSet.rulesDoc.matchThreshold);
          const threshold = Number.isFinite(thresholdRaw) ? thresholdRaw : 0.35;
          const hasNoReliableSignal = candidate.known === 0 || candidate.confidence <= 0;
          const matched = !hasNoReliableSignal && candidate.confidence >= threshold;

          batchRows.push({
            filename: sample,
            convention: matched ? displayConventionName(conventionId) : "NO_MATCH",
            confidence: Number(candidate.confidence || 0).toFixed(3)
          });
        }

        const firstCandidate = computeTopCandidate(samples[0]);
        if (firstCandidate) {
          renderDecodeResult(firstCandidate, samples[0]);
        }

        renderBatchResults(batchRows);
        statusChipEl.textContent = "Batch Complete";
      }

      function clearOutput() {
        filenameInput.value = "";
        matchIdEl.textContent = "NO_MATCH";
        matchConfidenceEl.textContent = "0.00";
        detectedMaskTextEl.textContent = "Run a decode to show the naming mask for the detected convention.";
        complianceNoteEl.textContent = "";
        if (definitionsNoteEl) {
          definitionsNoteEl.textContent = "";
        }
        definitionsListEl.innerHTML = '<li class="empty-row">No decoded definitions yet.</li>';
        if (batchResultsListEl) {
          batchResultsListEl.innerHTML = '<li class="empty-row">No sample run yet.</li>';
        }
        statusChipEl.textContent = state.ruleSets.length > 0 ? "Ready" : "No Decode Yet";
      }

      async function loadRules() {
        statusChipEl.textContent = "Loading Rules";
        state.ruleSets = [];
        state.loadErrors = [];
        state.familyPriorContext = null;
        state.wmlsFileInfoMeanings = new Map();
        state.wmlsFileTypeMeanings = new Map();
        state.wmlsFileTypeFormats = new Map();
        state.wmlsMaskVariants = [];
        state.dwcResAudRangeByCode = new Map();
        state.dwcConfMeanings = new Map();
        state.rawRuleEntriesBySource = new Map();

        if (bundleOnlyMode) {
          if (!tryHydrateFromLocalBundle()) {
            state.ruleSets = [];
            state.loadErrors = [bundleMissingMessage];
            statusChipEl.textContent = "Rules Load Failed";
            complianceNoteEl.textContent = state.loadErrors[0];
            return;
          }

          complianceNoteEl.textContent = bundleReadyMessage;
          statusChipEl.textContent = "Ready";
          return;
        }

        for (const sourcePath of conventionSources) {
          try {
            const response = await fetch(sourcePath, { cache: "no-store" });
            if (!response.ok) {
              throw new Error(`HTTP ${response.status}`);
            }

            const rulesDoc = await response.json();
            state.ruleSets.push({
              path: sourcePath,
              rulesDoc,
              index: buildRuleIndex(Array.isArray(rulesDoc.rules) ? rulesDoc.rules : [])
            });
          } catch (error) {
            const message = String(error && error.message ? error.message : error);
            state.loadErrors.push(`${sourcePath}: ${message}`);
          }
        }

        try {
          const response = await fetch(wmlsFileInfoSource, { cache: "no-store" });
          if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
          }
          const fileInfoDefinitions = await response.json();
          state.wmlsFileInfoMeanings = parseWmlsFileInfoMeaningMap(fileInfoDefinitions);
        } catch (error) {
          const message = String(error && error.message ? error.message : error);
          state.loadErrors.push(`${wmlsFileInfoSource}: ${message}`);
        }

        try {
          const response = await fetch(wmlsFileTypeSource, { cache: "no-store" });
          if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
          }
          const fileTypeDefinitions = await response.json();
          state.wmlsFileTypeMeanings = parseWmlsFileInfoMeaningMap(fileTypeDefinitions);
          state.wmlsFileTypeFormats = parseWmlsFileTypeFormatMap(fileTypeDefinitions);
        } catch (error) {
          const message = String(error && error.message ? error.message : error);
          state.loadErrors.push(`${wmlsFileTypeSource}: ${message}`);
        }

        try {
          const response = await fetch(wmlsMaskVariantsSource, { cache: "no-store" });
          if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
          }
          const variantsDoc = await response.json();
          state.wmlsMaskVariants = parseWmlsMaskVariantsDoc(variantsDoc);
        } catch (error) {
          const message = String(error && error.message ? error.message : error);
          state.loadErrors.push(`${wmlsMaskVariantsSource}: ${message}`);
        }

        try {
          const response = await fetch(dwcResAudRangeSource, { cache: "no-store" });
          if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
          }
          const dwcResAudRangeDoc = await response.json();
          state.dwcResAudRangeByCode = parseDwcResAudRangeMap(dwcResAudRangeDoc);
        } catch (error) {
          const message = String(error && error.message ? error.message : error);
          state.loadErrors.push(`${dwcResAudRangeSource}: ${message}`);
        }

        try {
          const response = await fetch(dwcConfSource, { cache: "no-store" });
          if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
          }
          const dwcConfDoc = await response.json();
          state.dwcConfMeanings = parseWmlsFileInfoMeaningMap(dwcConfDoc && dwcConfDoc.definitions);
        } catch (error) {
          const message = String(error && error.message ? error.message : error);
          state.loadErrors.push(`${dwcConfSource}: ${message}`);
        }

        if (state.ruleSets.length === 0) {
          const fileMode = window.location.protocol === "file:";
          if (fileMode && tryHydrateFromLocalBundle()) {
            complianceNoteEl.textContent = "";
            statusChipEl.textContent = "Ready";
            return;
          }

          statusChipEl.textContent = "Rules Load Failed";
          if (fileMode) {
            complianceNoteEl.textContent = "Rules could not be loaded via file:// fetch and local bundle fallback was not found. Open via localhost or regenerate ui/local_data_bundle.js.";
          } else {
            complianceNoteEl.textContent = state.loadErrors.join(" | ") || "No convention rules could be loaded.";
          }
          return;
        }

        const rawSourceLoad = await loadRawRuleSourceEntries(
          state.ruleSets,
          async (sourcePath) => {
            const response = await fetch(sourcePath, { cache: "no-store" });
            if (!response.ok) {
              throw new Error(`HTTP ${response.status}`);
            }
            return response.json();
          }
        );
        state.rawRuleEntriesBySource = rawSourceLoad.loadedBySource;
        for (const error of rawSourceLoad.errors) {
          state.loadErrors.push(`${error.sourcePath}: ${error.message}`);
        }

        complianceNoteEl.textContent = "";
        statusChipEl.textContent = "Ready";
      }

      const decodeAction = runBatchMode ? runSampleBatch : decodeFilename;

      decodeButton.addEventListener("click", () => {
        decodeAction().catch((error) => {
          const message = String(error && error.message ? error.message : error);
          statusChipEl.textContent = "Decode Error";
          complianceNoteEl.textContent = `Decode failed: ${message}`;
        });
      });
      clearButton.addEventListener("click", clearOutput);
      filenameInput.addEventListener("keydown", (event) => {
        if ((event.metaKey || event.ctrlKey) && event.key === "Enter") {
          decodeAction().catch((error) => {
            const message = String(error && error.message ? error.message : error);
            statusChipEl.textContent = "Decode Error";
            complianceNoteEl.textContent = `Decode failed: ${message}`;
          });
        }
      });

      loadRules();
};

